import { add_to_version_info as $8tj43$add_to_version_info, javascript_media_query as $8tj43$javascript_media_query, standard_price_format as $8tj43$standard_price_format, catchify as $8tj43$catchify1, observer as $8tj43$observer, slider_fractional_factory as $8tj43$slider_fractional_factory, report as $8tj43$report1, dlog as $8tj43$dlog, camelCasifyObject as $8tj43$camelCasifyObject, make_random_classname as $8tj43$make_random_classname, n_col_styling_with_dist as $8tj43$n_col_styling_with_dist, layout_get_visible_recs_without_partial_rows as $8tj43$layout_get_visible_recs_without_partial_rows, layout_get_total_rec_amount_for_row as $8tj43$layout_get_total_rec_amount_for_row, layout_media_query_header as $8tj43$layout_media_query_header, dwarn as $8tj43$dwarn, slider_fading_factory as $8tj43$slider_fading_factory, Amazing_Slider as $8tj43$Amazing_Slider, slider_snap_css as $8tj43$slider_snap_css, useExpandingContainer as $8tj43$useExpandingContainer, hex_to_rgb as $8tj43$hex_to_rgb, relative_luminance_from_rgb as $8tj43$relative_luminance_from_rgb, instant_exec_on_suspect_history_change as $8tj43$instant_exec_on_suspect_history_change, base64_encode_unicode as $8tj43$base64_encode_unicode, base64_decode_unicode as $8tj43$base64_decode_unicode, queueMacroTask as $8tj43$queueMacroTask, is_debug as $8tj43$is_debug, findMostFrequentItem as $8tj43$findMostFrequentItem, is_available_in as $8tj43$is_available_in, fetch_retry as $8tj43$fetch_retry, base_url as $8tj43$base_url, deparallelize_no_drop as $8tj43$deparallelize_no_drop, ContainedImage as $8tj43$ContainedImage, buildThresholdList as $8tj43$buildThresholdList, make_asyncIterable_exiter as $8tj43$make_asyncIterable_exiter, href_change_ipns as $8tj43$href_change_ipns, use_href_accessor as $8tj43$use_href_accessor1, get_session_id as $8tj43$get_session_id, add_version_query_params as $8tj43$add_version_query_params, snakeCasifyObject as $8tj43$snakeCasifyObject, make_url_with_query_params as $8tj43$make_url_with_query_params, sort_obj as $8tj43$sort_obj, insert_surfaces as $8tj43$insert_surfaces } from "@depict-ai/utilishared/ES10";
import { template as $8tj43$template, createComponent as $8tj43$createComponent, getNextElement as $8tj43$getNextElement, getNextMarker as $8tj43$getNextMarker, insert as $8tj43$insert, isServer as $8tj43$isServer, use as $8tj43$use, effect as $8tj43$effect, setAttribute as $8tj43$setAttribute, memo as $8tj43$memo, mergeProps as $8tj43$mergeProps1, addEventListener as $8tj43$addEventListener, runHydrationEvents as $8tj43$runHydrationEvents, delegateEvents as $8tj43$delegateEvents, spread as $8tj43$spread, classList as $8tj43$classList, className as $8tj43$className, style as $8tj43$style, Dynamic as $8tj43$Dynamic, setProperty as $8tj43$setProperty } from "solid-js/web";
import { createContext as $8tj43$createContext, createSignal as $8tj43$createSignal, getOwner as $8tj43$getOwner, createResource as $8tj43$createResource, untrack as $8tj43$untrack, createRoot as $8tj43$createRoot, createEffect as $8tj43$createEffect, runWithOwner as $8tj43$runWithOwner, onCleanup as $8tj43$onCleanup, createMemo as $8tj43$createMemo, Show as $8tj43$Show, createComputed as $8tj43$createComputed, createRenderEffect as $8tj43$createRenderEffect, mergeProps as $8tj43$mergeProps, useContext as $8tj43$useContext, createReaction as $8tj43$createReaction, on as $8tj43$on, Suspense as $8tj43$Suspense, ErrorBoundary as $8tj43$ErrorBoundary, Index as $8tj43$Index, For as $8tj43$For, createUniqueId as $8tj43$createUniqueId, mapArray as $8tj43$mapArray, batch as $8tj43$batch, Switch as $8tj43$Switch, Match as $8tj43$Match, splitProps as $8tj43$splitProps, createComponent as $8tj43$createComponent1, createSelector as $8tj43$createSelector, children as $8tj43$children } from "solid-js";
import { catchify as $8tj43$catchify, report as $8tj43$report, use_href_accessor as $8tj43$use_href_accessor, observer as $8tj43$observer1, dlog as $8tj43$dlog1, ListenableSet as $8tj43$ListenableSet, queueMacroTask as $8tj43$queueMacroTask1 } from "@depict-ai/utilishared/ES10";
import { createStore as $8tj43$createStore, reconcile as $8tj43$reconcile } from "solid-js/store";
import $8tj43$babelruntimehelpersdefineProperty from "@babel/runtime/helpers/defineProperty";
import $8tj43$babelruntimehelpersclassPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import $8tj43$babelruntimehelpersclassPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";

/*! Depict.ai search and product listing SDK */
import { register_es_version } from "../multi_import_deduplicator.mjs";
register_es_version("ui", "ES10");
const $8db9a15135765c11$export$83d89fbfd8236492 = "4.10.4";
function $00a5b94f0c11efbb$export$d9f36cf74e24d595(media_query) {
  const signal = $8tj43$createSignal(false);
  $8tj43$onCleanup($8tj43$javascript_media_query(media_query, _ref => {
    let {
      matches: matches
    } = _ref;
    return signal[1](matches);
  }).remove);
  return signal[0];
}
const $9b5022ae72f56399$var$get_available_range = (available_filters_, search_for_field) => {
  var _untrack, _untrack$find;
  const maybe_meta = (_untrack = $8tj43$untrack(available_filters_)) === null || _untrack === void 0 ? void 0 : (_untrack$find = _untrack.find(_ref => {
    let {
      op: op,
      field: field
    } = _ref;
    return field === search_for_field && op === "inrange";
  })) === null || _untrack$find === void 0 ? void 0 : _untrack$find.meta;
  if ((maybe_meta === null || maybe_meta === void 0 ? void 0 : maybe_meta.min) != undefined && (maybe_meta === null || maybe_meta === void 0 ? void 0 : maybe_meta.max) != undefined) return [maybe_meta.min, maybe_meta.max];
};
function $9b5022ae72f56399$export$e702733a056c40d6(_ref2) {
  let {
    available_filters_: available_filters_,
    selected_filters_: selected_filters_
  } = _ref2;
  $8tj43$createComputed(() => {
    // we don't want to update (as selected_filters change) as navigating will change the selected range before the available range changes and we might ruin a perfectly valid filter range
    available_filters_();
    $9b5022ae72f56399$var$correct_range_filter_range_once({
      selected_filters_: selected_filters_,
      available_filters_: available_filters_
    });
  });
}
function $9b5022ae72f56399$var$correct_range_filter_range_once(_ref3) {
  let {
    selected_filters_: [read_selected_filters_, write_selected_filters_],
    available_filters_: available_filters_
  } = _ref3;
  const selected_filters = $8tj43$untrack(read_selected_filters_);
  if (!selected_filters) return;
  for (let i = 0; i < selected_filters.length; i++) {
    const range_filter = selected_filters[i];
    if (range_filter.op !== "inrange") continue;
    const selected = range_filter === null || range_filter === void 0 ? void 0 : range_filter.data;
    if (!Array.isArray(selected) || selected.length !== 2) continue;
    const available = $9b5022ae72f56399$var$get_available_range(available_filters_, range_filter.field);
    if (!available) return;
    const [min, max] = available;
    let [lower, upper] = selected;
    let modified = false;
    if (lower < min || lower > max) {
      lower = min;
      modified = true;
    }
    if (upper > max || upper < min) {
      upper = max;
      modified = true;
    }
    if (modified) {
      const new_filters = [...selected_filters];
      const new_filter = {
        ...range_filter,
        data: [lower, upper]
      };
      new_filters.splice(i, 1, ...(lower === min && upper === max ? [] : [new_filter]));
      write_selected_filters_(new_filters);
    }
  }
}
function $43fbdca0f726a34b$export$92f2da32c6e7e7ee(_ref) {
  let {
    number_: number_,
    i18n_: i18n_
  } = _ref;
  return $8tj43$createMemo(() => {
    const numberToFormat = number_();
    if (isNaN(numberToFormat)) return "";
    const price_formatting = i18n_.price_formatting_();
    return $8tj43$standard_price_format(numberToFormat, 0,
    // we never want places after comma here it looks weird as hell
    price_formatting.decimal_places_delimiter_, price_formatting.thousands_delimiter_);
  });
}
function $60ec7a29849d81db$export$a71e92cfbb498adc(props) {
  return $8tj43$createMemo(() => {
    const price_formatting = props.price_formatting_;
    return $8tj43$standard_price_format(props.price_, price_formatting.places_after_comma_, price_formatting.decimal_places_delimiter_, price_formatting.thousands_delimiter_);
  });
}
function $33e7d1906c93db7d$export$205efb947c7ffd78(handler) {
  let passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let override_element = arguments.length > 2 ? arguments[2] : undefined;
  const catchified_handler = $8tj43$catchify1(handler);
  const owner = $8tj43$getOwner();
  // Some customers (e.g. equestrian) have `height: 100%` and/or `overflow-x: hidden` on the body, which means that scroll events won't get dispatched on `window`. The pages who get it on <body> won't get it on `window` and vice-versa, so there shouldn't be a worry about duplicate calling of the handler.
  // Use observer in case that this gets called before body exists
  if (!override_element) {
    const doWithBody = element => {
      element.addEventListener("scroll", catchified_handler, {
        passive: passive
      });
      $8tj43$runWithOwner(owner, () => $8tj43$onCleanup(() => element.removeEventListener("scroll", catchified_handler)));
    };
    const {
      body: body
    } = document;
    if (body)
      // Only start observer if we absolutely need it, for performance
      doWithBody(body);else {
      const disconnect = (0, $8tj43$observer).onexists("body", _ref => {
        let {
          element: element
        } = _ref;
        return doWithBody(element);
      });
      $8tj43$onCleanup(disconnect);
    }
  }
  for (const event of ["resize", "orientationchange", "scroll"]) {
    const listen_on = override_element !== null && override_element !== void 0 ? override_element : window;
    listen_on.addEventListener(event, catchified_handler, {
      passive: passive
    });
    $8tj43$onCleanup(() => listen_on.removeEventListener(event, catchified_handler));
  }
}
var $b69740fc6de9f17e$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=scroll-status style=display:none><span class=text><b></b> \u{2013} <b></b> <!$><!/> <b>`);
function $b69740fc6de9f17e$export$83fd5de5504a7a67(_ref) {
  let {
    formatted_number_of_results_: formatted_number_of_results_,
    first_result_in_viewport_: [get_first_result_in_viewport],
    last_result_in_viewport_: [get_last_result_in_viewport],
    number_of_results_: number_of_results_,
    i18n_: {
      price_formatting_: price_formatting_,
      of_: of_
    },
    get_scroll_position_ = () => scrollY,
    listen_to_scroll_on_: listen_to_scroll_on_,
    velocity_too_fast_ = 1.5
  } = _ref;
  if (0, $8tj43$isServer) return; // won't show in initial render and need scroll position
  const [first_to_show, set_first_to_show] = $8tj43$createSignal(0);
  const [last_to_show, set_last_to_show] = $8tj43$createSignal(0);
  const [count_to_show, set_count_to_show] = $8tj43$createSignal("");
  const [permitted_to_show, set_permitted_to_show] = $8tj43$createSignal(false); // due to scroll speed
  const [show_triggered, set_show_triggered] = $8tj43$createSignal(false); // signal to just switch between true/false to trigger a new animation which will persist the indicator
  const [times_too_fast, set_times_too_fast] = $8tj43$createSignal(0);
  const modified_price_formatting_ = $8tj43$createMemo(() => ({
    ...price_formatting_(),
    places_after_comma_: 0
  }));
  let element;
  let animation;
  let last_pos_time = +new Date();
  let last_pos = get_scroll_position_();
  let unpermit_when_possible = false;
  const handle_scrollpos_change = () => {
    if (animation) set_show_triggered(prev => !prev); // make sure that once we've decided to show the indicator it doesn't disappear before we stop scrolling
    const distance_travelled = Math.abs(get_scroll_position_() - last_pos);
    const now = +new Date();
    const age_of_distance = now - last_pos_time;
    const velocity = distance_travelled / age_of_distance; // pixels per millisecond
    if (velocity > velocity_too_fast_) {
      set_times_too_fast(prev => prev + 1);
      setTimeout(() => set_times_too_fast(prev => prev - 1), 1000);
    }
    last_pos_time = now;
    last_pos = get_scroll_position_();
  };
  $33e7d1906c93db7d$export$205efb947c7ffd78(handle_scrollpos_change, undefined, listen_to_scroll_on_);
  $8tj43$createComputed(() => {
    // We need to set this reactively to ensure that it's forbidden to show even when times_too_fast has tapered off after a few seconds, see https://github.com/depict-org/depict/pull/82
    if (times_too_fast() > 10) {
      set_permitted_to_show(true);
      unpermit_when_possible = false;
    } else if (animation) unpermit_when_possible = true;else set_permitted_to_show(false);
  });
  $8tj43$createEffect(() => {
    show_triggered();
    const first = get_first_result_in_viewport();
    const last = get_last_result_in_viewport();
    const count = formatted_number_of_results_();
    const allowed = permitted_to_show();
    const should_show = first !== undefined &&
    // we have gotten intersection data for first
    last !== undefined &&
    // we have gotten intersection data for last
    Math.abs(first) !== Infinity &&
    // first isn't infinity due to some division stuff (happened for me once)
    Math.abs(last) !== Infinity &&
    // last isn't infinity due to some division stuff (happened for me once)
    !(first === 0 && last === 0) &&
    // there aren't zero elements (I think is what this checks)
    count &&
    // we have a string with formatted number of results, it might take "time" for this to arrive and we don't want to show garbage in the meantime
    number_of_results_() >= 10; // at least 10 results
    if (!should_show || !allowed) return;
    // don't show invalid values - just let the last ones fade away
    set_first_to_show(first);
    set_last_to_show(last);
    set_count_to_show(count);
    const duration = 1500;
    const faded_in_offset = 0.02;
    // animation stuff
    if (animation) {
      // reset animation to just after we became visible
      const in_time = 180;
      if (animation.currentTime > in_time) animation.currentTime = in_time;
      // the six is a correction factor for my macbook (maybe also everywhere else) where I don't understand why I can't calculate the time of the first keyframe without it
      return;
    }
    element.style.display = "";
    animation = element.animate([{
      opacity: 0,
      offset: 0
    }, {
      opacity: 1,
      offset: faded_in_offset
    }, {
      opacity: 1,
      offset: 0.6
    }, {
      opacity: 0,
      offset: 1
    }], {
      duration: duration,
      fill: "forwards",
      easing: "ease-in-out"
    });
    animation.addEventListener("finish", $8tj43$catchify1(() => {
      if (unpermit_when_possible) set_permitted_to_show(false);
      animation = undefined;
      element.style.display = "none";
    }));
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($b69740fc6de9f17e$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$7 = _el$4.nextSibling,
      _el$8 = _el$7.nextSibling,
      _el$11 = _el$8.nextSibling,
      [_el$12, _co$] = $8tj43$getNextMarker(_el$11.nextSibling),
      _el$9 = _el$12.nextSibling,
      _el$10 = _el$9.nextSibling;
    var _ref$ = element;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$) : element = _el$;
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
      get price_() {
        return first_to_show();
      },
      get price_formatting_() {
        return modified_price_formatting_();
      }
    }));
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
      get price_() {
        return last_to_show();
      },
      get price_formatting_() {
        return modified_price_formatting_();
      }
    }));
    $8tj43$insert(_el$2, of_, _el$12, _co$);
    $8tj43$insert(_el$10, count_to_show);
    return _el$;
  })();
}
var $a61a2051e15c8d7a$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`);
const $a61a2051e15c8d7a$var$closing_functions = /*@__PURE__*/new Set();
const $a61a2051e15c8d7a$export$22970a0140fc759c = /*@__PURE__*/$8tj43$createSignal(false);
function $a61a2051e15c8d7a$export$5196e4c01fa56fcb(_ref) {
  let {
    children: children,
    on_close_: on_close_,
    close_after_: close_after_,
    ...more_attributes
  } = _ref;
  let close_toast_;
  const stay_open_promise = new Promise(r => close_toast_ = r);
  $8tj43$catchify1(async () => {
    const closing_animation_duration = 300; // ms
    const element = (() => {
      var _el$ = $8tj43$getNextElement($a61a2051e15c8d7a$var$_tmpl$);
      $8tj43$spread(_el$, more_attributes, false, true);
      $8tj43$insert(_el$, children);
      $8tj43$runHydrationEvents();
      return _el$;
    })();
    const [, set_is_showing_toast] = $a61a2051e15c8d7a$export$22970a0140fc759c;
    // if this is a memory leak the garbage collector is stupid - does someone know?
    for (const ev of ["pointerover", "focusin"]) element.addEventListener(ev, $8tj43$catchify1(() => closing_animation.pause()));
    for (const ev of ["pointerout", "focusout"]) element.addEventListener(ev, $8tj43$catchify1(() => closing_animation.play()));
    const body = await (0, $8tj43$observer).wait_for_element("body");
    const x_translate = "translateX(-50%) ";
    let remove_keyboard_listener;
    let had_toast_before = false;
    element.classList.add("depict", "toast", "plp");
    if ($a61a2051e15c8d7a$var$closing_functions.size) {
      // ensure we can never have multiple toasts open at the same time
      for (const fn of $a61a2051e15c8d7a$var$closing_functions) fn();
      had_toast_before = true;
    }
    body.append(element);
    // open toast
    element.animate({
      opacity: [0, 1],
      transform: [x_translate + "translateY(100%)", x_translate + "translateY(0)"]
    }, {
      easing: "ease-in",
      duration: 150,
      fill: "forwards",
      delay: had_toast_before ? 100 : 0 /* give old toasts a chance to animate closed */
    });
    // let other toasts close us if they open while we're still here
    $a61a2051e15c8d7a$var$closing_functions.add(close_toast_);
    set_is_showing_toast(true);
    const handler = $8tj43$catchify1(_ref2 => {
      let {
        key: key
      } = _ref2;
      if (key === "Escape")
        // make pressing escape close the toast
        close_toast_();
    });
    window.addEventListener("keydown", handler);
    remove_keyboard_listener = () => window.removeEventListener("keydown", handler);
    // this is both a very precise timeout for closing the modal (animations are much more precise than timeouts) and an animation letting the user know when it will close
    const closing_animation = element.animate({
      borderImageWidth: ["0 0% 2px 0", "0 100% 2px 0"]
    }, {
      duration: close_after_,
      fill: "forwards"
    });
    closing_animation.addEventListener("finish", close_toast_, {
      once: true
    });
    // wait until we should close - stay_open_promise is resolved by something
    await stay_open_promise;
    // start closing animation and wait for it to finish
    await new Promise(r => element.animate({
      opacity: [1, 0],
      transform: [x_translate + "translateY(0)", x_translate + "translateY(100%)"]
    }, {
      easing: "ease-out",
      duration: closing_animation_duration,
      fill: "forwards"
    }).addEventListener("finish", r, {
      once: true
    }));
    // remove elements and cleanup
    element.remove();
    $a61a2051e15c8d7a$var$closing_functions.delete(close_toast_);
    if (!$a61a2051e15c8d7a$var$closing_functions.size) set_is_showing_toast(false);
    on_close_ === null || on_close_ === void 0 || on_close_();
    remove_keyboard_listener();
  })();
  return {
    close_toast_: close_toast_
  };
}
var $b4465d8d605f61e9$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=statement>`),
  $b4465d8d605f61e9$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=buttons><button class="restore minor"></button><button class="ok major">`);
function $b4465d8d605f61e9$export$8895d39404bd2bb1(props) {
  let previous_sorting;
  let on_toast_hidden;
  let close_toast_ = () => {
    // if we get called to close the toast before it has shown, never show it
    show_configured_toast = () => {};
  };
  const {
    user_triggered_: user_triggered_,
    i18n_: i18n_,
    also_clear_sorting_: also_clear_sorting_,
    local_filter_cache_: [get_local_filter_cache, set_local_filter_cache],
    selected_filters_: [get_selected_filters, set_selected_filters],
    expanded_hierarchical_filters_: [get_expanded_hierarchical_filters, set_expanded_hierarchical_filters],
    delay_toast_: delay_toast_,
    expanded_filters_: expanded_filters_,
    filters_open_: filters_open_
  } = props;
  const previous_selected_filters = $8tj43$untrack(get_selected_filters);
  if (!previous_selected_filters.length) {
    // no filters selected, still clear sorting if applicable but don't display a toast for that since it's very minor
    if (also_clear_sorting_) props.current_sorting_[1]();
    if (delay_toast_) return () => {};
    return;
  }
  const previousExpandedFilters = $8tj43$untrack(() => expanded_filters_ === null || expanded_filters_ === void 0 ? void 0 : expanded_filters_[0]());
  const previousFiltersOpen = $8tj43$untrack(() => filters_open_ === null || filters_open_ === void 0 ? void 0 : filters_open_[0]());
  const previous_expanded_hierarchical_filters = $8tj43$untrack(get_expanded_hierarchical_filters);
  const previous_local_filter_cache = $8tj43$untrack(get_local_filter_cache);
  const statement_accessor = user_triggered_ ? i18n_.filters_cleared_ : i18n_.we_cleared_your_filters_;
  expanded_filters_ === null || expanded_filters_ === void 0 || expanded_filters_[1]([]);
  filters_open_ === null || filters_open_ === void 0 || filters_open_[1](false);
  set_selected_filters([]);
  scrollTo({
    top: 0
  });
  // also collapse expanded filters in hierarchical filter tree again
  set_expanded_hierarchical_filters([]);
  if (also_clear_sorting_) {
    previous_sorting = props.current_sorting_[0]();
    props.current_sorting_[1]();
  }
  // lifetime of this component isn't the same as lifetime of toast
  $8tj43$createRoot(dispose => {
    on_toast_hidden = dispose;
    $8tj43$createEffect($8tj43$on(get_selected_filters, () => {
      // if selected filters change, hide the toast
      close_toast_();
    }, {
      defer: true
    }));
  });
  let show_configured_toast = () => {
    ({
      close_toast_: close_toast_
    } = $a61a2051e15c8d7a$export$5196e4c01fa56fcb({
      class: "cleared_filters",
      close_after_: 10000,
      on_close_: on_toast_hidden,
      children: [(() => {
        var _el$ = $8tj43$getNextElement($b4465d8d605f61e9$var$_tmpl$);
        $8tj43$insert(_el$, statement_accessor);
        return _el$;
      })(), (() => {
        var _el$2 = $8tj43$getNextElement($b4465d8d605f61e9$var$_tmpl$2),
          _el$3 = _el$2.firstChild,
          _el$4 = _el$3.nextSibling;
        $8tj43$addEventListener(_el$3, "click", $8tj43$catchify1(() => {
          set_selected_filters(previous_selected_filters);
          set_expanded_hierarchical_filters(previous_expanded_hierarchical_filters);
          if (previousExpandedFilters) expanded_filters_ === null || expanded_filters_ === void 0 || expanded_filters_[1](previousExpandedFilters);
          if (also_clear_sorting_ && previous_sorting) props.current_sorting_[1](previous_sorting);
          if (typeof previousFiltersOpen === "boolean") filters_open_ === null || filters_open_ === void 0 || filters_open_[1](previousFiltersOpen);
          // also restore previous filter cache, I think this should trigger a correct re-merging with newly in-came filters from backend in case there are any. This is because selected filters otherwise might not exist anymore and therefore can't be viewed in the UI
          set_local_filter_cache(previous_local_filter_cache);
          scrollTo({
            top: 0
          });
        }), true);
        $8tj43$insert(_el$3, () => i18n_.restore_());
        _el$4.$$click = () => close_toast_() /* We have to wait for close_toast_ to get re-defined after the call to show_toast */;
        $8tj43$insert(_el$4, () => i18n_.ok_());
        $8tj43$runHydrationEvents();
        return _el$2;
      })()]
    }));
  };
  if (delay_toast_) return show_configured_toast;else show_configured_toast();
}
$8tj43$delegateEvents(["click"]);
var $94af29837186eb21$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a class=hint href=javascript:void(0)>`),
  $94af29837186eb21$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=no-results><div class=text></div><!$><!/>`);
function $94af29837186eb21$export$ef6006467f04ee41(_ref) {
  let {
    i18n_: i18n_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    selected_filters_: selected_filters_,
    local_filter_cache_: local_filter_cache_
  } = _ref;
  const root = $8tj43$getOwner();
  return [(() => {
    var _el$ = $8tj43$getNextElement($94af29837186eb21$var$_tmpl$2),
      _el$2 = _el$.firstChild,
      _el$4 = _el$2.nextSibling,
      [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$insert(_el$2, () => i18n_.no_results_text_());
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return Object.values(selected_filters_[0]()).length;
      },
      get children() {
        var _el$3 = $8tj43$getNextElement($94af29837186eb21$var$_tmpl$);
        $8tj43$addEventListener(_el$3, "click", $8tj43$catchify1(() => $8tj43$runWithOwner(root, () => $b4465d8d605f61e9$export$8895d39404bd2bb1({
          user_triggered_: true,
          selected_filters_: selected_filters_,
          also_clear_sorting_: false,
          expanded_hierarchical_filters_: expanded_hierarchical_filters_,
          i18n_: i18n_,
          local_filter_cache_: local_filter_cache_
        }))), true);
        $8tj43$insert(_el$3, () => i18n_.try_without_filters_());
        $8tj43$runHydrationEvents();
        return _el$3;
      }
    }), _el$5, _co$);
    return _el$;
  })()];
}
$8tj43$delegateEvents(["click"]);
function $ca55612a53dbbdd2$export$a2cc176055f8f08() {
  let what = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "grid";
  const text = "Please try setting `columnsAtSize`/`gridSpacing` on the `SearchPage`/`CategoryPage` components to change the " + what + " before setting it with CSS. If you do with CSS, set `columnsAtSize` to an empty array to ensure no declarations created by the SDK leak through.";
  return (0, $8tj43$isServer) ? {
    t: "<!-- ".concat(text, " -->")
  } : document.createComment(text);
}

// Errors caused by SDK consuming code interfacing with the SDK, not the SDK itself or other Depict packages
class $f3b7124b76123e44$export$e1d52e4f0c7557a1 extends Error {}
class $f3b7124b76123e44$export$aa14a9f43128f61f extends $f3b7124b76123e44$export$e1d52e4f0c7557a1 {
  constructor(templateError) {
    super("Uncaught error in product card template", {
      cause: templateError
    });
  }
}
var $74777e8fe65b3dcb$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div><!$><!/><!$><!/>`);
const $74777e8fe65b3dcb$var$ExtraInfoContext = /*@__PURE__*/$8tj43$createContext();
function $74777e8fe65b3dcb$export$240ecf5363d76c0f(props) {
  return $8tj43$createComponent($74777e8fe65b3dcb$var$ExtraInfoContext.Provider, {
    get value() {
      return props.getContext_;
    },
    get children() {
      return props.children;
    }
  });
}
function $74777e8fe65b3dcb$export$b69d0d92862de18b(props) {
  const getContextFunction = $8tj43$useContext($74777e8fe65b3dcb$var$ExtraInfoContext);
  return $8tj43$ErrorBoundary({
    fallback(err, retry) {
      const {
        message_: message_,
        severity_: severity_
      } = props;
      let message = message_;
      if (err instanceof (0, $f3b7124b76123e44$export$aa14a9f43128f61f)) {
        console.error(err.cause);
        message = "".concat(message, ": ").concat(err.message);
      } else $8tj43$report1([err, message_], severity_, getContextFunction === null || getContextFunction === void 0 ? void 0 : getContextFunction());
      return (() => {
        var _el$ = $8tj43$getNextElement($74777e8fe65b3dcb$var$_tmpl$),
          _el$2 = _el$.firstChild,
          [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
          _el$4 = _el$3.nextSibling,
          [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
        $8tj43$insert(_el$, message, _el$3, _co$);
        $8tj43$insert(_el$, () => {
          var _props$on_error_;
          return (_props$on_error_ = props.on_error_) === null || _props$on_error_ === void 0 ? void 0 : _props$on_error_.call(props, retry);
        }, _el$5, _co$2);
        $8tj43$effect(_$p => {
          var _props$class_list_;
          return $8tj43$classList(_el$, Object.fromEntries(((_props$class_list_ = props.class_list_) === null || _props$class_list_ === void 0 ? void 0 : _props$class_list_.map(c => [c, true])) || []), _$p);
        });
        return _el$;
      })();
    },
    get children() {
      return props.children;
    }
  });
}
function $cb64b315b25cfc59$export$2f0cbfbb4354bb52(elements) {
  // FYI this probably doesn't work on hugely deep nestings or large amount of elements
  return $8tj43$createMemo(() => $cb64b315b25cfc59$var$unwrapping_helper(elements));
}
function $cb64b315b25cfc59$var$unwrapping_helper(elements) {
  const result = [];
  if (Array.isArray(elements)) for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    result.push(...$cb64b315b25cfc59$var$unwrapping_helper(element));
  } else if (typeof elements == "function") result.push(...$cb64b315b25cfc59$var$unwrapping_helper(elements()));else if (elements != undefined && typeof elements != "boolean") result.push(elements);
  return result;
}
const $bdd80c7862246dc2$var$defaultCacheKey = /*@__PURE__*/Symbol();
const $bdd80c7862246dc2$var$cachedPlaceholderElements = {};
const $bdd80c7862246dc2$var$renderingCachedPlaceholderElement = {};
function $bdd80c7862246dc2$export$f33414a4df0afd3f(_ref) {
  let {
    product_card_template_: product_card_template_,
    num_placeholders_: num_placeholders_,
    content_blocks_: content_blocks_,
    placeholderCacheKey_: placeholderCacheKey_
  } = _ref;
  const [num_to_actually_show, set_num_to_actually_show] = $8tj43$createSignal($8tj43$untrack(num_placeholders_));
  if (0, $8tj43$isServer)
    // want to render simple placeholders on server, effects don't run there
    // FIXME when adding proper SSR: also SSR content blocks
    return $8tj43$createMemo(() => Array.from({
      length: num_placeholders_()
    }).map(() => {
      const template_result = product_card_template_(null, undefined);
      // @ts-ignore
      if (typeof (template_result === null || template_result === void 0 ? void 0 : template_result.then) !== "function") return template_result;
    }));
  $8tj43$createRenderEffect(() => {
    const existing_num = num_to_actually_show();
    const to_add = num_placeholders_() - existing_num;
    if (to_add <= 0) return;
    // Below comment is from when we used recommendation renderer and manual DOM manipulation for this, but I'm still scared to remove placeholders and mess up scroll restoration, so I'm keeping the way it worked. Otherwise, <Index> could be used which would be far more elegant.
    // We don't need to remove placeholders, only need to add. The reason for that is that chrome restores the scroll position once all tasks queued as reaction of the "popstate" events have been completed in the task queue. That means that we need to get the placeholders in fast, or we might lose scroll position if the previous site was shorter.
    // The query id and the amount might update in separate tasks because one comes from href_change_ipns and the other one from another "popstate" listener. Therefore, we need to be able to dynamically add more placeholders. I'm not entirely sure about this anymore though, since we have the scroll position on a per-id basis it might work anyway but THIS WORKS, and I've been working on this bug for 3 hours so let's just keep it this way.
    // Above comments were from when we added elements in this createRenderEffect. Now I changed it to just increment the number and render them from an <Index> instead, so I can add content blocks better
    // Functionality should be the same
    set_num_to_actually_show(existing_num + to_add);
  });
  return $8tj43$createComponent((0, $8tj43$Index), {
    get each() {
      return Array.from({
        length: num_to_actually_show()
      });
    },
    children: (_item, index) => {
      const possible_content_block = $8tj43$createMemo(() => {
        var _content_blocks_, _content_blocks_2;
        return content_blocks_ === null || content_blocks_ === void 0 ? void 0 : (_content_blocks_ = content_blocks_()) === null || _content_blocks_ === void 0 ? void 0 : (_content_blocks_2 = _content_blocks_()) === null || _content_blocks_2 === void 0 ? void 0 : _content_blocks_2[index];
      });
      // Show content block before product card, so it's *at* that index
      return [possible_content_block, $bdd80c7862246dc2$var$Placeholder({
        product_card_template_: product_card_template_,
        placeholderCacheKey_: placeholderCacheKey_
      })]; // https://github.com/solidjs/solid/releases/tag/v1.7.0
    }
  });
}
/**
 * Get one placeholder element. It will be cloned for each placeholder for ultimate performance even when solid-js isn't rendering the placeholders.
 */
function $bdd80c7862246dc2$var$Placeholder(_ref2) {
  let {
    product_card_template_: product_card_template_,
    placeholderCacheKey_ = $bdd80c7862246dc2$var$defaultCacheKey
  } = _ref2;
  const get_cloned_placeholders = function () {
    let element_to_clone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bdd80c7862246dc2$var$cachedPlaceholderElements[placeholderCacheKey_];
    return Array.isArray(element_to_clone) ? element_to_clone.map(el => el instanceof Node ? el.cloneNode(true) : el) : element_to_clone;
  };
  if ($bdd80c7862246dc2$var$cachedPlaceholderElements[placeholderCacheKey_]) return get_cloned_placeholders();
  let dispose_original_copy;
  const get_unwrapped_element = $8tj43$createRoot(dispose => {
    dispose_original_copy = dispose;
    // if product_card_template_ is async and rejects the resource will take care of throwing upwards here in the solid-js error handling system
    const [resource] = $8tj43$createResource(() => {
      const rendering_cached_placeholder_element = $bdd80c7862246dc2$var$renderingCachedPlaceholderElement[placeholderCacheKey_];
      if (rendering_cached_placeholder_element) return rendering_cached_placeholder_element;
      const return_value = product_card_template_(null, undefined);
      if (typeof return_value === "object" && typeof (return_value === null || return_value === void 0 ? void 0 : return_value.then) === "function")
        // Is Promise or promise-like object
        $bdd80c7862246dc2$var$renderingCachedPlaceholderElement[placeholderCacheKey_] = return_value;
      return return_value;
    });
    return $8tj43$createMemo(() => {
      if (resource.loading) return () => [];
      return $cb64b315b25cfc59$export$2f0cbfbb4354bb52(resource);
    });
  });
  $8tj43$onCleanup(() => {
    const rendering = $bdd80c7862246dc2$var$renderingCachedPlaceholderElement[placeholderCacheKey_];
    if (rendering) {
      // If we're still rendering in our separate root, let the rendering finish or other <Placeholder> components waiting for it might get an incomplete result
      const unset_current_rendering = () => {
        dispose_original_copy();
        $bdd80c7862246dc2$var$renderingCachedPlaceholderElement[placeholderCacheKey_] = undefined;
      };
      rendering === null || rendering === void 0 || rendering.then(unset_current_rendering, unset_current_rendering);
    } else
      // Otherwise, just make sure we've disposed our root
      dispose_original_copy();
  });
  return $8tj43$createMemo(() => {
    const unwrapped_array = get_unwrapped_element()();
    if (!(unwrapped_array !== null && unwrapped_array !== void 0 && unwrapped_array.length) || !unwrapped_array.every(item => item))
      // Haven't finished rendering yet in case of "async" rendering, so don't freeze the elements yet
      return;
    // placeholders have finished rendering, freeze the elements
    // here we might receive the result of a promise that has already been received, tore down and put into cached_placeholder_element, so don't overwrite that more valid result if it's already set
    $bdd80c7862246dc2$var$cachedPlaceholderElements[placeholderCacheKey_] || ($bdd80c7862246dc2$var$cachedPlaceholderElements[placeholderCacheKey_] = get_cloned_placeholders(unwrapped_array)); // Clone initial return value so that who gave us the elements can't mutate them, which has caused issues before with react
    $bdd80c7862246dc2$var$renderingCachedPlaceholderElement[placeholderCacheKey_] = undefined;
    dispose_original_copy(); // So that this memo will never re-run and the placeholder rendering function can clean up
    return get_cloned_placeholders(); // clone, just in case. If we wouldn't, someone could modify the copy in the DOM, and it would affect the cached version
  });
}

/*
 * Usually product templates are somewhat height-elastic depending on the content, i.e. if the title is longer we might up to two extra rows for this. That means that the placeholders almost never will reflect the size of the actual content when we do scroll restoration. This magic number specifies how many extra placeholders we should render everytime to compensate for this, since if the placeholders are in total shorter than the old scroll location the scroll restoration won't work.
 */
const $981356a8bf29ad72$export$6c9030e511152266 = 30;

/** @jsxImportSource solid-js */

function $6d2962bc9370f884$export$5e4aed86c12acdd9(_ref) {
  let {
    percentage_in_view_: percentage_in_view_,
    set_extra_displays_: set_extra_displays_,
    all_products_loaded_: all_products_loaded_,
    plp_results_: plp_results_,
    min_products_to_fetch_: min_products_to_fetch_,
    query_base_: query_base_,
    depict_api_: depict_api_
  } = _ref;
  let last_loaded = +new Date();
  let is_loading_more = false;
  let is_first_load = true;
  const [get_last_cursor, set_last_cursor] = $8tj43$createSignal();
  $8tj43$createComputed($8tj43$on(plp_results_, () => set_extra_displays_([]), {
    defer: true
  })); // empty array when a new request has completed (don't run this initially since it will already be empty)
  $8tj43$createComputed(() => {
    var _plp_results_;
    set_last_cursor((_plp_results_ = plp_results_()) === null || _plp_results_ === void 0 ? void 0 : _plp_results_.cursor);
    last_loaded = +new Date();
    is_first_load = true;
  });
  // percentage_in_view_ has equals: false so it should update even when set to the same value. That is to make sure that if the user bounces around below the "viewport" of our product listing we still start fetching as soon as is_loading_more becomes false again and we get IntersectionObserverEntries
  $8tj43$createEffect($8tj43$catchify1(async () => {
    const be_above_percentage = is_first_load ? 50 : 75; // if first load, load earlier
    if (percentage_in_view_() < be_above_percentage || is_loading_more) return;
    if (!get_last_cursor()) {
      // dlog("All results loaded, can't load more");
      all_products_loaded_ === null || all_products_loaded_ === void 0 || all_products_loaded_[1](true); // This is unset in SearchPage as we start fetching new results
      return;
    }
    // dlog("More than ", be_above_percentage, "% in view, ", percentage_in_view_(), "%, loading more");
    is_loading_more = true;
    const base_part = $8tj43$untrack(query_base_);
    const now = +new Date();
    // load faster if someone is scrolling aggressively
    const number_of_results_to_load = is_first_load ?
    // After first load, always just load 20 since people might just be browsing the top ones still
    min_products_to_fetch_ : now - last_loaded < 10000 ? min_products_to_fetch_ * 5 : min_products_to_fetch_;
    // dlog("loading ", number_of_results_to_load, "products, because it was", now - last_loaded, "ms since last load");
    const api_response = await depict_api_["query" in base_part ? "query" : "get_listing_products"]({
      cursor: get_last_cursor(),
      limit: number_of_results_to_load,
      ...base_part
    });
    const new_displays = (api_response === null || api_response === void 0 ? void 0 : api_response.displays) || [];
    set_extra_displays_(old_value => {
      // We want this to go fast. The apply method is the fastest way to add to an array, and AFAIK it's faster to add than to create a new one.
      // eslint-disable-next-line prefer-spread
      old_value.push.apply(old_value, new_displays);
      return old_value;
    });
    set_last_cursor(api_response.cursor);
    is_loading_more = false;
    last_loaded = +new Date();
    is_first_load = false;
  }));
}
function $e6dd9dfff4603d8c$export$63dd0350f8559dda(_ref) {
  let {
    displays_by_key_: displays_by_key_,
    get_last_result_in_viewport_: get_last_result_in_viewport_,
    index_to_target_map_: index_to_target_map_,
    is_loading_: is_loading_,
    get_extra_displays: get_extra_displays,
    isSliderLayout_: isSliderLayout_
  } = _ref;
  const [get_has_rendered_toggle, set_has_rendered_toggle] = $8tj43$createSignal(false);
  $8tj43$createEffect(() => {
    // We need this to run after the "render phase"
    get_extra_displays();
    set_has_rendered_toggle(old => !old);
  });
  return $8tj43$createMemo(() => {
    const last = get_last_result_in_viewport_();
    // Check if we are past (below) the last result, in that case we want it to count as 100% for a better infinite scroll experience
    past_last_result_check: {
      const elements_of_last_result = index_to_target_map_.get(index_to_target_map_.size - 1);
      if (!elements_of_last_result || isSliderLayout_()) break past_last_result_check;
      if ($8tj43$untrack(is_loading_)) {
        // We're loading, wait check again after we have inserted our new results
        get_has_rendered_toggle();
        break past_last_result_check;
      }
      for (const element of elements_of_last_result) {
        if (document.documentElement.contains(element) && element.getBoundingClientRect().top <= 0)
          // dlog(element, "which is of last product card is in or above viewport, probably loading more");
          return 100;
      }
    }
    if (isNaN(last)) return 0;
    if (Math.abs(last) === Infinity)
      // No product card in view and not after last card, assume first card
      return 0;
    return last / displays_by_key_().size * 100;
  }, undefined, {
    equals: false
  });
}

/**
 * Gets product_id (the thing we key the rendering on) from a display
 */
function $6a4c7ed6d005505c$export$548d053aba053d79(display) {
  if ("variant_index" in display) {
    const actual_display = display.variant_displays[display.variant_index];
    return actual_display.product_id;
  }
  if ("listing_id" in display) return display.listing_id;
  return display.product_id;
}
const $1e69163caedaab4e$var$ProductCardIndexContext = /*@__PURE__*/$8tj43$createContext();
function $1e69163caedaab4e$export$11354f017ddc9790(props) {
  return $8tj43$createComponent($1e69163caedaab4e$var$ProductCardIndexContext.Provider, {
    get value() {
      return props.index_;
    },
    get children() {
      return props.children;
    }
  });
}
function $1e69163caedaab4e$export$e3faf4d95300054f() {
  return $8tj43$useContext($1e69163caedaab4e$var$ProductCardIndexContext);
}

/**
 * This is a function that will safely clone an object that may contain promises.
 * It will use structuredClone to clone the object and then re-apply (copy) any promises that were in the original object to the cloned object.
 * @param obj Anything to clone
 */
function $6d75ec14f537c37f$export$83bb9af5671e1dbe(obj) {
  if (obj instanceof Promise) return obj;
  // Extract all promises, keep a map of them, and then re-apply them to both the original object and the target object after cloning
  const seen = new Set();
  const keyStack = [[]];
  const valueStack = [obj];
  const promiseLocationStack = [];
  while (valueStack.length) {
    const value = valueStack.pop();
    const keyPath = keyStack.pop();
    // Promises can only be in objects and we don't need to check for objects we've already seen (like in circular references)
    if (typeof value !== "object" || value === null || seen.has(value)) continue;
    seen.add(value);
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const ourValue = value[i];
        const valuesKeyPath = [...keyPath, i];
        if (ourValue instanceof Promise) {
          promiseLocationStack.push([valuesKeyPath, ourValue]);
          delete value[i]; // This will leave a hole in the array, but it's fine since we'll put it back soon
          // This way both the indexes will be correct when putting the value back and our for loop doesn't get messed up
        } else {
          keyStack.push(valuesKeyPath);
          valueStack.push(ourValue);
        }
      }
      continue;
    }
    for (const innerKey in value) {
      const ourValue = value[innerKey];
      const valuesKeyPath = [...keyPath, innerKey];
      if (ourValue instanceof Promise) {
        promiseLocationStack.push([valuesKeyPath, ourValue]);
        delete value[innerKey];
      } else {
        keyStack.push(valuesKeyPath);
        valueStack.push(ourValue);
      }
    }
  }
  let structuredClonedObject;
  let error;
  try {
    structuredClonedObject = structuredClone(obj);
  } catch (e) {
    // We still need to put back the promises in the original object, even if we threw an error
    error = e;
  }
  // Put back the promises in both the original object and the cloned object
  while (promiseLocationStack.length) {
    const [keyPath, promise] = promiseLocationStack.pop();
    let targetInClone = structuredClonedObject;
    let targetInOriginal = obj;
    for (let i = 0; i < keyPath.length - 1; i++) {
      if (!error) targetInClone = targetInClone[keyPath[i]];
      targetInOriginal = targetInOriginal[keyPath[i]];
    }
    if (!error) targetInClone[keyPath[keyPath.length - 1]] = promise;
    targetInOriginal[keyPath[keyPath.length - 1]] = promise;
  }
  if (error) throw error;
  return structuredClonedObject;
}
let $2d7bad8684bc7f44$var$printedCloneError = false;
function $2d7bad8684bc7f44$export$7f8bd308237ab5a5(get_displays_) {
  const displays_by_key_ = $8tj43$createMemo(() => {
    const displays = get_displays_();
    // We key by product_id because that's what can be used to uniquely identify products
    // This way <For> can optimize the rendering
    const map = new Map();
    for (let i = 0; i < displays.length; i++) {
      const display = displays[i];
      const product_id = $6a4c7ed6d005505c$export$548d053aba053d79(display);
      map.set(product_id, display);
    }
    return map;
  });
  return displays_by_key_;
}
const $2d7bad8684bc7f44$var$result_ids = ["search_result_id", "product_listing_result_id", "recommendation_id"];
function $2d7bad8684bc7f44$export$43f0fb951fcb0c54(_ref) {
  let {
    displays_by_key_: displays_by_key_,
    product_card_template_: product_card_template_,
    do_per_elements_: do_per_elements_,
    content_blocks_: content_blocks_
  } = _ref;
  return $8tj43$createComponent((0, $8tj43$For), {
    get each() {
      return [...displays_by_key_().keys()];
    },
    children: (product_id, index) => {
      const owner = $8tj43$getOwner();
      const possible_content_block = $8tj43$createMemo(() => {
        var _content_blocks_, _content_blocks_2;
        return content_blocks_ === null || content_blocks_ === void 0 ? void 0 : (_content_blocks_ = content_blocks_()) === null || _content_blocks_ === void 0 ? void 0 : (_content_blocks_2 = _content_blocks_()) === null || _content_blocks_2 === void 0 ? void 0 : _content_blocks_2[index()];
      });
      const display_accessor = $8tj43$createMemo(prev => {
        const new_display = displays_by_key_().get(product_id);
        if (prev && $2d7bad8684bc7f44$var$deep_equal(prev, new_display))
          // If displays are identical, they haven't changed due to merchant/market changing OR we made a new query and the displays are the same. Return the old display (same object reference) to avoid re-rendering.
          // This doesn't work if people mutate the displays from within the template but we hope they don't
          // (We can't know if the display changing is due to merchant/market changing or a new query otherwise and don't want to run into https://gitlab.com/depict-ai/depict.ai/-/merge_requests/6890/diffs)
          return prev;
        return new_display;
      });
      const [product_card_resource] = $8tj43$createResource(display_accessor,
      // re-render when the reference to the display object changes
      display => {
        // It's easy for merchants to accidentally mutate the display or some sub-object thereof
        // We had a case on singular where they popped an image url and due to use caching after some time there was no image
        // Attempt cloning the displays if possible (99.9% of the cases probably) and if not, just use the original display
        try {
          // Use promiseSafeStructuredClone so that:
          // 1. When fetching for example prices from an API, one can start that API request
          // 2. Add the promise to the display
          // 3. Already render the product card with placeholders for prices while the price loads
          // 4. When the price loads, re-render the display with the new price
          display = $6d75ec14f537c37f$export$83bb9af5671e1dbe(display);
        } catch (e) {
          if (!$2d7bad8684bc7f44$var$printedCloneError) {
            $2d7bad8684bc7f44$var$printedCloneError = true;
            $8tj43$dlog("Can't clone display", display, " (uncloneable objects in it), make sure you don't mutate it in the template since we cache.", e);
          }
        }
        let renderingResult;
        // Wrap the product card in a ProductCardIndexProvider so that the index is available to the product card
        // This is wo we can do intelligent image loading in ShopifyContainedImage without shopify devs having to pass in the index
        // We don't care about the return value of ProductCardIndexProvider because our rendering result might be a promise which solid doesn't support until it has gone through createResource
        $1e69163caedaab4e$export$11354f017ddc9790({
          index_: index,
          get children() {
            // This is the key - the functions called inside of the children getter of the provider are the one that have the context defined in their solid-internal Owner
            renderingResult = product_card_template_(display, {
              set_on_index_change: fn => $8tj43$runWithOwner(owner, () => $8tj43$createEffect(() => fn(index())))
            });
            return undefined; // just to satisfy the typing
          }
        });
        // renderingResult is guaranteed to be defined here (if rendering returned something) because the children getter of ProductCardIndexProvider is called synchronously (createRenderEffect is used solid-internally)
        return renderingResult;
      });
      const node_accessor = $cb64b315b25cfc59$export$2f0cbfbb4354bb52(product_card_resource);
      $8tj43$createEffect(() => {
        const product_card_nodes = node_accessor();
        const display = display_accessor();
        const elements = [];
        for (let i = 0; i < product_card_nodes.length; i++) {
          const element = product_card_nodes[i];
          if (!(element instanceof Element)) continue;
          elements.push(element);
          // Add tracking ids
          if (!(element instanceof HTMLElement)) continue; // Apparently only HTMLElements have dataset
          for (let i = 0; i < $2d7bad8684bc7f44$var$result_ids.length; i++) {
            const id = $2d7bad8684bc7f44$var$result_ids[i];
            const value = display[id];
            if (value) Object.assign(element.dataset, $8tj43$camelCasifyObject({
              [id]: value
            }));
          }
        }
        do_per_elements_ === null || do_per_elements_ === void 0 || do_per_elements_(elements, index);
      });
      return [
      // Show content block before product card, so it's *at* that index
      possible_content_block, node_accessor // Don't return product_card_resource as calling it could be creating the nodes which would mean we'd be double-creating the nodes,
      ]; // Regarding the as unknown shenanigans: https://github.com/solidjs/solid/releases/tag/v1.7.0
    }
  });
}
// source: https://medium.com/@pancemarko/deep-equality-in-javascript-determining-if-two-objects-are-equal-bf98cf47e934
// deeply diffs two objects
// Modified by chatGPT to not be recursive, since stiga was getting a stack overflow just due to the size of their data
// Modified futher to bias towards saying objects are equal non-primitive objects differ
function $2d7bad8684bc7f44$var$deep_equal(obj1, obj2) {
  const stack = [[obj1, obj2]];
  while (stack.length) {
    const [currentObj1, currentObj2] = stack.pop();
    if (currentObj1 === currentObj2) continue;
    if (Array.isArray(currentObj1) && Array.isArray(currentObj2)) {
      if (currentObj1.length !== currentObj2.length) return false;
      for (let i = 0; i < currentObj1.length; i++) stack.push([currentObj1[i], currentObj2[i]]);
    } else if (typeof currentObj1 === "object" && typeof currentObj2 === "object" && currentObj1 !== null && currentObj2 !== null) {
      if (Array.isArray(currentObj1) || Array.isArray(currentObj2)) return false;
      const keys1 = Object.keys(currentObj1);
      const keys2 = Object.keys(currentObj2);
      if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) return false;
      for (let key in currentObj1) {
        if ($2d7bad8684bc7f44$var$result_ids.includes(key)) continue; // ignore comparing values for keys we know are changing with every request
        stack.push([currentObj1[key], currentObj2[key]]);
      }
    } else if (typeof currentObj1 !== "function" && typeof currentObj2 !== "function")
      // Claim that all functions are equal, since the only way a function ends up here is because someone added it in the displayTransformer and that shouldn't force us to re-render, right?
      return false;
  }
  return true;
}
const $618bd53ea0a41cd4$export$f223d69ed12f5fb7 = /*@__PURE__*/$8tj43$createContext();
function $618bd53ea0a41cd4$export$4a14175d33d81a96(_ref) {
  let {
    displays_by_key_: displays_by_key_,
    product_card_template_: product_card_template_,
    content_blocks_: content_blocks_,
    alwaysObserveCards_: alwaysObserveCards_
  } = _ref;
  const targetToIndexMap_ = new Map();
  const indexToTargetMap_ = new Map();
  const [listenersForIntersecting, setListenersForIntersecting] = $8tj43$createSignal(0);
  const [currentlyIntersecting, setCurrentlyIntersecting] = $8tj43$createSignal(new Set(), {
    equals: false
  });
  if (0, $8tj43$isServer) return {
    renderedDisplays_: $2d7bad8684bc7f44$export$43f0fb951fcb0c54({
      displays_by_key_: displays_by_key_,
      product_card_template_: product_card_template_,
      content_blocks_: content_blocks_
    }),
    indexToTargetMap_: indexToTargetMap_,
    currentlyIntersecting: currentlyIntersecting
  };
  // The following sets up an intersection observer to determine which results are in the viewport, used for the ScrollStatus indicator, knowing when to load more and any other consumer of the useProductCardIsVisible hook.
  const shouldObserve = $8tj43$createMemo(() => alwaysObserveCards_ || listenersForIntersecting() > 0);
  const intersection_observer = new IntersectionObserver($8tj43$catchify1(records => {
    const intersectingValue = currentlyIntersecting();
    for (let i = 0; i < records.length; i++) {
      const record = records[i];
      const {
        target: target,
        intersectionRatio: intersectionRatio
      } = record;
      const index_of_target = targetToIndexMap_.get(target);
      if (index_of_target == undefined) return; // It seems like it can happen that we get IntersectionObserverEntries after the onCleanup function for a recommendation card has run, in Firefox. Probably a bug in Firefox? If I understood the bug correctly, this is a workaround.
      const is_in_set = intersectingValue.has(index_of_target);
      if (intersectionRatio > 0) {
        if (!is_in_set) intersectingValue.add(index_of_target);
      } else if (is_in_set) intersectingValue.delete(index_of_target);
    }
    setCurrentlyIntersecting(intersectingValue);
  }, "renderDisplays IO failed"));
  const renderedDisplays_ = $8tj43$createComponent($618bd53ea0a41cd4$export$f223d69ed12f5fb7.Provider, {
    value: {
      currentlyIntersecting_: currentlyIntersecting,
      setIsListening_: setListenersForIntersecting
    },
    get children() {
      return $2d7bad8684bc7f44$export$43f0fb951fcb0c54({
        displays_by_key_: displays_by_key_,
        product_card_template_: product_card_template_,
        content_blocks_: content_blocks_,
        do_per_elements_: (elements, index_accessor) =>
        // Adds/removes elements from the "results in viewport" intersection observer above
        $8tj43$createEffect(() => {
          if (!shouldObserve()) return;
          const display_index = index_accessor();
          // Nested createEffect because we only want to re-run this when the index changes (or we should/shouldn't observe)
          // We need to save in a map which index the elements of this template are so that we can know that in the IntersectionObserver callback
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            targetToIndexMap_.set(element, display_index);
            intersection_observer.observe(element);
            $8tj43$onCleanup(() => {
              intersection_observer.unobserve(element);
              targetToIndexMap_.delete(element);
              const intersecting = $8tj43$untrack(currentlyIntersecting);
              const wasDeleted = intersecting.delete(display_index);
              if (wasDeleted) setCurrentlyIntersecting(intersecting);
            });
          }
          indexToTargetMap_.set(display_index, elements);
          $8tj43$onCleanup(() => indexToTargetMap_.delete(display_index));
        })
      });
    }
  });
  return {
    renderedDisplays_: renderedDisplays_,
    indexToTargetMap_: indexToTargetMap_,
    currentlyIntersecting: currentlyIntersecting
  };
}
function $618bd53ea0a41cd4$export$80bb7300ce6a8be3() {
  const {
    setIsListening_: setIsListening_,
    currentlyIntersecting_: currentlyIntersecting_
  } = $8tj43$useContext($618bd53ea0a41cd4$export$f223d69ed12f5fb7) || {};
  const getOurIndex = $1e69163caedaab4e$export$e3faf4d95300054f();
  const isVisible = $8tj43$createMemo(() => currentlyIntersecting_ === null || currentlyIntersecting_ === void 0 ? void 0 : currentlyIntersecting_().has(getOurIndex === null || getOurIndex === void 0 ? void 0 : getOurIndex()));
  setIsListening_ === null || setIsListening_ === void 0 || setIsListening_(prev => prev + 1);
  $8tj43$onCleanup(() => setIsListening_ === null || setIsListening_ === void 0 ? void 0 : setIsListening_(prev => prev + 1));
  return isVisible;
}
function $45a8953d760b5e58$export$a1fd619a4743ca08(_ref) {
  let {
    plp_results_: plp_results_,
    product_card_template_: product_card_template_,
    first_result_in_viewport_: [, setFirstResultInViewport],
    last_result_in_viewport_: [lastResultInViewport, setLastResultsInViewport],
    all_products_loaded_: all_products_loaded_,
    min_products_to_fetch_: min_products_to_fetch_,
    query_base_: query_base_,
    depict_api_: depict_api_,
    is_loading_: is_loading_,
    content_blocks_: content_blocks_,
    setCurrentlyLoadedDisplays_: setCurrentlyLoadedDisplays_,
    isSliderLayout_: isSliderLayout_
  } = _ref;
  // Although typing doesn't reflect it, plp_results is guaranteed to contain an array of at least one display at this point
  const [get_extra_displays, set_extra_displays_] = $8tj43$createSignal([], {
    equals: false
  });
  const displays_by_key_ = $2d7bad8684bc7f44$export$7f8bd308237ab5a5($8tj43$createMemo(() => {
    var _plp_results_;
    return [...(((_plp_results_ = plp_results_()) === null || _plp_results_ === void 0 ? void 0 : _plp_results_.displays) || []), ...get_extra_displays()];
  }));
  const {
    indexToTargetMap_: indexToTargetMap_,
    renderedDisplays_: renderedDisplays_,
    currentlyIntersecting: currentlyIntersecting
  } = $618bd53ea0a41cd4$export$4a14175d33d81a96({
    displays_by_key_: displays_by_key_,
    product_card_template_: product_card_template_,
    content_blocks_: content_blocks_,
    alwaysObserveCards_: true
  });
  const percentage_in_view_ = $e6dd9dfff4603d8c$export$63dd0350f8559dda({
    get_last_result_in_viewport_: lastResultInViewport,
    displays_by_key_: displays_by_key_,
    index_to_target_map_: indexToTargetMap_,
    is_loading_: is_loading_,
    get_extra_displays: get_extra_displays,
    isSliderLayout_: isSliderLayout_
  });
  $8tj43$createComputed(() => setCurrentlyLoadedDisplays_(displays_by_key_().size));
  $6d2962bc9370f884$export$5e4aed86c12acdd9({
    percentage_in_view_: percentage_in_view_,
    set_extra_displays_: set_extra_displays_,
    all_products_loaded_: all_products_loaded_,
    plp_results_: plp_results_,
    min_products_to_fetch_: min_products_to_fetch_,
    query_base_: query_base_,
    depict_api_: depict_api_
  });
  $8tj43$createEffect(() => {
    const intersecting = currentlyIntersecting();
    setFirstResultInViewport(Math.min(...intersecting) + 1); // +1 because we want to start counting at 1
    setLastResultsInViewport(Math.max(...intersecting) + 1);
  });
  return renderedDisplays_;
}
var $63f1f8dbcd07d3b0$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`),
  $63f1f8dbcd07d3b0$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<style type=text/css>`);
function $63f1f8dbcd07d3b0$export$d21e32dfedac04be(props) {
  const container_class = "x" + $8tj43$createUniqueId();
  const container_element_ = (() => {
    var _el$ = $8tj43$getNextElement($63f1f8dbcd07d3b0$var$_tmpl$);
    $8tj43$spread(_el$, $8tj43$mergeProps1(() => props.element_attributes, {
      "classList": {
        [container_class]: true
      }
    }), false, true);
    $8tj43$insert(_el$, () => props.children);
    $8tj43$runHydrationEvents();
    return _el$;
  })(); // Don't want this in the error boundary below, it should only be for the actual layouting
  return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    get message_() {
      return "Failed calculating " + props.layout + " layout";
    },
    severity_: "error",
    get children() {
      return $63f1f8dbcd07d3b0$export$445d8d3f5f706a40(props, container_element_, false, container_class);
    }
  });
}
function $63f1f8dbcd07d3b0$export$445d8d3f5f706a40(props, container_element) {
  let insert_after_container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let container_class = arguments.length > 3 ? arguments[3] : undefined;
  if (!container_class) {
    // only try to add if it wasn't provided, so that we have a code path without classList when doing SSR
    container_class = $8tj43$make_random_classname();
    container_element.classList.add(container_class);
  }
  // Copy of Layout from utilishared but using solid-js signals instead of async iterable IPNS
  const show_all_rows = $8tj43$createMemo(() => props.rows === "all");
  const rows_or_empty_object = $8tj43$createMemo(() => show_all_rows() ? {} : props.rows);
  const view_more_button_elements = $cb64b315b25cfc59$export$2f0cbfbb4354bb52($8tj43$createMemo(() => rows_or_empty_object().button));
  const view_less_button_elements = $cb64b315b25cfc59$export$2f0cbfbb4354bb52($8tj43$createMemo(() => rows_or_empty_object().view_less_button));
  const have_a_view_more_button = $8tj43$createMemo(() => {
    const button = view_more_button_elements();
    return !(!button || Array.isArray(button) && !button.length);
  });
  const have_a_view_less_button = $8tj43$createMemo(() => {
    const button = view_less_button_elements();
    return !(!button || Array.isArray(button) && !button.length);
  });
  const [get_styling, set_styling] = $8tj43$createSignal();
  const selector_beginning = ".depict .".concat(container_class, ">"); // class so ppl can have id if needed
  const [get_children_count, set_children_count] = $8tj43$createSignal(0);
  const update_children_count = () => (0, $8tj43$isServer) ? 20 : set_children_count(container_element.children.length);
  const col_styling = $8tj43$createMemo(() => $8tj43$n_col_styling_with_dist(selector_beginning, props.grid_spacing, props.cols_at_size, props.layout, props.override_vertical_spacing));
  const default_currently_visible_signal = $8tj43$createSignal($8tj43$untrack(() => {
    var _ref, _rows_or_empty_object;
    return (_ref = (_rows_or_empty_object = rows_or_empty_object().start_rows) !== null && _rows_or_empty_object !== void 0 ? _rows_or_empty_object : rows_or_empty_object().max_rows) !== null && _ref !== void 0 ? _ref : 1;
  })); // Keep this signal here, so it doesn't change when rows_or_empty_object and I think it's to be expected that the "internal default signal" stays the same
  const rows_visible_signal = $8tj43$createMemo(() => rows_or_empty_object().currently_visible || default_currently_visible_signal);
  const get_rows_visible = $8tj43$createMemo(() => rows_visible_signal()[0]());
  const set_rows_visible = $8tj43$createMemo(() => rows_visible_signal()[1]);
  const view_more_button_class = "m" + $8tj43$createUniqueId();
  const view_less_button_class = "l" + $8tj43$createUniqueId(); //  https://github.com/solidjs/solid-docs/issues/263#issuecomment-1622388079
  const view_more_button_container = $8tj43$createMemo(() => have_a_view_more_button() && (() => {
    var _el$2 = $8tj43$getNextElement($63f1f8dbcd07d3b0$var$_tmpl$);
    $8tj43$addEventListener(_el$2, "click", $8tj43$catchify1(() => set_rows_visible()(prev => {
      var _rows_or_empty_object2;
      return prev + ((_rows_or_empty_object2 = rows_or_empty_object().rows_per_click) !== null && _rows_or_empty_object2 !== void 0 ? _rows_or_empty_object2 : 1);
    })), true);
    $8tj43$className(_el$2, "load-more-container ".concat(view_more_button_class));
    $8tj43$insert(_el$2, () => rows_or_empty_object().button);
    $8tj43$runHydrationEvents();
    return _el$2;
  })());
  // We need to have duplicate buttons because which ones is shown depends on the number of rows visible and therefore on the viewport size and therefore on the css media queries
  const view_less_button_container = $8tj43$createMemo(() => have_a_view_less_button() && (() => {
    var _el$3 = $8tj43$getNextElement($63f1f8dbcd07d3b0$var$_tmpl$);
    $8tj43$addEventListener(_el$3, "click", $8tj43$catchify1(() => set_rows_visible()(() => {
      var _rows_or_empty_object3;
      return (_rows_or_empty_object3 = rows_or_empty_object().start_rows) !== null && _rows_or_empty_object3 !== void 0 ? _rows_or_empty_object3 : 1;
    })), true);
    $8tj43$className(_el$3, "load-less-container ".concat(view_less_button_class));
    $8tj43$insert(_el$3, () => rows_or_empty_object().view_less_button);
    $8tj43$runHydrationEvents();
    return _el$3;
  })());
  const [force_style_update, set_force_style_update] = $8tj43$createSignal("");
  $8tj43$createComputed(() => {
    // Make sure we don't have more rows visible than max_rows (this could happen by max_rows being decreased)
    const rows_visible = get_rows_visible();
    const max_rows = rows_or_empty_object().max_rows;
    if (!isNaN(max_rows) && max_rows >= 0 && rows_visible > max_rows) set_rows_visible()(max_rows);
  });
  $8tj43$createEffect(() => set_force_style_update(" ")); // force style update after hydration due to https://discord.com/channels/722131463138705510/722167424186843267/1151544212517552168
  $8tj43$createRenderEffect(() => {
    // Be careful to only read show_all_rows in here (ofc doesn't apply to nested effects)
    if (show_all_rows()) {
      // no view more functionality requested
      set_styling(() => col_styling);
      return;
    }
    update_children_count();
    if (!(0, $8tj43$isServer)) {
      const mutation_observer = new MutationObserver($8tj43$catchify1(update_children_count));
      mutation_observer.observe(container_element, {
        childList: true
      });
      $8tj43$onCleanup(() => mutation_observer.disconnect());
    }
    set_styling(
    // this is needed because solid will think that the memo-accessor is a setter function otherwise
    () => $8tj43$createMemo(() => {
      const {
        rows_per_click: rows_per_click,
        max_rows = -1,
        start_rows: start_rows
      } = rows_or_empty_object();
      const rows_visible = get_rows_visible();
      const children_count = get_children_count();
      return force_style_update() + col_styling() + props.cols_at_size.map(options => {
        const [recs_per_row, min, max] = options;
        let should_hide_view_more_button;
        let visible_recs;
        if (props.disable_partial_rows) {
          visible_recs = $8tj43$layout_get_visible_recs_without_partial_rows(rows_visible, children_count, options);
          const visible_recs_next_show_more = $8tj43$layout_get_visible_recs_without_partial_rows(rows_visible + (rows_per_click || 0),
          // Should this really be zero when we default rows_per_click to 1?
          children_count, options);
          should_hide_view_more_button = visible_recs === visible_recs_next_show_more;
        } else {
          visible_recs = $8tj43$layout_get_total_rec_amount_for_row(rows_visible, options);
          should_hide_view_more_button = visible_recs >= children_count;
        }
        const should_hide_button_final = should_hide_view_more_button || max_rows !== -1 && rows_visible >= max_rows;
        // I don't really understand the logic for when the view more button gets hidden so IDK if below is correct, but it works how it should for now
        const should_hide_view_less_button = !should_hide_view_more_button || start_rows == undefined || rows_visible <= start_rows || children_count <= recs_per_row * start_rows;
        return "".concat($8tj43$layout_media_query_header(min, max), "{").concat(selector_beginning, ":nth-child(n+").concat(visible_recs + 1, "){display:none}").concat(props.layout == "slider" ? "".concat(selector_beginning, ":nth-child(n+").concat(visible_recs, "){margin-right:0}") : "").concat(should_hide_button_final ? ".depict .".concat(view_more_button_class, "{display:none!important}") : "").concat(should_hide_view_less_button ? ".depict .".concat(view_less_button_class, "{display:none!important}") : "", "}");
      }).join("");
    }));
  });
  const style_element = (() => {
    var _el$4 = $8tj43$getNextElement($63f1f8dbcd07d3b0$var$_tmpl$2);
    $8tj43$insert(_el$4, get_styling);
    return _el$4;
  })(); // need to create this after set_styling has been called or else there will be no styling in the SSR'd output
  if (insert_after_container) container_element.after(style_element);
  return [container_element, $8tj43$memo(view_more_button_container), $8tj43$memo(view_less_button_container), style_element];
}
$8tj43$delegateEvents(["click"]);
var $64d94dcaa058dc7b$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`),
  $64d94dcaa058dc7b$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<style type=text/css>`);
const $64d94dcaa058dc7b$export$c500183c31c2b22e = "--spans-columns";
function $64d94dcaa058dc7b$export$ab6b147eec64fea5(props) {
  const container_class = "x" + $8tj43$createUniqueId();
  const container_element_ = (() => {
    var _el$ = $8tj43$getNextElement($64d94dcaa058dc7b$var$_tmpl$);
    $8tj43$spread(_el$, $8tj43$mergeProps1(() => props.element_attributes, {
      "classList": {
        [container_class]: true
      }
    }), false, true);
    $8tj43$insert(_el$, () => props.children);
    $8tj43$runHydrationEvents();
    return _el$;
  })(); // Don't want this in the error boundary below, it should only be for the actual layouting
  return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    message_: "Failed calculating css grid layout",
    severity_: "error",
    get children() {
      return $64d94dcaa058dc7b$export$e2f22da34aaf310a(props, container_element_, false, container_class);
    }
  });
}
function $64d94dcaa058dc7b$export$e2f22da34aaf310a(props, container_element) {
  let insert_after_container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let container_class = arguments.length > 3 ? arguments[3] : undefined;
  if (!container_class) {
    // only try to add if it wasn't provided, so that we have a code path without classList when doing SSR
    container_class = $8tj43$make_random_classname();
    container_element.classList.add(container_class);
  }
  const container_selector = ".depict .".concat(container_class); // class so ppl can have id if needed
  const col_styling = $8tj43$createMemo(() => $64d94dcaa058dc7b$var$generate_media_queried_declarations({
    container_selector_: container_selector,
    default_grid_spacing_text: props.grid_spacing,
    cols_at_size_: props.cols_at_size,
    override_vertical_spacing_: props.override_vertical_spacing,
    top_row_shortened_by_: props.top_row_shortened_by_()
  }));
  const base_styling = $8tj43$createMemo(() => {
    return "".concat(container_selector, "{display:grid;}");
  });
  const get_styling = $8tj43$createMemo(() => base_styling() + col_styling());
  const style_element = (() => {
    var _el$2 = $8tj43$getNextElement($64d94dcaa058dc7b$var$_tmpl$2);
    $8tj43$insert(_el$2, get_styling);
    return _el$2;
  })(); // need to create this after set_styling has been called or else there will be no styling in the SSR'd output
  if (insert_after_container) container_element.after(style_element);
  return [container_element, style_element];
}
function $64d94dcaa058dc7b$var$generate_media_queried_declarations(_ref) {
  let {
    container_selector_: container_selector_,
    default_grid_spacing_text: default_grid_spacing_text,
    cols_at_size_: cols_at_size_,
    override_vertical_spacing_: override_vertical_spacing_,
    top_row_shortened_by_: top_row_shortened_by_
  } = _ref;
  return cols_at_size_.map(options => {
    const [n_cols, min, max, grid_spacing_for_size] = options;
    const main_spacing_to_use = grid_spacing_for_size || default_grid_spacing_text;
    // See comment in else block below
    const can_use_gap = override_vertical_spacing_ ? $64d94dcaa058dc7b$var$can_use_gap_for_unit(override_vertical_spacing_) : $64d94dcaa058dc7b$var$can_use_gap_for_unit(main_spacing_to_use);
    let spacing_styling;
    let additional_styling = ""; // outside the media query
    if (can_use_gap) spacing_styling = "gap:".concat(main_spacing_to_use, ";").concat(override_vertical_spacing_ ? "row-gap:".concat(override_vertical_spacing_, ";") : "");else {
      // When using percent units, which our default styling does (because convenient) and our interface relies on (hard to specify different gaps for different screen sizes)
      // row gaps in grids are relative to the whole height of the grid, maybe see also https://stackoverflow.com/a/53563865. The issue with that is that as we load more products, the gap grows. Also, it breaks existing integrations.
      // Logical thought: use margins for the vertical spacing. But margins in grids are apparently relative to the size of the individual items in grids.
      // Given that, and that content blocks can be of different width, we have to do some complicated calculations to convert the provided gap, which is in gap of the total container width, to a margin of the individual items.
      const vertical_spacing_to_use = override_vertical_spacing_ !== null && override_vertical_spacing_ !== void 0 ? override_vertical_spacing_ : main_spacing_to_use;
      const width_multiplier = "var(".concat($64d94dcaa058dc7b$export$c500183c31c2b22e, ", 1)"); // How many cards wide the current item is (needed because content blocks)
      const one_item_width_exclusing_gaps = "calc(calc(100 / ".concat(n_cols, ") - calc(calc(").concat(n_cols * 2 - 2, " * calc(").concat($64d94dcaa058dc7b$var$strip_percent_unit(vertical_spacing_to_use), " / 2)) / ").concat(n_cols, "))"); // Width of one item in percent of the whole
      // Equation from layout.tsx, also used in CheckboxGrid. Needs half spacing for some reason
      const this_item_width_meat = "calc(".concat(one_item_width_exclusing_gaps, " * ").concat(width_multiplier, ")"); // Width of just the card
      const this_item_width_gaps = "calc(calc(".concat(width_multiplier, " - 1) * ").concat($64d94dcaa058dc7b$var$strip_percent_unit(vertical_spacing_to_use), ")"); // Width of the gaps
      const this_item_width = "calc(".concat(this_item_width_meat, " + ").concat(this_item_width_gaps, ")"); // Width of this item including gaps
      // this_item_width needs to be unitless, and since plain css can't do calc(40% / 5%) which would become unitless we need to strip all units in the calculations before
      const convert_top_spacing_to_item_width_percentage = spacing => "calc(calc(100 / ".concat(this_item_width, ") * ").concat(spacing, ")"); // Now finally we can convert the desired spacing to a percentage of this individual item's width (including gaps that would be there but aren't because content blocks span them)
      spacing_styling = "column-gap:".concat(main_spacing_to_use, ";"); // Still use gaps in the horizontal direction because that works flawlessly
      // Re-use old layout code to get the correct :nth-child declarations for the top margins
      additional_styling = $8tj43$n_col_styling_with_dist(container_selector_ + ">", convert_top_spacing_to_item_width_percentage(default_grid_spacing_text), [[n_cols, min, max, grid_spacing_for_size ? convert_top_spacing_to_item_width_percentage(grid_spacing_for_size) : null]], "grid", override_vertical_spacing_ ? convert_top_spacing_to_item_width_percentage(override_vertical_spacing_) : override_vertical_spacing_, top_row_shortened_by_);
    }
    const media_query_body = "".concat(container_selector_, "{").concat(spacing_styling, "grid-template-columns:repeat(").concat(n_cols, ",minmax(0,1fr));}");
    return "".concat($8tj43$layout_media_query_header(min, max), "{").concat(media_query_body, "}").concat(additional_styling);
  }).join("");
}
function $64d94dcaa058dc7b$var$can_use_gap_for_unit(spacing) {
  const trimmed_spacing = spacing.trim();
  return !trimmed_spacing.includes("%");
}
function $64d94dcaa058dc7b$var$strip_percent_unit(css_value) {
  return css_value.replaceAll("%", "");
}
function $b2dbaafb23d00c7f$export$cb5808ba002cdeed(_ref) {
  let {
    layout_options_: layout_options_,
    sort_or_filter_open_: sort_or_filter_open_
  } = _ref;
  return $8tj43$createMemo(() => {
    const layout_options = layout_options_();
    // Add grid styling that changes when filters get opened/closed
    const when_filters_closed_cols = layout_options.cols_at_size;
    return sort_or_filter_open_() ? when_filters_closed_cols.map(row => {
      const [num_cols_default,,,, override_cols] = row;
      const cloned_row = [...row];
      // @ts-ignore
      cloned_row[0] = num_cols_default - 1;
      if (override_cols)
        // @ts-ignore
        cloned_row[4] = {
          overrides: Object.fromEntries(Object.entries(override_cols.overrides).map(_ref2 => {
            let [row, column] = _ref2;
            return [row, column - 1];
          }))
        };
      return cloned_row;
    }) : when_filters_closed_cols;
  });
}
function $40e2fa435715a1a0$export$a79e666719b3647c(cols_at_size_) {
  const size_active = $8tj43$createMemo(() => cols_at_size_().map(_ref => {
    let [n_cols, min_width, max_width] = _ref;
    const media_query = $8tj43$layout_media_query_header(min_width, max_width).replaceAll("@media", "");
    const matches = $00a5b94f0c11efbb$export$d9f36cf74e24d595(media_query);
    return [matches, n_cols];
  }));
  const n_cols_currently_showing = $8tj43$createMemo(() => {
    try {
      const [, n_cols_currently_showing] = size_active().find(_ref2 => {
        let [media_query] = _ref2;
        return media_query();
      });
      return n_cols_currently_showing;
    } catch (e) {
      $8tj43$dwarn("No active size found in columnsAtSize - can't render content blocks or looks");
      return null;
    }
  });
  return n_cols_currently_showing;
}
var $bc2337c9a05ecd18$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span>`);
function $bc2337c9a05ecd18$export$acb3eaade4b23afd(props) {
  // Work around https://github.com/solidjs/solid/issues/1980
  return (() => {
    var _el$ = $8tj43$getNextElement($bc2337c9a05ecd18$var$_tmpl$);
    $8tj43$effect(_p$ => {
      var _v$ = "".concat(props.class || "", " depict-placeholder"),
        _v$2 = props.style;
      _v$ !== _p$.e && $8tj43$className(_el$, _p$.e = _v$);
      _p$.t = $8tj43$style(_el$, _v$2, _p$.t);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}
function $3ab4aa97880fb88d$export$3f37af283f8fb843(props) {
  const style = $8tj43$createMemo(() => {
    const {
      style: style,
      height: height,
      width: width,
      aspectRatio: aspectRatio
    } = props;
    const is_image = aspectRatio != undefined;
    const size_data = is_image ? {
      width: "100%",
      "padding-bottom": "calc(calc(1 / ".concat(aspectRatio, ") * 100%)")
    } : {
      width: width,
      height: height
    };
    return {
      display: "block",
      ...(style || {}),
      ...size_data
    };
  });
  return $8tj43$createComponent((0, $bc2337c9a05ecd18$export$acb3eaade4b23afd), {
    get style() {
      return style();
    },
    get ["class"]() {
      return props.class;
    }
  });
}
var $ff7feae4dddd6073$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=content-block-wrapper>`);
function $ff7feae4dddd6073$export$791ef57e62e21c3f(_ref) {
  let {
    content_blocks_: incoming_content_blocks,
    cols_at_size_: cols_at_size_,
    set_top_row_shortened_by_: set_top_row_shortened_by_
  } = _ref;
  // these are by row
  const [content_blocks, set_content_blocks] = $8tj43$createStore([]);
  const n_cols_currently_showing_ = $40e2fa435715a1a0$export$a79e666719b3647c(cols_at_size_);
  $8tj43$createEffect(() => {
    const incoming_value = incoming_content_blocks();
    if (!incoming_value) {
      set_content_blocks([]);
      return;
    }
    set_content_blocks($8tj43$reconcile(incoming_value, {
      key: "content"
    })); // key: Make moving blocks faster, see https://github.com/solidjs/solid/issues/1925#issuecomment-1769671596
  });

  const get_wrapped_blocks_ = $ff7feae4dddd6073$var$wrap_blocks_in_div(content_blocks, n_cols_currently_showing_);
  $8tj43$createComputed(() => {
    // Update our styling if a content block forces some items that should be in the top row into a lower one, so we can generate margin-top declarations for them
    const top_row_block = get_wrapped_blocks_()[0];
    const blocks_in_top_row_taken = top_row_block === null || top_row_block === void 0 ? void 0 : top_row_block.span_columns;
    if (blocks_in_top_row_taken == undefined) {
      // Fall back to zero if no content block in top row, since then no blocks in top row are taken
      set_top_row_shortened_by_(0);
      return;
    }
    set_top_row_shortened_by_(blocks_in_top_row_taken - 1); // minus one because the content block wrapper also is an element
  });

  return $8tj43$createMemo(() => $ff7feae4dddd6073$export$92aa5d691d588f3f({
    wrapped_blocks_: get_wrapped_blocks_(),
    n_cols_currently_showing_: n_cols_currently_showing_()
  }).content_blocks_by_index_);
}
function $ff7feae4dddd6073$export$92aa5d691d588f3f(_ref2) {
  let {
    wrapped_blocks_: wrapped_blocks_,
    n_cols_currently_showing_: n_cols_currently_showing_
  } = _ref2;
  // This computation should be quite cheap since it just moves around things into an array
  const content_blocks_by_index_ = [];
  const constructed_block_arrays = new WeakSet();
  // Need to keep track of products displaced by blocks above when mapping rows to indexes in the actual grid
  const displaced_products_ = []; // undefined = is product, true = is content block if number instead of tuple number indicates content blocks in that row. Index in first array is row, index in second array is column
  if (!n_cols_currently_showing_)
    // Nope out of here if we don't know how many columns are showing
    return {
      content_blocks_by_index_: content_blocks_by_index_
    };
  for (let i = 0; i < wrapped_blocks_.length; i++) {
    // i = row to show at
    const block = wrapped_blocks_[i];
    if (!block) continue; // Array can have holes/not defined places
    const index_of_first_item_in_row = i * n_cols_currently_showing_;
    const index_of_last_item_in_row = index_of_first_item_in_row + n_cols_currently_showing_;
    const {
      span_rows: span_rows,
      position: position,
      span_columns: span_columns
    } = block; // span columns is already capped in the block wrapping step (wrap_blocks_in_div)
    let target_index;
    if (position === "left") target_index = index_of_first_item_in_row;else if (position === "right") target_index = index_of_last_item_in_row - span_columns;else if (position === "center") target_index = index_of_first_item_in_row + Math.floor((n_cols_currently_showing_ - span_columns) / 2);else throw new Error("Invalid position for content block - must be left, right or center: " + JSON.stringify(position));
    // Calculate displacement of us by content blocks above us
    let displacement_by_added_blocks = 0;
    for (let j = 0; j < i; j++) {
      const row = displaced_products_[j];
      if (row === undefined) continue; // there were no blocks in this row
      let displaced_items_in_row;
      if (typeof row === "number") displaced_items_in_row = row;else {
        displaced_items_in_row = row.filter(item => item).length;
        displaced_products_[j] = displaced_items_in_row;
      }
      displacement_by_added_blocks += displaced_items_in_row;
    }
    const index_of_us_in_row = target_index - index_of_first_item_in_row;
    for (let j = 0; j < index_of_us_in_row; j++) {
      var _displaced_products_$;
      if ((_displaced_products_$ = displaced_products_[i]) !== null && _displaced_products_$ !== void 0 && _displaced_products_$[j])
        // Add blocks in our *current* row to the displacement, but only the ones to our left
        displacement_by_added_blocks++;
    }
    // Add block to output array at the correct index
    const final_target_index = target_index - displacement_by_added_blocks;
    const existing_block = content_blocks_by_index_[final_target_index];
    const block_content = block.content;
    // If two blocks want to exist at the same location (can happen, for example if one block wants to be at the end of a row and the other one at the start of the next row) add an array with both
    if (existing_block) {
      if (constructed_block_arrays.has(existing_block))
        // Only push to arrays we have created to not create funky bugs when there's an array in JSX.Element
        existing_block.push(block_content);else {
        const array = [existing_block, block_content];
        constructed_block_arrays.add(array);
        content_blocks_by_index_[final_target_index] = array;
      }
    } else content_blocks_by_index_[final_target_index] = block_content;
    // Update displacement
    for (let j = 0; j < span_rows; j++) {
      var _ref3;
      const row = displaced_products_[_ref3 = i + j] || (displaced_products_[_ref3] = []);
      for (let k = index_of_us_in_row; k < index_of_us_in_row + span_columns; k++) row[k] = true;
    }
  }
  return {
    content_blocks_by_index_: content_blocks_by_index_,
    displaced_products_: displaced_products_
  };
}
/**
 * Takes a store that contains an array from where index is number of row and value is the result of executing the content block rendering function.
 * Then renders the content and wraps it into a div with the correct styling.
 * Also caps span_columns to max available columns
 */
function $ff7feae4dddd6073$var$wrap_blocks_in_div(rendered_content_blocks, max_span_columns) {
  const get_wrapped_blocks = $8tj43$mapArray(() => rendered_content_blocks, block => {
    if (!block) return;
    const final_span_columns = $8tj43$createMemo(() => {
      var _max_span_columns;
      return Math.min(block.span_columns, (_max_span_columns = max_span_columns()) !== null && _max_span_columns !== void 0 ? _max_span_columns : Infinity);
    });
    // If the item spans an entire row, limit the height to 1 row since there's no concept of "rows" if there are no products beside the block
    const final_span_rows = $8tj43$createMemo(() => final_span_columns() === max_span_columns() ? 1 : block.span_rows);
    const [rendering_delayed, set_rendering_delayed_] = $8tj43$createSignal(true);
    const content = $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !rendering_delayed();
      },
      get children() {
        var _el$ = $8tj43$getNextElement($ff7feae4dddd6073$var$_tmpl$);
        $8tj43$insert(_el$, $8tj43$createComponent($ff7feae4dddd6073$var$RenderContent, {
          get content() {
            return block.content;
          }
        }));
        $8tj43$effect(_p$ => {
          var _v$ = !!(final_span_columns() === max_span_columns()),
            _v$2 = {
              [(0, $64d94dcaa058dc7b$export$c500183c31c2b22e)]: final_span_columns()
            },
            _v$3 = "span ".concat(final_span_columns()),
            _v$4 = "span ".concat(final_span_rows());
          _v$ !== _p$.e && _el$.classList.toggle("spans-whole-row", _p$.e = _v$);
          _p$.t = $8tj43$style(_el$, _v$2, _p$.t);
          _v$3 !== _p$.a && ((_p$.a = _v$3) != null ? _el$.style.setProperty("grid-column", _v$3) : _el$.style.removeProperty("grid-column"));
          _v$4 !== _p$.o && ((_p$.o = _v$4) != null ? _el$.style.setProperty("grid-row", _v$4) : _el$.style.removeProperty("grid-row"));
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined,
          o: undefined
        });
        return _el$;
      }
    });
    return $8tj43$mergeProps(block, {
      // Create content divs for the blocks with as much fine-grained diffing as possible?
      content: () => {
        // Sneaky on-demand rendering, so we don't render more blocks than we can show: we have the rendered value here and don't return a function that renders because if our block would be moved around we'd be guaranteed to re-render
        // However, no need to count products to know if we should render: the <For> loops in Placeholders and render_displays will only call this function if there's actually a product here that wants to display this block
        set_rendering_delayed_(false);
        return content;
      },
      get span_columns() {
        // Cap max width of block to the number of columns available, for everyone downstream
        return final_span_columns();
      },
      get span_rows() {
        return final_span_rows();
      }
    });
  });
  return get_wrapped_blocks;
}
/**
 * Basically adds support for async content block functions and shows a rudimentary placeholder if rendering is delayed. Required due to react having a rendering delay.
 */
function $ff7feae4dddd6073$var$RenderContent(props) {
  const [resource] = $8tj43$createResource(() => props.content,
  // Could be reactive
  fn => fn());
  $8tj43$createEffect(() => {
    if (resource.error) console.error("Error in content block rendering", resource.error);
  });
  // The suspense is for when there's an async content block (which we have to support due to react having a rendering delay) so that we can show some height while it's loading (should kinda never be visible)
  return $8tj43$createComponent((0, $8tj43$Suspense), {
    get fallback() {
      return $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
        width: "100%",
        height: "max(100%, 400px)"
      });
    },
    children: resource
  });
}
var $ca6ab5f08bd28bca$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 14 26"><path d="M2 24.656c-.078 0-.156-.016-.234-.047s-.133-.066-.187-.129c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422l10.371-10.371L1.578 2.883c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422.258-.176.422-.176.305.059.422.176l10.805 10.793a.59.59 0 0 1 .176.434c0 .172-.059.305-.176.422L2.422 24.48a.42.42 0 0 1-.199.129.54.54 0 0 1-.223.047zm0 0"fill=#0f0f0f>`);
function $ca6ab5f08bd28bca$export$8be2714ec7f169ee() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($ca6ab5f08bd28bca$var$_tmpl$);
    $8tj43$effect(_p$ => {
      var _props$width_, _props$height_;
      var _v$ = (_props$width_ = props.width_) !== null && _props$width_ !== void 0 ? _props$width_ : 14,
        _v$2 = (_props$height_ = props.height_) !== null && _props$height_ !== void 0 ? _props$height_ : 26;
      _v$ !== _p$.e && $8tj43$setAttribute(_el$, "width", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$, "height", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}
var $002f09d00aac50b2$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`),
  $002f09d00aac50b2$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button aria-label="Scroll left"class="left d-navbutton"type=button>`),
  $002f09d00aac50b2$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<button aria-label="Scroll right"class="right d-navbutton"type=button>`),
  $002f09d00aac50b2$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class="depict-slider depict"><!$><!/><div class=sliding>`);
const $002f09d00aac50b2$var$SlidableContext = /*@__PURE__*/$8tj43$createContext();
function $002f09d00aac50b2$export$6649caad96ef8870(props) {
  const {
    slider_ref_: slider_ref_,
    faded_opacity_ = 0.7,
    mutation_plugins_ = [],
    disable_fading_: disable_fading_,
    snapAlign_: snapAlign_,
    fadingThreshold_ = 0.96
  } = props;
  const [hasHydrated, setHasHydrated] = $8tj43$createSignal(false);
  const shouldShowArrows = () => props.showArrow_ !== false;
  $8tj43$createEffect(() => setHasHydrated(true));
  const MakeButton = () => (() => {
    var _el$ = $8tj43$getNextElement($002f09d00aac50b2$var$_tmpl$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $ca6ab5f08bd28bca$export$8be2714ec7f169ee), {
      get height_() {
        return props.arrow_height_;
      },
      get width_() {
        return props.arrow_width_;
      }
    }));
    return _el$;
  })();
  // To support SSR it would be very hard to make Amazing_Slider compatible with solid's SSR because it would have to be rewritten in a more JSX way
  // However, all it would do on the server (when used by SlidableItems) is creating the following 5 div elements
  // Therefore, we just bail on the server (and first render on the client which is the hydration) and return a static version of the slider
  // Once we have hydrated, we construct and insert the actual slider
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return hasHydrated() && !(0, $8tj43$isServer);
    },
    get fallback() {
      return (() => {
        var _el$2 = $8tj43$getNextElement($002f09d00aac50b2$var$_tmpl$4),
          _el$6 = _el$2.firstChild,
          [_el$7, _co$] = $8tj43$getNextMarker(_el$6.nextSibling),
          _el$5 = _el$7.nextSibling;
        $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return shouldShowArrows();
          },
          get children() {
            return [(() => {
              var _el$3 = $8tj43$getNextElement($002f09d00aac50b2$var$_tmpl$2);
              $8tj43$insert(_el$3, $8tj43$createComponent(MakeButton, {}));
              return _el$3;
            })(), (() => {
              var _el$4 = $8tj43$getNextElement($002f09d00aac50b2$var$_tmpl$3);
              $8tj43$insert(_el$4, $8tj43$createComponent(MakeButton, {}));
              return _el$4;
            })()];
          }
        }), _el$7, _co$);
        $8tj43$insert(_el$5, () => props.children);
        return _el$2;
      })();
    },
    get children() {
      return (() => {
        const [intersectionEntries_, setIntersectionEntries] = $8tj43$createSignal([]);
        const fading_plugin = disable_fading_ ? undefined : $8tj43$slider_fading_factory({
          threshold_: fadingThreshold_,
          faded_opacity_: faded_opacity_
        });
        const slider = new (0, $8tj43$Amazing_Slider)({
          button_contents: {
            left: [MakeButton()],
            right: [MakeButton()]
          },
          constructor_plugins: [$8tj43$slider_snap_css(0, {
            align: snapAlign_
          }).constructor_plugin, ...(fading_plugin ? [fading_plugin.constructor_plugin] : [])],
          mutation_plugins: [...(fading_plugin ? [fading_plugin.mutation_plugin_] : []), ...mutation_plugins_, entries => setIntersectionEntries(entries)]
        });
        const {
          left_: left_,
          right_: right_
        } = slider.elements_;
        $8tj43$createEffect(() => left_.style.display = shouldShowArrows() ? "" : "none");
        $8tj43$createEffect(() => right_.style.display = shouldShowArrows() ? "" : "none");
        $8tj43$insert(slider.insert_here, () => $8tj43$createComponent($002f09d00aac50b2$var$SlidableContext.Provider, {
          value: {
            slider_: slider,
            intersectionEntries_: intersectionEntries_
          },
          get children() {
            return props.children;
          }
        }));
        $8tj43$onCleanup(() => slider.observer.disconnect());
        slider_ref_ === null || slider_ref_ === void 0 || slider_ref_(slider);
        return slider.container;
      })();
    }
  });
}
function $002f09d00aac50b2$export$eaa625fb39439e37() {
  return $8tj43$useContext($002f09d00aac50b2$var$SlidableContext);
}
var $7faea0096f14b59b$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=PLP-results><!$><!/><!$><!/>`);
function $7faea0096f14b59b$export$3925f87b1545cfc6(_ref) {
  let {
    plp_results_: plp_results_,
    depict_api_: depict_api_,
    all_products_loaded_: all_products_loaded_,
    min_products_to_fetch_: min_products_to_fetch_,
    query_base_: query_base_,
    first_result_in_viewport_: first_result_in_viewport_,
    last_result_in_viewport_: last_result_in_viewport_,
    scroll_restoration_data_: [get_scroll_restoration_data],
    no_results_options_: no_results_options_,
    desktop_filter_elements_: desktop_filter_elements_,
    sort_or_filter_open_: sort_or_filter_open_,
    product_card_template_: product_card_template_,
    layout_options_: layout_options_,
    id_currently_querying_for_: id_currently_querying_for_,
    content_blocks_by_row_: content_blocks_by_row_,
    ConfiguredScrollStatus_: ConfiguredScrollStatus_,
    setCurrentlyLoadedDisplays_: setCurrentlyLoadedDisplays_,
    showSliderArrow_: showSliderArrow_
  } = _ref;
  // The plp_results_ resource will be delayed because we're using createBatchedMemo to not make triplicate API requests, but we need to show the placeholders before already to match Chrome and Firefox's "content has to be there, ready for scroll restoration, before all popstate tasks have been completed"-requirement
  const is_loading_ = $8tj43$createMemo(() => plp_results_.loading || query_base_.loading);
  const has_no_results_or_failed = $8tj43$createMemo(() => {
    var _plp_results_;
    const displays = (_plp_results_ = plp_results_()) === null || _plp_results_ === void 0 ? void 0 : _plp_results_.displays;
    return !is_loading_() && (!Array.isArray(displays) || !displays.length);
  });
  if (all_products_loaded_)
    // This is for the case that all products were loaded in the first result I think?
    $8tj43$createComputed(() => {
      var _plp_results_2;
      const is_at_end = !((_plp_results_2 = plp_results_()) !== null && _plp_results_2 !== void 0 && _plp_results_2.cursor); // or failed, but we don't wanna / it's not easy to retry
      if (!is_loading_() && is_at_end) all_products_loaded_[1](true);
    });
  return (() => {
    var _el$ = $8tj43$getNextElement($7faea0096f14b59b$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !has_no_results_or_failed();
      },
      get fallback() {
        return $8tj43$createComponent((0, $94af29837186eb21$export$ef6006467f04ee41), no_results_options_);
      },
      get children() {
        return $74777e8fe65b3dcb$export$b69d0d92862de18b({
          severity_: "error",
          // More granular error handling
          // This _also_ fails when a product card rendering fails
          on_error_: retry => {
            // re-try / reset ErrorBoundary next time we're getting product cards
            const track = $8tj43$createReaction(retry);
            track(plp_results_);
          },
          class_list_: ["cards"],
          // So that the styling looks pretty when we've failed
          message_: "Result rendering failed",
          get children() {
            let suspense_contents;
            let is_just_after_plp_results_update = false;
            let fallback_is_alive = false;
            const [get_should_have_placeholders_rendered, set_should_have_placeholders_rendered] = $8tj43$createSignal(true);
            const [top_row_shortened_by_, set_top_row_shortened_by_] = $8tj43$createSignal(0);
            $8tj43$createSignal(false);
            const modified_cols_at_size = $b2dbaafb23d00c7f$export$cb5808ba002cdeed({
              layout_options_: layout_options_,
              sort_or_filter_open_: sort_or_filter_open_
            });
            const num_placeholders_ = $8tj43$createMemo(() => {
              var _get_scroll_restorati, _get_scroll_restorati2;
              // Can't use the data out of request_base for the id because request_base is too late, we need the correct amount of placeholders before the browser has restored the scroll state after processing all popstate events
              return (0, $981356a8bf29ad72$export$6c9030e511152266) + ((_get_scroll_restorati = (_get_scroll_restorati2 = get_scroll_restoration_data().find(_ref2 => {
                let {
                  for_id: for_id
                } = _ref2;
                return for_id === id_currently_querying_for_();
              })) === null || _get_scroll_restorati2 === void 0 ? void 0 : _get_scroll_restorati2.min_results_loaded) !== null && _get_scroll_restorati !== void 0 ? _get_scroll_restorati : min_products_to_fetch_);
            });
            const layout = $8tj43$createMemo(() => {
              const incoming_layout = layout_options_().layout;
              if (incoming_layout === "slider-without-filters") return "slider";
              return incoming_layout || "grid";
            });
            const doesnt_have_content_blocks = $8tj43$createMemo(() => !content_blocks_by_row_() || layout() !== "grid");
            const content_blocks_ = $8tj43$createMemo(() => doesnt_have_content_blocks() ?
            // This bailing here is to not use proxy/stores and retain old browser compatibility when no content blocks are present
            () => [] : $ff7feae4dddd6073$export$791ef57e62e21c3f({
              content_blocks_: content_blocks_by_row_,
              cols_at_size_: modified_cols_at_size,
              set_top_row_shortened_by_: set_top_row_shortened_by_
            }));
            const rendered_placeholders = $8tj43$createMemo(() => {
              if (get_should_have_placeholders_rendered()) return $bdd80c7862246dc2$export$f33414a4df0afd3f({
                content_blocks_: content_blocks_,
                product_card_template_: product_card_template_,
                num_placeholders_: num_placeholders_
              });
            });
            const [get_suspense_is_blocked, set_suspense_is_blocked] = $8tj43$createSignal(false);
            const block_suspense_if_needed = () => {
              if (!is_just_after_plp_results_update) return;
              is_just_after_plp_results_update = false;
              fallback_is_alive = false;
              set_suspense_is_blocked(true);
            };
            $8tj43$createComputed(() => {
              if (!is_loading_()) return;
              set_should_have_placeholders_rendered(true);
              set_suspense_is_blocked(false);
              is_just_after_plp_results_update = true;
            });
            $8tj43$createEffect($8tj43$on(plp_results_, () => {
              if (!fallback_is_alive) {
                // if all product card rendering functions after the initial rendering are synchronous the suspense boundary will never go into the fallback, so we don't know when they have finished rendering, and we can't block the suspense. Therefore, we're just doing it with this effect
                block_suspense_if_needed();
                set_should_have_placeholders_rendered(false);
              }
            }, {
              defer: true
            }));
            /*
            This suspense ensures that if someone has async templates, we still show placeholders until the product cards actually have finished rendering (automagically since they're createResource's)
            We're creating it outside the <Show> so that we can benefit from <For>'s optimisation between changing results
            (For the whole idea of the displays being cached to work we can't tear down and re-run ProductCards for every new result.
            We have to keep ProductCards alive, but hidden, and feed them new data as soon as we had it)
            */
            const product_cards_when_data = $8tj43$createComponent((0, $8tj43$Suspense), {
              get fallback() {
                fallback_is_alive = true;
                $8tj43$onCleanup(block_suspense_if_needed); // Block suspense after initial run every time after we fetch
                return $8tj43$createMemo(() => {
                  // We need to be able to block the suspense since when async product cards are *rendering* we want to show the placeholders on initial load but not when loading more
                  // In future we could have individual suspense's for each product card, but that's too much for now
                  if (get_suspense_is_blocked()) return suspense_contents;
                  set_should_have_placeholders_rendered(true); // just in case
                  $8tj43$onCleanup(() => set_should_have_placeholders_rendered(false));
                  return rendered_placeholders; // I lifted the placeholders into the memo since we don't want to re-render them when switching from <Show> to <Suspense>
                });
              },

              get children() {
                return (() => {
                  suspense_contents = $45a8953d760b5e58$export$a1fd619a4743ca08({
                    product_card_template_: product_card_template_,
                    plp_results_: plp_results_,
                    last_result_in_viewport_: last_result_in_viewport_,
                    first_result_in_viewport_: first_result_in_viewport_,
                    all_products_loaded_: all_products_loaded_,
                    min_products_to_fetch_: min_products_to_fetch_,
                    query_base_: query_base_,
                    depict_api_: depict_api_,
                    is_loading_: is_loading_,
                    content_blocks_: content_blocks_,
                    setCurrentlyLoadedDisplays_: setCurrentlyLoadedDisplays_,
                    isSliderLayout_: () => layout() === "slider"
                  });
                  $8tj43$onCleanup(() => suspense_contents = undefined);
                  return suspense_contents;
                })();
              }
            });
            /* This Show is so that we show placeholders while query_base is loading and because it's cumbersome to ensure that everything that directly accesses the plp_results_ resource is within the <Suspense> boundary */
            const listing_contents = $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return !is_loading_();
              },
              get fallback() {
                return rendered_placeholders();
              },
              children: product_cards_when_data
            });
            return [$8tj43$memo(() => $ca55612a53dbbdd2$export$a2cc176055f8f08(layout())), $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return doesnt_have_content_blocks();
              },
              get fallback() {
                return $8tj43$createComponent((0, $64d94dcaa058dc7b$export$ab6b147eec64fea5), {
                  get cols_at_size() {
                    return modified_cols_at_size();
                  },
                  get override_vertical_spacing() {
                    return layout_options_().override_vertical_spacing;
                  },
                  get grid_spacing() {
                    return layout_options_().grid_spacing;
                  },
                  element_attributes: {
                    class: "cards css-grid"
                  },
                  top_row_shortened_by_: top_row_shortened_by_,
                  children: listing_contents
                });
              },
              get children() {
                return $8tj43$createComponent((0, $8tj43$Show), {
                  get when() {
                    return layout() === "grid";
                  },
                  get fallback() {
                    return $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
                      arrow_height_: 25,
                      arrow_width_: 12.5,
                      disable_fading_: true,
                      get showArrow_() {
                        return showSliderArrow_();
                      },
                      slider_ref_: slider => {
                        const {
                          insert_here: insert_here,
                          container: container
                        } = slider;
                        const Layout = props => $63f1f8dbcd07d3b0$export$445d8d3f5f706a40(props, insert_here, true);
                        // Do like this, so we don't have to call mergeProps ourselves
                        $8tj43$createComponent(Layout, $8tj43$mergeProps1(layout_options_, {
                          rows: "all",
                          get cols_at_size() {
                            return modified_cols_at_size();
                          },
                          get layout() {
                            return layout();
                          }
                        }));
                        insert_here.classList.add("generated-spacing");
                        container.classList.add("products");
                        $8tj43$createEffect(
                        // @ts-ignore
                        $8tj43$on(query_base_, () => insert_here.scrollTo({
                          left: 0,
                          behavior: "instant"
                        }), {
                          defer: true
                        })); // Scroll to the beginning if a filter or the query changes
                        $8tj43$slider_fractional_factory(0, 0.75).constructor_plugin.call(slider, {}); // enable fractional scrolling
                        if (ConfiguredScrollStatus_) {
                          // Put scroll status into slider container, so it's centered relatively to the products
                          const rendered_scroll_status = ConfiguredScrollStatus_({
                            get_scroll_position_: () => insert_here.scrollLeft,
                            listen_to_scroll_on_: insert_here,
                            velocity_too_fast_: 3 // Require twice as hard scrolling to show ScrollStatus in slider since it's easier to scroll fast there
                          });

                          const non_solid_nodes = [...container.childNodes];
                          // We have to use `insert` over Element.append, because ConfiguredScrollStatus is in an ErrorBoundary and therefore returns a function. `insert` will wipe all children, therefore save them first and then tell insert that the element should contain these elements + whatever ScrollStatus returns
                          $8tj43$insert(container, $8tj43$createMemo(() => [...non_solid_nodes, rendered_scroll_status]));
                        }
                      },
                      children: listing_contents
                    });
                  },
                  get children() {
                    return $8tj43$createComponent((0, $63f1f8dbcd07d3b0$export$d21e32dfedac04be), {
                      get cols_at_size() {
                        return modified_cols_at_size();
                      },
                      get override_vertical_spacing() {
                        return layout_options_().override_vertical_spacing;
                      },
                      get grid_spacing() {
                        return layout_options_().grid_spacing;
                      },
                      rows: "all",
                      get layout() {
                        return layout();
                      },
                      element_attributes: {
                        class: "cards"
                      },
                      children: listing_contents
                    });
                  }
                });
              }
            })];
          }
        });
      }
    }), _el$3, _co$);
    $8tj43$insert(_el$, desktop_filter_elements_, _el$5, _co$2);
    $8tj43$effect(() => _el$.classList.toggle("nothing", !!has_no_results_or_failed()));
    return _el$;
  })();
}
function $8e8b179489080711$export$5bad61ecde080b1f() {
  const {
    collapse: collapse,
    expand: expand,
    ExpandingContainer: ExpandingContainer
  } = $8tj43$useExpandingContainer(...arguments);
  return {
    collapse: collapse,
    expand: expand,
    ExpandingContainer: _ref => {
      let {
        children: children
      } = _ref;
      // get reactive signals/solid's jsx elements into `ExpandingContainer`
      const fake_div = document.createElement("div");
      const outer_expanding = $8tj43$createComponent(ExpandingContainer, {
        children: [fake_div]
      });
      const parent = fake_div.parentElement;
      fake_div.remove();
      $8tj43$insert(parent, children);
      return outer_expanding;
    }
  };
}
const $ad371564683947ab$var$has_new_animate = /*@__PURE__*/$ad371564683947ab$export$e13dddbb31c3a42f();
function $ad371564683947ab$export$6c6d7a51fa9aa15d(props) {
  let fresh_component = true;
  let timeout_started = false;
  const {
    details_: details_,
    summary_: summary_,
    children: children,
    duration_: duration_,
    delay_: delay_,
    dont_animate_if_instant_open_ = true
  } = props;
  const {
    expand: expand,
    ExpandingContainer: ExpandingContainer,
    collapse: collapse
  } = $8e8b179489080711$export$5bad61ecde080b1f({
    duration: duration_ !== null && duration_ !== void 0 ? duration_ : 250,
    delay: delay_ !== null && delay_ !== void 0 ? delay_ : 0
  });
  const [is_in_dom, set_is_in_dom] = $8tj43$createSignal(document.documentElement.contains(details_));
  // we want this extra layer for if the props.is_open_ function changes itself but not the value of the signal. If we re-run below effect it flickers sometimes for some reason
  const is_open_memo = $8tj43$createMemo(() => props.is_open_[0]());
  const toggle = () => props.is_open_[1](!$8tj43$untrack(is_open_memo));
  $8tj43$insert(details_, [summary_, $8tj43$createComponent(ExpandingContainer, {
    children: children
  })], null);
  if (!$8tj43$untrack(is_in_dom)) (0, $8tj43$observer).wait_for_element(details_).then($8tj43$catchify1(() => set_is_in_dom(true)));
  $8tj43$createEffect($8tj43$catchify1(async () => {
    const is_open = is_open_memo();
    if (!is_in_dom())
      // wait with setting state until we're in DOM, animation won't work otherwise
      return;
    if (dont_animate_if_instant_open_ && fresh_component && !timeout_started) {
      timeout_started = true;
      setTimeout($8tj43$catchify1(() => fresh_component = false));
    }
    if (is_open) {
      details_.open = true; // open up the toggle so the animation can happen
      const do_duration = dont_animate_if_instant_open_ && fresh_component ? $ad371564683947ab$var$has_new_animate ? 0 : 1 /* if the zero duration is 1 modern chrome will paint a frame with unexpanded and then one with expanded which doesn't look nice, if you have 0 on older browsers they won't play the animation at all (i.e. iOS 12.5.5) */ : duration_;
      await expand(0, do_duration);
    } else {
      const animation = await collapse();
      animation === null || animation === void 0 || animation.addEventListener("finish", $8tj43$catchify1(() => details_.open = false));
    }
  }));
  details_.addEventListener("toggle", $8tj43$catchify1(() => {
    const {
      open: open
    } = details_;
    if (open !== $8tj43$untrack(() => props.is_open_[0]()))
      // diffing here since the two items in is_open might be setters and getters that aren't part of one signal like in CheckboxHierarchicalFilter
      props.is_open_[1](open);
  }) // in case someone somehow toggles it without us intercepting it at least follow suit
  );

  summary_.addEventListener("click", $8tj43$catchify1(ev => {
    ev.preventDefault();
    toggle();
  }));
  summary_.addEventListener("keydown", $8tj43$catchify1(ev => {
    const {
      key: key
    } = ev;
    if (key === "Enter" || key === " ") {
      ev.preventDefault();
      toggle();
    }
  }));
  return details_;
}
function $ad371564683947ab$export$e13dddbb31c3a42f() {
  try {
    document.createElement("b").animate({
      opacity: [0]
    });
    return true;
  } catch (e) {
    return false;
  }
}
var $9783d437ad61594c$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=21.064 height=21.064 viewBox="0 0 21.064 21.064"><path d="M11.669 10.531l9.156-9.156a.78.78 0 0 0 .237-.569c0-.221-.079-.412-.237-.569A.8.8 0 0 0 20.24 0a.77.77 0 0 0-.569.237l-9.14 9.14-9.14-9.14A.79.79 0 0 0 .807 0a.77.77 0 0 0-.569.237A.78.78 0 0 0 0 .807a.77.77 0 0 0 .237.569l9.156 9.156-9.156 9.14c-.159.157-.237.349-.237.569s.079.412.237.569c.085.085.174.148.268.19a1.095 1.095 0 0 0 .316.048.894.894 0 0 0 .285-.048.84.84 0 0 0 .285-.19l9.139-9.14 9.14 9.14a.894.894 0 0 0 .268.19 1.049 1.049 0 0 0 .301.048.941.941 0 0 0 .301-.048.84.84 0 0 0 .285-.19.78.78 0 0 0 .237-.569c0-.221-.079-.412-.237-.569z">`);
function $9783d437ad61594c$export$3b621d86b1566b2() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($9783d437ad61594c$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}

/**
 * Lower cases a string if possible. Mostly used to make the filter url values case-insensitive.
 */
function $af5d8e0b7d97a7f6$export$325f75597868c4f0(stuff) {
  if (typeof stuff !== "string") return stuff;
  return stuff.toLowerCase();
}
var $4711a82d08d2021b$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button class="clear-all-filters minor">`),
  $4711a82d08d2021b$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=inner><span class=title><!$><!/>: </span><!$><!/>`),
  $4711a82d08d2021b$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<button class="clear-filter major"><!$><!/><span><!$><!/><!$><!/><!$><!/> \u{2013} <!$><!/><!$><!/><!$><!/>`),
  $4711a82d08d2021b$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<button class="clear-filter major"><!$><!/><span>`);
function $4711a82d08d2021b$export$fecbb157621501bd(_ref) {
  let {
    number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
    i18n_: i18n_,
    selected_filters_: selected_filters_,
    local_filter_cache_: [read_local_filter_cache],
    get_search_filters_open_: get_search_filters_open_,
    get_search_sorting_open_: get_search_sorting_open_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_
  } = _ref;
  const {
    price_formatting_: price_formatting_
  } = i18n_;
  const [read_selected_filters, write_selected_filters] = selected_filters_;
  const {
    collapse: collapse,
    expand: expand,
    ExpandingContainer: ExpandingContainer
  } = $8e8b179489080711$export$5bad61ecde080b1f({
    duration: 200
  });
  const owner = $8tj43$getOwner();
  const outmost_element = $8tj43$createComponent(ExpandingContainer, {
    get children() {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return read_selected_filters().length;
        },
        get children() {
          var _el$ = $8tj43$getNextElement($4711a82d08d2021b$var$_tmpl$2),
            _el$2 = _el$.firstChild,
            _el$4 = _el$2.firstChild,
            [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
            _el$3 = _el$5.nextSibling,
            _el$7 = _el$2.nextSibling,
            [_el$8, _co$2] = $8tj43$getNextMarker(_el$7.nextSibling);
          $8tj43$insert(_el$2, () => i18n_.selected_filters_title_(), _el$5, _co$);
          $8tj43$insert(_el$, $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
            slider_ref_: slider => slider.container.classList.add("filter-crumbs"),
            get children() {
              return [(() => {
                var _el$6 = $8tj43$getNextElement($4711a82d08d2021b$var$_tmpl$);
                $8tj43$addEventListener(_el$6, "click", $8tj43$catchify1(() =>
                // click event handlers don't have an owner, carry it over
                $8tj43$runWithOwner(owner, () => $b4465d8d605f61e9$export$8895d39404bd2bb1({
                  selected_filters_: selected_filters_,
                  i18n_: i18n_,
                  also_clear_sorting_: false,
                  user_triggered_: true,
                  expanded_hierarchical_filters_: expanded_hierarchical_filters_,
                  local_filter_cache_: local_filter_cache_
                }))), true);
                $8tj43$insert(_el$6, () => i18n_.clear_all_from_filter_crumbs_());
                $8tj43$runHydrationEvents();
                return _el$6;
              })(), $8tj43$createComponent((0, $8tj43$Index), {
                get each() {
                  return read_selected_filters();
                },
                children: (filter, index_in_selected_filters) => {
                  const matching_filter = $8tj43$createMemo(() => read_local_filter_cache().find(hay => hay.field === filter().field && hay.op === filter().op));
                  const meta = $8tj43$createMemo(() => {
                    var _matching_filter;
                    return (_matching_filter = matching_filter()) === null || _matching_filter === void 0 ? void 0 : _matching_filter.meta;
                  });
                  const iterable_selected_filter_data = $8tj43$createMemo(() => {
                    const {
                      data: data
                    } = filter();
                    if (Array.isArray(data)) return data;else return [data];
                  });
                  const data_structure_if_hierarchical = $8tj43$createMemo(() => {
                    const m = meta();
                    if ((m === null || m === void 0 ? void 0 : m.type) !== "checkbox-hierarchical") return;
                    const {
                      values: values
                    } = m;
                    const data_structure = {};
                    for (let i = 0; i < values.length; i++) {
                      const value = values[i];
                      let pointer = data_structure;
                      let parent_ = {};
                      let created_an_object = false;
                      for (let j = 0; j < value.length; j++) {
                        var _pointer;
                        const this_categories_name = $af5d8e0b7d97a7f6$export$325f75597868c4f0(value[j]);
                        const obj = (_pointer = pointer)[this_categories_name] || (_pointer[this_categories_name] = (() => {
                          const value_as_string = value.map(v => typeof v === "number" ? v + "" : v); // don't think backend will ever send numbers but technically it's allowed;
                          const created_obj = {
                            parent_: parent_,
                            value_: value_as_string,
                            children_: {}
                          };
                          parent_ = created_obj;
                          created_an_object = true;
                          return created_obj;
                        })());
                        pointer = obj.children_;
                        parent_ = obj;
                      }
                      if (!created_an_object && "value_" in parent_)
                        // if an object was created for our "depth" in the hierarchy but not for our specific entry this means that the entry array was unsorted and looked something like
                        // [
                        //   ["Öl", "IPA"],
                        //   ["Öl", "Pale Ale"],
                        //   ["Öl", "Ale"],
                        //   ["Öl", "Mörk Lager"],
                        //   ["Öl", "Suröl"],
                        //   ["Öl", "Veteöl"],
                        //   ["Öl", "Stout och Porter"],
                        //   ["Öl"], // <- We are here, our `hierarchical_data_structure[string]`-object was created when we iterated over ["Öl", "IPA"]
                        //   ["Öl", "Ljus Lager"],
                        // ];
                        // In this case we want to just correct the name and value of the already created object, which will be in parent_
                        parent_.value_ = value.map(v => v + "");
                    }
                    return data_structure;
                  });
                  return $8tj43$createComponent((0, $8tj43$Show), {
                    get when() {
                      return matching_filter();
                    },
                    get children() {
                      return $8tj43$createComponent((0, $8tj43$Show), {
                        get when() {
                          var _matching_filter2;
                          return ((_matching_filter2 = matching_filter()) === null || _matching_filter2 === void 0 ? void 0 : _matching_filter2.op) !== "inrange";
                        },
                        get fallback() {
                          number_of_rendered_selected_filters_items_[1](prev => prev + 1);
                          $8tj43$onCleanup(() => number_of_rendered_selected_filters_items_[1](prev => prev - 1));
                          return (() => {
                            var _el$9 = $8tj43$getNextElement($4711a82d08d2021b$var$_tmpl$3),
                              _el$24 = _el$9.firstChild,
                              [_el$25, _co$9] = $8tj43$getNextMarker(_el$24.nextSibling),
                              _el$10 = _el$25.nextSibling,
                              _el$12 = _el$10.firstChild,
                              [_el$13, _co$3] = $8tj43$getNextMarker(_el$12.nextSibling),
                              _el$14 = _el$13.nextSibling,
                              [_el$15, _co$4] = $8tj43$getNextMarker(_el$14.nextSibling),
                              _el$16 = _el$15.nextSibling,
                              [_el$17, _co$5] = $8tj43$getNextMarker(_el$16.nextSibling),
                              _el$11 = _el$17.nextSibling,
                              _el$18 = _el$11.nextSibling,
                              [_el$19, _co$6] = $8tj43$getNextMarker(_el$18.nextSibling),
                              _el$20 = _el$19.nextSibling,
                              [_el$21, _co$7] = $8tj43$getNextMarker(_el$20.nextSibling),
                              _el$22 = _el$21.nextSibling,
                              [_el$23, _co$8] = $8tj43$getNextMarker(_el$22.nextSibling);
                            _el$9.$$click = () => {
                              const cloned_selected_filters = [...read_selected_filters()];
                              cloned_selected_filters.splice(index_in_selected_filters, 1);
                              write_selected_filters(cloned_selected_filters);
                            };
                            $8tj43$insert(_el$9, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}), _el$25, _co$9);
                            $8tj43$insert(_el$10, () => price_formatting_().pre_, _el$13, _co$3);
                            $8tj43$insert(_el$10, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
                              get price_() {
                                return filter().data[0];
                              },
                              get price_formatting_() {
                                return price_formatting_();
                              }
                            }), _el$15, _co$4);
                            $8tj43$insert(_el$10, () => price_formatting_().post_, _el$17, _co$5);
                            $8tj43$insert(_el$10, () => price_formatting_().pre_, _el$19, _co$6);
                            $8tj43$insert(_el$10, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
                              get price_() {
                                return filter().data[1];
                              },
                              get price_formatting_() {
                                return price_formatting_();
                              }
                            }), _el$21, _co$7);
                            $8tj43$insert(_el$10, () => price_formatting_().post_, _el$23, _co$8);
                            $8tj43$effect(() => {
                              var _matching_filter3, _matching_filter3$met;
                              return $8tj43$setAttribute(_el$9, "data-group-title", (_matching_filter3 = matching_filter()) === null || _matching_filter3 === void 0 ? void 0 : (_matching_filter3$met = _matching_filter3.meta) === null || _matching_filter3$met === void 0 ? void 0 : _matching_filter3$met.group_title);
                            });
                            $8tj43$runHydrationEvents();
                            return _el$9;
                          })();
                        },
                        get children() {
                          return $8tj43$createComponent((0, $8tj43$Index), {
                            get each() {
                              return iterable_selected_filter_data();
                            },
                            children: selected_data => {
                              const index_of_us_in_meta = $8tj43$createMemo(() => {
                                var _meta, _meta$values;
                                const sel_d = selected_data();
                                return (_meta = meta()) === null || _meta === void 0 ? void 0 : (_meta$values = _meta.values) === null || _meta$values === void 0 ? void 0 : _meta$values.findIndex(value => {
                                  return $af5d8e0b7d97a7f6$export$325f75597868c4f0(value) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(sel_d) || Array.isArray(value) && Array.isArray(sel_d) && value.length === sel_d.length && value.every((item, index) => $af5d8e0b7d97a7f6$export$325f75597868c4f0(sel_d[index]) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(item));
                                });
                              });
                              const name = $8tj43$createMemo(() => {
                                var _meta2, _meta2$names, _meta3, _meta3$values;
                                const index = index_of_us_in_meta();
                                if (index == undefined || index < 0) return;
                                return ((_meta2 = meta()) === null || _meta2 === void 0 ? void 0 : (_meta2$names = _meta2.names) === null || _meta2$names === void 0 ? void 0 : _meta2$names[index]) || ((_meta3 = meta()) === null || _meta3 === void 0 ? void 0 : (_meta3$values = _meta3.values) === null || _meta3$values === void 0 ? void 0 : _meta3$values[index]);
                              });
                              const us_in_structure = $8tj43$createMemo(() => {
                                const structure = data_structure_if_hierarchical();
                                if (!structure) return;
                                let we_in_structure;
                                let pointer = structure;
                                for (const step of selected_data()) {
                                  var _pointer2, _we_in_structure;
                                  we_in_structure = (_pointer2 = pointer) === null || _pointer2 === void 0 ? void 0 : _pointer2[$af5d8e0b7d97a7f6$export$325f75597868c4f0(step)];
                                  pointer = (_we_in_structure = we_in_structure) === null || _we_in_structure === void 0 ? void 0 : _we_in_structure.children_;
                                }
                                return we_in_structure;
                              });
                              const hide_us = $8tj43$createMemo(() => {
                                var _us_in_structure;
                                // if all siblings checked, hide us
                                const parent = (_us_in_structure = us_in_structure()) === null || _us_in_structure === void 0 ? void 0 : _us_in_structure.parent_;
                                const siblings = parent === null || parent === void 0 ? void 0 : parent.children_;
                                if (siblings) return [parent, ...Object.values(siblings)].every(_ref2 => {
                                  var _iterable_selected_fi;
                                  let {
                                    value_: value_
                                  } = _ref2;
                                  return (_iterable_selected_fi = iterable_selected_filter_data()) === null || _iterable_selected_fi === void 0 ? void 0 : _iterable_selected_fi.some(v => Array.isArray(v) && v.length === value_.length && value_.every((val, index) => $af5d8e0b7d97a7f6$export$325f75597868c4f0(v[index]) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(val)));
                                });
                                return false;
                              });
                              return $8tj43$createComponent((0, $8tj43$Show), {
                                get when() {
                                  return $8tj43$memo(() => !!name())() && !hide_us();
                                },
                                get children() {
                                  return (() => {
                                    number_of_rendered_selected_filters_items_[1](prev => prev + 1);
                                    $8tj43$onCleanup(() => number_of_rendered_selected_filters_items_[1](prev => prev - 1));
                                    return (() => {
                                      var _el$26 = $8tj43$getNextElement($4711a82d08d2021b$var$_tmpl$4),
                                        _el$28 = _el$26.firstChild,
                                        [_el$29, _co$10] = $8tj43$getNextMarker(_el$28.nextSibling),
                                        _el$27 = _el$29.nextSibling;
                                      $8tj43$addEventListener(_el$26, "click", $8tj43$catchify1(() => {
                                        const to_remove = selected_data();
                                        const cloned_selected_filters = [...read_selected_filters()];
                                        cloned_selected_filters.splice(index_in_selected_filters, 1);
                                        const data = filter().data;
                                        const cloned_data = Array.isArray(data) ? [...data] : [data];
                                        const index_of_item = cloned_data.findIndex(item => $af5d8e0b7d97a7f6$export$325f75597868c4f0(item) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(to_remove));
                                        if (index_of_item >= 0) cloned_data.splice(index_of_item, 1);
                                        const in_structure = us_in_structure();
                                        if (in_structure) {
                                          // also unselect potentially selected children
                                          const recursive_kids = Object.values(in_structure.children_);
                                          while (recursive_kids.length) {
                                            const kid = recursive_kids.pop();
                                            const {
                                              value_: value_
                                            } = kid;
                                            const index_to_remove = cloned_data.findIndex(item => Array.isArray(item) && item.length === value_.length && value_.every((val, index) => $af5d8e0b7d97a7f6$export$325f75597868c4f0(item[index]) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(val)));
                                            if (index_to_remove >= 0) cloned_data.splice(index_to_remove, 1);
                                            recursive_kids.push(...Object.values(kid.children_));
                                          }
                                        }
                                        if (cloned_data.length) {
                                          const cloned_filter = {
                                            ...filter(),
                                            data: cloned_data
                                          };
                                          cloned_selected_filters.push(cloned_filter);
                                        }
                                        write_selected_filters(cloned_selected_filters);
                                      }), true);
                                      $8tj43$insert(_el$26, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}), _el$29, _co$10);
                                      $8tj43$insert(_el$27, name);
                                      $8tj43$effect(() => {
                                        var _matching_filter4, _matching_filter4$met;
                                        return $8tj43$setAttribute(_el$26, "data-group-title", (_matching_filter4 = matching_filter()) === null || _matching_filter4 === void 0 ? void 0 : (_matching_filter4$met = _matching_filter4.meta) === null || _matching_filter4$met === void 0 ? void 0 : _matching_filter4$met.group_title);
                                      });
                                      $8tj43$runHydrationEvents();
                                      return _el$26;
                                    })();
                                  })();
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              })];
            }
          }), _el$8, _co$2);
          return _el$;
        }
      });
    }
  });
  const [is_in_dom, set_is_in_dom] = $8tj43$createSignal(document.documentElement.contains(outmost_element));
  const hidden = $8tj43$createMemo(() => get_search_filters_open_() || get_search_sorting_open_());
  if (!$8tj43$untrack(is_in_dom)) (0, $8tj43$observer).wait_for_element(outmost_element).then($8tj43$catchify1(() => set_is_in_dom(true)));
  outmost_element.classList.add("selected-filters");
  $8tj43$createEffect($8tj43$catchify1(async () => {
    if (!is_in_dom())
      // wait with setting state until we're in DOM, animation won't work otherwise
      return;
    const is_small = window.matchMedia("(max-width:651px)").matches; // only animate on mobile where this could be feeling weird when something changes in the background, on desktop we want the instant snapping
    const duration = is_small ? undefined : $ad371564683947ab$export$e13dddbb31c3a42f() ? 0 : 1;
    /* we still need this component to render when it's hidden to update the "notification" on the filters button */
    if (hidden()) await collapse(0, duration);else await expand(0, duration);
  }));
  return outmost_element;
}
$8tj43$delegateEvents(["click"]);
async function $d5f1e6a0f9117286$export$79b1565500412d9b(search_modal, modal_fn_opts, parent) {
  const body = parent || document.body || (await (0, $8tj43$observer).wait_for_element("body"));
  let dispose_and_remove;
  const open_modal_ = $8tj43$catchify1(async function () {
    let extra_options_for_modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_dispose = arguments.length > 1 ? arguments[1] : undefined;
    // Below await is very intentional,
    // The reason is that effects don't run in <Suspense> boundaries before they've resolved and this carries even through roots created, but if a modal is opened from a suspense boundary we still want the effects in it to run
    // This is because the suspense is for the content in the page and not the modal (the modal goes above it)
    // By having an await here, solid loses all its knowledge of the suspense boundary
    // (there is also some bug where effects don't run when created inside a suspense boundary that is resolved)
    if (await dispose_and_remove)
      // modal is already open
      return;
    const modal_els = $8tj43$createRoot(dispose => {
      let closing_animation;
      let animation_started;
      dispose_and_remove = () => {
        const actually_close = () => {
          dispose();
          on_dispose === null || on_dispose === void 0 || on_dispose();
          const {
            activeElement: activeElement
          } = document;
          modal_els.forEach(el => {
            if (el.contains(activeElement)) {
              var _blur, _ref;
              // Fix page jumping to the bottom when closing modal with scape after animation in safari
              activeElement === null || activeElement === void 0 || (_blur = (_ref = activeElement).blur) === null || _blur === void 0 || _blur.call(_ref);
            }
            el.remove();
          });
        };
        if (animation_started && +new Date() - animation_started > 1000)
          // Animation broke, close it this time
          actually_close();else if (!animation_started && closing_animation) {
          var _catchify;
          animation_started = +new Date();
          (_catchify = $8tj43$catchify1(closing_animation)()) === null || _catchify === void 0 || _catchify.then($8tj43$catchify1(actually_close));
        } else actually_close();
      };
      return search_modal({
        ...modal_fn_opts,
        ...extra_options_for_modal,
        close_modal_: close_modal_,
        open_modal_: open_modal_,
        register_closing_animation_: animation => closing_animation = animation
      });
    });
    body.append(...modal_els);
  });
  const close_modal_ = $8tj43$catchify1(() => {
    if (dispose_and_remove) {
      // modal is open
      const dispose_fn = dispose_and_remove;
      // set dispose function to undefined in case that it triggers this dispose function itself. Not doing it leads to a bug like https://github.com/solidjs/solid/discussions/1194
      dispose_and_remove = undefined;
      dispose_fn();
    }
  });
  return {
    open_modal_: open_modal_,
    close_modal_: close_modal_
  };
}
var $19e828709c7723a0$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class=count>`),
  $19e828709c7723a0$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<label class=input-row><div class=left><input type=checkbox><span class=custom-indicator></span><span class="text line-clamp"></span></div><!$><!/>`);
const $19e828709c7723a0$export$48513f6b9f8ce62d = props => {
  /* don't destructure props, it could have reactive getters */ // It seems like there's no diffing without memos here (since we often just have computations in the getters above that update to the same result often because their dependencies change with unrelated changes often), so put memos here to avoid unneeded DOM changes
  const count = $8tj43$createMemo(() => props.count_);
  const label = $8tj43$createMemo(() => props.label_);
  const checked = $8tj43$createMemo(() => props.checked_);
  const value = $8tj43$createMemo(() => props.value_);
  const is_count_zero = $8tj43$createMemo(() => props.is_count_zero_ || count() === 0);
  const id = $8tj43$make_random_classname();
  return (/* We can't use actual margin because ExpandingContainer gets messed up */(() => {
      var _el$ = $8tj43$getNextElement($19e828709c7723a0$var$_tmpl$2),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.firstChild,
        _el$4 = _el$3.nextSibling,
        _el$5 = _el$4.nextSibling,
        _el$7 = _el$2.nextSibling,
        [_el$8, _co$] = $8tj43$getNextMarker(_el$7.nextSibling);
      $8tj43$setAttribute(_el$, "for", id);
      $8tj43$use(input_el => {
        var _props$input_ref_;
        // For the checkboxes we know that they changed by putting them into a form and listening on the form changing.
        // A bug here was that some checkboxes didn't match the state of their checked() solid accessor.
        // The reason for that being that we re-use the checkboxes. That means if one box was unchecked by the user and then removed, the "checked" value of "another" checkbox (that now had position 0) had changed to 0 (because the user unchecked the box with position 0) while solid js still believed that it was checked because it's checked signal hadn't changed.
        // I've worked around this by restoring the state of the checkbox to what it is in solid js a bit after it was changed
        // Why it can't be done instantaneously I don't know.
        input_el.addEventListener("change", $8tj43$catchify1(() => requestAnimationFrame($8tj43$catchify1(() => {
          if (input_el.checked !== checked()) input_el.checked = checked();
        }))));
        (_props$input_ref_ = props.input_ref_) === null || _props$input_ref_ === void 0 || _props$input_ref_.call(props, input_el);
      }, _el$3);
      $8tj43$setAttribute(_el$3, "id", id);
      $8tj43$use(el => {
        var _props$custom_indicat;
        return (_props$custom_indicat = props.custom_indicator_ref) === null || _props$custom_indicat === void 0 ? void 0 : _props$custom_indicat.call(props, el);
      }, _el$4);
      $8tj43$insert(_el$5, () => label() || value());
      $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return count() != undefined;
        },
        get children() {
          var _el$6 = $8tj43$getNextElement($19e828709c7723a0$var$_tmpl$);
          $8tj43$insert(_el$6, count);
          return _el$6;
        }
      }), _el$8, _co$);
      $8tj43$effect(_p$ => {
        var _v$ = !!is_count_zero(),
          _v$2 = value(),
          _v$3 = !checked() && is_count_zero();
        _v$ !== _p$.e && _el$.classList.toggle("count-0", _p$.e = _v$);
        _v$2 !== _p$.t && $8tj43$setAttribute(_el$3, "name", _p$.t = _v$2);
        _v$3 !== _p$.a && $8tj43$setProperty(_el$3, "disabled", _p$.a = _v$3);
        return _p$;
      }, {
        e: undefined,
        t: undefined,
        a: undefined
      });
      $8tj43$effect(() => $8tj43$setProperty(_el$3, "checked", checked()));
      return _el$;
    })()
  );
};
var $ff3225aef892a467$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg><path d="M10.173 5.548H5.5V.875c0-.075-.027-.14-.081-.193S5.301.601 5.226.601s-.14.027-.193.081-.081.118-.081.193v4.673H.274c-.075 0-.14.027-.193.081A.27.27 0 0 0 0 5.827c0 .075.027.14.081.193s.118.081.193.081h4.678v4.673c0 .075.027.14.081.193s.118.081.193.081.14-.027.193-.081.081-.118.081-.193V6.101h4.673a.27.27 0 0 0 .199-.081c.054-.054.08-.118.08-.193a.27.27 0 0 0-.279-.279z"fill=#000>`);
function $ff3225aef892a467$export$f21ab0717a89c77f(props) {
  return (() => {
    var _el$ = $8tj43$getNextElement($ff3225aef892a467$var$_tmpl$);
    $8tj43$spread(_el$, $8tj43$mergeProps1(props, {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "11",
      "height": "12"
    }), true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $3e850b2f2cca761f$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button type=button class=expand-filter><!$><!/><span>`);
function $3e850b2f2cca761f$export$ca21a16d65b3dd8(_ref) {
  let {
    show_extras_: [get_show_extras, set_show_extras],
    i18n_: i18n_
  } = _ref;
  return (() => {
    var _el$ = $8tj43$getNextElement($3e850b2f2cca761f$var$_tmpl$),
      _el$3 = _el$.firstChild,
      [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling),
      _el$2 = _el$4.nextSibling;
    $8tj43$addEventListener(_el$, "click", $8tj43$catchify1(() => set_show_extras(p => !p)), true);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $ff3225aef892a467$export$f21ab0717a89c77f), {}), _el$4, _co$);
    $8tj43$insert(_el$2, (() => {
      var _c$ = $8tj43$memo(() => !!get_show_extras());
      return () => _c$() ? i18n_.view_less_() : i18n_.view_more_();
    })());
    $8tj43$effect(() => _el$.classList.toggle("expanded", !!get_show_extras()));
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
$8tj43$delegateEvents(["click"]);
var $02b6641aa50ce528$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class=highlighted-part>`),
  $02b6641aa50ce528$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span>`);
function $02b6641aa50ce528$export$ba17c5b7e6dda39f(_ref) {
  let {
    whole_text_to_display_: whole_text_to_display_memo,
    searching_for_value_: searching_for_value_memo,
    class_: class_
  } = _ref;
  const [get_has_highlighted, set_has_highlighted] = $8tj43$createSignal(false);
  const text_itself = $8tj43$createMemo(() => $8tj43$batch(() => {
    set_has_highlighted(false);
    const searching_for_value = searching_for_value_memo();
    const whole_text_to_display_ = whole_text_to_display_memo();
    let for_black = "";
    let pushed_grey = false;
    const search_q = searching_for_value;
    if (!search_q) return whole_text_to_display_;
    const output = [];
    const searching_for = search_q.toLowerCase();
    const push_black = () => {
      if (for_black) {
        set_has_highlighted(true);
        output.push((() => {
          var _el$ = $8tj43$getNextElement($02b6641aa50ce528$var$_tmpl$);
          $8tj43$insert(_el$, for_black);
          return _el$;
        })()); // "black"
        for_black = "";
      }
    };
    for (let i = 0; i < whole_text_to_display_.length;) {
      let is_whole_word = true;
      let searching_for_but_with_texts_casing = "";
      const i_at_start = i;
      for (let j = 0; j < searching_for.length; i++, j++) {
        const letter_in_suggestion = whole_text_to_display_[i];
        if ((letter_in_suggestion === null || letter_in_suggestion === void 0 ? void 0 : letter_in_suggestion.toLowerCase()) !== searching_for[j]) {
          is_whole_word = false;
          i = i_at_start;
          break;
        }
        searching_for_but_with_texts_casing += letter_in_suggestion;
      }
      if (is_whole_word) {
        push_black();
        output.push(searching_for_but_with_texts_casing);
        pushed_grey = true;
      } else for_black += whole_text_to_display_[i++];
    }
    push_black();
    if (!pushed_grey) {
      set_has_highlighted(false);
      return whole_text_to_display_;
    }
    return output;
  }));
  return (() => {
    var _el$2 = $8tj43$getNextElement($02b6641aa50ce528$var$_tmpl$2);
    $8tj43$className(_el$2, class_);
    $8tj43$insert(_el$2, text_itself);
    $8tj43$effect(_p$ => {
      var _v$ = !!get_has_highlighted(),
        _v$2 = whole_text_to_display_memo() /* for when line-clamped, users can see full text on hover */;
      _v$ !== _p$.e && _el$2.classList.toggle("has-match", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$2, "title", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$2;
  })();
}
var $133484ef10e4e954$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<form class=checkboxes><!$><!/><!$><!/>`);
const $133484ef10e4e954$var$max_visible_without_collapsing = 15;
const $133484ef10e4e954$var$show_non_collapsible_when_collapsed = 4;
function $133484ef10e4e954$export$dd948f91abc3a1c4(_ref) {
  let {
    filter_: filter_,
    selected_filters_: [get_selected_filters, set_selected_filters],
    i18n_: i18n_,
    view_more_button_below_group_: [, set_view_more_button_below_group_],
    filter_query_: filter_query_
  } = _ref;
  const existing_filter = $8tj43$createMemo(() => {
    const {
      field: field,
      op: op
    } = filter_();
    return get_selected_filters().find(_ref2 => {
      let {
        field: checking_field,
        op: checking_op
      } = _ref2;
      return checking_field === field && checking_op === op;
    });
  });
  let form;
  const checkboxes = $8tj43$createMemo(() => {
    const meta = filter_().meta;
    return meta.values.map((value_, index) => {
      var _meta$names, _meta$counts;
      return {
        value_: value_,
        name_: (_meta$names = meta.names) === null || _meta$names === void 0 ? void 0 : _meta$names[index],
        count_: (_meta$counts = meta.counts) === null || _meta$counts === void 0 ? void 0 : _meta$counts[index]
      };
    });
  });
  const render_checkbox = checkbox => {
    // Checkbox always calls the getters in props, so we don't wrap these values into memos
    const is_checked = $8tj43$createMemo(() => {
      var _existing_filter;
      const data = (_existing_filter = existing_filter()) === null || _existing_filter === void 0 ? void 0 : _existing_filter.data;
      const value = $af5d8e0b7d97a7f6$export$325f75597868c4f0(checkbox().value_);
      return !!(data !== null && data !== void 0 && data.some(item => $af5d8e0b7d97a7f6$export$325f75597868c4f0(item) === value));
    });
    const value = $8tj43$createMemo(() => checkbox().value_);
    const is_count_zero = $8tj43$createMemo(() => checkbox().count_ === 0);
    const display_text = $8tj43$createMemo(() => checkbox().name_ || value());
    return $8tj43$createComponent((0, $19e828709c7723a0$export$48513f6b9f8ce62d), {
      get value_() {
        return value();
      },
      get label_() {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return is_count_zero();
          },
          get fallback() {
            return $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
              whole_text_to_display_: display_text,
              searching_for_value_: () => filter_query_ === null || filter_query_ === void 0 ? void 0 : filter_query_()
            });
          },
          get children() {
            return display_text();
          }
        });
      },
      get count_() {
        return checkbox().count_;
      },
      get checked_() {
        return is_checked();
      }
    });
  };
  const show_extras_signal = $8tj43$createSignal(false);
  const [get_show_extras] = show_extras_signal;
  const togglable_rest = $8tj43$createMemo(() => checkboxes().length > $133484ef10e4e954$var$max_visible_without_collapsing);
  const {
    expand: expand,
    collapse: collapse,
    ExpandingContainer: ExpandingContainer
  } = $8e8b179489080711$export$5bad61ecde080b1f({
    duration: 200
  });
  const expanding_container_els = $8tj43$createComponent(ExpandingContainer, {
    get children() {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return togglable_rest();
        },
        get children() {
          return $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              return checkboxes().slice($133484ef10e4e954$var$show_non_collapsible_when_collapsed);
            },
            children: render_checkbox
          });
        }
      });
    }
  });
  $8tj43$createRenderEffect(() => {
    set_view_more_button_below_group_(togglable_rest() ? $8tj43$createComponent((0, $3e850b2f2cca761f$export$ca21a16d65b3dd8), {
      show_extras_: show_extras_signal,
      i18n_: i18n_
    }) : []);
  });
  $8tj43$onCleanup(() => set_view_more_button_below_group_());
  $8tj43$createEffect($8tj43$catchify1(async () => {
    if (!togglable_rest()) {
      await collapse();
      return;
    }
    if (get_show_extras()) await expand();else await collapse();
  }));
  return (() => {
    var _el$ = $8tj43$getNextElement($133484ef10e4e954$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$addEventListener(_el$, "change", $8tj43$catchify1(() => {
      const set_filter = existing_filter();
      const {
        field: field,
        op: op
      } = filter_();
      const base_object = set_filter ? set_filter : {
        op: op,
        field: field
      };
      const filter_object = {
        ...base_object,
        data: [...new FormData(form)].filter(_ref3 => {
          let [, value] = _ref3;
          return value === "on";
        }).map(_ref4 => {
          let [key] = _ref4;
          return key;
        })
      };
      const selected_filters = [...get_selected_filters()];
      if (set_filter) selected_filters.splice(selected_filters.indexOf(set_filter), 1);
      if (filter_object.data.length) selected_filters.push(filter_object);
      set_selected_filters(selected_filters);
    }));
    var _ref$ = form;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$) : form = _el$;
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
      get each() {
        return $8tj43$memo(() => !!togglable_rest())() ? checkboxes().slice(0, $133484ef10e4e954$var$show_non_collapsible_when_collapsed) : checkboxes();
      },
      children: render_checkbox
    }), _el$3, _co$);
    $8tj43$insert(_el$, expanding_container_els, _el$5, _co$2);
    return _el$;
  })();
}
var $b54fc842e721c9eb$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<form class=radios>`),
  $b54fc842e721c9eb$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span class=count>`),
  $b54fc842e721c9eb$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<label class=input-row><div class=left><input type=radio><span class=custom-indicator></span><!$><!/></div><!$><!/>`);
function $b54fc842e721c9eb$export$430444115f70a734(_ref) {
  let {
    selected_filters_: selected_filters_,
    filter_: filter_,
    filter_query_: filter_query_
  } = _ref;
  const radio_name = $8tj43$make_random_classname();
  const existing_filter = $8tj43$createMemo(() => {
    const {
      op: op,
      field: field
    } = filter_();
    return selected_filters_[0]().find(_ref2 => {
      let {
        field: checking_field,
        op: checking_op
      } = _ref2;
      return checking_field === field && checking_op === op;
    });
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($b54fc842e721c9eb$var$_tmpl$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
      get each() {
        return filter_().meta.values;
      },
      children: (value, index) => {
        const random_selector = $8tj43$make_random_classname();
        const count = $8tj43$createMemo(() => {
          var _counts;
          return (_counts = filter_().meta.counts) === null || _counts === void 0 ? void 0 : _counts[index];
        });
        const label = $8tj43$createMemo(() => {
          var _filter_$meta, _filter_$meta$names;
          const name = (_filter_$meta = filter_().meta) === null || _filter_$meta === void 0 ? void 0 : (_filter_$meta$names = _filter_$meta.names) === null || _filter_$meta$names === void 0 ? void 0 : _filter_$meta$names[index];
          if (name) return name;
          const v = value();
          return Array.isArray(v) ? v.join(" - ") : v + "";
        });
        return (() => {
          var _el$2 = $8tj43$getNextElement($b54fc842e721c9eb$var$_tmpl$3),
            _el$3 = _el$2.firstChild,
            _el$4 = _el$3.firstChild,
            _el$5 = _el$4.nextSibling,
            _el$6 = _el$5.nextSibling,
            [_el$7, _co$] = $8tj43$getNextMarker(_el$6.nextSibling),
            _el$9 = _el$3.nextSibling,
            [_el$10, _co$2] = $8tj43$getNextMarker(_el$9.nextSibling);
          $8tj43$setAttribute(_el$2, "for", random_selector);
          $8tj43$addEventListener(_el$4, "change", $8tj43$catchify1(() => {
            const filter_object = {
              op: filter_().op,
              field: filter_().field,
              data: value()
            };
            const set_filter = existing_filter();
            const selected_filters = [...selected_filters_[0]()];
            if (set_filter) selected_filters.splice(selected_filters.indexOf(set_filter), 1);
            selected_filters.push(filter_object);
            selected_filters_[1](selected_filters);
          }));
          $8tj43$setAttribute(_el$4, "id", random_selector);
          $8tj43$setAttribute(_el$4, "name", radio_name);
          $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return count() !== 0;
            },
            get fallback() {
              return label();
            },
            get children() {
              return $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
                whole_text_to_display_: label,
                searching_for_value_: () => filter_query_ === null || filter_query_ === void 0 ? void 0 : filter_query_()
              });
            }
          }), _el$7, _co$);
          $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return count() != undefined;
            },
            get children() {
              var _el$8 = $8tj43$getNextElement($b54fc842e721c9eb$var$_tmpl$2);
              $8tj43$insert(_el$8, count);
              return _el$8;
            }
          }), _el$10, _co$2);
          $8tj43$effect(() => _el$2.classList.toggle("count-0", !!(count() === 0)));
          $8tj43$effect(() => $8tj43$setProperty(_el$4, "checked", $8tj43$createMemo(() => {
            var _existing_filter;
            const v = value();
            const data = (_existing_filter = existing_filter()) === null || _existing_filter === void 0 ? void 0 : _existing_filter.data;
            if ($af5d8e0b7d97a7f6$export$325f75597868c4f0(data) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(v)) return true;
            return Array.isArray(data) && data.every((item, index) => item === v[index]);
          })()));
          return _el$2;
        })();
      }
    }));
    return _el$;
  })();
}
var $1e7465a8ffa97f6c$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=range><div class=input-group><div class=field><input type=number></div><div class=separator>-</div><div class=field><input type=number></div></div><!$><!/><div class=value-text><span class=min><!$><!/><!$><!/><!$><!/></span><span class=max><!$><!/><!$><!/><!$><!/>`),
  $1e7465a8ffa97f6c$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=slider><div class=progress>`),
  $1e7465a8ffa97f6c$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=range-group><input type=range step=any><input type=range step=any>`);
function $1e7465a8ffa97f6c$export$e0d834a0ad870cda(_ref) {
  let {
    filter_: filter_,
    selected_filters_: selected_filters_,
    i18n_: i18n_,
    filter_query_: filter_query_
  } = _ref;
  // If you ever attempt to implement that one can drag one range "knob" over the other like on prisjakt, see https://gitlab.com/depict-ai/depict.ai/-/merge_requests/8458/diffs?commit_id=c52dbdd15ca073489bee138b15d27bb6bf2992df
  // The issue with it is that one wants to discard the changes to the lower value as soon as the lower value has become the upper value when dragging the initially lower knob over the initially upper knob
  // But we can't reliably know when we've started dragging/changing the value (or at least I gave up at that point for now)
  const defaultRange = $8tj43$createMemo(() => {
    const {
      data: data
    } = filter_();
    if (data) return data;
    const {
      min: min,
      max: max
    } = filter_().meta;
    return [min, max];
  });
  const current_range = $8tj43$createSignal($8tj43$untrack(defaultRange));
  const selected_filter = $8tj43$createMemo(() => selected_filters_[0]().find(_ref2 => {
    let {
      field: checking_field,
      op: checking_op
    } = _ref2;
    return checking_field === filter_().field && checking_op === filter_().op;
  }));
  let debounce_timeout;
  $8tj43$onCleanup(() => clearTimeout(debounce_timeout));
  $8tj43$createComputed(() => {
    var _selected_filter;
    const defined_filter_data = (_selected_filter = selected_filter()) === null || _selected_filter === void 0 ? void 0 : _selected_filter.data;
    const default_data = defaultRange();
    if (Array.isArray(defined_filter_data)) current_range[1](defined_filter_data);else current_range[1](default_data);
  });
  $8tj43$createComputed(() => {
    clearTimeout(debounce_timeout);
    debounce_timeout = setTimeout($8tj43$catchify1(range => $8tj43$untrack(() => {
      const default_data = defaultRange();
      const filter_object = {
        op: filter_().op,
        field: filter_().field,
        data: range
      };
      const set_filter = selected_filter();
      const selected_filters = [...selected_filters_[0]()];
      const has_default_data = default_data.every((item, index) => range[index] === item); // if we just have the default data, don't write it to the filters since then it's hard to know if filters are set or not (whether to show clear button or not)
      const has_changed = (set_filter === null || set_filter === void 0 ? void 0 : set_filter.data[0]) !== range[0] || (set_filter === null || set_filter === void 0 ? void 0 : set_filter.data[1]) !== range[1];
      let modified_filters_array = false;
      if (set_filter && (has_changed || has_default_data)) {
        selected_filters.splice(selected_filters.indexOf(set_filter), 1);
        modified_filters_array = true;
      }
      if (!has_default_data && has_changed) {
        // we don't need to check .length too right?
        selected_filters.push(filter_object);
        modified_filters_array = true;
      }
      if (modified_filters_array) selected_filters_[1](selected_filters);
    })), 300, current_range[0]());
  });
  return $8tj43$createComponent($1e7465a8ffa97f6c$var$RangeSelector, {
    i18n_: i18n_,
    get price_formatting_() {
      return i18n_.price_formatting_;
    },
    current_range_: current_range,
    get min_() {
      return $8tj43$createMemo(() => filter_().meta.min);
    },
    get max_() {
      return $8tj43$createMemo(() => filter_().meta.max);
    }
  });
}
function $1e7465a8ffa97f6c$var$RangeSelector(_ref3) {
  let {
    max_: max_,
    min_: min_,
    current_range_: current_range_,
    price_formatting_: price_formatting_,
    i18n_: i18n_
  } = _ref3;
  let price_input_1;
  let price_input_2;
  const [get_current_range] = current_range_;
  const pre_price = $8tj43$createMemo(() => price_formatting_().pre_);
  const post_price = $8tj43$createMemo(() => price_formatting_().post_);
  const should_be_disabled_ = $8tj43$createMemo(() => Math.abs(min_() - max_()) < 2);
  return (() => {
    var _el$ = $8tj43$getNextElement($1e7465a8ffa97f6c$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$3.nextSibling,
      _el$6 = _el$5.nextSibling,
      _el$7 = _el$6.firstChild,
      _el$23 = _el$2.nextSibling,
      [_el$24, _co$7] = $8tj43$getNextMarker(_el$23.nextSibling),
      _el$8 = _el$24.nextSibling,
      _el$9 = _el$8.firstChild,
      _el$10 = _el$9.firstChild,
      [_el$11, _co$] = $8tj43$getNextMarker(_el$10.nextSibling),
      _el$12 = _el$11.nextSibling,
      [_el$13, _co$2] = $8tj43$getNextMarker(_el$12.nextSibling),
      _el$14 = _el$13.nextSibling,
      [_el$15, _co$3] = $8tj43$getNextMarker(_el$14.nextSibling),
      _el$16 = _el$9.nextSibling,
      _el$17 = _el$16.firstChild,
      [_el$18, _co$4] = $8tj43$getNextMarker(_el$17.nextSibling),
      _el$19 = _el$18.nextSibling,
      [_el$20, _co$5] = $8tj43$getNextMarker(_el$19.nextSibling),
      _el$21 = _el$20.nextSibling,
      [_el$22, _co$6] = $8tj43$getNextMarker(_el$21.nextSibling);
    var _ref$ = price_input_1;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$4) : price_input_1 = _el$4;
    $8tj43$addEventListener(_el$4, "keydown", $8tj43$catchify1(_ref4 => {
      let {
        key: key
      } = _ref4;
      if (key === "Enter") $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 0, price_input_1);
    }), true);
    $8tj43$addEventListener(_el$4, "blur", $8tj43$catchify1(() => $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 0, price_input_1)));
    var _ref$2 = price_input_2;
    typeof _ref$2 === "function" ? $8tj43$use(_ref$2, _el$7) : price_input_2 = _el$7;
    $8tj43$addEventListener(_el$7, "keydown", $8tj43$catchify1(_ref5 => {
      let {
        key: key
      } = _ref5;
      if (key === "Enter") $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 1, price_input_2);
    }), true);
    $8tj43$addEventListener(_el$7, "blur", $8tj43$catchify1(() => $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 1, price_input_2)));
    $8tj43$insert(_el$, $8tj43$createComponent($1e7465a8ffa97f6c$var$ExponentialSlider, {
      max_: max_,
      min_: min_,
      current_range_: current_range_,
      i18n_: i18n_,
      should_be_disabled_: should_be_disabled_
    }), _el$24, _co$7);
    $8tj43$insert(_el$9, pre_price, _el$11, _co$);
    $8tj43$insert(_el$9, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
      get price_() {
        return min_();
      },
      get price_formatting_() {
        return price_formatting_();
      }
    }), _el$13, _co$2);
    $8tj43$insert(_el$9, post_price, _el$15, _co$3);
    $8tj43$insert(_el$16, pre_price, _el$18, _co$4);
    $8tj43$insert(_el$16, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
      get price_() {
        return max_();
      },
      get price_formatting_() {
        return price_formatting_();
      }
    }), _el$20, _co$5);
    $8tj43$insert(_el$16, post_price, _el$22, _co$6);
    $8tj43$effect(_p$ => {
      var _v$ = !!(min_() === max_()),
        _v$2 = should_be_disabled_(),
        _v$3 = i18n_.range_filter_low_point_aria_label_(),
        _v$4 = min_(),
        _v$5 = max_(),
        _v$6 = should_be_disabled_(),
        _v$7 = i18n_.range_filter_high_point_aria_label_(),
        _v$8 = min_(),
        _v$9 = max_();
      _v$ !== _p$.e && _el$.classList.toggle("disabled", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setProperty(_el$4, "disabled", _p$.t = _v$2);
      _v$3 !== _p$.a && $8tj43$setAttribute(_el$4, "aria-label", _p$.a = _v$3);
      _v$4 !== _p$.o && $8tj43$setAttribute(_el$4, "min", _p$.o = _v$4);
      _v$5 !== _p$.i && $8tj43$setAttribute(_el$4, "max", _p$.i = _v$5);
      _v$6 !== _p$.n && $8tj43$setProperty(_el$7, "disabled", _p$.n = _v$6);
      _v$7 !== _p$.s && $8tj43$setAttribute(_el$7, "aria-label", _p$.s = _v$7);
      _v$8 !== _p$.h && $8tj43$setAttribute(_el$7, "min", _p$.h = _v$8);
      _v$9 !== _p$.r && $8tj43$setAttribute(_el$7, "max", _p$.r = _v$9);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined,
      h: undefined,
      r: undefined
    });
    $8tj43$effect(() => $8tj43$setProperty(_el$4, "value", get_current_range()[0]));
    $8tj43$effect(() => $8tj43$setProperty(_el$7, "value", get_current_range()[1]));
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
function $1e7465a8ffa97f6c$var$ExponentialSlider(_ref6) {
  let {
    current_range_: current_range_,
    min_: min_,
    i18n_: i18n_,
    max_: max_,
    should_be_disabled_: should_be_disabled_
  } = _ref6;
  // inspired by https://observablehq.com/@mbostock/nonlinear-slider
  const transform_linear_to_nonlinear = _ref7 => {
    let [smaller, larger] = _ref7;
    return [Math.sqrt(smaller), Math.sqrt(larger)];
  };
  const [read_current_range, write_current_range] = current_range_;
  const modified_range_accessor = $8tj43$createMemo(() => transform_linear_to_nonlinear(read_current_range()));
  const modified_max = $8tj43$createMemo(() => Math.sqrt(max_()));
  const modified_min = $8tj43$createMemo(() => Math.sqrt(min_()));
  const offset_value_calculator_ = (value, how_many) => {
    const number_in_linear = value * value;
    const changed = number_in_linear + how_many;
    return Math.sqrt(changed);
  };
  const convert_back = (smaller, larger) => [Math.round(smaller * smaller), Math.round(larger * larger)];
  const modified_range_setter = new_range_or_function => {
    const old_range = $8tj43$untrack(modified_range_accessor);
    const new_range = typeof new_range_or_function === "function" ? new_range_or_function(old_range) : new_range_or_function;
    const [smaller, larger] = new_range;
    const [old_smaller, old_larger] = old_range;
    const new_range_converted = convert_back(smaller, larger);
    const old_range_converted = convert_back(old_smaller, old_larger);
    if (new_range_converted[0] === old_range_converted[0] && new_range_converted[1] === old_range_converted[1])
      // If the new value gets identical rounding errors to the old value when being converted back, don't write it to the signal since it would cause an infinite loop
      return new_range;
    write_current_range(new_range_converted);
    return new_range;
  };
  return $1e7465a8ffa97f6c$var$LinearSlider({
    current_range_: [modified_range_accessor, modified_range_setter],
    // "Lie" to the actual slider so we don't have to implement exponential handling in there
    min_: modified_min,
    max_: modified_max,
    offset_value_calculator_: offset_value_calculator_,
    i18n_: i18n_,
    should_be_disabled_: should_be_disabled_
  });
}
function $1e7465a8ffa97f6c$var$LinearSlider(_ref8) {
  let {
    max_: max_,
    min_: min_,
    current_range_: current_range_,
    offset_value_calculator_: offset_value_calculator_,
    i18n_: i18n_,
    should_be_disabled_: should_be_disabled_
  } = _ref8;
  let range_input_1;
  let range_input_2;
  let clickable_slider;
  const [get_current_range, set_current_range] = current_range_;
  const progress_styling = $8tj43$createMemo(() => {
    const min = min_();
    const span = max_() - min;
    const [start, end] = get_current_range();
    if (should_be_disabled_()) return "left:50%;right:50%";
    return "left:".concat((start - min) / span * 100, "%;right:").concat(100 - (end - min) / span * 100, "%");
  });
  const set_value = (el, index) => {
    // initially I set the value on the elements by just having value={get_current_range()[0]}
    // the issue with that is that we sometimes need to set the value to an invalid range (i.e. sometimes when navigating backwards and forwards)
    // if we do that, the browser will change el.value to fit withing min and max and then once min and max have updated (they update later, when we have an api response, while value updates instantly from history.state) el.value will be different from the solid signal that set it
    // with this "workaround" we ensure that el.value matches the solid signal closer
    $8tj43$createEffect(() => {
      min_();
      max_();
      el.value = get_current_range()[index];
    });
  };
  return [(() => {
    var _el$25 = $8tj43$getNextElement($1e7465a8ffa97f6c$var$_tmpl$2),
      _el$26 = _el$25.firstChild;
    $8tj43$addEventListener(_el$25, "click", $8tj43$catchify1(e => {
      const rect = clickable_slider.getBoundingClientRect();
      const slider_beginning_left = rect.left;
      const slider_width = rect.width;
      const click_from_left_in_slider = e.clientX - slider_beginning_left; // both of these value contain scroll position so this should work regardless of horisontal scroll if there is any
      const place_of_click_in_percent = click_from_left_in_slider / slider_width * 100;
      const one_percent_of_range = (max_() - min_()) / 100;
      const place_of_click = min_() + one_percent_of_range * place_of_click_in_percent;
      const [lower, upper] = get_current_range();
      const distance_to_lower_point = Math.abs(place_of_click - lower);
      const distance_to_upper_point = Math.abs(upper - place_of_click);
      if (distance_to_lower_point < distance_to_upper_point) set_current_range([place_of_click, upper]);else set_current_range([lower, place_of_click]);
    }), true);
    var _ref$3 = clickable_slider;
    typeof _ref$3 === "function" ? $8tj43$use(_ref$3, _el$25) : clickable_slider = _el$25;
    $8tj43$effect(_$p => $8tj43$style(_el$26, progress_styling(), _$p));
    $8tj43$runHydrationEvents();
    return _el$25;
  })(), (() => {
    var _el$27 = $8tj43$getNextElement($1e7465a8ffa97f6c$var$_tmpl$3),
      _el$28 = _el$27.firstChild,
      _el$29 = _el$28.nextSibling;
    $8tj43$use(el => {
      range_input_1 = el;
      set_value(range_input_1, 0);
    }, _el$28);
    $8tj43$addEventListener(_el$28, "input", $8tj43$catchify1(() => $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 0, range_input_1, offset_value_calculator_)), true);
    $8tj43$use(el => {
      range_input_2 = el;
      set_value(range_input_2, 1);
    }, _el$29);
    $8tj43$addEventListener(_el$29, "input", $8tj43$catchify1(() => $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_, 1, range_input_2, offset_value_calculator_)), true);
    $8tj43$effect(_p$ => {
      var _v$10 = should_be_disabled_(),
        _v$11 = i18n_.range_filter_low_point_aria_label_(),
        _v$12 = min_(),
        _v$13 = max_(),
        _v$14 = should_be_disabled_(),
        _v$15 = i18n_.range_filter_high_point_aria_label_(),
        _v$16 = min_(),
        _v$17 = max_();
      _v$10 !== _p$.e && $8tj43$setProperty(_el$28, "disabled", _p$.e = _v$10);
      _v$11 !== _p$.t && $8tj43$setAttribute(_el$28, "aria-label", _p$.t = _v$11);
      _v$12 !== _p$.a && $8tj43$setAttribute(_el$28, "min", _p$.a = _v$12);
      _v$13 !== _p$.o && $8tj43$setAttribute(_el$28, "max", _p$.o = _v$13);
      _v$14 !== _p$.i && $8tj43$setProperty(_el$29, "disabled", _p$.i = _v$14);
      _v$15 !== _p$.n && $8tj43$setAttribute(_el$29, "aria-label", _p$.n = _v$15);
      _v$16 !== _p$.s && $8tj43$setAttribute(_el$29, "min", _p$.s = _v$16);
      _v$17 !== _p$.h && $8tj43$setAttribute(_el$29, "max", _p$.h = _v$17);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined,
      h: undefined
    });
    $8tj43$effect(() => $8tj43$setProperty(_el$28, "value", $8tj43$createMemo(() => {
      min_();
      max_();
      return get_current_range()[0];
    }, undefined, {
      equals: false
    })()));
    $8tj43$runHydrationEvents();
    return _el$27;
  })()];
}
function $1e7465a8ffa97f6c$var$set_range_with_sanitation(min_, max_, current_range_signal, index, target_el) {
  let get_offset_value = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : (value, how_many) => value + how_many;
  let value_as_number = +target_el.value;
  const min = $8tj43$untrack(() => min_());
  const max = $8tj43$untrack(() => max_());
  const too_small = value_as_number < min;
  const too_big = value_as_number > max;
  const current_range = $8tj43$untrack(current_range_signal[0]);
  const [current_lower, current_upper] = current_range;
  if (index === 0 && value_as_number >= current_upper) target_el.value = value_as_number = get_offset_value(current_upper, -1);else if (index === 1 && value_as_number <= current_lower) target_el.value = value_as_number = get_offset_value(current_lower, 1);else if (too_small || too_big) target_el.value = value_as_number = too_small ? min : max;
  const new_value = [...current_range];
  new_value[index] = value_as_number;
  current_range_signal[1](new_value);
}
$8tj43$delegateEvents(["keydown", "click", "input"]);
var $457279ff15864cb9$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=morphing-sign role=img><span></span><span>`);
function $457279ff15864cb9$export$e5c2828934226505(_ref) {
  let {
    expanded_: expanded_,
    i18n_: i18n_
  } = _ref;
  return (() => {
    var _el$ = $8tj43$getNextElement($457279ff15864cb9$var$_tmpl$);
    $8tj43$effect(_p$ => {
      var _v$ = !!expanded_(),
        _v$2 = expanded_() ? i18n_.morphing_sign_expanded_aria_label_() : i18n_.morphing_sign_collapsed_aria_label_();
      _v$ !== _p$.e && _el$.classList.toggle("expanded", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$, "aria-label", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}
var $f3a159279dc1a8fb$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class=highlighted-part>`);
const $f3a159279dc1a8fb$var$dont_cut_in_between_less_than_characters = 30;
function $f3a159279dc1a8fb$export$e1a98a189fd2c0e7(_ref) {
  let {
    content_result_: content_result_,
    key_: key_,
    cut_when_possible_: cut_when_possible_
  } = _ref;
  const matched_tokens = $8tj43$createMemo(() => {
    var _content_result_$high, _content_result_$high2;
    return (_content_result_$high = content_result_().highlights) === null || _content_result_$high === void 0 ? void 0 : (_content_result_$high2 = _content_result_$high.find(highlight => highlight.field == key_)) === null || _content_result_$high2 === void 0 ? void 0 : _content_result_$high2.matched_tokens;
  });
  const full_value = $8tj43$createMemo(() => {
    var _content_result_$key_;
    return (_content_result_$key_ = content_result_()[key_]) === null || _content_result_$key_ === void 0 ? void 0 : _content_result_$key_.replaceAll("\n", " ");
  });
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _matched_tokens;
      return (_matched_tokens = matched_tokens()) === null || _matched_tokens === void 0 ? void 0 : _matched_tokens.length;
    },
    get fallback() {
      return full_value();
    },
    get children() {
      return (() => {
        const segmented_cut_text = $8tj43$createMemo(() => {
          const segmented_text = $f3a159279dc1a8fb$export$1b00d74faf266c56(full_value(), matched_tokens());
          if (cut_when_possible_) $f3a159279dc1a8fb$var$cut_text(segmented_text);
          return segmented_text;
        });
        return $8tj43$createComponent((0, $8tj43$Index), {
          get each() {
            return segmented_cut_text();
          },
          children: item => {
            return $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return item().highlighted_;
              },
              get fallback() {
                return item().text_;
              },
              get children() {
                var _el$ = $8tj43$getNextElement($f3a159279dc1a8fb$var$_tmpl$);
                $8tj43$insert(_el$, () => item().text_);
                return _el$;
              }
            });
          }
        });
      })();
    }
  });
}
function $f3a159279dc1a8fb$var$cut_text(segmented_text) {
  // cut away chunks of text that are not highlighted to give a google-like overview of the content
  const highlighted_segments = segmented_text === null || segmented_text === void 0 ? void 0 : segmented_text.filter(segment => segment.highlighted_);
  if (!segmented_text || !(highlighted_segments !== null && highlighted_segments !== void 0 && highlighted_segments.length)) return;
  // We have one or more highlighted segments
  if (highlighted_segments.length === 1) {
    // cut away from the left until the start of the highlighted sentence if just one sentence is highlighted
    $f3a159279dc1a8fb$var$cut_start(segmented_text.indexOf(highlighted_segments[0]), segmented_text);
    return;
  }
  // We have two or more highlighted segments, take the two biggest chunks and show them + a bit text around
  const sorted_highlighted_segments = [...highlighted_segments].sort((a, b) => b.text_.trim().length - a.text_.trim().length // trim to avoid unfair comparisons due to whitespace
  );

  const [longest_segment, next_longest_segment] = sorted_highlighted_segments;
  // We need to cut before the first segment - possibly through other segments - and maybe between segments
  let [index_of_first_segment, index_of_second_segment] = [segmented_text.indexOf(longest_segment), segmented_text.indexOf(next_longest_segment)].sort((a, b) => a - b);
  $f3a159279dc1a8fb$var$cut_start(index_of_first_segment, segmented_text);
  // update indexes since we might have removed segments
  [index_of_first_segment, index_of_second_segment] = [segmented_text.indexOf(longest_segment), segmented_text.indexOf(next_longest_segment)].sort((a, b) => a - b);
  let number_of_characters_between_segments = 0;
  for (let i = index_of_first_segment + 1; i < index_of_second_segment; i++) {
    const segment = segmented_text[i];
    number_of_characters_between_segments += segment.text_.length;
  }
  if (number_of_characters_between_segments < $f3a159279dc1a8fb$var$dont_cut_in_between_less_than_characters)
    // don't cut if there are less than 30 characters between the two segments
    return;
  // We have more than 50 characters between the two segments, cut between them
  const [split_start_segment, split_start_character] = $f3a159279dc1a8fb$var$find_split_point(index_of_first_segment, index_of_second_segment, segmented_text);
  const [split_end_segment, split_end_character] = $f3a159279dc1a8fb$var$find_split_point(index_of_second_segment, index_of_first_segment, segmented_text);
  if (split_start_segment === undefined || split_end_segment === undefined ||
  // identical split point, or split end before split start, can't do anything
  split_start_segment == split_end_segment && split_start_character >= split_end_character || split_start_segment > split_end_segment) return;
  const dots_segment = {
    text_: " \u2026 ",
    highlighted_: false
  };
  const split_and_dotted_values = segmented_text.flatMap((segment, i) => {
    if (i < split_start_segment || i > split_end_segment) return segment;
    const text = segment.text_;
    if (i == split_end_segment && i == split_start_segment) return [{
      ...segment,
      text_: text.slice(0, split_start_character).trimEnd()
    }, dots_segment, {
      ...segment,
      text_: text.slice(split_end_character + 1, text.length).trimStart()
    }];else if (i == split_start_segment) {
      segment.text_ = text.slice(0, split_start_character).trimEnd(); // this would be split_start_character + 1, but we want to remove the last "dot" because . ... looks weird
      return segment;
    } else if (i == split_end_segment) return [dots_segment, {
      ...segment,
      text_: text.slice(split_end_character + 1, text.length).trimStart()
    }];
    return []; // remove all segments inbetween
  });

  segmented_text.splice(0, segmented_text.length, ...split_and_dotted_values); // Sorry…
  $f3a159279dc1a8fb$var$heal_holes(segmented_text);
}
function $f3a159279dc1a8fb$var$heal_holes(segmented_text) {
  // try to heal "holes" created in the segments so there are only alternating segments
  const segments_to_delete = new Set();
  for (let i = 0; i < segmented_text.length; i++) {
    var _previous_segment, _previous_segment2;
    const segment = segmented_text[i];
    let previous_segment;
    for (let j = i - 1; j >= 0; j--) {
      previous_segment = segmented_text[j];
      // Don't write to a segment that's marked for deletion or the contents we write to it will be deleted
      if (!segments_to_delete.has(previous_segment)) break;
    }
    if ((_previous_segment = previous_segment) !== null && _previous_segment !== void 0 && _previous_segment.highlighted_ && segment.highlighted_ || ((_previous_segment2 = previous_segment) === null || _previous_segment2 === void 0 ? void 0 : _previous_segment2.highlighted_) === false && segment.highlighted_ === false) {
      previous_segment.text_ += segment.text_; // IDK if this ever happens
      segments_to_delete.add(segment);
    }
  }
  for (const segment of segments_to_delete) {
    const index = segmented_text.indexOf(segment);
    segmented_text.splice(index, 1);
  }
}
function $f3a159279dc1a8fb$var$find_split_point(index_of_start_segment, index_of_end_segment, segmented_text) {
  let be_very_aggressive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const should_loop_backwards = index_of_start_segment > index_of_end_segment;
  const step = should_loop_backwards ? -1 : 1;
  const desperate_split_attempts = [":", ";", ","];
  while (desperate_split_attempts.length) {
    const split_point_between_words = [];
    // for the middle also try to split with a few more characters if the default ones don't work over a full run
    const desperate_split_attempt = desperate_split_attempts.pop();
    let is_first_character = true;
    for (let i = index_of_start_segment + step; should_loop_backwards ? i > index_of_end_segment : i < index_of_end_segment; i += step) {
      const segment = segmented_text[i];
      const text = segment.text_;
      for (let j = should_loop_backwards ? text.length - 1 : 0; should_loop_backwards ? j >= 0 : j < text.length; j += step) {
        const character = text[j];
        if (character == "." || character == "?" || character == "!" || character == desperate_split_attempt) return [i, j]; // segment index, character index
        if (is_first_character) is_first_character = false;else if (be_very_aggressive && character == " ") {
          split_point_between_words.push([i, j]);
          if (split_point_between_words.length > 3)
            // We can't find a split point, so we'll just split between words
            // This is because for UI reasons we only want to show 2 lines of text, so we need to be very aggressive with getting the second match soon
            return split_point_between_words[1];
        }
      }
    }
  }
  return [];
}
function $f3a159279dc1a8fb$var$cut_start(cut_left_of_index, segmented_text) {
  // Cut the start of the text to bring the first matching token
  let is_first_character = false;
  let words_encountered = 0;
  outmost_loop: for (let i = cut_left_of_index - 1; i >= 0; i--) {
    const segment = segmented_text[i];
    // We assume that two adjacent highlighted segments don't exist and have been merged if they were to have existed
    const text = segment.text_;
    for (let j = text.length - 1; j >= 0; j--) {
      const character = text[j];
      const is_space = character == " ";
      if (!is_first_character && is_space) words_encountered++;
      if (character == "." || character == "?" || character == "!" || character == "," || words_encountered > 8 && is_space) {
        // We have to be really aggressive at the start of sentences so stuff can be seen on mobile, hence comma
        segment.text_ = text.slice(j + 1).trimStart();
        segmented_text.splice(0, i);
        if (character === "," || is_space)
          // if we cut at a comma or psace, we add a … at the beginning
          segmented_text.unshift({
            text_: "\u2026 ",
            highlighted_: false
          });
        break outmost_loop;
      }
      if (is_first_character) is_first_character = false;
    }
  }
  $f3a159279dc1a8fb$var$heal_holes(segmented_text); // if we added a ... there could now be a sequence that's not alternating true/false
}

function $f3a159279dc1a8fb$export$1b00d74faf266c56(text, matched_strings) {
  let loose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const output = [];
  if (!text) return; // shouldn't happen but whatever
  for (let i = 0; i < text.length; i++) {
    const found_strings = [];
    if (!i || text[i - 1] == " " || loose)
      // only match at the start of a word or string, it looks weird if i.e. "we" is highlighted in "activewear
      for (let j = 0; j < matched_strings.length; j++) {
        const matched_string = matched_strings[j];
        const part_in_text = text.slice(i, i + matched_string.length);
        if (matched_string.length < 2 && !loose) continue; // don't match on single characters, i.e. "I", it looks weird
        if (part_in_text.toLowerCase() === matched_string.toLowerCase()) found_strings.push(part_in_text); // use the casing from the text, not from typesense, can look weird otherwise
      }

    const last_index_in_output = output.length - 1;
    if (!found_strings.length) {
      var _output$last_index_in;
      const character = text[i];
      if (((_output$last_index_in = output[last_index_in_output]) === null || _output$last_index_in === void 0 ? void 0 : _output$last_index_in.highlighted_) === false || output.length && /\s/.test(character))
        // always push whitespace characters to the last segment, this is because typesense doesn't see them as part of the matched tokens but we want to be able to detect "phat" matched segments
        output[last_index_in_output].text_ += character;else output.push({
        highlighted_: false,
        text_: character
      });
    } else {
      var _output$last_index_in2;
      const longest_found_string = found_strings.reduce((a, b) => a.length > b.length ? a : b);
      if ((_output$last_index_in2 = output[last_index_in_output]) !== null && _output$last_index_in2 !== void 0 && _output$last_index_in2.highlighted_) output[last_index_in_output].text_ += longest_found_string;else output.push({
        highlighted_: true,
        text_: longest_found_string
      });
      i += longest_found_string.length - 1;
    }
  }
  return output;
}
var $b0e2100b511ec9a4$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span>`),
  $b0e2100b511ec9a4$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span class=highlighted-part>`);
function $b0e2100b511ec9a4$export$8e79c28529dbfa90(props) {
  const segmented_text = $8tj43$createMemo(() => {
    const {
      to_highlight_: to_highlight_,
      text_: text_
    } = props;
    return $f3a159279dc1a8fb$export$1b00d74faf266c56(text_, to_highlight_ ? [to_highlight_] : [], true);
  });
  const has_highlights = $8tj43$createMemo(() => segmented_text().some(segment => segment.highlighted_));
  return (() => {
    var _el$ = $8tj43$getNextElement($b0e2100b511ec9a4$var$_tmpl$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
      get each() {
        return segmented_text();
      },
      children: item => {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return item().highlighted_;
          },
          get fallback() {
            return item().text_;
          },
          get children() {
            var _el$2 = $8tj43$getNextElement($b0e2100b511ec9a4$var$_tmpl$2);
            $8tj43$insert(_el$2, () => item().text_);
            return _el$2;
          }
        });
      }
    }));
    $8tj43$effect(_p$ => {
      var _v$ = props.text_,
        _v$2 = !!has_highlights();
      _v$ !== _p$.e && $8tj43$setAttribute(_el$, "title", _p$.e = _v$);
      _v$2 !== _p$.t && _el$.classList.toggle("has-match", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}
var $0ae614c5c7babb43$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<form class="checkboxes hierarchical"><!$><!/><!$><!/>`),
  $0ae614c5c7babb43$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=checkbox-details><!$><!/><!$><!/>`),
  $0ae614c5c7babb43$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<details>`),
  $0ae614c5c7babb43$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<summary class=category-parent><div class=summary><span class=count></span><!$><!/>`);
const $0ae614c5c7babb43$var$max_visible_without_collapsing = 15;
const $0ae614c5c7babb43$var$show_non_collapsible_when_collapsed = 4;
function $0ae614c5c7babb43$export$a32086fa6616eafd(_ref) {
  let {
    filter_: filter_,
    selected_filters_: selected_filters_,
    i18n_: i18n_,
    view_more_button_below_group_: [, set_view_more_button_below_group],
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    filter_query_: filter_query_
  } = _ref;
  let form;
  const existing_filter = $8tj43$createMemo(() => {
    const {
      field: field,
      op: op
    } = filter_();
    return selected_filters_[0]().find(_ref2 => {
      let {
        field: checking_field,
        op: checking_op
      } = _ref2;
      return checking_field === field && checking_op === op;
    });
  });
  const show_extras = $8tj43$createSignal(false);
  const is_being_searched_ = $8tj43$createMemo(() => !!(filter_query_ !== null && filter_query_ !== void 0 && filter_query_())); // If the user is searching in the filter
  const trigger_sync_ = $0ae614c5c7babb43$var$batching_filter_state_syncer({
    filter_: filter_,
    existing_filter_: existing_filter,
    selected_filters_: selected_filters_,
    get category_structure_() {
      return structured_categories();
    }
  });
  const structured_categories = $8tj43$createMemo(() => {
    const execute_when_structure_finished = [];
    const {
      values: values,
      names: names,
      counts: counts
    } = filter_().meta;
    const data_structure = {};
    for (let i = 0; i < values.length; i++) {
      const value = values[i];
      let pointer = data_structure;
      let parent_ = {};
      let created_an_object = false;
      for (let j = 0; j < value.length; j++) {
        var _pointer;
        const this_categories_name = value[j];
        const obj = (_pointer = pointer)[this_categories_name] || (_pointer[this_categories_name] = (() => {
          const value_as_string = value.map(v => typeof v === "number" ? v + "" : v); // don't think backend will ever send numbers but technically it's allowed;
          const created_obj = {
            name_: names[i],
            count_: counts === null || counts === void 0 ? void 0 : counts[i],
            parent_: parent_,
            is_expanded_: $0ae614c5c7babb43$var$make_expanded_signal({
              expanded_hierarchical_filters_: expanded_hierarchical_filters_,
              filter_value_: value_as_string,
              is_being_searched_: is_being_searched_
            }),
            value_: value_as_string,
            children_: {}
          };
          const {
            signal_: signal_,
            on_structure_complete_: on_structure_complete_
          } = $0ae614c5c7babb43$var$create_updating_signal({
            self_: created_obj,
            existing_filter_: $8tj43$untrack(existing_filter),
            trigger_sync_: trigger_sync_
          });
          execute_when_structure_finished.push(on_structure_complete_);
          created_obj.is_checked_ = signal_;
          parent_ = created_obj;
          created_an_object = true;
          return created_obj;
        })());
        pointer = obj.children_;
        parent_ = obj;
      }
      if (!created_an_object && "value_" in parent_) {
        // if an object was created for our "depth" in the hierarchy but not for our specific entry this means that the entry array was unsorted and looked something like
        // [
        //   ["Öl", "IPA"],
        //   ["Öl", "Pale Ale"],
        //   ["Öl", "Ale"],
        //   ["Öl", "Mörk Lager"],
        //   ["Öl", "Suröl"],
        //   ["Öl", "Veteöl"],
        //   ["Öl", "Stout och Porter"],
        //   ["Öl"], // <- We are here, our `hierarchical_data_structure[string]`-object was created when we iterated over ["Öl", "IPA"]
        //   ["Öl", "Ljus Lager"],
        // ];
        // In this case we want to just correct the name and value of the already created object, which will be in parent_
        parent_.value_ = value.map(v => v + "");
        parent_.name_ = names[i];
        parent_.count_ = counts === null || counts === void 0 ? void 0 : counts[i];
        parent_.is_expanded_ = $0ae614c5c7babb43$var$make_expanded_signal({
          expanded_hierarchical_filters_: expanded_hierarchical_filters_,
          filter_value_: parent_.value_,
          is_being_searched_: is_being_searched_
        });
      }
    }
    while (execute_when_structure_finished.length) execute_when_structure_finished.pop()();
    $0ae614c5c7babb43$var$expand_until_choice(data_structure);
    $8tj43$dlog("CheckboxHierarchicalFilter: Recomputed structured_categories", data_structure);
    return data_structure;
  });
  const some_top_level_are_hidden = $8tj43$createMemo(() => Object.keys(structured_categories()).length > $0ae614c5c7babb43$var$max_visible_without_collapsing);
  const {
    expand: expand,
    collapse: collapse,
    ExpandingContainer: ExpandingContainer
  } = $8e8b179489080711$export$5bad61ecde080b1f({
    duration: 200
  });
  const expanding_container_els = $8tj43$createComponent(ExpandingContainer, {
    get children() {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return some_top_level_are_hidden();
        },
        get children() {
          return $0ae614c5c7babb43$var$render_stuff($8tj43$createMemo(() => Object.fromEntries(Object.entries(structured_categories()).slice($0ae614c5c7babb43$var$show_non_collapsible_when_collapsed))), existing_filter, i18n_, filter_query_);
        }
      });
    }
  });
  $8tj43$createRenderEffect(() => {
    set_view_more_button_below_group(some_top_level_are_hidden() ? $8tj43$createComponent((0, $3e850b2f2cca761f$export$ca21a16d65b3dd8), {
      show_extras_: show_extras,
      i18n_: i18n_
    }) : []);
  });
  $8tj43$onCleanup(() => set_view_more_button_below_group());
  $8tj43$createEffect($8tj43$catchify1(async () => {
    if (!some_top_level_are_hidden()) {
      await collapse();
      return;
    }
    if (show_extras[0]()) await expand();else await collapse();
  }));
  return (() => {
    var _el$ = $8tj43$getNextElement($0ae614c5c7babb43$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    var _ref$ = form;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$) : form = _el$;
    $8tj43$insert(_el$, () => $0ae614c5c7babb43$var$render_stuff($8tj43$createMemo(() => some_top_level_are_hidden() ? Object.fromEntries(Object.entries(structured_categories()).slice(0, $0ae614c5c7babb43$var$show_non_collapsible_when_collapsed)) : structured_categories()), existing_filter, i18n_, filter_query_), _el$3, _co$);
    $8tj43$insert(_el$, expanding_container_els, _el$5, _co$2);
    $8tj43$effect(() => _el$.classList.toggle("any-expandable", !!Object.values(structured_categories()).some(category => Object.keys(category.children_).length)));
    return _el$;
  })();
}
function $0ae614c5c7babb43$var$render_stuff(data, existing_filter, i18n_, filter_query_) {
  const keys = $8tj43$createMemo(() => Object.keys(data()));
  return $8tj43$createComponent((0, $8tj43$For), {
    get each() {
      return keys();
    },
    children: key => $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return $8tj43$createMemo(() => !!data()[key])();
      },
      get children() {
        return (() => {
          // for some reason the for thing doesn't dispose of us if the key no longer exists?? so I'm doing it with show instead
          const value = $8tj43$createMemo(() => data()[key]); // still sometimes get undefined here even though we have <Show>
          const has_expandable = $8tj43$createMemo(() => {
            var _value;
            return !!Object.keys(((_value = value()) === null || _value === void 0 ? void 0 : _value.children_) || {}).length;
          });
          const value_as_string = $8tj43$createMemo(() => {
            var _value2;
            return JSON.stringify((_value2 = value()) === null || _value2 === void 0 ? void 0 : _value2.value_);
          });
          const label_text = $8tj43$createMemo(() => {
            var _value3;
            return ((_value3 = value()) === null || _value3 === void 0 ? void 0 : _value3.name_) || value_as_string();
          });
          return (() => {
            var _el$6 = $8tj43$getNextElement($0ae614c5c7babb43$var$_tmpl$2),
              _el$7 = _el$6.firstChild,
              [_el$8, _co$3] = $8tj43$getNextMarker(_el$7.nextSibling),
              _el$9 = _el$8.nextSibling,
              [_el$10, _co$4] = $8tj43$getNextMarker(_el$9.nextSibling);
            $8tj43$insert(_el$6, $8tj43$createComponent((0, $19e828709c7723a0$export$48513f6b9f8ce62d), {
              get value_() {
                return value_as_string();
              },
              get label_() {
                return $8tj43$createComponent((0, $8tj43$Show), {
                  get when() {
                    var _value4;
                    return ((_value4 = value()) === null || _value4 === void 0 ? void 0 : _value4.count_) === 0;
                  },
                  get fallback() {
                    return $8tj43$createComponent((0, $b0e2100b511ec9a4$export$8e79c28529dbfa90), {
                      get text_() {
                        return label_text();
                      },
                      get to_highlight_() {
                        return filter_query_ === null || filter_query_ === void 0 ? void 0 : filter_query_();
                      }
                    });
                  },
                  get children() {
                    return label_text();
                  }
                });
              },
              get count_() {
                var _value5;
                return $8tj43$memo(() => !!has_expandable())() ? undefined : (_value5 = value()) === null || _value5 === void 0 ? void 0 : _value5.count_;
              },
              get is_count_zero_() {
                var _value6;
                return $8tj43$memo(() => !!has_expandable())() && ((_value6 = value()) === null || _value6 === void 0 ? void 0 : _value6.count_) === 0;
              },
              get checked_() {
                var _value$is_checked_$, _value7, _value7$is_checked_, _value7$is_checked_$;
                return (_value$is_checked_$ = (_value7 = value()) === null || _value7 === void 0 ? void 0 : (_value7$is_checked_ = _value7.is_checked_) === null || _value7$is_checked_ === void 0 ? void 0 : (_value7$is_checked_$ = _value7$is_checked_[0]) === null || _value7$is_checked_$ === void 0 ? void 0 : _value7$is_checked_$.call(_value7$is_checked_)) !== null && _value$is_checked_$ !== void 0 ? _value$is_checked_$ : false;
              },
              input_ref_: input => {
                input.addEventListener("change", $8tj43$catchify1(() => $8tj43$untrack(() => {
                  var _value9;
                  const {
                    checked: checked
                  } = input;
                  if (checked) {
                    var _value8;
                    (_value8 = value()) === null || _value8 === void 0 || _value8.is_expanded_.set_user_expanded_(true);
                  }
                  (_value9 = value()) === null || _value9 === void 0 || _value9.is_checked_[1](checked);
                })));
                const any_kids_checked = $8tj43$createMemo(() => {
                  var _value10;
                  let are_checked = false;
                  const to_check = Object.values(((_value10 = value()) === null || _value10 === void 0 ? void 0 : _value10.children_) || {});
                  while (to_check.length) {
                    const kid_to_check = to_check.pop();
                    to_check.push(...Object.values(kid_to_check.children_));
                    if (kid_to_check.is_checked_[0]()) {
                      are_checked = true;
                      break;
                    }
                  }
                  return are_checked;
                });
                $8tj43$createEffect(() => input.classList[any_kids_checked() ? "add" : "remove"]("fake-checked"));
              }
            }), _el$8, _co$3);
            $8tj43$insert(_el$6, $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return has_expandable();
              },
              get children() {
                return (() => {
                  const is_open = $8tj43$createMemo(() => {
                    const v = value();
                    if (!v)
                      // only to prevent cleanup errors
                      return $8tj43$createSignal(false);
                    const {
                      is_expanded_: {
                        ui_should_show_expanded_: ui_should_show_expanded_,
                        set_user_expanded_: set_user_expanded_
                      }
                    } = v;
                    return [ui_should_show_expanded_, set_user_expanded_];
                  });
                  return $8tj43$createComponent((0, $ad371564683947ab$export$6c6d7a51fa9aa15d), {
                    get details_() {
                      return $8tj43$getNextElement($0ae614c5c7babb43$var$_tmpl$3);
                    },
                    get summary_() {
                      return (() => {
                        var _el$12 = $8tj43$getNextElement($0ae614c5c7babb43$var$_tmpl$4),
                          _el$13 = _el$12.firstChild,
                          _el$14 = _el$13.firstChild,
                          _el$15 = _el$14.nextSibling,
                          [_el$16, _co$5] = $8tj43$getNextMarker(_el$15.nextSibling);
                        $8tj43$insert(_el$14, () => {
                          var _value11;
                          return (_value11 = value()) === null || _value11 === void 0 ? void 0 : _value11.count_;
                        });
                        $8tj43$insert(_el$13, $8tj43$createComponent((0, $457279ff15864cb9$export$e5c2828934226505), {
                          i18n_: i18n_,
                          get expanded_() {
                            return $8tj43$createMemo(() => {
                              var _value$is_expanded_$u, _value12, _value12$is_expanded_, _value12$is_expanded_2;
                              return (_value$is_expanded_$u = (_value12 = value()) === null || _value12 === void 0 ? void 0 : (_value12$is_expanded_ = _value12.is_expanded_) === null || _value12$is_expanded_ === void 0 ? void 0 : (_value12$is_expanded_2 = _value12$is_expanded_.ui_should_show_expanded_) === null || _value12$is_expanded_2 === void 0 ? void 0 : _value12$is_expanded_2.call(_value12$is_expanded_)) !== null && _value$is_expanded_$u !== void 0 ? _value$is_expanded_$u : false;
                            });
                          }
                        }), _el$16, _co$5);
                        $8tj43$effect(() => {
                          var _value13;
                          return _el$14.classList.toggle("count-0", !!(((_value13 = value()) === null || _value13 === void 0 ? void 0 : _value13.count_) === 0));
                        });
                        return _el$12;
                      })();
                    },
                    get is_open_() {
                      return is_open();
                    },
                    get children() {
                      return $0ae614c5c7babb43$var$render_stuff($8tj43$createMemo(() => {
                        var _value14;
                        return ((_value14 = value()) === null || _value14 === void 0 ? void 0 : _value14.children_) || {};
                      }), existing_filter, i18n_, filter_query_);
                    }
                  });
                })();
              }
            }), _el$10, _co$4);
            $8tj43$effect(() => _el$6.classList.toggle("expandable", !!has_expandable()));
            return _el$6;
          })();
        })();
      }
    })
  });
}
function $0ae614c5c7babb43$var$batching_filter_state_syncer(props) {
  const {
    filter_: filter_,
    selected_filters_: selected_filters_,
    existing_filter_: existing_filter_
  } = props;
  let sync_queued = false;
  const sync_fn = $8tj43$catchify1(async () => {
    sync_queued = false;
    // if we change, update filter state - next microtask, so that "reactions" to the change can process before we send it off to the API
    const set_filter = existing_filter_();
    const {
      field: field,
      op: op
    } = filter_();
    const base_object = set_filter ? set_filter : {
      op: op,
      field: field
    };
    const data = [];
    // recursively go through and build new filter value
    const to_process = Object.values(props.category_structure_);
    while (to_process.length) {
      const item = to_process.pop();
      to_process.push(...Object.values(item.children_));
      if (item.is_checked_[0]()) data.push(item.value_);
    }
    const filter_object = {
      ...base_object,
      data: data
    };
    $8tj43$dlog("CheckboxHierarchicalFilter: Updating API state", filter_object);
    const selected_filters = [...selected_filters_[0]()];
    if (set_filter) selected_filters.splice(selected_filters.indexOf(set_filter), 1);
    if (filter_object.data.length) selected_filters.push(filter_object);
    selected_filters_[1](selected_filters);
  });
  const trigger_sync = () => {
    if (!sync_queued) {
      queueMicrotask(sync_fn);
      sync_queued = true;
    }
  };
  return trigger_sync;
}
function $0ae614c5c7babb43$var$create_updating_signal(_ref3) {
  let {
    self_: self_,
    existing_filter_: existing_filter_,
    trigger_sync_: trigger_sync_
  } = _ref3;
  const signal_ = [];
  const on_structure_complete_ = () => {
    var _existing_filter_$dat, _existing_filter_$dat2;
    // wait for the children to have populated and us to have received the correct value_ and name_ values
    let updating_blocked = false;
    const index_of_us_in_selected_filter = existing_filter_ === null || existing_filter_ === void 0 ? void 0 : (_existing_filter_$dat = existing_filter_.data) === null || _existing_filter_$dat === void 0 ? void 0 : (_existing_filter_$dat2 = _existing_filter_$dat.findIndex) === null || _existing_filter_$dat2 === void 0 ? void 0 : _existing_filter_$dat2.call(_existing_filter_$dat, el => el.length === self_.value_.length && el.every((sub_el, index) => $af5d8e0b7d97a7f6$export$325f75597868c4f0(self_.value_[index]) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(sub_el)));
    signal_.push(...$8tj43$createSignal(index_of_us_in_selected_filter >= 0));
    const [read_checked, write_checked] = signal_;
    const child_objects = Object.values(self_.children_);
    const get_child_object_values = child_objects.map(_ref4 => {
      let {
        is_checked_: [read_is_checked]
      } = _ref4;
      return read_is_checked;
    });
    $8tj43$createComputed($8tj43$on(read_checked, trigger_sync_, {
      defer: true
    }));
    $8tj43$createComputed($8tj43$on(read_checked, $8tj43$catchify1(new_value => {
      if (updating_blocked) return;
      for (const child of child_objects) child.is_checked_[1](new_value);
    }), {
      defer: true
    }));
    $8tj43$createEffect($8tj43$on(get_child_object_values, $8tj43$catchify1(() => {
      const all_kids_checked = get_child_object_values.every(accessor => accessor());
      if (all_kids_checked === read_checked()) return;
      updating_blocked = true;
      let initial_run = true;
      let done = false;
      $8tj43$createComputed(() => {
        if (!done) read_checked();
        if (initial_run) {
          initial_run = false;
          return;
        }
        updating_blocked = false; // change back updating blocked once the updates finished
        done = true;
      });
      write_checked(all_kids_checked);
    }), {
      defer: true
    }));
  };
  return {
    signal_: signal_,
    on_structure_complete_: on_structure_complete_
  };
}
function $0ae614c5c7babb43$var$make_expanded_signal(_ref5) {
  var _untrack$untrack;
  let {
    expanded_hierarchical_filters_: [read_expanded_hierarchical_filters, write_expanded_hierarchical_filters],
    filter_value_: filter_value_,
    is_being_searched_: is_being_searched_
  } = _ref5;
  const index_in_expanded_filters = $8tj43$createMemo(() => read_expanded_hierarchical_filters().findIndex(_ref6 => {
    let {
      value_: value_
    } = _ref6;
    return value_.length === filter_value_.length && value_.every((item, index) => filter_value_[index] === item);
  }), undefined, {
    equals: false
  } // we always want this to update so that we can make updates of the object on this index depend on this memo
  );

  const clone_history_state_with_us_removed = () => {
    const state = [...$8tj43$untrack(read_expanded_hierarchical_filters)];
    const index = $8tj43$untrack(index_in_expanded_filters);
    if (index >= 0) state.splice(index, 1);
    return state;
  };
  const user_choice_signal = $8tj43$createSignal((_untrack$untrack = $8tj43$untrack(read_expanded_hierarchical_filters)[$8tj43$untrack(index_in_expanded_filters)]) === null || _untrack$untrack === void 0 ? void 0 : _untrack$untrack.expanded_); // we already have a value stored from before, use it as inital value, otherwise default to collapsed
  const [get_user_choice_expanded, set_user_choice_expanded] = user_choice_signal;
  const [get_low_precedence_expanded, set_low_precedence_expanded] = $8tj43$createSignal(false); // for us to be helpful for the user to expand long trees where there's no choice to be made but user setting anything takes precedence
  $8tj43$createComputed($8tj43$on(index_in_expanded_filters, index => {
    if (index >= 0) {
      var _read_expanded_hierar;
      // if history.state state updates, update signal
      const expanded_from_history_state = (_read_expanded_hierar = read_expanded_hierarchical_filters()[index]) === null || _read_expanded_hierar === void 0 ? void 0 : _read_expanded_hierar.expanded_;
      if (typeof expanded_from_history_state == "boolean") set_user_choice_expanded(expanded_from_history_state);
    }
  }, {
    defer: true
  }));
  $8tj43$createComputed($8tj43$on(get_user_choice_expanded, expanded_ => {
    if (typeof expanded_ != "boolean") return;
    const new_state = clone_history_state_with_us_removed();
    new_state.push({
      value_: filter_value_,
      expanded_: expanded_
    });
    write_expanded_hierarchical_filters(new_state);
  }, {
    defer: true
  }));
  return {
    ui_should_show_expanded_: $8tj43$createMemo(
    // When user is searching through filters, expand everything they haven't collapsed, so they can see the results
    () => {
      var _user_choice_signal$;
      return (_user_choice_signal$ = user_choice_signal[0]()) !== null && _user_choice_signal$ !== void 0 ? _user_choice_signal$ : is_being_searched_() || get_low_precedence_expanded();
    }),
    set_low_precedence_expanded_: set_low_precedence_expanded,
    set_user_expanded_: set_user_choice_expanded
  };
}
function $0ae614c5c7babb43$var$expand_until_choice(data_structure) {
  const nodes = Object.values(data_structure);
  const cloned_nodes = [...nodes];
  $8tj43$batch(() => {
    while (cloned_nodes.length) {
      const node = cloned_nodes.pop();
      node.is_expanded_.set_low_precedence_expanded_(false); // default all to false on every update
      cloned_nodes.push(...Object.values(node.children_));
    }
    while (nodes.length === 1) {
      const node = nodes.pop();
      // as long as there's only one thing to expand, expand everything
      node.is_expanded_.set_low_precedence_expanded_(true);
      nodes.push(...Object.values(node.children_));
    }
  });
}

/** @jsxImportSource solid-js */

function $fc830a7ee59416ef$export$ebdc3711f7e02ccd(what_to_watch) {
  const [width, setWidth] = $8tj43$createSignal();
  const resizeObserver = new ResizeObserver($8tj43$catchify1(records => {
    for (let j = 0; j < records.length; j++) {
      var _records$j$borderBoxS, _records$j$borderBoxS2, _records$j$borderBoxS3;
      const width = (_records$j$borderBoxS = (_records$j$borderBoxS2 = records[j].borderBoxSize) === null || _records$j$borderBoxS2 === void 0 ? void 0 : (_records$j$borderBoxS3 = _records$j$borderBoxS2[0]) === null || _records$j$borderBoxS3 === void 0 ? void 0 : _records$j$borderBoxS3.inlineSize) !== null && _records$j$borderBoxS !== void 0 ? _records$j$borderBoxS : what_to_watch.getBoundingClientRect().width;
      setWidth(width);
    }
  }));
  // If we start observing elements before they're in the DOM Chrome (Version 117.0.5938.92 (Official Build) (arm64)) sometimes gives us a resize event with a width of 0 and then doesn't dispatch one with the actual width once it's in the DOM. So we wait until the element is in the DOM before we start observing it.
  // It doesn't seem to work even when waiting for it to be in the DOM, also wait an animation frame
  const disconnect = (0, $8tj43$observer).onexists(what_to_watch, _ref => {
    let {
      element: element
    } = _ref;
    return requestAnimationFrame($8tj43$catchify1(() => {
      const current_size = what_to_watch.getBoundingClientRect().width;
      if (current_size)
        // If element has size, set signal to that. ResizeObserver only triggers when the content is visible in some cases, but it might already have a size. This reduces size filter expanding animation jank in chrome.
        setWidth(current_size);
      resizeObserver.observe(element);
    }));
  });
  $8tj43$onCleanup(() => {
    resizeObserver.disconnect();
    disconnect();
  });
  return width;
}
var $830ea8efda59884e$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=checkbox-grid style=position:absolute;z-index:-1;pointer-events:none;opacity:0 aria-hidden=true>`),
  $830ea8efda59884e$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span class=count-wrapper><span class=count>`),
  $830ea8efda59884e$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<button><!$><!/><!$><!/>`);
const $830ea8efda59884e$var$gap_px = 5;
const $830ea8efda59884e$var$max_columns = 3;
const $830ea8efda59884e$export$414f6a19d38e655c = _ref => {
  let {
    filter_: filter_,
    selected_filters_: [get_selected_filters, set_selected_filters],
    filter_query_: filter_query_,
    details_element_width_: details_element_width_
  } = _ref;
  const existing_filter = $8tj43$createMemo(() => {
    const {
      field: field,
      op: op
    } = filter_();
    return get_selected_filters().find(_ref2 => {
      let {
        field: checking_field,
        op: checking_op
      } = _ref2;
      return checking_field === field && checking_op === op;
    });
  });
  const buttons = $8tj43$createMemo(() => {
    const meta = filter_().meta;
    return meta.values.map((value_, index) => {
      var _meta$names, _meta$counts;
      return {
        value_: value_,
        name_: (_meta$names = meta.names) === null || _meta$names === void 0 ? void 0 : _meta$names[index],
        count_: (_meta$counts = meta.counts) === null || _meta$counts === void 0 ? void 0 : _meta$counts[index]
      };
    });
  });
  const [sizes_set, set_sizes_set] = $8tj43$createSignal(new Set(), {
    equals: false
  });
  const [cols_at_size, set_cols_at_size] = $8tj43$createSignal([[1, "0px", ""]]);
  const [container, set_container] = $8tj43$createSignal();
  const container_width_accessor = $8tj43$createMemo(() => {
    const element = container();
    if (!element) return;
    return $fc830a7ee59416ef$export$ebdc3711f7e02ccd(element);
  });
  const [shadow_children, set_shadow_children] = $8tj43$createSignal(new Set(), {
    equals: false
  });
  const shadow_grid = (() => {
    var _el$ = $8tj43$getNextElement($830ea8efda59884e$var$_tmpl$);
    $8tj43$insert(_el$, () => [...shadow_children()]);
    return _el$;
  })(); // for getting the smallest possible sizes of all the items
  $8tj43$createEffect(() => {
    var _container_width_acce;
    const container_width = ((_container_width_acce = container_width_accessor()) === null || _container_width_acce === void 0 ? void 0 : _container_width_acce()) || details_element_width_();
    if (container_width === undefined) return; // On firefox, unexpanded <details> elements' contents dont't have a width, fall back to the width of the details element itself to not have janky expanding animations due to wrong number of columns at point of expanding
    $830ea8efda59884e$var$adjust_sizes(container_width, sizes_set(), set_cols_at_size);
  });
  return [$8tj43$createComponent((0, $63f1f8dbcd07d3b0$export$d21e32dfedac04be), {
    get cols_at_size() {
      return cols_at_size();
    },
    grid_spacing: $830ea8efda59884e$var$gap_px + "px",
    rows: "all",
    layout: "grid",
    element_attributes: {
      class: "checkbox-grid",
      ref: el => set_container(el)
    },
    get children() {
      return $8tj43$createComponent((0, $8tj43$Index), {
        get each() {
          return buttons();
        },
        children: value => {
          const is_selected = $8tj43$createMemo(() => {
            var _existing_filter;
            const data = (_existing_filter = existing_filter()) === null || _existing_filter === void 0 ? void 0 : _existing_filter.data;
            const current_value = $af5d8e0b7d97a7f6$export$325f75597868c4f0(value().value_);
            return !!(data !== null && data !== void 0 && data.some(item => $af5d8e0b7d97a7f6$export$325f75597868c4f0(item) === current_value));
          });
          const MakeButton = attributes => {
            const label = $8tj43$createMemo(() => value().name_ || value().value_ + "");
            const count_zero = $8tj43$createMemo(() => value().count_ === 0);
            return (() => {
              var _el$2 = $8tj43$getNextElement($830ea8efda59884e$var$_tmpl$3),
                _el$5 = _el$2.firstChild,
                [_el$6, _co$] = $8tj43$getNextMarker(_el$5.nextSibling),
                _el$7 = _el$6.nextSibling,
                [_el$8, _co$2] = $8tj43$getNextMarker(_el$7.nextSibling);
              $8tj43$spread(_el$2, $8tj43$mergeProps1(attributes, {
                get disabled() {
                  return $8tj43$memo(() => !!count_zero())() && !is_selected();
                },
                get classList() {
                  return {
                    minor: !is_selected(),
                    major: is_selected(),
                    "major-minor-transition": true
                  };
                },
                get onClick() {
                  return $8tj43$catchify1(() => {
                    const set_filter = existing_filter();
                    const {
                      field: field,
                      op: op
                    } = filter_();
                    const base_object = set_filter ? set_filter : {
                      op: op,
                      field: field
                    };
                    const old_data = base_object.data;
                    const new_data = [...(Array.isArray(old_data) ? [...old_data] : old_data ? [old_data] : [])];
                    const new_filter_object = {
                      ...base_object,
                      data: new_data
                    };
                    if (!is_selected()) new_filter_object.data.push(value().value_);else {
                      const current_value_lower = $af5d8e0b7d97a7f6$export$325f75597868c4f0(value().value_);
                      new_filter_object.data = new_filter_object.data.filter(v => $af5d8e0b7d97a7f6$export$325f75597868c4f0(v) !== current_value_lower);
                    }
                    const selected_filters = [...get_selected_filters().filter(f => f !== set_filter), ...(new_filter_object.data.length ? [new_filter_object] : [])];
                    set_selected_filters(selected_filters);
                  });
                }
              }), false, true);
              $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
                get when() {
                  return count_zero();
                },
                get fallback() {
                  return $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
                    whole_text_to_display_: label,
                    searching_for_value_: () => filter_query_ === null || filter_query_ === void 0 ? void 0 : filter_query_()
                  });
                },
                get children() {
                  return label();
                }
              }), _el$6, _co$);
              $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
                get when() {
                  return value().count_ != undefined;
                },
                get children() {
                  var _el$3 = $8tj43$getNextElement($830ea8efda59884e$var$_tmpl$2),
                    _el$4 = _el$3.firstChild;
                  $8tj43$insert(_el$4, () => value().count_);
                  return _el$3;
                }
              }), _el$8, _co$2);
              $8tj43$runHydrationEvents();
              return _el$2;
            })();
          };
          const invisible_size_button = $8tj43$createComponent(MakeButton, {
            tabIndex: -1
          });
          const smallest_possible_size = $fc830a7ee59416ef$export$ebdc3711f7e02ccd(invisible_size_button); // create ResizeObserver for the invisible size button where the div hugs its content
          const sizes_value = $8tj43$untrack(sizes_set);
          const shadow_children_value = $8tj43$untrack(shadow_children);
          sizes_value.add(smallest_possible_size);
          set_sizes_set(sizes_value);
          shadow_children_value.add(invisible_size_button);
          set_shadow_children(shadow_children_value);
          $8tj43$onCleanup(() => {
            const sizes_value = $8tj43$untrack(sizes_set);
            const shadow_children_value = $8tj43$untrack(shadow_children);
            sizes_value.delete(smallest_possible_size);
            set_sizes_set(sizes_value);
            shadow_children_value.delete(invisible_size_button);
            set_shadow_children(shadow_children_value);
          });
          // The actual button that will be visible
          return $8tj43$createComponent(MakeButton, {});
        }
      });
    }
  }), shadow_grid];
};
/**
 * Calculate and apply cols_at_size overrides to fit as many items as possible in a row, evenly spaced
 */
function $830ea8efda59884e$var$adjust_sizes(container_width, sizes, set_cols_at_size) {
  let current_row_index = 0;
  let current_row_items = [];
  const column_to_row_result = {};
  const check_would_fit_evenly = (min_size_of_item, at_number_of_columnns) => {
    const would_have_even_size = container_width / at_number_of_columnns - (at_number_of_columnns * 2 - 2) * ($830ea8efda59884e$var$gap_px / 2) / at_number_of_columnns; // What size would our element have (without gaps), given that now every column had the same width (equation from Layout.tsx)
    return would_have_even_size >= min_size_of_item; // would this item still fit if we added another column? (probably what the caller has done with at_number_of_columns), given that every item has the same size
  };

  for (const size_item of sizes) {
    const size = size_item();
    if (size == undefined) return; // Only do stuff if we know all the sizes
    const current_row_length = current_row_items.length;
    const can_add_another_column_initial_val = current_row_length < $830ea8efda59884e$var$max_columns; // allow max 4 items per row
    let can_add_another_column = can_add_another_column_initial_val;
    if (can_add_another_column)
      // can we actually? Since adding another column changes the size of all elements in the row we need to check all of them
      for (let i = -1; i < current_row_length; i++) {
        var _ref3;
        // -1 is for the new item we're adding and every item is guaranteed to exist
        const size_to_check = (_ref3 = current_row_items[i]) !== null && _ref3 !== void 0 ? _ref3 : size;
        const would_have_columns = current_row_length + 1; // if we added another column
        const would_fit_evenly = check_would_fit_evenly(size_to_check, would_have_columns); // see comments in check_would_fit_evenly
        if (!would_fit_evenly) {
          can_add_another_column = false;
          break;
        }
      }
    if (can_add_another_column) current_row_items.push(size);else {
      column_to_row_result[++current_row_index] = current_row_length || 1; // overrides is indexed by 1 it seems, therefore ++curent_row_index
      current_row_items = [size]; // save current item for next row
    }
  }

  const items_left_to_add = current_row_items.length;
  if (items_left_to_add) {
    let num_columns = 1; // We want to have as close to max_columns as possible in the last row
    let fits = true;
    do
    // Check if more columns would fit
    for (let i = 0; i < items_left_to_add; i++) {
      const item = current_row_items[i];
      const would_fit_evenly = check_would_fit_evenly(item, num_columns + 1);
      if (!would_fit_evenly) {
        fits = false;
        break;
      }
    } while (fits && ++num_columns < $830ea8efda59884e$var$max_columns);
    column_to_row_result[++current_row_index] = num_columns; // Add last row that's left after loop finished
  }

  set_cols_at_size([[1, "0px", "", null, {
    overrides: column_to_row_result
  }]]);
}
var $2cb856c297c53e6c$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<form class=checkbox-color><!$><!/><!$><!/>`);
const $2cb856c297c53e6c$var$max_visible_without_collapsing = 30;
const $2cb856c297c53e6c$var$show_non_collapsible_when_collapsed = 8;
function $2cb856c297c53e6c$export$82ed4b28ecb67608(_ref) {
  let {
    filter_: filter_,
    selected_filters_: [get_selected_filters, set_selected_filters],
    i18n_: i18n_,
    view_more_button_below_group_: [, set_view_more_button_below_group_],
    filter_query_: filter_query_
  } = _ref;
  // same as in CheckboxFilter, maybe we should make this DRY at some point
  const existing_filter = $8tj43$createMemo(() => {
    const {
      field: field,
      op: op
    } = filter_();
    return get_selected_filters().find(_ref2 => {
      let {
        field: checking_field,
        op: checking_op
      } = _ref2;
      return checking_field === field && checking_op === op;
    });
  });
  let form;
  const checkboxes = $8tj43$createMemo(() => {
    const meta = filter_().meta;
    return meta.values.map((value_, index) => {
      var _meta$names, _meta$counts, _meta$swatches;
      return {
        value_: value_,
        name_: (_meta$names = meta.names) === null || _meta$names === void 0 ? void 0 : _meta$names[index],
        count_: (_meta$counts = meta.counts) === null || _meta$counts === void 0 ? void 0 : _meta$counts[index],
        swatch_: (_meta$swatches = meta.swatches) === null || _meta$swatches === void 0 ? void 0 : _meta$swatches[index]
      };
    });
  });
  const backendFilterV2 = $8tj43$createMemo(() => "swatches" in (filter_().meta || {}));
  const render_checkbox = checkbox => {
    const hex_color = $8tj43$createMemo(() => {
      var _split;
      if (backendFilterV2()) return checkbox().swatch_ || "#000";
      return ((_split = checkbox().value_.split(";")) === null || _split === void 0 ? void 0 : _split[1]) || "";
    });
    const hasGradientOrOtherValidNonHexColor = $8tj43$createMemo(() => {
      const color = hex_color();
      return !!color && !color.startsWith("#");
    });
    const setBlackCheckClass = $8tj43$createMemo(() => {
      // Set this to true if we should show a black tick in the checkbox for better contrast on light backgrounds
      if (hasGradientOrOtherValidNonHexColor()) return false;
      const rgb_color = $8tj43$hex_to_rgb(hex_color());
      if (!rgb_color) return false;
      return $2cb856c297c53e6c$var$does_black_contrast_better(rgb_color);
    });
    const is_checked = $8tj43$createMemo(() => {
      var _existing_filter;
      const data = (_existing_filter = existing_filter()) === null || _existing_filter === void 0 ? void 0 : _existing_filter.data;
      const value = $af5d8e0b7d97a7f6$export$325f75597868c4f0(checkbox().value_);
      return !!(data !== null && data !== void 0 && data.some(item => $af5d8e0b7d97a7f6$export$325f75597868c4f0(item) === value));
    });
    const value = $8tj43$createMemo(() => checkbox().value_);
    const label_text = $8tj43$createMemo(() => checkbox().name_ || value() + "");
    const count = $8tj43$createMemo(() => checkbox().count_);
    const colorNameDatasetValue = $8tj43$createMemo(() => {
      var _split2;
      if (backendFilterV2()) return label_text();
      return ((_split2 = checkbox().value_.split(";")) === null || _split2 === void 0 ? void 0 : _split2[0]) || "";
    });
    const input_row = $8tj43$createComponent((0, $19e828709c7723a0$export$48513f6b9f8ce62d), {
      get value_() {
        return value();
      },
      get label_() {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return count() !== 0;
          },
          get fallback() {
            return label_text();
          },
          get children() {
            return $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
              whole_text_to_display_: label_text,
              searching_for_value_: () => filter_query_ === null || filter_query_ === void 0 ? void 0 : filter_query_()
            });
          }
        });
      },
      get count_() {
        return count();
      },
      get checked_() {
        return is_checked();
      },
      custom_indicator_ref: span => {
        const {
          classList: classList,
          style: style
        } = span;
        classList.add("color");
        $8tj43$createRenderEffect(() => style.background = hex_color() || "black" // default to black background so that the default-checkmark also is visible on dark page backgrounds (the or here can be removed when we fully go v2)
        );

        $8tj43$createRenderEffect(() => span.dataset.colorName = colorNameDatasetValue());
        $8tj43$createRenderEffect(() => classList.toggle("black-check", setBlackCheckClass()));
        $8tj43$createRenderEffect(() => classList.toggle("outlined-check", hasGradientOrOtherValidNonHexColor()));
      }
    });
    return input_row;
  };
  const show_extras_signal = $8tj43$createSignal(false);
  const [get_show_extras] = show_extras_signal;
  const togglable_rest = $8tj43$createMemo(() => checkboxes().length > $2cb856c297c53e6c$var$max_visible_without_collapsing);
  const expand_animation_duration = 200;
  const {
    expand: expand,
    collapse: collapse,
    ExpandingContainer: ExpandingContainer
  } = $8e8b179489080711$export$5bad61ecde080b1f({
    duration: expand_animation_duration
  });
  const [get_having_expanding_in_dom, set_having_expanding_in_dom] = $8tj43$createSignal($8tj43$untrack(togglable_rest)); // We need to remove the expanding els from the DOM if they're empty, otherwise the flexbox makes a weird gap to the right of the last item sometimes
  const expanding_container_els = $8tj43$createComponent(ExpandingContainer, {
    get children() {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return togglable_rest();
        },
        get children() {
          return $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              return checkboxes().slice($2cb856c297c53e6c$var$show_non_collapsible_when_collapsed);
            },
            children: render_checkbox
          });
        }
      });
    }
  });
  expanding_container_els.style.flexGrow = "1"; // gets weird otherwise with few elements (we need it to grow to take the whole width so the justify-content to get the gap works)
  const inner_div = expanding_container_els === null || expanding_container_els === void 0 ? void 0 : expanding_container_els.firstChild;
  if (inner_div) inner_div.classList.add("checkbox-color");else $8tj43$report1(new Error("Someone refactored ExpandingContainer and broke CheckboxColor"), "error");
  $8tj43$createComputed(() => {
    if (togglable_rest()) set_having_expanding_in_dom(true); // instantly put into the DOM before the animation starts
  });

  $8tj43$createRenderEffect(() => {
    set_view_more_button_below_group_(togglable_rest() ? $8tj43$createComponent((0, $3e850b2f2cca761f$export$ca21a16d65b3dd8), {
      show_extras_: show_extras_signal,
      i18n_: i18n_
    }) : []);
  });
  $8tj43$onCleanup(() => set_view_more_button_below_group_());
  $8tj43$createEffect($8tj43$catchify1(async () => {
    if (!togglable_rest()) {
      await collapse();
      set_having_expanding_in_dom(false); // Once animation has finished, remove expanding from DOM
      // Waiting with removing might not be needed, but it felt slightly glitchy before and this works so leaving it
      return;
    }
    if (get_show_extras()) await expand();else await collapse();
  }));
  return (() => {
    var _el$ = $8tj43$getNextElement($2cb856c297c53e6c$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$addEventListener(_el$, "change", $8tj43$catchify1(() => {
      const set_filter = existing_filter();
      const {
        field: field,
        op: op
      } = filter_();
      const base_object = set_filter ? set_filter : {
        op: op,
        field: field
      };
      const filter_object = {
        ...base_object,
        data: [...new FormData(form)].filter(_ref3 => {
          let [_key, value] = _ref3;
          return value === "on";
        }).map(_ref4 => {
          let [key] = _ref4;
          return key;
        })
      };
      const selected_filters = [...get_selected_filters()];
      if (set_filter) selected_filters.splice(selected_filters.indexOf(set_filter), 1);
      if (filter_object.data.length) selected_filters.push(filter_object);
      set_selected_filters(selected_filters);
    }));
    var _ref$ = form;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$) : form = _el$;
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
      get each() {
        return $8tj43$memo(() => !!togglable_rest())() ? checkboxes().slice(0, $2cb856c297c53e6c$var$show_non_collapsible_when_collapsed) : checkboxes();
      },
      children: render_checkbox
    }), _el$3, _co$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return get_having_expanding_in_dom();
      },
      children: expanding_container_els
    }), _el$5, _co$2);
    return _el$;
  })();
}
// Daniel's magic https://gitlab.com/depict-ai/depict.ai/-/merge_requests/7648#note_1468373350
function $2cb856c297c53e6c$var$does_black_contrast_better(rgb) {
  const luminance_color = $8tj43$relative_luminance_from_rgb(...rgb);
  const luminance_white = 1;
  const luminance_black = 0;
  const contrast_ratio_if_white = (luminance_white + 0.05) / (luminance_color + 0.05);
  const contrast_ratio_if_black = (luminance_color + 0.05) / (luminance_black + 0.05);
  return contrast_ratio_if_black > contrast_ratio_if_white;
}
var $d2988f745661df9c$export$2e2bcd8739ae039 = {
  checkbox: (0, $133484ef10e4e954$export$dd948f91abc3a1c4),
  radio: (0, $b54fc842e721c9eb$export$430444115f70a734),
  range: (0, $1e7465a8ffa97f6c$export$e0d834a0ad870cda),
  "checkbox-hierarchical": (0, $0ae614c5c7babb43$export$a32086fa6616eafd),
  "checkbox-grid": (0, $830ea8efda59884e$export$414f6a19d38e655c),
  "checkbox-color": (0, $2cb856c297c53e6c$export$82ed4b28ecb67608)
};
var $905f44be08b7378e$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=16.8 height=14><path d="M4.617 12.738a.48.48 0 0 1-.164-.027c-.051-.023-.094-.055-.129-.098L.125 8.414A.39.39 0 0 1 0 8.117c0-.113.039-.211.125-.293s.18-.125.293-.125.215.043.297.125l3.902 3.902L16.086.262c.082-.082.18-.125.297-.125s.211.043.293.125.125.184.125.301-.043.215-.125.297L4.914 12.613c-.039.043-.086.078-.141.098s-.102.027-.156.027zm0 0">`);
function $905f44be08b7378e$export$f2ca6fc699ca1fb4() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($905f44be08b7378e$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $d0ff304c14f50521$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class=show-selected aria-hidden=true><span></span><!$><!/>`);
function $d0ff304c14f50521$export$53c59af873b303c9(_ref) {
  let {
    selected_filters_in_group_: selected_filters_in_group_,
    i18n_: {
      price_formatting_: price_formatting_
    }
  } = _ref;
  const [show_tick_icon, set_show_tick_icon] = $8tj43$createSignal(false);
  const text = $8tj43$createMemo(() => $8tj43$batch(() => {
    set_show_tick_icon(false);
    let {
      size: size
    } = selected_filters_in_group_();
    try_specific: {
      if (size > 1) break try_specific;
      for (const [selected_filter, filter_data] of selected_filters_in_group_()) {
        // we're intentionally not looping in this statement since we always just want to show the first thing in the filter group
        const {
          meta: meta
        } = filter_data;
        const {
          type: type
        } = meta;
        if (type === "range") return [$8tj43$memo(() => price_formatting_().pre_), $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
          get price_() {
            return selected_filter.data[0];
          },
          get price_formatting_() {
            return price_formatting_();
          }
        }), $8tj43$memo(() => price_formatting_().post_), " \u2013 ", $8tj43$memo(() => price_formatting_().pre_), $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
          get price_() {
            return selected_filter.data[1];
          },
          get price_formatting_() {
            return price_formatting_();
          }
        }), $8tj43$memo(() => price_formatting_().post_)];else {
          var _names, _values;
          const {
            data: data
          } = selected_filter;
          const data_is_array = Array.isArray(data);
          if (data_is_array && data.length !== 1) {
            size = data.length;
            break try_specific;
          }
          const needle = data_is_array ? data[0] : data;
          const index_in_meta = meta.values.findIndex(value => $af5d8e0b7d97a7f6$export$325f75597868c4f0(needle) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(value) || Array.isArray(needle) && Array.isArray(value) && needle.length === value.length && value.every((item, index) => $af5d8e0b7d97a7f6$export$325f75597868c4f0(needle[index]) === $af5d8e0b7d97a7f6$export$325f75597868c4f0(item)));
          return ((_names = meta.names) === null || _names === void 0 ? void 0 : _names[index_in_meta]) || ((_values = meta.values) === null || _values === void 0 ? void 0 : _values[index_in_meta]);
        }
      }
    }
    set_show_tick_icon(true);
    return size + "";
  }));
  return (() => {
    var _el$ = $8tj43$getNextElement($d0ff304c14f50521$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling,
      [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling);
    $8tj43$insert(_el$2, text);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return show_tick_icon();
      },
      get children() {
        return $8tj43$createComponent((0, $905f44be08b7378e$export$f2ca6fc699ca1fb4), {});
      }
    }), _el$4, _co$);
    return _el$;
  })();
}
function $f1e63746f76ce012$export$ab34afce88557c0e(props) {
  var _untrack$expanded_, _untrack;
  const expanded_state_item_in_history_state = $8tj43$createMemo(() => props.expanded_filters_[0]().find(item => item.section_ === props.section_));
  const is_open = $8tj43$createSignal((_untrack$expanded_ = (_untrack = $8tj43$untrack(expanded_state_item_in_history_state)) === null || _untrack === void 0 ? void 0 : _untrack.expanded_) !== null && _untrack$expanded_ !== void 0 ? _untrack$expanded_ : false);
  const fallback_state_from_api = $8tj43$createMemo(() => {
    const arr = props.filter_array_().map(item => {
      var _item$meta;
      return item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.group_expanded;
    }).filter(item => typeof item === "boolean");
    const set = new Set(arr);
    if (set.size !== 1)
      // backend can't decide
      return undefined;
    return arr[0];
  });
  $8tj43$createComputed($8tj43$on(expanded_state_item_in_history_state, new_state => {
    // this is the most powerful source except for of course the user setting it
    if (new_state) is_open[1](new_state.expanded_);
  }, {
    defer: true
  }));
  $8tj43$createComputed(() => {
    // sync from API to actually open if no user set state
    // This is an untested codepath as of Thu Jul 14 17:22:50 CEST 2022
    // Backend hasn't implemented sending group_expanded yet so we have to wait for that to test this
    const new_fallback_state = fallback_state_from_api();
    if (typeof new_fallback_state !== "boolean") return; // ignore
    if (!expanded_state_item_in_history_state())
      // there's no user set state, it's free real estate for fallback state
      is_open[1](new_fallback_state);
  });
  $8tj43$createComputed($8tj43$on(is_open[0], new_state => {
    // update history state if needed when user changes expanded state
    if (!expanded_state_item_in_history_state()) {
      // we're operating in fallback mode
      if (new_state === fallback_state_from_api())
        // API fallback state updated which updated us, don't save that in history state (it's only for manual changes)
        return;
    }
    const new_arr = [...props.expanded_filters_[0]()];
    const existing_index = new_arr.indexOf(expanded_state_item_in_history_state());
    if (existing_index >= 0) new_arr.splice(existing_index, 1);
    new_arr.push({
      section_: props.section_,
      expanded_: new_state
    });
    props.expanded_filters_[1](new_arr);
  }, {
    defer: true
  }));
  return is_open;
}
function $ceafb6fb91c6f394$export$89c6019e4baa40b1(props) {
  const style = $8tj43$createMemo(() => {
    const {
      style: style,
      height: height,
      width: width
    } = props;
    return {
      ...(style || {}),
      height: height !== null && height !== void 0 ? height : "1em",
      ...(width && {
        width: width
      })
    };
  });
  return $8tj43$createComponent((0, $bc2337c9a05ecd18$export$acb3eaade4b23afd), {
    get style() {
      return style();
    },
    get ["class"]() {
      return props.class;
    }
  });
}
var $ef0f18a578b32578$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=20 height=22 viewBox="0 0 20 22"><path d="M19.811 20.174l-6.234-6.809a7.96 7.96 0 0 0 .923-1.179c.274-.424.502-.865.687-1.323a8.04 8.04 0 0 0 .42-1.436 7.88 7.88 0 0 0 .144-1.507c0-.526-.051-1.042-.154-1.548-.096-.506-.243-.995-.441-1.466s-.441-.919-.728-1.343a8.28 8.28 0 0 0-.984-1.21 7.86 7.86 0 0 0-1.2-.984A7.56 7.56 0 0 0 10.89.651C10.418.453 9.929.302 9.423.2S8.401.046 7.875.046 6.833.097 6.327.2 5.332.453 4.86.651a7.56 7.56 0 0 0-1.354.718c-.431.287-.831.615-1.2.984a8.28 8.28 0 0 0-.984 1.21 7.73 7.73 0 0 0-.728 1.343c-.198.472-.349.96-.451 1.466A8.31 8.31 0 0 0 0 7.921a8.31 8.31 0 0 0 .144 1.548c.103.506.253.995.451 1.466a8.08 8.08 0 0 0 .728 1.354 7.86 7.86 0 0 0 .984 1.2 7.54 7.54 0 0 0 1.2.995c.431.287.882.53 1.354.728.472.191.96.338 1.466.441a8.31 8.31 0 0 0 1.548.144c.451 0 .896-.038 1.333-.113a7.83 7.83 0 0 0 1.282-.328 7.55 7.55 0 0 0 1.2-.533 8.08 8.08 0 0 0 1.107-.749l6.245 6.809a.45.45 0 0 0 .174.123.55.55 0 0 0 .205.041.61.61 0 0 0 .195-.031c.061-.021.116-.055.164-.102.109-.096.164-.219.164-.369.007-.144-.038-.267-.133-.369zM1.046 7.921c0-.937.178-1.818.533-2.646.362-.834.851-1.559 1.466-2.174.622-.615 1.347-1.101 2.174-1.456.827-.362 1.712-.543 2.656-.543s1.829.181 2.656.543c.827.355 1.548.841 2.164 1.456.622.615 1.111 1.34 1.466 2.174a6.52 6.52 0 0 1 .543 2.646c0 .943-.181 1.829-.543 2.656a6.89 6.89 0 0 1-1.466 2.174c-.615.615-1.336 1.104-2.164 1.466-.827.356-1.712.533-2.656.533s-1.829-.178-2.656-.533c-.827-.362-1.552-.851-2.174-1.466-.615-.622-1.104-1.347-1.466-2.174-.355-.827-.533-1.712-.533-2.656z">`);
function $ef0f18a578b32578$export$82eafebb825fc23f() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($ef0f18a578b32578$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $e354b2f9ce33cb75$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=search-in-filters><input type=text class=query><!$><!/><button class=clear-filter-search>`);
const $e354b2f9ce33cb75$var$min_items_to_enable_filter_searching = 15; // For checkbox color and checkbox grid we 2x this
function $e354b2f9ce33cb75$export$4b2c5292ffe0c5dd(filter_array_, section, i18n_) {
  const [filter_query_, set_filter_query_] = $8tj43$createSignal();
  // Check if we have enough items to enable searching
  const enable_searchability = $8tj43$createMemo(() => {
    let count = 0;
    for (const filter of filter_array_()) {
      var _filter$meta;
      const type = (_filter$meta = filter.meta) === null || _filter$meta === void 0 ? void 0 : _filter$meta.type;
      if (type === "range") continue;
      const length = filter.meta.values.length;
      count += type === "checkbox-color" || type === "checkbox-grid" ? length / 2 : length; // For checkbox-color we have two columns, checkbox-grid three, so we can show search later
    }

    return count >= $e354b2f9ce33cb75$var$min_items_to_enable_filter_searching;
  });
  const SearchThisFilterGroup_ = () => {
    return $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return enable_searchability();
      },
      get children() {
        var _el$ = $8tj43$getNextElement($e354b2f9ce33cb75$var$_tmpl$),
          _el$2 = _el$.firstChild,
          _el$4 = _el$2.nextSibling,
          [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
          _el$3 = _el$5.nextSibling;
        _el$2.$$input = ev => set_filter_query_(ev.currentTarget.value);
        $8tj43$insert(_el$, $8tj43$createComponent((0, $ef0f18a578b32578$export$82eafebb825fc23f), {
          width: "16",
          height: "17.6",
          "class": "search-icon"
        }), _el$5, _co$);
        _el$3.$$click = () => set_filter_query_();
        $8tj43$insert(_el$3, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {
          width: "12",
          height: "12"
        }));
        $8tj43$effect(_p$ => {
          var _v$ = i18n_.search_a_filter_()(section),
            _v$2 = filter_query_() ? "" : "none";
          _v$ !== _p$.e && $8tj43$setAttribute(_el$2, "placeholder", _p$.e = _v$);
          _v$2 !== _p$.t && ((_p$.t = _v$2) != null ? _el$3.style.setProperty("display", _v$2) : _el$3.style.removeProperty("display"));
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        $8tj43$effect(() => $8tj43$setProperty(_el$2, "value", filter_query_() || ""));
        $8tj43$runHydrationEvents();
        return _el$;
      }
    });
  };
  const searched_filter_array_ = $8tj43$createMemo(() => {
    const query = filter_query_();
    if (!enable_searchability() || !query) return filter_array_();
    const lowercase_query = query.toLowerCase();
    const check_string_match = to_check => {
      to_check = to_check.toLowerCase();
      return to_check.includes(lowercase_query) || lowercase_query.includes(to_check);
    };
    return filter_array_().map(filter => {
      var _filter$meta2, _meta$names;
      const type = (_filter$meta2 = filter.meta) === null || _filter$meta2 === void 0 ? void 0 : _filter$meta2.type;
      if (type === "range") return filter; // can't search in range filters and for checkbox-hierarchical we do the searching in the filter component since we have access to a hierarchical structure there
      const meta = filter.meta;
      const {
        values: values,
        names: names,
        counts: counts
      } = meta;
      if (!Array.isArray(values)) return filter; // Might have to adjust this in the future, but I think these super simple filters won't need search
      const is_hierarchical_checkbox = type === "checkbox-hierarchical";
      // Which index of counts, values and names should be kept
      const filtered_indexes = values.map((item, index) => {
        const item_from_names = names === null || names === void 0 ? void 0 : names[index];
        if (item_from_names && !is_hierarchical_checkbox)
          // We should use names if they exist, but sometimes backend doesn't provide any at all, and sometimes they are undefined, presumably from create_modified_filters
          item = item_from_names;
        if (typeof item === "number") return true;
        if (is_hierarchical_checkbox && names)
          // Special case for hierarchical checkboxes where we need to check if any of the names in the path match the query
          item = item.map((_, index) => names[$e354b2f9ce33cb75$var$find_str_arr_in_str_arr_arr("findIndex", values, item.slice(0, index + 1))]);
        if (Array.isArray(item)) return item.some(item => check_string_match(item + "")); // If any of the items in the array match, keep it
        return check_string_match(item);
      });
      const new_values = values.filter((_, i) => filtered_indexes[i]);
      if (!new_values.length) return false; // false = please delete this filter, see below
      const new_filter_object = {
        ...filter,
        meta: {
          ...meta,
          ...(counts ? {
            counts: counts === null || counts === void 0 ? void 0 : counts.filter((_, i) => filtered_indexes[i])
          } : {}),
          ...(names ? {
            names: (_meta$names = meta.names) === null || _meta$names === void 0 ? void 0 : _meta$names.filter((_, i) => filtered_indexes[i])
          } : {}),
          values: new_values
        }
      };
      if (is_hierarchical_checkbox) {
        // For hierarchical checkbox we need to fill the holes created by filtering, for example if there is
        // ["Clothes"]
        // ["Clothes", "Blazers"]
        // And the user searched for "blazers" we need to add back ["Clothes"] so CheckboxHierarchicalFilter doesn't get confused
        // I explored doing the filtering there instead, but it's very hard to do it early enough before the expansion/collapsedness is calculated and check-logic is set up in relation to other items
        // So we do it here instead
        const new_meta = new_filter_object.meta;
        const new_values = new_meta.values;
        for (const value of new_values) {
          if (!Array.isArray(value)) continue; // Shouldn't happen
          if (value.length < 2) continue; // No parent
          const parent = value.slice(0, -1);
          // Check if parent exists
          if ($e354b2f9ce33cb75$var$find_str_arr_in_str_arr_arr("some", new_values, parent)) continue; // Parent exists
          // Otherwise, put it back
          const index_to_restore = $e354b2f9ce33cb75$var$find_str_arr_in_str_arr_arr("findIndex", values, parent);
          if (index_to_restore < 0) {
            $8tj43$dwarn("Can't restore", parent, "to", new_values);
            continue;
          }
          const current_index_of_us = new_values.findIndex(item => item === value);
          new_values.splice(current_index_of_us, 0, values[index_to_restore]);
          const count_to_restore = counts === null || counts === void 0 ? void 0 : counts[index_to_restore];
          if (count_to_restore) {
            var _new_meta$counts;
            (_new_meta$counts = new_meta.counts) === null || _new_meta$counts === void 0 || _new_meta$counts.splice(current_index_of_us, 0, count_to_restore);
          }
          const name_to_restore = names === null || names === void 0 ? void 0 : names[index_to_restore];
          if (name_to_restore) {
            var _new_meta$names;
            (_new_meta$names = new_meta.names) === null || _new_meta$names === void 0 || _new_meta$names.splice(current_index_of_us, 0, name_to_restore);
          }
        }
      }
      return new_filter_object;
    }).filter(filter => filter); // Delete filters that don't have a value anymore
  });

  return {
    SearchThisFilterGroup_: SearchThisFilterGroup_,
    searched_filter_array_: searched_filter_array_,
    filter_query_: filter_query_
  };
}
/**
 * Finds/whatevers what's effectively one hierarchical filter item in an array of hierarchical filter items
 * Functions similar to this happen loads in create_modified_filters, but they have additional checks so not touching them RN
 */
function $e354b2f9ce33cb75$var$find_str_arr_in_str_arr_arr(operation, haystack, needle) {
  return haystack[operation](value => value.length === needle.length && value.every((item, index) => item === needle[index]));
}
$8tj43$delegateEvents(["input", "click"]);
var $f6b0500577e1b210$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=filter-collapsible>`),
  $f6b0500577e1b210$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button class=clear-group><!$><!/><span>`),
  $f6b0500577e1b210$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=view-more-clear><!$><!/><!$><!/>`),
  $f6b0500577e1b210$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class=filter-collapsible-body><div class=filter-part><!$><!/><!$><!/></div><!$><!/>`),
  $f6b0500577e1b210$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<details class=filter-collapsible>`),
  $f6b0500577e1b210$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<summary class=filter-group-summary><div class=summary><span></span><div class=selected-w-sign><!$><!/><!$><!/>`),
  $f6b0500577e1b210$var$_tmpl$7 = /*#__PURE__*/$8tj43$template(`<div class=ungrouped>`),
  $f6b0500577e1b210$var$_tmpl$8 = /*#__PURE__*/$8tj43$template(`<button class="clear-all-filters major">`);
function $f6b0500577e1b210$export$3f1a388cc0d8fed7(props) {
  // Split like this to make placeholder wrapping more visible & this component is exported and used in MobileModal
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return props.available_filters_();
    },
    get fallback() {
      return Array.from({
        length: 5
      }).map(() => (() => {
        var _el$ = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$);
        $8tj43$insert(_el$, $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
          width: "100%",
          height: "50px"
        }));
        return _el$;
      })());
    },
    get children() {
      return $8tj43$createComponent($f6b0500577e1b210$var$ActualFilterBody, props);
    }
  });
}
function $f6b0500577e1b210$var$ActualFilterBody(props) {
  const [modified_available_filters_with_selected_unexisting_ones_injected_from_local_state] = props.local_filter_cache_;
  const withMaybeCount0Removed = $8tj43$createMemo(() => {
    const filters = modified_available_filters_with_selected_unexisting_ones_injected_from_local_state();
    if (!props.hideCount0FilterOptions_()) return filters;
    return filters.map(filter => {
      const oldMeta = filter.meta;
      if (!oldMeta) return filter;
      const modifiedMeta = {
        ...oldMeta
      };
      if ("counts" in modifiedMeta)
        // Remove all count 0 filter options, important that counts is last option
        for (const key of ["names", "values", "swatches", "counts"]) modifiedMeta[key] && (modifiedMeta[key] = modifiedMeta[key].filter((_, index) => modifiedMeta.counts[index] !== 0));
      return {
        ...filter,
        meta: modifiedMeta
      };
    });
  });
  const togglable_filters = $8tj43$createMemo(() => withMaybeCount0Removed().filter(item => {
    var _item$meta;
    return item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.group_title;
  }));
  const untogglable_filters = $8tj43$createMemo(() => withMaybeCount0Removed().filter(item => {
    var _item$meta2;
    return !(item !== null && item !== void 0 && (_item$meta2 = item.meta) !== null && _item$meta2 !== void 0 && _item$meta2.group_title);
  }));
  const togglable_filters_grouped_by_collapsible = $8tj43$createMemo(() => {
    const output = {};
    for (const filter of togglable_filters()) {
      var _ref;
      const title = filter.meta.group_title;
      const our_array = output[_ref = title] || (output[_ref] = []);
      our_array.push(filter);
    }
    return output;
  });
  return [$8tj43$createComponent((0, $8tj43$For), {
    get each() {
      return Object.keys(togglable_filters_grouped_by_collapsible());
    },
    children: (section_, get_section_index) => {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return togglable_filters_grouped_by_collapsible()[section_];
        },
        get children() {
          return (() => {
            const filter_array_ = $8tj43$createMemo(() => Object.values(togglable_filters_grouped_by_collapsible())[get_section_index()]);
            const {
              SearchThisFilterGroup_: SearchThisFilterGroup_,
              searched_filter_array_: searched_filter_array_,
              filter_query_: filter_query_
            } = $e354b2f9ce33cb75$export$4b2c5292ffe0c5dd(filter_array_, section_, props.i18n_);
            const is_open = $f1e63746f76ce012$export$ab34afce88557c0e({
              get expanded_filters_() {
                return props.expanded_filters_;
              },
              section_: section_,
              filter_array_: filter_array_
            });
            const view_more_button_below_group = $8tj43$createSignal();
            const selected_filters_in_group = $8tj43$createMemo(() => new Map(filter_array_().map(filter_from_api => [props.selected_filters_[0]().find(filter => filter.op === filter_from_api.op && filter.field === filter_from_api.field),
            // this is absolutely not accurate which is why we have the .filter below, it's just the easiest way to get the typing of the map correct
            filter_from_api]).filter(_ref2 => {
              let [selected_filter] = _ref2;
              return selected_filter;
            })));
            const a_filter_is_selected = $8tj43$createMemo(() => selected_filters_in_group().size);
            const [get_details_width, set_get_details_width] = $8tj43$createSignal();
            const details_element_width_ = $8tj43$createMemo(() => {
              var _get_details_width;
              return get_details_width === null || get_details_width === void 0 ? void 0 : (_get_details_width = get_details_width()) === null || _get_details_width === void 0 ? void 0 : _get_details_width();
            });
            return $8tj43$createComponent((0, $ad371564683947ab$export$6c6d7a51fa9aa15d), {
              is_open_: is_open,
              get details_() {
                return (() => {
                  var _el$19 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$5);
                  $8tj43$use(element => set_get_details_width(() => $fc830a7ee59416ef$export$ebdc3711f7e02ccd(element)), _el$19);
                  $8tj43$setAttribute(_el$19, "data-group-title", section_);
                  return _el$19;
                })();
              },
              get summary_() {
                return (() => {
                  var _el$20 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$6),
                    _el$21 = _el$20.firstChild,
                    _el$22 = _el$21.firstChild,
                    _el$23 = _el$22.nextSibling,
                    _el$24 = _el$23.firstChild,
                    [_el$25, _co$7] = $8tj43$getNextMarker(_el$24.nextSibling),
                    _el$26 = _el$25.nextSibling,
                    [_el$27, _co$8] = $8tj43$getNextMarker(_el$26.nextSibling);
                  $8tj43$insert(_el$22, section_);
                  $8tj43$insert(_el$23, $8tj43$createComponent((0, $8tj43$Show), {
                    get when() {
                      return a_filter_is_selected();
                    },
                    get children() {
                      return $8tj43$createComponent((0, $d0ff304c14f50521$export$53c59af873b303c9), {
                        selected_filters_in_group_: selected_filters_in_group,
                        get i18n_() {
                          return props.i18n_;
                        }
                      });
                    }
                  }), _el$25, _co$7);
                  $8tj43$insert(_el$23, $8tj43$createComponent((0, $457279ff15864cb9$export$e5c2828934226505), {
                    get expanded_() {
                      return is_open[0];
                    },
                    get i18n_() {
                      return props.i18n_;
                    }
                  }), _el$27, _co$8);
                  return _el$20;
                })();
              },
              get children() {
                var _el$2 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$4),
                  _el$3 = _el$2.firstChild,
                  _el$4 = _el$3.firstChild,
                  [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
                  _el$6 = _el$5.nextSibling,
                  [_el$7, _co$2] = $8tj43$getNextMarker(_el$6.nextSibling),
                  _el$17 = _el$3.nextSibling,
                  [_el$18, _co$6] = $8tj43$getNextMarker(_el$17.nextSibling);
                $8tj43$insert(_el$3, $8tj43$createComponent(SearchThisFilterGroup_, {}), _el$5, _co$);
                $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Index), {
                  get each() {
                    return searched_filter_array_();
                  },
                  children: filter => $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
                    severity_: "error",
                    get message_() {
                      return "Filter group " + JSON.stringify(section_) + " failed";
                    },
                    get children() {
                      return $8tj43$createComponent((0, $8tj43$Dynamic), {
                        get component() {
                          var _filter, _filter$meta;
                          return (0, $d2988f745661df9c$export$2e2bcd8739ae039)[(_filter = filter()) === null || _filter === void 0 ? void 0 : (_filter$meta = _filter.meta) === null || _filter$meta === void 0 ? void 0 : _filter$meta.type];
                        },
                        filter_: filter,
                        get expanded_hierarchical_filters_() {
                          return props.expanded_hierarchical_filters_;
                        },
                        get selected_filters_() {
                          return props.selected_filters_;
                        },
                        get i18n_() {
                          return props.i18n_;
                        },
                        view_more_button_below_group_: view_more_button_below_group,
                        filter_query_: filter_query_,
                        details_element_width_: details_element_width_
                      });
                    }
                  })
                }), _el$7, _co$2);
                $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
                  get when() {
                    return $8tj43$createMemo(() => {
                      const signal_value = view_more_button_below_group[0]();
                      return (signal_value && Array.isArray(signal_value) ? signal_value.length : signal_value) || a_filter_is_selected();
                    })();
                  },
                  get children() {
                    var _el$8 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$3),
                      _el$13 = _el$8.firstChild,
                      [_el$14, _co$4] = $8tj43$getNextMarker(_el$13.nextSibling),
                      _el$15 = _el$14.nextSibling,
                      [_el$16, _co$5] = $8tj43$getNextMarker(_el$15.nextSibling);
                    $8tj43$insert(_el$8, () => view_more_button_below_group[0](), _el$14, _co$4);
                    $8tj43$insert(_el$8, $8tj43$createComponent((0, $8tj43$Show), {
                      get when() {
                        return a_filter_is_selected();
                      },
                      get children() {
                        var _el$9 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$2),
                          _el$11 = _el$9.firstChild,
                          [_el$12, _co$3] = $8tj43$getNextMarker(_el$11.nextSibling),
                          _el$10 = _el$12.nextSibling;
                        $8tj43$addEventListener(_el$9, "click", $8tj43$catchify1(() => {
                          const new_filter_obj = [...props.selected_filters_[0]()];
                          for (const filter of filter_array_()) {
                            const index = new_filter_obj.findIndex(_ref3 => {
                              let {
                                op: op,
                                field: field
                              } = _ref3;
                              return op === filter.op && field === filter.field;
                            });
                            if (index >= 0) new_filter_obj.splice(index, 1);
                          }
                          props.selected_filters_[1](new_filter_obj);
                        }), true);
                        $8tj43$insert(_el$9, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}), _el$12, _co$3);
                        $8tj43$insert(_el$10, () => props.i18n_.clear_individual_filter_());
                        $8tj43$runHydrationEvents();
                        return _el$9;
                      }
                    }), _el$16, _co$5);
                    return _el$8;
                  }
                }), _el$18, _co$6);
                return _el$2;
              }
            });
          })();
        }
      });
    }
  }), $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _untogglable_filters;
      return (_untogglable_filters = untogglable_filters()) === null || _untogglable_filters === void 0 ? void 0 : _untogglable_filters.length;
    },
    get children() {
      var _el$28 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$7);
      $8tj43$insert(_el$28, $8tj43$createComponent((0, $8tj43$Index), {
        get each() {
          return untogglable_filters();
        },
        children: filter => {
          const view_more_button_below_group = $8tj43$createSignal();
          const [get_view_more_button_below_group] = view_more_button_below_group;
          return [$8tj43$createComponent((0, $8tj43$Dynamic), {
            get component() {
              var _filter2, _filter2$meta;
              return (0, $d2988f745661df9c$export$2e2bcd8739ae039)[(_filter2 = filter()) === null || _filter2 === void 0 ? void 0 : (_filter2$meta = _filter2.meta) === null || _filter2$meta === void 0 ? void 0 : _filter2$meta.type];
            },
            filter_: filter,
            get expanded_hierarchical_filters_() {
              return props.expanded_hierarchical_filters_;
            },
            get selected_filters_() {
              return props.selected_filters_;
            },
            get i18n_() {
              return props.i18n_;
            },
            view_more_button_below_group_: view_more_button_below_group
          }), $8tj43$memo(get_view_more_button_below_group)];
        }
      }));
      return _el$28;
    }
  }), $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _props$selected_filte;
      return $8tj43$memo(() => !!!props.are_in_modal_ /* modal has its own clear button */)() && ((_props$selected_filte = props.selected_filters_[0]()) === null || _props$selected_filte === void 0 ? void 0 : _props$selected_filte.length);
    },
    get children() {
      var _el$29 = $8tj43$getNextElement($f6b0500577e1b210$var$_tmpl$8);
      $8tj43$addEventListener(_el$29, "click", $8tj43$catchify1(() => $b4465d8d605f61e9$export$8895d39404bd2bb1({
        user_triggered_: true,
        selected_filters_: props.selected_filters_,
        i18n_: props.i18n_,
        also_clear_sorting_: false,
        expanded_hierarchical_filters_: props.expanded_hierarchical_filters_,
        local_filter_cache_: props.local_filter_cache_
      })), true);
      $8tj43$insert(_el$29, () => props.i18n_.clear_all_filters_from_big_button_());
      $8tj43$runHydrationEvents();
      return _el$29;
    }
  })];
}
$8tj43$delegateEvents(["click"]);
var $cfdbd124dd09d713$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=sorting-attributes>`),
  $cfdbd124dd09d713$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=sorting-direction>`),
  $cfdbd124dd09d713$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div><div class=input-row><input type=radio><span class=custom-indicator></span><!$><!/>`),
  $cfdbd124dd09d713$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div><label class=input-row><input type=radio><span class=custom-indicator></span><!$><!/>`);
function $cfdbd124dd09d713$export$1f1775a58da589b5(_ref) {
  let {
    available_sortings_: available_sortings_,
    current_sorting_: [get_current_sorting, set_current_sorting],
    meta_of_currently_selected_sorting_: meta_of_currently_selected_sorting_
  } = _ref;
  const title_radio_name = $8tj43$make_random_classname();
  const order_radio_name = $8tj43$make_random_classname();
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _available_sortings_;
      return (_available_sortings_ = available_sortings_()) === null || _available_sortings_ === void 0 ? void 0 : _available_sortings_.length;
    },
    get fallback() {
      return (() => {
        var _el$3 = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$);
        $8tj43$insert(_el$3, () => Array.from({
          length: 4
        }).map(() => (() => {
          var _el$4 = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$3),
            _el$5 = _el$4.firstChild,
            _el$6 = _el$5.firstChild,
            _el$7 = _el$6.nextSibling,
            _el$8 = _el$7.nextSibling,
            [_el$9, _co$] = $8tj43$getNextMarker(_el$8.nextSibling);
          $8tj43$setProperty(_el$6, "disabled", true);
          $8tj43$insert(_el$5, $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
            height: "1.2em",
            width: "100%"
          }), _el$9, _co$);
          return _el$4;
        })()));
        return _el$3;
      })();
    },
    get children() {
      return [(() => {
        var _el$ = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$);
        $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
          get each() {
            var _available_sortings_2, _available_sortings_3;
            return ((_available_sortings_2 = available_sortings_()) === null || _available_sortings_2 === void 0 ? void 0 : (_available_sortings_3 = _available_sortings_2.filter) === null || _available_sortings_3 === void 0 ? void 0 : _available_sortings_3.call(_available_sortings_2, sorting => {
              var _sorting$meta;
              return (_sorting$meta = sorting.meta) === null || _sorting$meta === void 0 ? void 0 : _sorting$meta.title;
            })) || [];
          },
          children: (item, index) => {
            const is_checked = $8tj43$createMemo(() => {
              var _item$meta$values;
              const sort = get_current_sorting();
              if (!sort)
                // if no sortings are selected, "select" first sort
                return index === 0;
              return sort.field === item().field && (sort.order === item().order || ((_item$meta$values = item().meta.values) === null || _item$meta$values === void 0 ? void 0 : _item$meta$values.length) > 1);
            });
            return (/* wrapping div for flex gap polyfill scss mixin */(() => {
                var _el$10 = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$4),
                  _el$11 = _el$10.firstChild,
                  _el$12 = _el$11.firstChild,
                  _el$13 = _el$12.nextSibling,
                  _el$14 = _el$13.nextSibling,
                  [_el$15, _co$2] = $8tj43$getNextMarker(_el$14.nextSibling);
                $8tj43$addEventListener(_el$12, "change", $8tj43$catchify1(() => set_current_sorting(item())));
                $8tj43$setAttribute(_el$12, "name", title_radio_name);
                $8tj43$insert(_el$11, () => item().meta.title, _el$15, _co$2);
                $8tj43$effect(() => $8tj43$setProperty(_el$12, "checked", is_checked()));
                return _el$10;
              })()
            );
          }
        }));
        return _el$;
      })(), $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          var _meta_of_currently_se, _meta_of_currently_se2;
          return ((_meta_of_currently_se = meta_of_currently_selected_sorting_()) === null || _meta_of_currently_se === void 0 ? void 0 : (_meta_of_currently_se2 = _meta_of_currently_se.values) === null || _meta_of_currently_se2 === void 0 ? void 0 : _meta_of_currently_se2.length) > 1;
        },
        get children() {
          var _el$2 = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$2);
          $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              var _meta_of_currently_se3;
              return (_meta_of_currently_se3 = meta_of_currently_selected_sorting_()) === null || _meta_of_currently_se3 === void 0 ? void 0 : _meta_of_currently_se3.values;
            },
            children: (order_value, index) => {
              const is_checked = $8tj43$createMemo(() => {
                var _get_current_sorting;
                return ((_get_current_sorting = get_current_sorting()) === null || _get_current_sorting === void 0 ? void 0 : _get_current_sorting.order) === order_value();
              });
              return (() => {
                var _el$16 = $8tj43$getNextElement($cfdbd124dd09d713$var$_tmpl$4),
                  _el$17 = _el$16.firstChild,
                  _el$18 = _el$17.firstChild,
                  _el$19 = _el$18.nextSibling,
                  _el$20 = _el$19.nextSibling,
                  [_el$21, _co$3] = $8tj43$getNextMarker(_el$20.nextSibling);
                $8tj43$addEventListener(_el$18, "change", $8tj43$catchify1(() => set_current_sorting(c => c && {
                  ...c,
                  order: order_value()
                })));
                $8tj43$setAttribute(_el$18, "name", order_radio_name);
                $8tj43$insert(_el$17, () => {
                  var _meta_of_currently_se4, _meta_of_currently_se5;
                  return (_meta_of_currently_se4 = meta_of_currently_selected_sorting_()) === null || _meta_of_currently_se4 === void 0 ? void 0 : (_meta_of_currently_se5 = _meta_of_currently_se4.names) === null || _meta_of_currently_se5 === void 0 ? void 0 : _meta_of_currently_se5[index];
                }, _el$21, _co$3);
                $8tj43$effect(() => $8tj43$setProperty(_el$18, "checked", is_checked()));
                return _el$16;
              })();
            }
          }));
          return _el$2;
        }
      })];
    }
  });
}
function $e56d241d0f33d459$export$fe334901e8bebd57() {
  const cleanup_fns = [];
  const cleanup = () => cleanup_fns.forEach(f => f());
  // use an animation to automatically retain the `overflow` values and all other styling
  for (const element of [document.documentElement, document.body]) {
    try {
      const animation = element.animate({
        overflow: "hidden",
        offset: 0
      }, 1);
      animation.pause();
      const fn = $8tj43$catchify1(animation.play.bind(animation));
      cleanup_fns.push(fn);
      $8tj43$onCleanup(fn);
    } catch (e) {
      $8tj43$dlog("Probably partial keyframe error", e);
    }
    if (getComputedStyle(element).overflow !== "hidden") {
      // safari gets special hacky treatment
      const style = element.style;
      const original_value = style.overflow;
      style.overflow = "hidden";
      const fn = $8tj43$catchify1(() => style.overflow = original_value);
      cleanup_fns.push(fn);
      $8tj43$onCleanup(fn);
    }
  }
  return cleanup;
} // the way that houdini does that (FYI) it fixes the page jumps
// const from_top = scrollY;
// document.body.style.position = "fixed";
// document.body.style.left = 0;
// document.body.style.right = 0;
// document.body.style.top = `-${from_top}px`;
// document.body.style.overflowY = "scroll";

var $79af35736fe8e5c8$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=14 height=14 class=sort-icon><path d="M6.199 10.254a.35.35 0 0 0-.496 0L3.5 12.453V.348a.35.35 0 0 0-.7 0v12.105L.598 10.254c-.137-.137-.359-.137-.492 0a.35.35 0 0 0 0 .492l2.797 2.801a.35.35 0 0 0 .496 0L6.2 10.746c.137-.137.137-.355 0-.492zM9.449 3.5H8.051a.35.35 0 0 1-.352-.352V1.75c0-.191.156-.352.352-.352h1.398c.195 0 .352.16.352.352v1.398a.35.35 0 0 1-.352.352zm-1.051-.699h.703v-.699h-.703zm0 0"></path><path d="M10.852 6.301H8.051a.35.35 0 0 1-.352-.352V4.551a.35.35 0 0 1 .352-.352h2.801a.35.35 0 0 1 .348.352v1.398a.35.35 0 0 1-.348.352zm-2.453-.699H10.5v-.703H8.398zm3.851 3.5H8.051c-.195 0-.352-.16-.352-.352V7.352A.35.35 0 0 1 8.051 7h4.199c.191 0 .352.156.352.352V8.75c0 .191-.16.352-.352.352zm-3.852-.703h3.5V7.7h-3.5zm5.25 3.499H8.051a.35.35 0 0 1-.352-.348v-1.402a.35.35 0 0 1 .352-.348h5.598a.35.35 0 0 1 .352.348v1.402a.35.35 0 0 1-.352.348zm-5.25-.699H13.3V10.5H8.398zm0 0">`);
function $79af35736fe8e5c8$export$da32f7add8a22e86() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($79af35736fe8e5c8$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $73e3c96bc365e0e9$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=14 height=14 class=sort-icon><path d="M6.199 10.254a.35.35 0 0 0-.496 0L3.5 12.453V.348a.35.35 0 0 0-.7 0v12.105L.598 10.254c-.137-.137-.359-.137-.492 0a.35.35 0 0 0 0 .492l2.797 2.801a.35.35 0 0 0 .496 0L6.2 10.746c.137-.137.137-.355 0-.492zm3.25 1.644H8.051a.35.35 0 0 1-.352-.348v-1.402a.35.35 0 0 1 .352-.348h1.398a.35.35 0 0 1 .352.348v1.402a.35.35 0 0 1-.352.348zm-1.051-.699h.703V10.5h-.703zm2.454-2.097H8.051c-.195 0-.352-.16-.352-.352V7.352A.35.35 0 0 1 8.051 7h2.801a.35.35 0 0 1 .348.352V8.75c0 .191-.156.352-.348.352zm-2.453-.703H10.5V7.7H8.398zm3.851-2.098H8.051a.35.35 0 0 1-.352-.352V4.551a.35.35 0 0 1 .352-.352h4.199c.191 0 .352.156.352.352v1.398c0 .195-.16.352-.352.352zm-3.852-.699h3.5v-.703h-3.5zm5.25-2.102H8.051a.35.35 0 0 1-.352-.352V1.75c0-.191.156-.352.352-.352h5.598c.195 0 .352.16.352.352v1.398a.35.35 0 0 1-.352.352zm-5.25-.699H13.3v-.699H8.398zm0 0">`);
function $73e3c96bc365e0e9$export$d10e63059ddb9fd4() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($73e3c96bc365e0e9$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $05f67356defcdd65$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=14 height=15 class=filter-icon><path d="M1.75 14.697c-.096 0-.178-.034-.246-.103s-.103-.15-.103-.246V8.75c0-.096.034-.178.103-.246s.15-.103.246-.103.178.034.246.103.103.15.103.246v5.599c0 .096-.034.178-.103.246s-.15.103-.246.103zm0-9.796c-.096 0-.178-.034-.246-.103s-.103-.15-.103-.246v-3.5c0-.1.034-.185.103-.253s.15-.103.246-.103.178.034.246.103.103.153.103.253v3.5c0 .096-.034.178-.103.246s-.15.103-.246.103zm.697 2.796H1.053c-.292 0-.54-.103-.745-.308S0 6.938 0 6.651s.103-.54.308-.745.453-.308.745-.308h1.395c.292 0 .54.103.745.308s.308.453.308.745-.103.533-.308.738-.453.308-.745.308zM1.053 6.303c-.1 0-.185.034-.253.103s-.103.15-.103.246.034.178.103.246S.952 7 1.053 7h1.395c.1 0 .185-.034.253-.103s.103-.15.103-.246-.034-.178-.103-.246-.153-.103-.253-.103H1.053zm5.599 8.395c-.096 0-.178-.034-.246-.103s-.103-.15-.103-.246v-2.796c0-.1.034-.184.103-.253s.15-.102.246-.102.178.034.246.102.103.153.103.253v2.796c0 .096-.034.178-.103.246s-.15.103-.246.103zm0-7c-.096 0-.178-.034-.246-.103s-.103-.15-.103-.246V1.053c0-.1.034-.185.103-.253s.15-.103.246-.103.178.034.246.103S7 .952 7 1.053v6.296c0 .096-.034.178-.103.246s-.15.103-.246.103zm.697 2.803H5.947c-.287 0-.533-.102-.738-.308s-.308-.453-.308-.745.103-.533.308-.738.451-.308.738-.308h1.401c.292 0 .54.103.745.308s.308.451.308.738-.103.54-.308.745-.453.308-.745.308zM5.947 9.099c-.096 0-.178.034-.246.103s-.103.15-.103.246.034.185.103.253.15.103.246.103h1.401c.096 0 .178-.034.246-.103s.103-.153.103-.253-.034-.178-.103-.246-.15-.103-.246-.103H5.947zm5.605 5.599c-.1 0-.184-.034-.253-.103s-.102-.15-.102-.246v-7c0-.096.034-.178.102-.246S11.453 7 11.553 7s.178.034.246.103.103.15.103.246v7c0 .096-.034.178-.103.246s-.15.103-.246.103zm0-11.197c-.1 0-.184-.034-.253-.103s-.102-.15-.102-.246V1.053c0-.1.034-.185.102-.253s.153-.103.253-.103.178.034.246.103.103.153.103.253v2.099c0 .096-.034.178-.103.246s-.15.103-.246.103zm.697 2.803h-1.401c-.287 0-.533-.103-.738-.308s-.308-.453-.308-.745.103-.54.308-.745.451-.308.738-.308h1.401c.292 0 .54.103.745.308s.308.453.308.745-.102.54-.308.745-.453.308-.745.308zm-1.401-1.401c-.096 0-.178.034-.246.103s-.102.15-.102.246.034.178.102.246.15.103.246.103h1.401c.096 0 .178-.034.246-.103s.102-.15.102-.246-.034-.178-.102-.246-.15-.103-.246-.103h-1.401z">`);
function $05f67356defcdd65$export$28f6150e232898de() {
  return $8tj43$getNextElement($05f67356defcdd65$var$_tmpl$);
}

/**
 * Returns true when we have an array of filters that's an array but empty and no selected filters.
 * Used for hiding the filter button, filter section is from sort/filter modal and desktop filters
 */
function $6fcb97029a69ec44$export$50f68cc9882e36a4(args_for_filtering) {
  var _args_for_filtering$a, _args_for_filtering$s;
  return ((_args_for_filtering$a = args_for_filtering.available_filters_()) === null || _args_for_filtering$a === void 0 ? void 0 : _args_for_filtering$a.length) === 0 && !((_args_for_filtering$s = args_for_filtering.selected_filters_[0]()) !== null && _args_for_filtering$s !== void 0 && _args_for_filtering$s.length);
}
var $082c4ed3e22f8d71$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button class="clear minor">`),
  $082c4ed3e22f8d71$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class="depict plp"id=depict-filter-sort-mobile-modal-container><div class=depict-filter-sort-modal-backdrop></div><button class=dismiss-modal></button><div class=filter-sort-modal><div class=body><!$><!/><!$><!/></div><div class=bottom-row><!$><!/><button class="show-results major">`),
  $082c4ed3e22f8d71$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<details class=sorting>`),
  $082c4ed3e22f8d71$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<summary class=sort-filter-summary><div class=summary><div class=left-els><!$><!/><span></span></div><!$><!/>`),
  $082c4ed3e22f8d71$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<div class=body>`),
  $082c4ed3e22f8d71$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<details class=filters>`),
  $082c4ed3e22f8d71$var$_tmpl$7 = /*#__PURE__*/$8tj43$template(`<b>`);
const $082c4ed3e22f8d71$var$no_go_selector = ".range .range-group";
function $082c4ed3e22f8d71$export$9bf11afa910f536e(_ref) {
  let {
    args_for_sorting_: args_for_sorting_,
    args_for_filtering_: args_for_filtering_,
    search_filters_open_: [get_search_filters_open, set_search_filters_open],
    search_sorting_open_: [get_search_sorting_open, set_search_sorting_open],
    dismiss_modal_: dismiss_modal_,
    register_closing_animation_: register_closing_animation_,
    formatted_number_of_results_: formatted_number_of_results_,
    i18n_: i18n_
  } = _ref;
  $e56d241d0f33d459$export$fe334901e8bebd57();
  let modal;
  let modal_body;
  let background;
  let dismiss_button;
  let resolve_cleanup_promise;
  let touches = 0;
  const cleanup_promise = new Promise(r => resolve_cleanup_promise = r);
  const [sorting_expanded, set_sorting_expanded] = $8tj43$createSignal($8tj43$untrack(() => get_search_sorting_open()));
  const [filters_expanded, set_filters_expanded] = $8tj43$createSignal($8tj43$untrack(() => get_search_filters_open()));
  const modal_scrolling_prevented = $8tj43$createSignal(false);
  // Note: we're not using Element.animate here because it's completely broken for animating the modal up-down on iOS 15.4 (I debugged it for three hours and then just updated) and still a bit glitchy on other versions. Might be possible to switch now for later versions but probably not worth it
  const set_style = (el, property, value) => el.style.setProperty(property, value);
  const set_background_style = (property, value) => set_style(background, property, value);
  const set_modal_style = (property, value) => set_style(modal, property, value);
  const set_button_style = (property, value) => set_style(dismiss_button, property, value);
  const set_button_fraction_in = fraction => set_button_style("transform", "translateY(calc(calc(-100% - ".concat(getComputedStyle(dismiss_button).top, ") * ").concat(1 - fraction, "))"));
  // sync what was open if possible for when switching mobile/desktop or navigating away and coming back
  $8tj43$createComputed(() => {
    const filtering_collapsible_expanded = filters_expanded();
    const sorting_collapsible_expanded = sorting_expanded();
    if (filtering_collapsible_expanded && !sorting_collapsible_expanded) {
      set_search_filters_open(true);
      set_search_sorting_open(false);
    } else if (sorting_collapsible_expanded && !filtering_collapsible_expanded) {
      set_search_filters_open(false);
      set_search_sorting_open(true);
    }
  });
  $8tj43$onCleanup($8tj43$catchify1(() => {
    if (!sorting_expanded() && !filters_expanded()) {
      set_search_filters_open(false);
      set_search_sorting_open(false);
    }
  }));
  register_closing_animation_(() => {
    set_background_style("transition", "all 300ms ease-out");
    set_background_style("opacity", "0");
    set_modal_style("transition", "all 200ms ease-out");
    set_modal_style("transform", "translateY(100%)");
    set_button_style("transition", "all 100ms ease-out");
    set_button_fraction_in(0);
    return new Promise(r => setTimeout(r, 300));
  });
  $8tj43$onCleanup(resolve_cleanup_promise);
  return [(() => {
    var _el$ = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$2),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$4.firstChild,
      _el$6 = _el$5.firstChild,
      [_el$7, _co$] = $8tj43$getNextMarker(_el$6.nextSibling),
      _el$8 = _el$7.nextSibling,
      [_el$9, _co$2] = $8tj43$getNextMarker(_el$8.nextSibling),
      _el$10 = _el$5.nextSibling,
      _el$13 = _el$10.firstChild,
      [_el$14, _co$3] = $8tj43$getNextMarker(_el$13.nextSibling),
      _el$12 = _el$14.nextSibling;
    $8tj43$use(el => {
      background = el;
      (0, $8tj43$observer).wait_for_element(el).then($8tj43$catchify1(() => {
        set_background_style("transition", "all 200ms ease-in");
        // For some reason this needs a requestAnimationFrame but the other modal-opening animations don't
        requestAnimationFrame($8tj43$catchify1(() => set_background_style("opacity", "1")));
      }));
    }, _el$2);
    $8tj43$addEventListener(_el$2, "click", dismiss_modal_, true);
    $8tj43$use(el => {
      dismiss_button = el;
      (0, $8tj43$observer).wait_for_element(el).then($8tj43$catchify1(() => {
        set_button_style("transition", "all 200ms ease-in");
        set_button_fraction_in(1);
      }));
    }, _el$3);
    $8tj43$addEventListener(_el$3, "click", dismiss_modal_, true);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}));
    _el$4.$$touchstart = _ref2 => {
      let {
        changedTouches: changedTouches,
        target: target
      } = _ref2;
      // touchstart should always only have one changed touch, track it here
      if (touches >= 1) {
        $8tj43$dlog("Got new touch", changedTouches, "ignoring"); // only support 1 touch for now
        return;
      }
      if (target.closest($082c4ed3e22f8d71$var$no_go_selector) || target.matches($082c4ed3e22f8d71$var$no_go_selector)) {
        $8tj43$dlog("Got touch on slider, ignoring for UX", target, changedTouches);
        return;
      }
      set_modal_style("transition", "unset");
      set_background_style("transition", "unset");
      set_button_style("transition", "unset");
      const [{
        identifier: our_fingers_identifier,
        pageY: start_page_y
      }] = changedTouches;
      let gesture_starting_page_y = start_page_y;
      const start_time = +new Date();
      let total_distance_travelled = 0;
      let last_move_page_y = start_page_y;
      let first_move_was_downwards = false;
      let distance_from_start_of_gesture = 0;
      const end_handler = $8tj43$catchify1(e => {
        const changedTouches = e === null || e === void 0 ? void 0 : e.changedTouches;
        if (changedTouches && changedTouches[0].identifier !== our_fingers_identifier)
          // other finger stopped touch, ignore it
          return;
        modal_scrolling_prevented[1](false);
        const velocity = total_distance_travelled / (+new Date() - start_time); // px/ms
        const {
          offsetHeight: offsetHeight
        } = modal;
        if ((e === null || e === void 0 ? void 0 : e.type) === "touchend" && distance_from_start_of_gesture > offsetHeight / 3 || velocity > 1.5 && distance_from_start_of_gesture > offsetHeight / 10 // I think this is a good magic number
        ) dismiss_modal_();else if (e) {
          set_background_style("transition", "all 150ms ease-out");
          set_background_style("opacity", "1");
          set_modal_style("transition", "all 150ms ease-out");
          set_modal_style("transform", "translateY(0)");
          set_button_style("transition", "all 100ms ease-out");
          set_button_fraction_in(1);
        }
        touches--;
        modal.removeEventListener("touchend", end_handler);
        modal.removeEventListener("touchcancel", end_handler);
        modal.removeEventListener("touchmove", move_handler);
      });
      const move_handler = $8tj43$catchify1(e => {
        const {
          changedTouches: changedTouches
        } = e;
        let called_prevent_default = false;
        for (let i = 0; i < changedTouches.length; i++) {
          const {
            pageY: this_move_page_y,
            clientY: clientY,
            identifier: identifier_of_a_touch
          } = changedTouches[i];
          // unrelated to this functionality, we want to block that the site behind is being scrolled when swiping on this if the modal isn't scrollable
          const scroll_top_max = modal_body.scrollTopMax || modal_body.scrollHeight - modal_body.clientHeight;
          if (scroll_top_max === 0) {
            e.preventDefault();
            called_prevent_default = true;
          }
          // end unrelated
          if (identifier_of_a_touch !== our_fingers_identifier) continue;
          if (modal_body.scrollTop > 0) {
            gesture_starting_page_y = this_move_page_y;
            return;
          }
          total_distance_travelled += Math.abs(this_move_page_y - last_move_page_y);
          distance_from_start_of_gesture = this_move_page_y - gesture_starting_page_y;
          if (!first_move_was_downwards) {
            if (distance_from_start_of_gesture < 0) {
              // user wants to scroll down, end it
              end_handler();
              return;
            } else first_move_was_downwards = true;
          }
          if (distance_from_start_of_gesture > 0) modal_scrolling_prevented[1](true);else modal_scrolling_prevented[1](false);
          if (!called_prevent_default) e.preventDefault();
          set_modal_style("transform", "translateY(".concat(distance_from_start_of_gesture, "px)"));
          set_background_style("opacity", 1 - clientY / window.innerHeight / 2 + "");
          const on_way_to_snap_point = distance_from_start_of_gesture / (modal.offsetHeight / 3);
          set_button_fraction_in(1 - (on_way_to_snap_point < 0 ? 0 : on_way_to_snap_point > 1 ? 1 : on_way_to_snap_point));
          last_move_page_y = this_move_page_y;
        }
      });
      modal.addEventListener("touchend", end_handler);
      modal.addEventListener("touchcancel", end_handler);
      modal.addEventListener("touchmove", move_handler, {
        passive: false
      });
      touches++;
    };
    $8tj43$use(el => {
      modal = el;
      (0, $8tj43$observer).wait_for_element(el).then($8tj43$catchify1(() => {
        set_modal_style("transition", "all 200ms ease-in");
        set_modal_style("transform", "translateY(0)");
      }));
    }, _el$4);
    var _ref$ = modal_body;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$5) : modal_body = _el$5;
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $ad371564683947ab$export$6c6d7a51fa9aa15d), {
      is_open_: [sorting_expanded, set_sorting_expanded],
      get details_() {
        return $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$3);
      },
      get summary_() {
        return (() => {
          var _el$16 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$4),
            _el$17 = _el$16.firstChild,
            _el$18 = _el$17.firstChild,
            _el$20 = _el$18.firstChild,
            [_el$21, _co$4] = $8tj43$getNextMarker(_el$20.nextSibling),
            _el$19 = _el$21.nextSibling,
            _el$22 = _el$18.nextSibling,
            [_el$23, _co$5] = $8tj43$getNextMarker(_el$22.nextSibling);
          $8tj43$insert(_el$18, (() => {
            var _c$ = $8tj43$memo(() => {
              var _args_for_sorting_$cu;
              return ((_args_for_sorting_$cu = args_for_sorting_.current_sorting_[0]()) === null || _args_for_sorting_$cu === void 0 ? void 0 : _args_for_sorting_$cu.order) === "asc";
            });
            return () => _c$() ? $8tj43$createComponent((0, $79af35736fe8e5c8$export$da32f7add8a22e86), {}) : $8tj43$createComponent((0, $73e3c96bc365e0e9$export$d10e63059ddb9fd4), {});
          })(), _el$21, _co$4);
          $8tj43$insert(_el$19, () => i18n_.sorting_text_());
          $8tj43$insert(_el$17, $8tj43$createComponent((0, $457279ff15864cb9$export$e5c2828934226505), {
            expanded_: sorting_expanded,
            i18n_: i18n_
          }), _el$23, _co$5);
          return _el$16;
        })();
      },
      get children() {
        return (() => {
          var _el$24 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$5);
          $8tj43$insert(_el$24, $8tj43$createComponent((0, $cfdbd124dd09d713$export$1f1775a58da589b5), args_for_sorting_));
          return _el$24;
        })();
      }
    }), _el$7, _co$);
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !$6fcb97029a69ec44$export$50f68cc9882e36a4(args_for_filtering_);
      },
      get children() {
        return $8tj43$createComponent((0, $ad371564683947ab$export$6c6d7a51fa9aa15d), {
          is_open_: [filters_expanded, set_filters_expanded],
          get details_() {
            return $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$6);
          },
          get summary_() {
            return (() => {
              var _el$26 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$4),
                _el$27 = _el$26.firstChild,
                _el$28 = _el$27.firstChild,
                _el$30 = _el$28.firstChild,
                [_el$31, _co$6] = $8tj43$getNextMarker(_el$30.nextSibling),
                _el$29 = _el$31.nextSibling,
                _el$32 = _el$28.nextSibling,
                [_el$33, _co$7] = $8tj43$getNextMarker(_el$32.nextSibling);
              $8tj43$insert(_el$28, $8tj43$createComponent((0, $05f67356defcdd65$export$28f6150e232898de), {}), _el$31, _co$6);
              $8tj43$insert(_el$29, () => i18n_.filters_());
              $8tj43$insert(_el$27, $8tj43$createComponent((0, $457279ff15864cb9$export$e5c2828934226505), {
                expanded_: filters_expanded,
                i18n_: i18n_
              }), _el$33, _co$7);
              return _el$26;
            })();
          },
          get children() {
            return (() => {
              var _el$34 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$5);
              $8tj43$insert(_el$34, $8tj43$createComponent((0, $f6b0500577e1b210$export$3f1a388cc0d8fed7), $8tj43$mergeProps1(args_for_filtering_, {
                are_in_modal_: true
              })));
              return _el$34;
            })();
          }
        });
      }
    }), _el$9, _co$2);
    $8tj43$insert(_el$10, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        var _args_for_filtering_$;
        return (_args_for_filtering_$ = args_for_filtering_.selected_filters_[0]()) === null || _args_for_filtering_$ === void 0 ? void 0 : _args_for_filtering_$.length;
      },
      get children() {
        var _el$11 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$);
        $8tj43$addEventListener(_el$11, "click", $8tj43$catchify1(() => {
          const show_toast = $b4465d8d605f61e9$export$8895d39404bd2bb1({
            user_triggered_: true,
            expanded_hierarchical_filters_: args_for_filtering_.expanded_hierarchical_filters_,
            i18n_: i18n_,
            local_filter_cache_: args_for_filtering_.local_filter_cache_,
            selected_filters_: args_for_filtering_.selected_filters_,
            also_clear_sorting_: false,
            delay_toast_: true
          });
          cleanup_promise.then($8tj43$catchify1(show_toast));
        }), true);
        $8tj43$insert(_el$11, () => i18n_.clear_individual_filter_());
        $8tj43$runHydrationEvents();
        return _el$11;
      }
    }), _el$14, _co$3);
    $8tj43$addEventListener(_el$12, "click", dismiss_modal_, true);
    $8tj43$insert(_el$12, () => i18n_.show_n_results_()((() => {
      var _el$35 = $8tj43$getNextElement($082c4ed3e22f8d71$var$_tmpl$7);
      $8tj43$insert(_el$35, formatted_number_of_results_);
      return _el$35;
    })()));
    $8tj43$effect(_p$ => {
      var _v$ = i18n_.close_(),
        _v$2 = modal_scrolling_prevented[0]() ? "overflow:hidden" : "";
      _v$ !== _p$.e && $8tj43$setAttribute(_el$3, "aria-label", _p$.e = _v$);
      _p$.t = $8tj43$style(_el$5, _v$2, _p$.t);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$;
  })()];
}
$8tj43$delegateEvents(["click", "touchstart"]);
let $972f6bce0f9d61be$export$68620bd6d5c6bb86;
function $972f6bce0f9d61be$export$e183a13865960371(params_to_default_value, router_) {
  const signals = {};
  const entries = Object.entries(params_to_default_value);
  const event_handler = $8tj43$catchify1((what_happened, args) => {
    // Intentionally always update our signals to the history state to allow external control of SDK state for doing things like https://linear.app/depictai/issue/X-1432/is-this-possible-with-the-depict-sdk
    if (what_happened !== "popstate") return;
    // Had to undo the comment above,but leaving the history. Doing this because discovering why it doesn't work is a deja-vu and I don't want to have to discover it again.
    // If we want others to interface with our state, it's better to expose it from DepictCategory/DepictSearch
    // The reason for that is because writes to the state trigger writes to the state (something about local filter state, see the comment where `last_remote_state !== available_filters_()` happens in create_modified_filters.tsx)
    // And can infinite loop, like in https://app.jiminny.com/playback/569c8f65-edea-4735-bd9e-4eb5a0b14cad
    // It's the classical equilibrium problem when syncing state both down and up, and it's much easier to avoid than solve
    $972f6bce0f9d61be$var$history_state_change(signals, entries, args.state);
  });
  // createRenderEffect because we need the instant execution so the signals always contain values, even before solid's render phase
  $8tj43$createRenderEffect(() => {
    let signal_changed = false;
    let {
      state: state
    } = (globalThis === null || globalThis === void 0 ? void 0 : globalThis.history) || {
      state: {}
    }; // cloning isn't necessary because we're calling replaceState on it anyway
    if (state === null || typeof state != "object") state = {};
    for (const [param, default_value] of entries) {
      var _state$param;
      const [read_signal] = signals[param] || (signals[param] = $8tj43$createSignal((_state$param = state[param]) !== null && _state$param !== void 0 ? _state$param : default_value));
      const new_value = read_signal();
      if (new_value !== state[param]) {
        signal_changed = true;
        state[param] = new_value;
      }
    }
    if (signal_changed) router_.navigate_.replace_state_(state);
    $8tj43$onCleanup(() => $972f6bce0f9d61be$export$68620bd6d5c6bb86 = {
      time: new Date().toISOString(),
      stack: new Error().stack
    });
  });
  // history_dot_state_to_state needs to update after its signals after url_state does BUT in the same task (might even have to be in the same tick in the microtask queue). If we'd use window.addEventListener("popstate") it would be guaranteed to be too late since each event listener has its own task
  (0, $8tj43$instant_exec_on_suspect_history_change).add(event_handler);
  $8tj43$onCleanup($8tj43$catchify1(() => (0, $8tj43$instant_exec_on_suspect_history_change).delete(event_handler)));
  $8tj43$createEffect($8tj43$catchify1(() => $8tj43$untrack($8tj43$catchify1(() => $972f6bce0f9d61be$var$history_state_change(signals, entries, history.state))))); // we need this to run after reading the initial state from history.state to write the defaults to history.state
  return signals;
}
function $972f6bce0f9d61be$var$history_state_change(signals, entries, state) {
  $8tj43$batch(() => {
    for (const [param, default_value] of entries) {
      const [, write_signal] = signals[param];
      const new_value = state === null || state === void 0 ? void 0 : state[param];
      write_signal(new_value !== null && new_value !== void 0 ? new_value : default_value);
    }
  });
}
function $44aa24b1bb793549$export$b288c38ae3fddb56(_ref) {
  let {
    available_filters_: available_filters_,
    local_filter_cache_: [read_local_cache, write_local_cache],
    selected_filters_: [read_selected_filters]
  } = _ref;
  let last_remote_state;
  let executions = 0;
  let oneSecondInfiniteLoopPreventionTimeout;
  $8tj43$createComputed(() => {
    var _available_filters_;
    // Sometimes (24 events in sentry, https://depictai-0o.sentry.io/issues/?project=5476183&query=is%3Aunresolved+filters+failed&referrer=issue-list&statsPeriod=14d), for some inexplicable reason, this computation infinite loops
    // I spent a 1h17min debug session with MadePeople in a tab where they could reproduce
    // Observations were that of the signal read_local_cache the observers at some point randomly started having this computation first instead of the effect that writes the value to the history
    // It's VERY HARD to get a tab in a state where it can be reproduced, like with the exact same circumstances it happens "once a day" for them and there's no noticable pattern. But when a tab is found, it can be reliably reproduced by going backwards/forwards.
    // Also we reliably clean up and dispose of the search page and the effect of history_dot_state_to_state stays in the signals' observers, but for some reason it disappears when the bug happens (onCleanup doesn't get called then either, if I debugged that correctly)
    // As a value first workaround, we just recognise when the computation has been executed "too often" and just start not doing anything after that
    const remote_filters = Object.fromEntries(((_available_filters_ = available_filters_()) === null || _available_filters_ === void 0 ? void 0 : _available_filters_.map(filter => {
      var _filter$meta;
      return [JSON.stringify([filter.field, filter.op, filter === null || filter === void 0 ? void 0 : (_filter$meta = filter.meta) === null || _filter$meta === void 0 ? void 0 : _filter$meta.type]), filter];
    })) || []);
    const local_filters = Object.fromEntries(read_local_cache().map(filter => {
      var _filter$meta2;
      return [JSON.stringify([filter.field, filter.op, filter === null || filter === void 0 ? void 0 : (_filter$meta2 = filter.meta) === null || _filter$meta2 === void 0 ? void 0 : _filter$meta2.type]), filter];
    }));
    const selected_filters = Object.fromEntries(read_selected_filters().map(filter_obj => [JSON.stringify([filter_obj.field, filter_obj.op]), filter_obj]));
    const new_local_filter_state = [];
    // we want to be as close as possible to available_filters_ in local_filters except that we want to keep values from previous available_filters_ as long as they're selected
    for (const filter_id of [...Object.keys(local_filters).filter(key => !(key in remote_filters)), ...Object.keys(remote_filters)]) {
      const local_filter = local_filters[filter_id];
      const remote_filter = remote_filters[filter_id];
      const filter_id_without_meta_type = JSON.stringify(JSON.parse(filter_id).slice(0, 2));
      if (!remote_filter)
        // check if this filter is selected, if it is just take the local one but set counts to 0 and remove non-selected options
        {
          if (filter_id_without_meta_type in selected_filters) new_local_filter_state.push($44aa24b1bb793549$var$modify_only_local_filter(local_filter, selected_filters[filter_id_without_meta_type]));
        } else if (!local_filter)
        // just take the remote one
        new_local_filter_state.push(remote_filter);else {
        // both exist, merge them if needed
        const remote_meta = remote_filter.meta;
        const local_meta = local_filter.meta;
        const this_applied_filter = selected_filters[filter_id_without_meta_type];
        if (!remote_meta || !local_meta || !("values" in remote_meta) || !("values" in local_meta) || !Array.isArray(this_applied_filter === null || this_applied_filter === void 0 ? void 0 : this_applied_filter.data))
          // can't or shouldn't be merged due to not being selected, just take remote one
          new_local_filter_state.push(remote_filter);else {
          const data_objs_in_remote = Object.fromEntries(remote_meta.values.map((value, index) => {
            var _remote_meta$counts, _remote_meta$names, _swatches;
            return [JSON.stringify(value), {
              value_: value,
              count_: (_remote_meta$counts = remote_meta.counts) === null || _remote_meta$counts === void 0 ? void 0 : _remote_meta$counts[index],
              name_: (_remote_meta$names = remote_meta.names) === null || _remote_meta$names === void 0 ? void 0 : _remote_meta$names[index],
              swatches_: (_swatches = remote_meta.swatches) === null || _swatches === void 0 ? void 0 : _swatches[index]
            }];
          }));
          const data_objs_in_local = Object.fromEntries(local_meta.values.map((value, index) => {
            var _local_meta$names, _swatches2;
            return [JSON.stringify(value), {
              value_: value,
              count_: 0,
              name_: (_local_meta$names = local_meta.names) === null || _local_meta$names === void 0 ? void 0 : _local_meta$names[index],
              swatches_: (_swatches2 = local_meta.swatches) === null || _swatches2 === void 0 ? void 0 : _swatches2[index]
            }];
          }));
          const new_data = [...Object.keys(data_objs_in_local).filter(key => {
            // put data entries that are selected and don't exist in new remote state first
            if (key in data_objs_in_remote) return false;
            const selected_values = this_applied_filter.data;
            return selected_values.some(value => {
              const is_equal = JSON.stringify(value) === key;
              if (is_equal) return true;
              if (local_meta.type === remote_meta.type && local_meta.type === "checkbox-hierarchical") {
                // Very special case for hierarchical checkboxes - when a parent has all kids checked and a kid is deselected, the parent gets deselected. But since if it still has selected children we don't want to remove it from the filter state, even though it isn't selected, as the UI won't know the correct title of the parent category otherwise. This keeps it in that case.
                const selected_values = data_objs_in_local[key].value_;
                const values_length = value === null || value === void 0 ? void 0 : value.length;
                if (values_length > 1 && values_length - 1 === selected_values.length) {
                  let is_parent = true;
                  for (let i = 0; i < selected_values.length; i++) if (selected_values[i] !== value[i]) is_parent = false;
                  return is_parent;
                }
              }
              return false;
            });
          }).map(key => data_objs_in_local[key]), ...Object.values(data_objs_in_remote)];
          const new_values = new_data.map(_ref2 => {
            let {
              value_: value_
            } = _ref2;
            return value_;
          });
          const result = {
            ...remote_filter,
            meta: {
              ...remote_filter.meta,
              values: new_values,
              names: new_data.map(_ref3 => {
                let {
                  name_: name_
                } = _ref3;
                return name_;
              }),
              counts: new_data.map(_ref4 => {
                let {
                  count_: count_
                } = _ref4;
                return count_;
              }),
              ...("swatches" in remote_filter && {
                swatches: new_data.map(_ref5 => {
                  let {
                    swatches_: swatches_
                  } = _ref5;
                  return swatches_;
                })
              })
            }
          };
          new_local_filter_state.push(result);
        }
      }
    }
    if (last_remote_state !== available_filters_() ||
    // we HAVE to update the local filter state (it can contain same info but needs to be different object reference) every time the API state changes, otherwise the CheckboxHierarchicalFilter component doesn't update
    // Sorry……… They're not that big
    JSON.stringify(new_local_filter_state) !== JSON.stringify(read_local_cache())) {
      var _sources, _sources$find;
      const owner = $8tj43$getOwner();
      const signal = owner === null || owner === void 0 ? void 0 : (_sources = owner.sources) === null || _sources === void 0 ? void 0 : (_sources$find = _sources.find) === null || _sources$find === void 0 ? void 0 : _sources$find.call(_sources, source => source.value === read_local_cache());
      if (executions > 50) {
        var _signal$observers, _signal$observers$map;
        // We're probably in an infinite loop, let's just stop
        $8tj43$report1(new Error("Infinite loop detected in create_modified_filters"), "error", {
          executions: executions,
          new_local_filter_state: new_local_filter_state,
          available_filters: available_filters_(),
          last_remote_state: last_remote_state,
          history_length: history.length,
          location: location.href,
          foundSignal: !!signal,
          observerSlots: signal === null || signal === void 0 ? void 0 : signal.observerSlots,
          observers: signal === null || signal === void 0 ? void 0 : (_signal$observers = signal.observers) === null || _signal$observers === void 0 ? void 0 : (_signal$observers$map = _signal$observers.map) === null || _signal$observers$map === void 0 ? void 0 : _signal$observers$map.call(_signal$observers, o => (o === null || o === void 0 ? void 0 : o.fn) + ""),
          lastHistoryDotStateToStateCleanupInfo: $972f6bce0f9d61be$export$68620bd6d5c6bb86
        });
        return;
      }
      write_local_cache(new_local_filter_state);
      // Keep track how many times we wrote this signal
      executions++;
      oneSecondInfiniteLoopPreventionTimeout || (oneSecondInfiniteLoopPreventionTimeout = setTimeout($8tj43$catchify1(() => {
        executions = 0;
        oneSecondInfiniteLoopPreventionTimeout = undefined;
      }), 1000));
    }
    last_remote_state = available_filters_();
  });
}
/**
 * When a filter is only available locally due to being selected in a previous navigation, we want to make that clear and prevent further "invalid" choices.
 * This sets the counts to 0 (if applicable) and removes non-selected options (if applicable)
 */
function $44aa24b1bb793549$var$modify_only_local_filter(local_filter_object, selected_filter) {
  const old_meta = local_filter_object.meta;
  const selected_filter_data = selected_filter.data;
  const modified_filter_object = {
    ...local_filter_object
  };
  if (old_meta) {
    const new_meta = {
      ...old_meta
    };
    modified_filter_object.meta = new_meta;
    // set counts to 0
    if ("counts" in new_meta) {
      const counts = new_meta.counts;
      if (counts) new_meta.counts = counts.map(() => 0);
    }
    if (Array.isArray(selected_filter_data) && "values" in new_meta) {
      // we have an array of values and want to strip the ones from the available ones that aren't selected
      const values = new_meta.values;
      if (Array.isArray(values)) {
        const jsond_set_values = selected_filter_data.map(data => JSON.stringify(data));
        const indexes_to_remove = new Set();
        for (let i = 0; i < values.length; i++) {
          const value = values[i];
          if (!jsond_set_values.includes(JSON.stringify(value)))
            // We want to remove the entry with this value from the filter object because it's not selected
            indexes_to_remove.add(i);
        }
        new_meta.values = values.filter((_, index) => !indexes_to_remove.has(index));
        if (new_meta.names) new_meta.names = new_meta.names.filter((_, index) => !indexes_to_remove.has(index));
        if ("swatches" in new_meta) {
          var _new_meta$swatches;
          new_meta.swatches = (_new_meta$swatches = new_meta.swatches) === null || _new_meta$swatches === void 0 ? void 0 : _new_meta$swatches.filter((_, index) => !indexes_to_remove.has(index));
        }
        if (new_meta.counts)
          // remove counts that are too much, they're all zero anyway if they exist
          new_meta.counts.length -= indexes_to_remove.size;
      }
    }
  }
  return modified_filter_object;
}
var $bce10e104a1dd893$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=14 height=14><path d="M12.949 7.699H.352A.35.35 0 0 1 0 7.352.35.35 0 0 1 .352 7h12.598a.35.35 0 0 1 .352.352.35.35 0 0 1-.352.348zm0 0">`);
function $bce10e104a1dd893$export$cb808a3c41736d8e() {
  return $8tj43$getNextElement($bce10e104a1dd893$var$_tmpl$);
}
var $7396052a1484264f$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=filters><div class=body>`),
  $7396052a1484264f$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=sorting><div class=body>`),
  $7396052a1484264f$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=sort-and-filter-buttons><div class=outer><div class=inner><!$><!/><!$><!/><!$><!/>`),
  $7396052a1484264f$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<span class=num-filters>`),
  $7396052a1484264f$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<div class=open-filters-button-container><!$><!/><button type=button><!$><!/><span>`),
  $7396052a1484264f$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<button class="toggle-button for-sorting major-minor-transition"><span></span><!$><!/>`);
function $7396052a1484264f$export$d7841e452f2e59a8(_ref) {
  let {
    current_sorting_: current_sorting_,
    set_extra_els_in_results_container_: set_extra_els_in_results_container_,
    search_filters_open_: search_filters_open_,
    search_sorting_open_: search_sorting_open_,
    set_sort_or_filter_open_: set_sort_or_filter_open_,
    i18n_: i18n_,
    available_sortings_: available_sortings_,
    available_filters_: available_filters_,
    expanded_filters_: expanded_filters_,
    middle_elements_: middle_elements_,
    input_modal_open_: input_modal_open_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
    set_sort_and_filter_element_: set_sort_and_filter_element_,
    sort_and_filter_disabled_: sort_and_filter_disabled_,
    formatted_number_of_results_: formatted_number_of_results_,
    filter_button_width_: filter_button_width_,
    sort_button_width_: sort_button_width_,
    selected_filters_: selected_filters_,
    local_filter_cache_: local_filter_cache_,
    get_extra_filters_button_: get_extra_filters_button_,
    get_extra_sorting_button_: get_extra_sorting_button_,
    filterModalParent_: filterModalParent_,
    hideCount0FilterOptions_: hideCount0FilterOptions_
  } = _ref;
  const Self = () => {
    // This could technically be in SearchPage and CategoryPage and would be better suited there since it writes into local_filter_cache_ which i.e. SelectedFilters uses, but it's better suited here IMO due to DRY and being inside the correct error boundary here
    $44aa24b1bb793549$export$b288c38ae3fddb56({
      available_filters_: available_filters_,
      selected_filters_: selected_filters_,
      local_filter_cache_: local_filter_cache_
    });
    const cleanup_promise = new Promise(r => $8tj43$onCleanup(r));
    const [filters_open, set_filters_open] = search_filters_open_;
    const [sorting_open, set_sorting_open] = search_sorting_open_;
    const [get_current_sorting_] = current_sorting_;
    const [is_small, set_is_small] = $8tj43$createSignal(false);
    const dismiss_modal_ = $8tj43$catchify1(() => {
      set_filters_open(false);
      set_sorting_open(false);
    });
    const meta_of_currently_selected_sorting_ = $8tj43$createMemo(() => {
      var _available_sortings_, _available_sortings_$, _available_sortings_$2;
      return (_available_sortings_ = available_sortings_()) === null || _available_sortings_ === void 0 ? void 0 : (_available_sortings_$ = _available_sortings_.find) === null || _available_sortings_$ === void 0 ? void 0 : (_available_sortings_$2 = _available_sortings_$.call(_available_sortings_, _ref2 => {
        let {
          field: field,
          order: order
        } = _ref2;
        const current = get_current_sorting_();
        return (current === null || current === void 0 ? void 0 : current.field) === field && (current === null || current === void 0 ? void 0 : current.order) === order;
      })) === null || _available_sortings_$2 === void 0 ? void 0 : _available_sortings_$2.meta;
    });
    const filter_options = {
      expanded_hierarchical_filters_: expanded_hierarchical_filters_,
      local_filter_cache_: local_filter_cache_,
      available_filters_: available_filters_,
      expanded_filters_: expanded_filters_,
      selected_filters_: selected_filters_,
      i18n_: i18n_,
      hideCount0FilterOptions_: hideCount0FilterOptions_
    };
    const hide_filters = $8tj43$createMemo(() => $6fcb97029a69ec44$export$50f68cc9882e36a4(filter_options));
    const sorting_options = {
      current_sorting_: current_sorting_,
      available_sortings_: available_sortings_,
      meta_of_currently_selected_sorting_: meta_of_currently_selected_sorting_
    };
    const make_open_filters_button = function () {
      let adhere_to_width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let is_tabbable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return $8tj43$createComponent($7396052a1484264f$var$OpenFiltersButton, {
        tabindex_: is_tabbable ? 0 : -1,
        i18n_: i18n_,
        search_filters_open_: search_filters_open_,
        search_sorting_open_: search_sorting_open_,
        number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
        filter_button_width_: adhere_to_width ? filter_button_width_ : undefined,
        hide_button_: hide_filters
      });
    };
    const make_open_sorting_button = function () {
      let adhere_to_width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let is_tabbable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return $8tj43$createComponent($7396052a1484264f$var$OpenSortingButton, {
        tabindex_: is_tabbable ? 0 : -1,
        i18n_: i18n_,
        get_current_sorting_: get_current_sorting_,
        search_filters_open_: search_filters_open_,
        search_sorting_open_: search_sorting_open_,
        available_sortings_: available_sortings_,
        sort_button_width_: adhere_to_width ? sort_button_width_ : undefined,
        meta_of_currently_selected_sorting_: meta_of_currently_selected_sorting_
      });
    };
    let open_modal_;
    let close_modal_;
    let grid_is_in_original_state = true;
    $8tj43$createComputed(() => {
      const fi_o = filters_open();
      const so_o = sorting_open();
      const i_s = is_small();
      // we need to always read all the signal if we have them in the if-statement the value of it changes when the computation runs
      if ((fi_o || so_o) && !i_s) {
        if (!grid_is_in_original_state) return;
        set_sort_or_filter_open_(true);
        grid_is_in_original_state = false;
      } else if (!grid_is_in_original_state) {
        set_sort_or_filter_open_(false);
        grid_is_in_original_state = true;
      }
    });
    $8tj43$createEffect(() => {
      if (!filters_open() && !sorting_open()) {
        var _close_modal_;
        (_close_modal_ = close_modal_) === null || _close_modal_ === void 0 || _close_modal_();
        set_extra_els_in_results_container_("");
      } else if (is_small()) {
        var _open_modal_;
        if ($8tj43$untrack(() => input_modal_open_ === null || input_modal_open_ === void 0 ? void 0 : input_modal_open_())) {
          // we don't want to shove another modal into the users face, silently close the filters for them
          set_filters_open(false);
          set_sorting_open(false);
          return;
        }
        (_open_modal_ = open_modal_) === null || _open_modal_ === void 0 || _open_modal_();
        set_extra_els_in_results_container_("");
      } else {
        var _close_modal_2;
        (_close_modal_2 = close_modal_) === null || _close_modal_2 === void 0 || _close_modal_2();
        if (filters_open()) set_extra_els_in_results_container_(() => $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return !hide_filters();
          },
          get children() {
            var _el$ = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$),
              _el$2 = _el$.firstChild;
            $8tj43$insert(_el$2, $8tj43$createComponent((0, $f6b0500577e1b210$export$3f1a388cc0d8fed7), filter_options));
            return _el$;
          }
        }));else set_extra_els_in_results_container_((() => {
          var _el$3 = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$2),
            _el$4 = _el$3.firstChild;
          $8tj43$insert(_el$4, $8tj43$createComponent((0, $cfdbd124dd09d713$export$1f1775a58da589b5), sorting_options));
          return _el$3;
        })());
      }
    });
    $8tj43$catchify1(async () => {
      ({
        open_modal_: open_modal_,
        close_modal_: close_modal_
      } = await $d5f1e6a0f9117286$export$79b1565500412d9b((0, $082c4ed3e22f8d71$export$9bf11afa910f536e), {
        args_for_sorting_: sorting_options,
        args_for_filtering_: filter_options,
        search_filters_open_: search_filters_open_,
        search_sorting_open_: search_sorting_open_,
        formatted_number_of_results_: formatted_number_of_results_,
        dismiss_modal_: dismiss_modal_,
        i18n_: i18n_
      }, filterModalParent_));
      const {
        remove: remove
      } = $8tj43$javascript_media_query("(max-width:651px)", _ref3 => {
        let {
          matches: matches
        } = _ref3;
        return set_is_small(matches);
      });
      cleanup_promise.then(remove);
    })();
    get_extra_filters_button_ === null || get_extra_filters_button_ === void 0 || get_extra_filters_button_(make_open_filters_button());
    get_extra_sorting_button_ === null || get_extra_sorting_button_ === void 0 || get_extra_sorting_button_(make_open_sorting_button());
    $8tj43$createEffect(() => {
      if (sort_and_filter_disabled_ !== null && sort_and_filter_disabled_ !== void 0 && sort_and_filter_disabled_()) {
        // If someone changes the layout to slider-without-filters dynamically, close sorting and filters
        set_filters_open(false);
        set_sorting_open(false);
      }
    });
    return $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !(sort_and_filter_disabled_ !== null && sort_and_filter_disabled_ !== void 0 && sort_and_filter_disabled_());
      },
      get children() {
        var _el$5 = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$3),
          _el$6 = _el$5.firstChild,
          _el$7 = _el$6.firstChild,
          _el$8 = _el$7.firstChild,
          [_el$9, _co$] = $8tj43$getNextMarker(_el$8.nextSibling),
          _el$10 = _el$9.nextSibling,
          [_el$11, _co$2] = $8tj43$getNextMarker(_el$10.nextSibling),
          _el$12 = _el$11.nextSibling,
          [_el$13, _co$3] = $8tj43$getNextMarker(_el$12.nextSibling);
        var _ref$ = set_sort_and_filter_element_;
        typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$5) : set_sort_and_filter_element_ = _el$5;
        $8tj43$insert(_el$7, () => make_open_filters_button(true, true), _el$9, _co$);
        $8tj43$insert(_el$7, () => middle_elements_ === null || middle_elements_ === void 0 ? void 0 : middle_elements_(), _el$11, _co$2);
        $8tj43$insert(_el$7, () => make_open_sorting_button(true, true), _el$13, _co$3);
        return _el$5;
      }
    });
  };
  return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    message_: "Sorting and filters failed",
    severity_: "error",
    get children() {
      return $8tj43$createComponent(Self, {});
    }
  });
}
function $7396052a1484264f$var$OpenFiltersButton(_ref4) {
  let {
    i18n_: i18n_,
    search_filters_open_: search_filters_open_,
    search_sorting_open_: search_sorting_open_,
    filter_button_width_: filter_button_width_,
    tabindex_: tabindex_,
    number_of_rendered_selected_filters_items_: [num_selected_filters],
    hide_button_: hide_button_
  } = _ref4;
  const filters_closed = $8tj43$createMemo(() => !search_filters_open_[0]());
  // We assume in embedded_num_products that this is a single HTMLElement so pls change there if you change it here
  return (() => {
    var _el$14 = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$5),
      _el$20 = _el$14.firstChild,
      [_el$21, _co$5] = $8tj43$getNextMarker(_el$20.nextSibling),
      _el$16 = _el$21.nextSibling,
      _el$18 = _el$16.firstChild,
      [_el$19, _co$4] = $8tj43$getNextMarker(_el$18.nextSibling),
      _el$17 = _el$19.nextSibling;
    $8tj43$insert(_el$14, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return num_selected_filters();
      },
      get children() {
        var _el$15 = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$4);
        $8tj43$insert(_el$15, num_selected_filters);
        $8tj43$effect(_$p => $8tj43$style(_el$15, filters_closed() ? "" : "opacity:0", _$p));
        return _el$15;
      }
    }), _el$21, _co$5);
    $8tj43$addEventListener(_el$16, "click", $8tj43$catchify1(() => $8tj43$batch(() => {
      if (search_filters_open_[0]()) {
        search_filters_open_[1](false);
        return;
      }
      search_filters_open_[1](true);
      search_sorting_open_[1](false);
    })), true);
    $8tj43$setAttribute(_el$16, "tabindex", tabindex_);
    $8tj43$className(_el$16, "filter toggle-button major-minor-transition" + ((0, $8tj43$isServer) ? " minor" : ""));
    $8tj43$insert(_el$16, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return filters_closed();
      },
      get fallback() {
        return $8tj43$createComponent((0, $bce10e104a1dd893$export$cb808a3c41736d8e), {});
      },
      get children() {
        return $8tj43$createComponent((0, $05f67356defcdd65$export$28f6150e232898de), {});
      }
    }), _el$19, _co$4);
    $8tj43$insert(_el$17, () => i18n_.filter_text_());
    $8tj43$effect(_p$ => {
      var _v$ = hide_button_() ? {
          display: "none"
        } : {},
        _v$2 = !filters_closed(),
        _v$3 = !!filters_closed(),
        _v$4 = (filters_closed() ? i18n_.open_filters_ : i18n_.close_filters_)(),
        _v$5 = filter_button_width_ !== null && filter_button_width_ !== void 0 && filter_button_width_() ? {
          width: filter_button_width_() + "px"
        } : {};
      _p$.e = $8tj43$style(_el$14, _v$, _p$.e);
      _v$2 !== _p$.t && _el$16.classList.toggle("major", _p$.t = _v$2);
      _v$3 !== _p$.a && _el$16.classList.toggle("minor", _p$.a = _v$3);
      _v$4 !== _p$.o && $8tj43$setAttribute(_el$16, "aria-label", _p$.o = _v$4);
      _p$.i = $8tj43$style(_el$16, _v$5, _p$.i);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$14;
  })();
}
function $7396052a1484264f$var$OpenSortingButton(_ref5) {
  let {
    i18n_: i18n_,
    get_current_sorting_: get_current_sorting_,
    search_filters_open_: search_filters_open_,
    available_sortings_: available_sortings_,
    search_sorting_open_: search_sorting_open_,
    sort_button_width_: sort_button_width_,
    tabindex_: tabindex_,
    meta_of_currently_selected_sorting_: meta_of_currently_selected_sorting_
  } = _ref5;
  const sorting_closed = $8tj43$createMemo(() => !search_sorting_open_[0]());
  // We assume in embedded_num_products that this is a single HTMLElement so pls change there if you change it here
  return (() => {
    var _el$22 = $8tj43$getNextElement($7396052a1484264f$var$_tmpl$6),
      _el$23 = _el$22.firstChild,
      _el$24 = _el$23.nextSibling,
      [_el$25, _co$6] = $8tj43$getNextMarker(_el$24.nextSibling);
    $8tj43$addEventListener(_el$22, "click", $8tj43$catchify1(() => $8tj43$batch(() => {
      if (search_sorting_open_[0]()) {
        search_sorting_open_[1](false);
        return;
      }
      search_filters_open_[1](false);
      search_sorting_open_[1](true);
    })), true);
    $8tj43$setAttribute(_el$22, "tabindex", tabindex_);
    $8tj43$insert(_el$23, (() => {
      var _c$ = $8tj43$memo(() => !!sorting_closed());
      return () => {
        var _meta_of_currently_se;
        return (
          // Show the title of the currently selected sorting when the sorting is closed, if there's currently a sorting selected
          // This is to balance that both it should be easy to find the sorting and to see what sorting currently is set
          // See issue description of https://gitlab.com/depict-ai/depict.ai/-/merge_requests/6537
          _c$() && ((_meta_of_currently_se = meta_of_currently_selected_sorting_()) === null || _meta_of_currently_se === void 0 ? void 0 : _meta_of_currently_se.title) || i18n_.sorting_text_()
        );
      };
    })());
    $8tj43$insert(_el$22, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return sorting_closed();
      },
      get fallback() {
        return $8tj43$createComponent((0, $bce10e104a1dd893$export$cb808a3c41736d8e), {});
      },
      get children() {
        return $8tj43$memo(() => {
          var _get_current_sorting_;
          return ((_get_current_sorting_ = get_current_sorting_()) === null || _get_current_sorting_ === void 0 ? void 0 : _get_current_sorting_.order) === "asc";
        })() ? $8tj43$createComponent((0, $79af35736fe8e5c8$export$da32f7add8a22e86), {}) : $8tj43$createComponent((0, $73e3c96bc365e0e9$export$d10e63059ddb9fd4), {});
      }
    }), _el$25, _co$6);
    $8tj43$effect(_p$ => {
      var _v$6 = !sorting_closed(),
        _v$7 = !!sorting_closed(),
        _v$8 = (sorting_closed() ? i18n_.open_sorting_ : i18n_.close_sorting_)(),
        _v$9 = sort_button_width_ !== null && sort_button_width_ !== void 0 && sort_button_width_() ? {
          width: sort_button_width_() + "px"
        } : {};
      _v$6 !== _p$.e && _el$22.classList.toggle("major", _p$.e = _v$6);
      _v$7 !== _p$.t && _el$22.classList.toggle("minor", _p$.t = _v$7);
      _v$8 !== _p$.a && $8tj43$setAttribute(_el$22, "aria-label", _p$.a = _v$8);
      _p$.o = $8tj43$style(_el$22, _v$9, _p$.o);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$22;
  })();
}
$8tj43$delegateEvents(["click"]);
var $70f5ae4deea73eee$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=14 height=14><path d="M6.402.453L2.203 4.652a.35.35 0 0 0 0 .496c.137.137.359.137.492 0l3.605-3.605v11.406a.35.35 0 0 0 .348.352.35.35 0 0 0 .352-.352V1.543l3.602 3.605a.35.35 0 0 0 .496 0c.066-.07.102-.16.102-.25a.35.35 0 0 0-.102-.246L6.895.453c-.133-.137-.355-.137-.492 0zm0 0">`);
function $70f5ae4deea73eee$export$2624c5890f1bbcf7() {
  return $8tj43$getNextElement($70f5ae4deea73eee$var$_tmpl$);
}
var $6a16b21155984cef$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=floating-buttons><button class=filter><div></div></button><button class=sort><div></div></button><button class=up><div>`);
function $6a16b21155984cef$export$b23abd26de154ede(props) {
  if (0, $8tj43$isServer) return; // won't show in initial render and need scroll position
  const [is_small, set_is_small] = $8tj43$createSignal(true);
  $8tj43$onCleanup($8tj43$javascript_media_query("(max-width:651px)", _ref => {
    let {
      matches: matches
    } = _ref;
    return set_is_small(matches);
  }).remove);
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return is_small();
    },
    get children() {
      return $6a16b21155984cef$var$ActualFloatingButtons(props);
    }
  });
}
function $6a16b21155984cef$var$ActualFloatingButtons(_ref2) {
  let {
    search_filters_open_: [get_search_filters_open_, set_search_filters_open_],
    search_sorting_open_: [get_search_sorting_open_, set_search_sorting_open_],
    current_sorting_: current_sorting_,
    sort_and_filter_element_: sort_and_filter_element_,
    i18n_: i18n_
  } = _ref2;
  let old_pos = scrollY;
  let diff_over_second_or_touch = 0; // for things not supporting touch events
  let timeout;
  let inertia_timeout;
  let is_in_touch_scroll = false;
  let direction_up = false;
  let resolve_cleanup_promise;
  const cleanup_promise = new Promise(r => resolve_cleanup_promise = r);
  const [is_scrolling_upwards, set_is_scrolling_upwards] = $8tj43$createSignal(false);
  const [get_is_showing_toast] = (0, $a61a2051e15c8d7a$export$22970a0140fc759c);
  const [modal_is_closed, set_if_modal_is_closed] = $8tj43$createSignal(!$8tj43$untrack(get_search_filters_open_) && !$8tj43$untrack(get_search_sorting_open_));
  const [regular_buttons_are_in_view, set_regular_buttons_are_in_view] = $8tj43$createSignal(false);
  const handle_scrollpos_change = () => $8tj43$untrack(() => {
    const new_pos = scrollY;
    if (modal_is_closed()) {
      const diff = new_pos - old_pos;
      const new_direction = diff < 0;
      if (direction_up !== new_direction)
        // direction changed, reset diff
        diff_over_second_or_touch = 0;
      direction_up = new_direction;
      diff_over_second_or_touch += diff;
      if (!is_in_touch_scroll)
        // touch not supported or scrolled without touching screen i.e. with keyboard
        setTimeout(() => diff_over_second_or_touch -= diff, 1000); // I think error handling is not worth the overhead here
      if (diff_over_second_or_touch < -50) set_is_scrolling_upwards(true);else if (diff_over_second_or_touch > 30) set_is_scrolling_upwards(false);
    }
    old_pos = new_pos;
  });
  const touchstart_handler = $8tj43$catchify1(e => {
    is_in_touch_scroll = true;
    if (e.touches.length === 1) {
      // we had no touches but then we got some. Adding a new touch cancels the inertia. We are in a new touch so do reset the diff
      clearTimeout(inertia_timeout);
      diff_over_second_or_touch = 0;
    }
  });
  const touchend_handler = $8tj43$catchify1(e => {
    if (e.touches.length === 0)
      // scroll gesture of any type (pinch can also be used as scroll, etc.) ended
      inertia_timeout = setTimeout(
      // inertia ends after 500ms (educated guess)
      $8tj43$catchify1(() => {
        is_in_touch_scroll = false;
        diff_over_second_or_touch = 0;
      }), 500);
  });
  addEventListener("touchstart", touchstart_handler);
  addEventListener("touchend", touchend_handler);
  $8tj43$onCleanup(() => {
    removeEventListener("touchstart", touchstart_handler);
    removeEventListener("touchend", touchend_handler);
  });
  $33e7d1906c93db7d$export$205efb947c7ffd78(handle_scrollpos_change);
  $8tj43$onCleanup(resolve_cleanup_promise);
  $8tj43$createComputed(() => {
    clearTimeout(timeout);
    const everything_closed = !get_search_filters_open_() && !get_search_sorting_open_();
    if (!$8tj43$untrack(modal_is_closed) && everything_closed)
      // I think the point of this is to delay the animation a bit IIRC
      timeout = setTimeout($8tj43$catchify1(() => set_if_modal_is_closed(true)), 200);else set_if_modal_is_closed(everything_closed);
  });
  $8tj43$createComputed($8tj43$catchify1(async () => {
    const element = sort_and_filter_element_();
    if (!element) return;
    await (0, $8tj43$observer).wait_for_element(element);
    const is = new IntersectionObserver(records => $8tj43$batch(() => {
      for (const record of records) set_regular_buttons_are_in_view(record.isIntersecting);
    }));
    is.observe(element);
    await cleanup_promise;
    is.disconnect();
  }));
  return (() => {
    var _el$ = $8tj43$getNextElement($6a16b21155984cef$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$2.nextSibling,
      _el$5 = _el$4.firstChild,
      _el$6 = _el$4.nextSibling,
      _el$7 = _el$6.firstChild;
    $8tj43$addEventListener(_el$2, "click", $8tj43$catchify1(() => {
      set_search_filters_open_(true);
      set_search_sorting_open_(false);
    }), true);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $05f67356defcdd65$export$28f6150e232898de), {}));
    $8tj43$addEventListener(_el$4, "click", $8tj43$catchify1(() => {
      set_search_filters_open_(false);
      set_search_sorting_open_(true);
    }), true);
    $8tj43$insert(_el$5, (() => {
      var _c$ = $8tj43$memo(() => {
        var _current_sorting_$;
        return ((_current_sorting_$ = current_sorting_[0]()) === null || _current_sorting_$ === void 0 ? void 0 : _current_sorting_$.order) === "asc";
      });
      return () => _c$() ? $8tj43$createComponent((0, $79af35736fe8e5c8$export$da32f7add8a22e86), {}) : $8tj43$createComponent((0, $73e3c96bc365e0e9$export$d10e63059ddb9fd4), {});
    })());
    $8tj43$addEventListener(_el$6, "click", $8tj43$catchify1(() => scrollTo({
      top: 0,
      behavior: "smooth"
    })), true);
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $70f5ae4deea73eee$export$2624c5890f1bbcf7), {}));
    $8tj43$effect(_p$ => {
      var _v$ = !!(is_scrolling_upwards() && modal_is_closed() && !regular_buttons_are_in_view() && !get_is_showing_toast()),
        _v$2 = i18n_.filter_text_(),
        _v$3 = i18n_.sorting_text_(),
        _v$4 = i18n_.scroll_to_top_();
      _v$ !== _p$.e && _el$.classList.toggle("show-them", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$2, "aria-label", _p$.t = _v$2);
      _v$3 !== _p$.a && $8tj43$setAttribute(_el$4, "aria-label", _p$.a = _v$3);
      _v$4 !== _p$.o && $8tj43$setAttribute(_el$6, "aria-label", _p$.o = _v$4);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
$8tj43$delegateEvents(["click"]);
const $2855bffe06ef7a03$var$fallback_operator = "in";
const $2855bffe06ef7a03$var$fallback_token = "";
const $2855bffe06ef7a03$var$legacy_filter_prefix = "filter_";
const $2855bffe06ef7a03$var$operator_map = {
  "eq": "\u2261",
  "neq": "\u2260",
  "in": "\u2208",
  "nin": "\u2209",
  "leq": "\u2264",
  "geq": "\u2265",
  "inrange": "\uD83D\uDD22"
};
const $2855bffe06ef7a03$var$ascending_token = "\uD83D\uDCC8";
const $2855bffe06ef7a03$var$descending_token = "\uD83D\uDCC9";
const $2855bffe06ef7a03$var$range_delimiter = "-";
const $2855bffe06ef7a03$var$string_item_delimiter = "\u201A"; // This is not a comma but a comma-like character that browsers will render in the URL bar.
const $2855bffe06ef7a03$var$array_item_delimiter = "\u2023"; // FIXME: decide on a character. Could theoretically be a double string delimiter.
const $2855bffe06ef7a03$var$empty_item_replacement = "0\uFE0F\u20E3";
const $2855bffe06ef7a03$var$op_to_token = op => {
  if (op === $2855bffe06ef7a03$var$fallback_operator) return $2855bffe06ef7a03$var$fallback_token;
  return $2855bffe06ef7a03$var$operator_map[op];
};
/**
 * Checks if a given array of filter data can be neatly serialized into an URL query parameter, or if it should fall back to JSON+base64.
 * The requirements are either an array of strings, containing no reserved characters, or an array of arrays of strings, containing no reserved characters.
 * No deep or mixed nesting levels are supported.
 */
function $2855bffe06ef7a03$var$array_is_serializable(array) {
  let is_root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (array.every(item => Array.isArray(item))) {
    if (!is_root)
      // Deeply nested arrays are not supported, but also don't exist as filters (yet)
      return false;
    return array.every(item => $2855bffe06ef7a03$var$array_is_serializable(item, false));
  }
  if (array.some(item => typeof item !== "string"))
    // Numbers are not supported, since 1 and "1" would encode to the same thing
    return false;
  // Encoding reserved characters is not supported
  return !array.some(item => item.includes($2855bffe06ef7a03$var$array_item_delimiter) || item.includes($2855bffe06ef7a03$var$string_item_delimiter) || item === $2855bffe06ef7a03$var$empty_item_replacement);
}
/**
 * Human readable string[] or string[][] serialization for URLs.
 * @param array
 * @returns
 */
function $2855bffe06ef7a03$var$encode_array(array) {
  const is_nested = array.every(item => Array.isArray(item));
  if (is_nested) return array.map($2855bffe06ef7a03$var$encode_array).join($2855bffe06ef7a03$var$array_item_delimiter) + $2855bffe06ef7a03$var$array_item_delimiter; // Nested arrays require a suffix to close nesting levels
  return array.map(item => item === "" ? $2855bffe06ef7a03$var$empty_item_replacement : item).join($2855bffe06ef7a03$var$string_item_delimiter);
}
function $2855bffe06ef7a03$var$decode_array(encoded_array) {
  const is_nested = encoded_array.includes($2855bffe06ef7a03$var$array_item_delimiter);
  if (is_nested) return encoded_array.split($2855bffe06ef7a03$var$array_item_delimiter).filter(s => s !== "") // Remove empty segments, caused by trailing delimiter
  .map($2855bffe06ef7a03$var$decode_array);
  return encoded_array.split($2855bffe06ef7a03$var$string_item_delimiter).filter(s => s !== "") // Remove empty segments, caused by trailing delimiter in the single item special case
  .map(item => item === $2855bffe06ef7a03$var$empty_item_replacement ? "" : item);
}
function $2855bffe06ef7a03$var$encode_filter_data(op, data) {
  if (data === "true")
    // boolean encoding
    return "1";
  if (data === "false")
    // boolean encoding
    return "0";
  const data_is_array = Array.isArray(data);
  if (op === "inrange" && data_is_array && data.every(item => typeof item === "number"))
    // numeric range filter encoding
    return data.join($2855bffe06ef7a03$var$range_delimiter);
  if (data_is_array && $2855bffe06ef7a03$var$array_is_serializable(data)) {
    const encoded_data = $2855bffe06ef7a03$var$encode_array(data);
    if (!encoded_data.includes($2855bffe06ef7a03$var$array_item_delimiter) && !encoded_data.includes($2855bffe06ef7a03$var$string_item_delimiter))
      // A string[] with only one item will encode without delimiters, which is indistinguishable from a plain string during decoding
      // In that case we add a delimiter suffix at the end
      return encoded_data + $2855bffe06ef7a03$var$string_item_delimiter;
    return encoded_data;
  }
  // Fallback encoding
  return $8tj43$base64_encode_unicode(JSON.stringify(data));
}
function $2855bffe06ef7a03$var$decode_filter_data(op, encoded_data) {
  if (encoded_data === "1") return "true";
  if (encoded_data === "0") return "false";
  if (op === "inrange" && encoded_data.includes($2855bffe06ef7a03$var$range_delimiter)) return encoded_data.split($2855bffe06ef7a03$var$range_delimiter).map(x => parseFloat(x));
  if (encoded_data.includes($2855bffe06ef7a03$var$string_item_delimiter) || encoded_data.includes($2855bffe06ef7a03$var$array_item_delimiter)) return $2855bffe06ef7a03$var$decode_array(encoded_data);
  try {
    return JSON.parse($8tj43$base64_decode_unicode(encoded_data));
  } catch (e) {
    $8tj43$dlog("Failed to fallback parse filter data", op, encoded_data, e);
  }
  return null;
}
function $2855bffe06ef7a03$export$58aa3f171519b6d7(filters, search_params, filter_query_param_prefix) {
  for (const filter of filters) {
    const {
      field: field,
      op: op,
      data: data
    } = filter;
    const encoded_data = $2855bffe06ef7a03$var$encode_filter_data(op, data);
    search_params.set(filter_query_param_prefix + field + $2855bffe06ef7a03$var$op_to_token(op), encoded_data);
  }
}
function $2855bffe06ef7a03$export$f934fa24c3a86811(search_params, filter_query_param_prefix) {
  const found_filters = [];
  for (const key of search_params.keys()) {
    // Allow for backwards compatibility with the old filter query param prefix
    let chosen_prefix = filter_query_param_prefix;
    if (!key.startsWith(chosen_prefix)) {
      chosen_prefix = $2855bffe06ef7a03$var$legacy_filter_prefix;
      if (!key.startsWith(chosen_prefix)) continue;
    }
    const encoded_data = search_params.get(key);
    if (!encoded_data) continue;
    const [op, token] = Object.entries($2855bffe06ef7a03$var$operator_map).find(_ref => {
      let [, token] = _ref;
      return key.endsWith(token);
    }) || [$2855bffe06ef7a03$var$fallback_operator, $2855bffe06ef7a03$var$fallback_token];
    const data = $2855bffe06ef7a03$var$decode_filter_data(op, encoded_data);
    if (!data) continue;
    const field = key.slice(chosen_prefix.length, token ? -token.length : undefined);
    found_filters.push({
      field: field,
      op: op,
      data: data
    });
  }
  return found_filters;
}
function $2855bffe06ef7a03$export$62acb285a7579555(sorting, search_params, sorting_query_param) {
  if (!sorting) return;
  const {
    field: field,
    order: order
  } = sorting;
  const ascending = order === "asc";
  search_params.set(sorting_query_param, field + (ascending ? $2855bffe06ef7a03$var$ascending_token : $2855bffe06ef7a03$var$descending_token));
}
function $2855bffe06ef7a03$export$766e9676e74997d3(search_params, sorting_query_param_) {
  const encoded_sorting = search_params.get(sorting_query_param_);
  if (!encoded_sorting) return;
  if (encoded_sorting.endsWith($2855bffe06ef7a03$var$ascending_token)) return {
    field: encoded_sorting.slice(0, -$2855bffe06ef7a03$var$ascending_token.length),
    order: "asc"
  };
  if (encoded_sorting.endsWith($2855bffe06ef7a03$var$descending_token)) return {
    field: encoded_sorting.slice(0, -$2855bffe06ef7a03$var$descending_token.length),
    order: "desc"
  };
  $8tj43$dlog("Invalid sorting query param value", encoded_sorting);
  return;
}
function $2855bffe06ef7a03$export$916e6850778505f6(search_params, filter_query_param_prefix, sorting_query_param) {
  // We'll be modifying the URLSearchParams object, so we need to make a copy of the keys first
  const keys = [...search_params.keys()];
  for (const key of keys) if (key.startsWith(filter_query_param_prefix) || key === sorting_query_param || key.startsWith($2855bffe06ef7a03$var$legacy_filter_prefix)) search_params.delete(key);
}
const $2855bffe06ef7a03$export$84daa4fa1471698b = "#went_sideways_clear_filters";
function $2855bffe06ef7a03$export$43cd1e747fecd42e(_ref2) {
  let {
    to_url_: to_url_,
    set_clearing_flag_: set_clearing_flag_,
    from_search_params_ = new URLSearchParams(location.search),
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_
  } = _ref2;
  if (!to_url_) return to_url_;
  const was_url_object = to_url_ instanceof URL;
  const url_object = was_url_object ? to_url_ : new URL(to_url_, location.origin);
  const {
    searchParams: searchParams
  } = url_object;
  let transferredAnyFilters = false;
  if (from_search_params_.has(sorting_query_param_)) searchParams.set(sorting_query_param_, from_search_params_.get(sorting_query_param_));
  for (const key of from_search_params_.keys()) if (key.startsWith(filter_query_param_prefix_)) {
    searchParams.set(key, from_search_params_.get(key));
    transferredAnyFilters = true;
  }
  if (set_clearing_flag_ && transferredAnyFilters) url_object.hash = $2855bffe06ef7a03$export$84daa4fa1471698b;
  if (was_url_object) return url_object;
  return url_object.href;
}

// Minifiable and tree-shakable enum
// Why not use const enum? See https://gitlab.com/depict-ai/depict.ai/-/merge_requests/9223#note_1675965260
const $397620a4d7958ed1$export$74ee7529ce0f8a00 = "listingId";
const $397620a4d7958ed1$export$5aae649db1b959fc = "externalId";
var $52efc9ae4382e25a$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<nav class=crumbs>`),
  $52efc9ae4382e25a$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<a class=crumb>`),
  $52efc9ae4382e25a$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<span class=separator>`);
function $52efc9ae4382e25a$export$5646050d516e06bc(_ref) {
  let {
    crumb_data_: get_api_crumb_data,
    router_: router_,
    i18n_: i18n_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    sorting_query_param_: sorting_query_param_,
    placeholderData_ = [,,,]
  } = _ref;
  const crumb_data = $8tj43$createMemo(() => get_api_crumb_data() || placeholderData_);
  return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    severity_: "error",
    message_: "BreadCrumbs failed",
    get children() {
      var _el$ = $8tj43$getNextElement($52efc9ae4382e25a$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
        get each() {
          return crumb_data();
        },
        children: (display_accessor, index) => {
          const href = $8tj43$createMemo(() => {
            var _display_accessor;
            return $2855bffe06ef7a03$export$43cd1e747fecd42e({
              to_url_: (_display_accessor = display_accessor()) === null || _display_accessor === void 0 ? void 0 : _display_accessor.page_url,
              filter_query_param_prefix_:
              // page_url here can be a getter if that was added in the display transformers as a way of making this reactive
              filter_query_param_prefix_,
              sorting_query_param_: sorting_query_param_
            });
          });
          return [$8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return display_accessor();
            },
            get fallback() {
              return $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
                height: "calc(1em + 1px)",
                width: "10ch"
              });
            },
            get children() {
              var _el$2 = $8tj43$getNextElement($52efc9ae4382e25a$var$_tmpl$2);
              $8tj43$addEventListener(_el$2, "click", $8tj43$catchify1(ev => router_.navigate_.go_to_({
                new_url_: href(),
                is_replace_: false,
                event_: ev,
                force_spa_navigation_: true,
                listing_query_: {
                  id: display_accessor().listing_id,
                  type: $397620a4d7958ed1$export$74ee7529ce0f8a00
                }
              })), true);
              $8tj43$insert(_el$2, () => display_accessor().title);
              $8tj43$effect(() => $8tj43$setAttribute(_el$2, "href", href()));
              $8tj43$runHydrationEvents();
              return _el$2;
            }
          }), $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return index < crumb_data().length - 1;
            },
            get children() {
              var _el$3 = $8tj43$getNextElement($52efc9ae4382e25a$var$_tmpl$3);
              $8tj43$insert(_el$3, () => i18n_.breadcrumbs_separator_());
              return _el$3;
            }
          })];
        }
      }));
      $8tj43$effect(() => $8tj43$setAttribute(_el$, "aria-label", i18n_.breadcrumbs_aria_label_()));
      return _el$;
    }
  });
}
$8tj43$delegateEvents(["click"]);

/**
 * This function is used to determine if the user is trying to open a link in a new tab or window, and we therefore should not single page navigate
 * @param clickEvent The click event that triggered the navigation
 */
function $9b35d1384e31813a$export$29d28dadc2d6b631(clickEvent) {
  return (clickEvent === null || clickEvent === void 0 ? void 0 : clickEvent.button) || (clickEvent === null || clickEvent === void 0 ? void 0 : clickEvent.metaKey) || (clickEvent === null || clickEvent === void 0 ? void 0 : clickEvent.ctrlKey) || (clickEvent === null || clickEvent === void 0 ? void 0 : clickEvent.shiftKey // if true, shift button on windows, linux or macOS which opens in a new window
  );
}

var $43fbb365ed0ac99e$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<nav class=quicklinks>`),
  $43fbb365ed0ac99e$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div>QuickLinks failed`),
  $43fbb365ed0ac99e$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<a class=quicklink>`);
function $43fbb365ed0ac99e$export$466cdc317043f6cb(_ref) {
  let {
    quicklinks_data_: quicklinks_data_,
    router_: router_,
    id_to_query_for_: id_to_query_for_,
    breadcrumb_data_: breadcrumb_data_,
    i18n_: i18n_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    id_type_: id_type_
  } = _ref;
  let scrolling_logic_ran_for_listing_id = false;
  let last_scroll_position;
  let scroll_to_element_on_dom_insertion;
  let last_was_placeholder = false;
  let sliding_element;
  $8tj43$createComputed(() => {
    id_to_query_for_();
    scrolling_logic_ran_for_listing_id = false;
  });
  const place_holdey_quicklinks_data = $8tj43$createMemo(() => quicklinks_data_() || [,,,]);
  const selected_index = $8tj43$createMemo(() => {
    var _quicklinks_data_;
    return (_quicklinks_data_ = quicklinks_data_()) === null || _quicklinks_data_ === void 0 ? void 0 : _quicklinks_data_.findIndex(item => item[id_type_() === $397620a4d7958ed1$export$5aae649db1b959fc ? "external_id" : "listing_id"] === id_to_query_for_());
  }); // this will be -1 when viewing child categories
  const scrollpos_per_listing_id = {};
  const mutation_plugins = [function () {
    if (!scrolling_logic_ran_for_listing_id) return;
    const {
      scrollLeft: scrollLeft
    } = this.insert_here;
    if (scrollLeft > 0) {
      last_scroll_position = scrollLeft;
      const current_id = $8tj43$untrack(id_to_query_for_);
      // make sure to not save position where selected item isn't in viewport
      const current_selected_index = $8tj43$untrack(selected_index);
      const intersecting_thing = this.intersecting_items_object[current_selected_index];
      if ((intersecting_thing === null || intersecting_thing === void 0 ? void 0 : intersecting_thing.intersectionRatio) >= 0.95 || current_selected_index == undefined || current_selected_index < 0) scrollpos_per_listing_id[current_id] = scrollLeft;else if (current_id in scrollpos_per_listing_id)
        // if about to go out of view, stop saving it so that the "always show new things in view" thing can get to work
        delete scrollpos_per_listing_id[current_id];
    }
  }];
  $8tj43$createComputed(() => {
    var _place_holdey_quickli, _place_holdey_quickli2;
    if ((_place_holdey_quickli = place_holdey_quicklinks_data()) !== null && _place_holdey_quickli !== void 0 && (_place_holdey_quickli2 = _place_holdey_quickli[0]) !== null && _place_holdey_quickli2 !== void 0 && _place_holdey_quickli2.listing_id) {
      if (last_was_placeholder) queueMicrotask($8tj43$catchify1(() => {
        var _sliding_element;
        (_sliding_element = sliding_element) === null || _sliding_element === void 0 || _sliding_element.scrollTo({
          left: 0
        }); // for some reason we land one element to the right after placeholder rendering otherwise
      }));

      last_was_placeholder = false;
    } else last_was_placeholder = true;
  });
  const [in_out_dom, set_in_out_dom] = $8tj43$createSignal(false);
  return $8tj43$createComponent((0, $8tj43$ErrorBoundary), {
    fallback: err => {
      const msg = "QuickLinks failed";
      $8tj43$report1([err, msg], "error");
      return $8tj43$getNextElement($43fbb365ed0ac99e$var$_tmpl$2);
    },
    get children() {
      var _el$ = $8tj43$getNextElement($43fbb365ed0ac99e$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
        faded_opacity_: 0.5,
        mutation_plugins_: mutation_plugins,
        slider_ref_: slider => {
          const {
            insert_here: insert_here,
            intersecting_items_object: intersecting_items_object
          } = slider;
          sliding_element = insert_here;
          (0, $8tj43$observer).onexists(insert_here, _ref2 => {
            let {
              element: element
            } = _ref2;
            if (scroll_to_element_on_dom_insertion == undefined) {
              if (!element.scrollLeft) {
                const target_position = last_scroll_position;
                if (target_position) element.scrollTo({
                  left: target_position
                });else
                  // run scrolling logic, it might not have run because we went to another page and then back so breadcrumb_data_ is the same
                  set_in_out_dom(prev => !prev);
              }
            } else {
              slider.scroll_to_abs(scroll_to_element_on_dom_insertion, true);
              last_scroll_position = insert_here.scrollLeft; // update this because it might get removed from the DOM before intersection observers triggered (actually happened for me)
              scroll_to_element_on_dom_insertion = undefined;
            }
          });
          $8tj43$createEffect($8tj43$on($8tj43$createMemo(() => {
            in_out_dom();
            return breadcrumb_data_();
          }, undefined, {
            equals: false
          }), new_data => {
            const quicklinks_data = quicklinks_data_(); // this signal should have updated by now since this is a createEffect
            const current_id = id_to_query_for_();
            if (!new_data || !quicklinks_data || !current_id) return;
            const owner = $8tj43$getOwner();
            queueMicrotask(() => {
              var _intersecting_items_o;
              // has to be in microtask so that elements have rendered and are scroll-to-able
              scrolling_logic_ran_for_listing_id = true;
              const saved_scroll_position = scrollpos_per_listing_id[current_id];
              if (saved_scroll_position) {
                insert_here.scrollTo({
                  left: saved_scroll_position
                });
                last_scroll_position = saved_scroll_position;
              } else if (!(((_intersecting_items_o = intersecting_items_object[selected_index()]) === null || _intersecting_items_o === void 0 ? void 0 : _intersecting_items_o.intersectionRatio) >= 0.95)) {
                // negated larger than to handle left side of comparison being undefined
                let done_work = false;
                $8tj43$runWithOwner(owner, () => $8tj43$createComputed($8tj43$catchify1(() => {
                  if (done_work || !Array.isArray(quicklinks_data_())) return;
                  const sel_index = selected_index();
                  const target_element = sel_index >= 0 ? sel_index : 0;
                  if (document.documentElement.contains(insert_here)) {
                    slider.scroll_to_abs(target_element, true); // if nothing selected and no selected scroll position, go to left
                    last_scroll_position = insert_here.scrollLeft; // update this because it might get removed from the DOM before intersection observers triggered (actually happened for me)
                  } else
                    // can't scroll if not in the DOM, scroll when we're back instead
                    scroll_to_element_on_dom_insertion = target_element;
                  done_work = true;
                })));
              }
            });
          }, {
            defer: true
          }));
        },
        get children() {
          return $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              return place_holdey_quicklinks_data();
            },
            children: (display_accessor, index) => {
              const is_selected = $8tj43$createMemo(() => selected_index() === index);
              // Problem: if opening a sibling link in a new tab, filter clearing behavior is no longer consistent
              // Solution:
              // If id of current category is in quick links they're siblings, don't add state to the url
              // If it's not in it, it's a child of the current one, so add state
              // (This brought up the issue on what happens if someone links to a filter that no longer exists, I chose to ignore that for now)
              // Problem: When you don't open a link in a new tab, we don't display the filter cleared toast
              // Solution: instead of not adding the state to the url, add a flag to the link if it's a sibling and then display the toast on load if the flag is set
              const is_sibling = $8tj43$createMemo(() => {
                var _quicklinks_data_2;
                const current_id = id_to_query_for_();
                const lookForId = id_type_() === $397620a4d7958ed1$export$5aae649db1b959fc ? "external_id" : "listing_id";
                return (_quicklinks_data_2 = quicklinks_data_()) === null || _quicklinks_data_2 === void 0 ? void 0 : _quicklinks_data_2.some(quickLink => quickLink[lookForId] === current_id);
              });
              const href = $8tj43$createMemo(() => {
                var _display_accessor;
                return (
                  // We don't want these links to delete the sort and filter state by default, only if `clear_filters_when_going_sideways` explicitly clears them
                  $2855bffe06ef7a03$export$43cd1e747fecd42e({
                    to_url_: (_display_accessor = display_accessor()) === null || _display_accessor === void 0 ? void 0 : _display_accessor.page_url,
                    set_clearing_flag_: is_sibling(),
                    sorting_query_param_: sorting_query_param_,
                    filter_query_param_prefix_: filter_query_param_prefix_
                  })
                );
              });
              return (() => {
                var _el$3 = $8tj43$getNextElement($43fbb365ed0ac99e$var$_tmpl$3);
                $8tj43$addEventListener(_el$3, "click", $8tj43$catchify1(ev => {
                  const url = href();
                  if (is_selected() && !$9b35d1384e31813a$export$29d28dadc2d6b631(ev) || !url)
                    // allow open currently selected one in new tab but otherwise prevent clicks
                    ev.preventDefault();else if (url) router_.navigate_.go_to_({
                    new_url_: url,
                    is_replace_: false,
                    event_: ev,
                    force_spa_navigation_: true,
                    listing_query_: {
                      id: display_accessor().listing_id,
                      type: $397620a4d7958ed1$export$74ee7529ce0f8a00
                    }
                  });
                }), true);
                $8tj43$insert(_el$3, () => {
                  var _display_accessor2;
                  return ((_display_accessor2 = display_accessor()) === null || _display_accessor2 === void 0 ? void 0 : _display_accessor2.title) || $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
                    height: "1em",
                    width: "10ch"
                  });
                });
                $8tj43$effect(_p$ => {
                  var _v$ = !!is_selected(),
                    _v$2 = href();
                  _v$ !== _p$.e && _el$3.classList.toggle("selected", _p$.e = _v$);
                  _v$2 !== _p$.t && $8tj43$setAttribute(_el$3, "href", _p$.t = _v$2);
                  return _p$;
                }, {
                  e: undefined,
                  t: undefined
                });
                $8tj43$runHydrationEvents();
                return _el$3;
              })();
            }
          });
        }
      }));
      $8tj43$effect(() => $8tj43$setAttribute(_el$, "aria-label", i18n_.quicklinks_aria_label_()));
      return _el$;
    }
  });
}
$8tj43$delegateEvents(["click"]);
const $5e6abec0dab4e610$var$max_history_change_frequency = 300;
const $5e6abec0dab4e610$var$api_max_products_per_request = 100;
function $5e6abec0dab4e610$export$6e49da55e449af7c(_ref) {
  let {
    scroll_restoration_data_: [, set_scroll_restoration_data],
    last_result_in_viewport_: [get_last_result_in_viewport_],
    id_: id_,
    can_write_scroll_restoration_: can_write_scroll_restoration_
  } = _ref;
  // store last actually seen (within viewport) product in history.state
  let last_time_history_changed = 0;
  let set_to_later;
  let timeout;
  const set_min_results_loaded = min_results_loaded => {
    if (!$8tj43$untrack(can_write_scroll_restoration_)) return;
    set_scroll_restoration_data([{
      for_id: $8tj43$untrack(id_),
      min_results_loaded: min_results_loaded
    }]); // get rid of old data the browser saves the old state and will restore it later on
  };

  $8tj43$createComputed($8tj43$catchify1(() => {
    const last_result = get_last_result_in_viewport_();
    if (last_result == undefined || last_result <= 0 || last_result == Infinity) return;
    if (isNaN(last_result)) {
      // if last_result is NaN there's an issue somewhere, but if we store something here that's not a number the for loop further down will break, and we won't be able to load results at all, so let's just continue
      $8tj43$report1(new Error("last_result is NaN, this should not happen"), "error", {
        last_result: last_result
      });
      return;
    }
    // We can push to history.state max 100 times per 30 seconds (Safari) so we have to debounce/cap this at 300ms for aggressive scrolling.
    // Pushing to history.state right before we leave the page (onunload etc.) is unreliable, as it has to occur *before* the next page is pushed to history.
    // Instead, we delay our push with a timeout set to the next acceptable interval to the previous one, when necessary
    const now = +new Date();
    const time_since_last_ran = now - last_time_history_changed;
    if (time_since_last_ran > $5e6abec0dab4e610$var$max_history_change_frequency) {
      // If the interval to the previous push is already long enough, it's fine to push the next value directly.
      set_min_results_loaded(last_result);
      last_time_history_changed = now;
      // Even though the interval has passed, there could still be a delayed push timeout in flight (browser can delay timeouts at will).
      // We've already written the guaranteed-to-be-freshest value so we can just cancel it.
      clearTimeout(timeout);
      return;
    }
    set_to_later = last_result;
    // If a delayed push timeout is already running, just changing the value that will be pushed is sufficient
    if (timeout) return;
    timeout = setTimeout($8tj43$catchify1(() => {
      timeout = undefined;
      last_time_history_changed = +new Date();
      set_min_results_loaded(set_to_later);
    }), $5e6abec0dab4e610$var$max_history_change_frequency - time_since_last_ran);
  }));
  $8tj43$onCleanup(() => clearTimeout(timeout)); // could cause weird bugs otherwise
}

async function $5e6abec0dab4e610$export$cc42dd29bf655ab6(_ref2) {
  var _untrack$find$min_res, _untrack$find;
  let {
    scroll_restoration_data_: [get_scroll_restoration_data],
    make_request_: make_request_,
    min_products_to_fetch_: min_products_to_fetch_,
    id_: id_
  } = _ref2;
  const to_fetch_according_to_state = (_untrack$find$min_res = (_untrack$find = $8tj43$untrack(get_scroll_restoration_data).find(_ref3 => {
    let {
      for_id: for_id
    } = _ref3;
    return for_id === id_;
  })) === null || _untrack$find === void 0 ? void 0 : _untrack$find.min_results_loaded) !== null && _untrack$find$min_res !== void 0 ? _untrack$find$min_res : 0;
  const total_products_to_fetch = to_fetch_according_to_state < min_products_to_fetch_ ? min_products_to_fetch_ : to_fetch_according_to_state + 20; // if we fetch according to state, fetch some more in case that the screen size increased, there's some in-accuracy or for the user to scroll. Sometimes the load more post processor will trigger to fetch more after this, but I think that's ok.
  if (total_products_to_fetch <= $5e6abec0dab4e610$var$api_max_products_per_request) return await make_request_(total_products_to_fetch);
  const displays = [];
  const owner = $8tj43$getOwner();
  let last_response;
  let next_cursor;
  for (let fetch_this_time = $5e6abec0dab4e610$var$api_max_products_per_request; displays.length < total_products_to_fetch;) {
    // Carry over the request when making the owner so that display transformers can use onCleanup
    last_response = await $8tj43$runWithOwner(owner, () => make_request_(fetch_this_time, next_cursor));
    const new_displays = last_response.displays;
    displays.push(...new_displays);
    next_cursor = last_response.cursor;
    const left_to_fetch = total_products_to_fetch - displays.length;
    if (!next_cursor) {
      if (left_to_fetch > 0) $8tj43$dwarn("Got response without a cursor when attempting to restore scroll position, giving up", last_response, total_products_to_fetch, displays);
      break;
    }
    fetch_this_time = left_to_fetch < $5e6abec0dab4e610$var$api_max_products_per_request ? left_to_fetch : $5e6abec0dab4e610$var$api_max_products_per_request;
  }
  return {
    ...last_response,
    displays: displays
  };
}
function $ec225bf1f1627ea8$export$210f130a61ac1e8d(fn) {
  const [external_value, set_external_value] = $8tj43$createSignal();
  const [is_loading, set_is_loading] = $8tj43$createSignal(false);
  let last_queued;
  let last_value;
  let initial_run = true;
  $8tj43$createComputed($8tj43$catchify1(async () => {
    last_value = fn();
    if (initial_run) {
      initial_run = false;
      set_external_value(() => last_value);
    } else {
      const us = {};
      last_queued = us;
      set_is_loading(true);
      await new Promise(r => {
        // want this to happen ASAP but earliest after the next task in the macrotask queue
        requestAnimationFrame(r); // to ensure this happens before rendering
        $8tj43$queueMacroTask(r); // to ensure it happens next event loop execution even if the browser doesn't decide to paint after it
      });

      if (last_queued !== us) return; // basically the equivalent of canceling the last timeout, we want to wait a macrotask until there's a macrotask of no new information
      set_external_value(() => last_value);
      set_is_loading(false);
    }
  }));
  Object.defineProperty(external_value, "loading", {
    get() {
      return is_loading();
    }
  });
  return external_value;
}
let $c3820807ac1e6fd7$export$44dad306455dddf;
(function (DEPICT_ID) {
  DEPICT_ID["SEARCH_MODAL"] = "depict-search-modal";
  DEPICT_ID["SEARCH_PAGE"] = "depict-search-page";
  DEPICT_ID["PLP_CATEGORY"] = "depict-plp-category";
})($c3820807ac1e6fd7$export$44dad306455dddf || ($c3820807ac1e6fd7$export$44dad306455dddf = {}));
function $a4777acaffa35a82$export$3945d6db2dfd3d12(_ref) {
  let {
    crumb_data_: crumb_data_,
    id_to_query_for_: id_to_query_for_,
    i18n_: i18n_,
    selected_filters_: selected_filters_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    plp_results_: plp_results_,
    sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
    id_type_: id_type_,
    expanded_filters_: expanded_filters_,
    filters_open_: filters_open_
  } = _ref;
  // If we just got opened in a new tab, clear filters instantly and remove the flag
  $a4777acaffa35a82$var$clear_if_opened_new_tab_with_sideways_url_params_flag({
    plp_results_: plp_results_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    selected_filters_: selected_filters_,
    i18n_: i18n_,
    sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
    expanded_filters_: expanded_filters_,
    filters_open_: filters_open_
  });
  // The code below is for when we're already open and the user navigates to a new category
  let previous_crumb_data = $8tj43$untrack(crumb_data_);
  let id_when_we_got_previous_data = {
    id_: $8tj43$untrack(id_to_query_for_),
    type_: $8tj43$untrack(id_type_)
  };
  let allow_filter_clearing = true; // set to false when going backwards/forwards
  // temporarily disable filter clearing when going backwards/forwards
  const handler = () => allow_filter_clearing = false;
  window.addEventListener("popstate", handler); // popstate only gets called when using back/forwards button of browser or the history navigate to achieve the same, but not on pushState or replaceState
  $8tj43$onCleanup(() => window.removeEventListener("popstate", handler));
  $8tj43$createEffect($8tj43$on(crumb_data_, $8tj43$catchify1(new_crumb_data => {
    const id_of_new_data = id_to_query_for_();
    const type_of_id_of_new_data = id_type_();
    if (allow_filter_clearing && previous_crumb_data && new_crumb_data && (id_of_new_data !== id_when_we_got_previous_data.id_ || type_of_id_of_new_data !== id_when_we_got_previous_data.type_)) {
      const previous_length = previous_crumb_data.length;
      const new_length = new_crumb_data.length;
      const went_upwards = new_length < previous_length;
      const went_downwards = previous_length < new_length;
      const shorter_array = went_upwards ? new_crumb_data : previous_crumb_data;
      const longer_array = went_upwards ? previous_crumb_data : new_crumb_data;
      if (!((went_upwards || went_downwards) && shorter_array.every((_ref2, index) => {
        let {
          listing_id: listing_id
        } = _ref2;
        return longer_array[index].listing_id === listing_id;
      }))) {
        // We went sideways, not up or down. Clear filters.
        $b4465d8d605f61e9$export$8895d39404bd2bb1({
          user_triggered_: false,
          i18n_: i18n_,
          also_clear_sorting_: false,
          selected_filters_: selected_filters_,
          expanded_hierarchical_filters_: expanded_hierarchical_filters_,
          local_filter_cache_: local_filter_cache_,
          expanded_filters_: expanded_filters_,
          filters_open_: filters_open_
        });
        // Also ensure we don't have `sideways_url_params_flag` set anymore
        sideways_filter_clearing_flag_[1](false);
      }
    }
    id_when_we_got_previous_data = {
      id_: id_of_new_data,
      type_: type_of_id_of_new_data
    };
    previous_crumb_data = new_crumb_data;
    if (!allow_filter_clearing) allow_filter_clearing = true;
  })));
}
function $a4777acaffa35a82$var$clear_if_opened_new_tab_with_sideways_url_params_flag(_ref3) {
  let {
    plp_results_: plp_results_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    i18n_: i18n_,
    selected_filters_: selected_filters_,
    local_filter_cache_: local_filter_cache_,
    sideways_filter_clearing_flag_: [get_sideways_filter_clearing_flag_, set_sideways_filter_clearing_flag_],
    expanded_filters_: expanded_filters_,
    filters_open_: filters_open_
  } = _ref3;
  const tracking_function_for_plp_results = $8tj43$createReaction(() => {
    // On first rendering of the CategoryPage (after we have results), check if we got to this URL by going sideways in QuickLinks and clear filters with toast if so
    if (!$8tj43$untrack(get_sideways_filter_clearing_flag_)) return;
    set_sideways_filter_clearing_flag_(false);
    $8tj43$dlog("Flag to clear filters was set, clearing filters");
    $8tj43$queueMacroTask(() => {
      // Do it next task so that all the filters have time to populate
      $b4465d8d605f61e9$export$8895d39404bd2bb1({
        user_triggered_: false,
        i18n_: i18n_,
        also_clear_sorting_: false,
        selected_filters_: selected_filters_,
        expanded_hierarchical_filters_: expanded_hierarchical_filters_,
        local_filter_cache_: local_filter_cache_,
        filters_open_: filters_open_,
        expanded_filters_: expanded_filters_
      });
    });
  });
  tracking_function_for_plp_results(plp_results_);
}
var $1145661fd3ca5519$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=statement style=white-space:pre-wrap>No \`id\` specified in \`listingQuery\`, this is probably unintentional. Make sure to create (and insert) the CategoryPage *after* you have specified a listingQuery.`),
  $1145661fd3ca5519$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=buttons><button class="ok major">`);
function $1145661fd3ca5519$export$7af06a63c5a976c9(el, listing_id, i18n_) {
  if (!(0, $8tj43$is_debug)) return; // Just to make sure we don't show this in production
  const owner = $8tj43$getOwner();
  const disconnect = (0, $8tj43$observer).onexists(el, _ref => {
    let {
      element: element
    } = _ref;
    return $8tj43$runWithOwner(owner, () => $8tj43$createEffect(() => {
      if (!document.documentElement.contains(element)) return;
      if (!listing_id()) {
        const warning = "No `id` specified in `listingQuery`, this is probably unintentional. Make sure to create (and insert) the CategoryPage *after* you have specified a listingQuery.";
        $8tj43$dwarn(warning);
        const {
          close_toast_: close_toast_
        } = $a61a2051e15c8d7a$export$5196e4c01fa56fcb({
          class: "warning",
          close_after_: 120000,
          style: {
            background: "#ffb830"
          },
          children: [$8tj43$getNextElement($1145661fd3ca5519$var$_tmpl$), (() => {
            var _el$2 = $8tj43$getNextElement($1145661fd3ca5519$var$_tmpl$2),
              _el$3 = _el$2.firstChild;
            _el$3.$$click = () => close_toast_() /* We have to wait for close_toast_ to get defined after the call to show_toast */;
            $8tj43$insert(_el$3, () => i18n_.ok_());
            $8tj43$runHydrationEvents();
            return _el$2;
          })()]
        });
      }
    }));
  });
  $8tj43$onCleanup(disconnect);
}
$8tj43$delegateEvents(["click"]);
const $ec8a6e10026dcff9$export$5c28802497c8a83c = /*@__PURE__*/Symbol("category_title_type");
function $3a2bed57c9a57e21$export$d31a1a1a83ad9413(plp_results_, _ref) {
  let [get_selected_filters, set_selected_filters] = _ref;
  $8tj43$createComputed(() => {
    var _plp_results_;
    const available_filters = (_plp_results_ = plp_results_()) === null || _plp_results_ === void 0 ? void 0 : _plp_results_.filters;
    if (!available_filters) return;
    const selected_filters = get_selected_filters();
    if (!selected_filters) return;
    const new_filters = [];
    let modified_filters = false;
    for (let i = 0; i < selected_filters.length; i++) {
      const selected_filter = selected_filters[i];
      const available_filter = available_filters.find(available_filter => available_filter.field === selected_filter.field && available_filter.op === selected_filter.op);
      const available_filter_old_filter_link = available_filters.find(available_filter => available_filter.actual_field === selected_filter.field && available_filter.op === selected_filter.op);
      if (!available_filter && available_filter_old_filter_link) {
        new_filters.push({
          ...selected_filter,
          field: available_filter_old_filter_link.field
        }); // <- Change the field to be the new field which actually is group_title
        modified_filters = true;
      } else new_filters.push(selected_filter);
    }
    if (modified_filters)
      // This will unfortunately trigger a refetch which isn't great UX but it's the best we can do for now
      set_selected_filters(new_filters);
  });
}
const $5441862cd2f5e111$var$ListingContext = /*@__PURE__*/$8tj43$createContext();
function $5441862cd2f5e111$export$e68cff63f76bd15b(props) {
  const our_object = {};
  return $8tj43$createComponent($5441862cd2f5e111$var$ListingContext.Provider, {
    value: our_object,
    get children() {
      return props.children;
    }
  });
}
function $5441862cd2f5e111$export$8d0c4fdbb05a2f2e() {
  return $8tj43$useContext($5441862cd2f5e111$var$ListingContext);
}
function $a35e6f680c5bbc60$export$54299a3c81f5425() {
  const d = document;
  const [isVisible, setIsVisible] = $8tj43$createSignal(d.visibilityState !== "hidden");
  const handleVisibilityChange = () => setIsVisible(d.visibilityState !== "hidden");
  d.addEventListener("visibilitychange", handleVisibilityChange);
  $8tj43$onCleanup(() => d.removeEventListener("visibilitychange", handleVisibilityChange));
  return isVisible;
}
var $801e8845d3fa3653$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`);
function $801e8845d3fa3653$export$94026ee33dbabc26(props) {
  return (() => {
    var _el$ = $8tj43$getNextElement($801e8845d3fa3653$var$_tmpl$);
    $8tj43$insert(_el$, () => props.children);
    $8tj43$effect(_p$ => {
      var _v$ = "padding-bottom:calc(calc(1 / ".concat(props.aspectRatio, ") * 100%)"),
        _v$2 = "s-image-container" + (props.class ? " " + props.class : "");
      _p$.e = $8tj43$style(_el$, _v$, _p$.e);
      _v$2 !== _p$.t && $8tj43$className(_el$, _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}
let $6db93f70c2db1486$var$browserIsBugged = false;
function $6db93f70c2db1486$export$2972b890694ced75(callback, _ref) {
  let {
    timeout: timeout
  } = _ref;
  if ($6db93f70c2db1486$var$browserIsBugged) timeout /= 4;
  const cancel = () => {
    cancelIdleCallback(idleHandle);
    clearTimeout(racingTimeout);
  };
  const idleHandle = requestIdleCallback(deadline => {
    cancel();
    return callback(deadline);
  }, {
    timeout: timeout
  });
  const racingTimeout = setTimeout(() => {
    $8tj43$dwarn("Browser did not respect requestIdleCallback timeout");
    $6db93f70c2db1486$var$browserIsBugged = true;
    cancel();
    callback({
      didTimeout: false,
      timeRemaining() {
        return 500;
      }
    });
  }, timeout + 1000);
  return cancel;
}
function $29b3cf99ce390e3b$export$566cd7e46bad5c2d(callback) {
  var _globalThis$performan, _globalThis$performan2, _globalThis$performan3, _globalThis$performan4;
  const page_hasnt_loaded =
  // @ts-ignore
  (globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 ? void 0 : (_globalThis$performan2 = _globalThis$performan.getEntriesByType) === null || _globalThis$performan2 === void 0 ? void 0 : (_globalThis$performan3 = _globalThis$performan2.call(_globalThis$performan, "navigation")) === null || _globalThis$performan3 === void 0 ? void 0 : (_globalThis$performan4 = _globalThis$performan3.every) === null || _globalThis$performan4 === void 0 ? void 0 : _globalThis$performan4.call(_globalThis$performan3, e => e === null || e === void 0 ? void 0 : e.loadEventEnd)) === false;
  const cancelFrameCheck = $29b3cf99ce390e3b$var$checkForFrameDipsUntil(2000, () => {
    cancelIdleCallback();
    // Allow a long time of loading images since otherwise it takes even longer to erroneously load images later
    callback({
      didTimeout: false,
      timeRemaining: () => 1000
    });
  }, page_hasnt_loaded);
  const cancelIdleCallback = $6db93f70c2db1486$export$2972b890694ced75(deadline => {
    cancelFrameCheck();
    callback(deadline);
  },
  // If page hasn't loaded yet, it's more likely we run into the chrome bug than need to delay image loading to not lock up the browser, so only give rIC a 4s timeout
  {
    timeout: page_hasnt_loaded ? 4000 : 15000
  });
}
/**
 * Calls the provided callback function if the browser ran for checkDuration ms without three frame dip below 20 FPS.
 */
function $29b3cf99ce390e3b$var$checkForFrameDipsUntil(checkDuration, runWhenNoDips, pageHasntLoaded) {
  const maxDips = 3;
  const noDipsBelow = 20;
  const fpsOverTime = [];
  let dipsLeft = maxDips;
  let start = performance.now();
  let cleanedUp = false;
  let lastTime;
  const check = () => requestAnimationFrame($8tj43$catchify1(time => {
    if (cleanedUp) return;
    if (lastTime != undefined) {
      const fps = 1000 / (time - lastTime);
      fpsOverTime.push(fps);
      if (fps < noDipsBelow && !dipsLeft--) {
        $8tj43$dlog("FPS dipped below ".concat(noDipsBelow, " to ").concat(fps, ", bailing from requestIdleCallback shortcut - rIC seems legit"), fpsOverTime);
        return;
      }
    }
    lastTime = time;
    if (time <= start + checkDuration) check();else {
      if (fpsOverTime.length < checkDuration / 1000 * noDipsBelow) {
        $8tj43$dlog("Not enough FPS data to determine if we should short-circuit requestIdleCallback, rIC seems legit. FPS:", fpsOverTime);
        return;
      }
      $8tj43$dlog("Short-circuiting requestIdleCallback (probably bugged) due to only ", maxDips - dipsLeft, " dips below ", noDipsBelow, " FPS for ", checkDuration, "ms. FPS:", fpsOverTime);
      runWhenNoDips();
    }
  }));
  // If page hasn't loaded yet, wait for it to load before starting the check
  // This is because the first few frames until the load event are usually slower
  if (pageHasntLoaded) addEventListener("load", () => {
    start = performance.now();
    check();
  }, {
    once: true
  });else check();
  return () => cleanedUp = true;
}
const $56047603f9d212b6$var$onIdleFunctionsSymbol = /*@__PURE__*/Symbol("onIdleFunctions");
const $56047603f9d212b6$export$f8945274f08a3105 = /*@__PURE__*/Symbol("listingContextAspectRatios");
const $56047603f9d212b6$export$6066eb417ed2e9f7 = /*@__PURE__*/Symbol("listingContextAspectRatios");
function $56047603f9d212b6$export$6e5611bc7e57e477(props) {
  const img = new Image(); // Need to use new Image or browser might not start loading image before it's in the DOM
  const [ourRatioKeyed, setOurRatioKeyed] = $8tj43$createSignal();
  const [rAFSinceReturned, setRAFSinceReturned] = $8tj43$createSignal(false);
  const sizeToUse = $8tj43$createMemo(() => {
    var _props$sizeHeight;
    // We first put the images into the DOM after they have been decoded. We can only get the correct object-fit value after the image is in the DOM.
    // To avoid using an observer for knowing when the image is in the DOM (one of the most CPU intensive things when we did lighthouse optimisation) we just re-check an animationframe after we told <Show> to show the image, which seems to work reliably
    rAFSinceReturned();
    // props.size could be a getter that expects a cleanup so get it in this memo instead of where we set img.sizes (also we need to multiply, and it's good with some diffing here so people calling the comp don't have to)
    const incomingSize = props.size();
    const ratio = ourRatioKeyed();
    const containerHeight = (_props$sizeHeight = props.sizeHeight) === null || _props$sizeHeight === void 0 ? void 0 : _props$sizeHeight.call(props);
    if (!incomingSize || !ratio || !containerHeight || getComputedStyle(img).objectFit !== "cover") return incomingSize;
    const maybeCorrectedSize = ratio * containerHeight;
    return Math.round(Math.max(incomingSize, maybeCorrectedSize));
  });
  const src_options = $8tj43$createMemo(() => {
    const {
      src: src,
      customUrls: customUrls
    } = props;
    const fallback_src = (customUrls || $56047603f9d212b6$export$1d6267828870adda)(src, 400);
    const srcset = $56047603f9d212b6$var$make_srcset(props.src, props.resolutions || [64, 128, 256, 300, 400, 512, 640, 768, 1024, 1280, 1536, 2048, 2560, 3072, 3584, 4096], customUrls);
    // The order here *might* matter - I've seen mobile safari always start with loading the 400px version when it was reversed
    return {
      srcset: srcset,
      src: fallback_src
    };
  });
  // Work around https://github.com/solidjs/solid/issues/1828
  const [, otherAttributes] = $8tj43$splitProps(props, ["resolutions", "size", "src", "srcSet", "loading", "keyRatioUpdating", "sizeHeight", "onDecoded", "customUrls" // Can't have properties ending on underscore because the property name mangling will get confused by this <-
  ]);

  const [hasSetSize, setHasSetSize] = $8tj43$createSignal(false);
  const [hasDecoded, setHasDecoded] = $8tj43$createSignal(false);
  const productCardIndexAccessor = $1e69163caedaab4e$export$e3faf4d95300054f();
  const listingContext = $5441862cd2f5e111$export$8d0c4fdbb05a2f2e();
  const isPrioritisedImage = $8tj43$createMemo(() => (productCardIndexAccessor === null || productCardIndexAccessor === void 0 ? void 0 : productCardIndexAccessor()) < 8);
  const shouldActuallyEnableLazyLoading = $8tj43$createMemo(() => {
    const {
      loading: loading
    } = props;
    if (loading === "force-lazy") return true;
    return loading === "lazy" && !isPrioritisedImage();
  });
  const modifiedOtherAttributes = $8tj43$mergeProps(otherAttributes, {
    get loading() {
      return shouldActuallyEnableLazyLoading() ? "lazy" : undefined;
    }
  });
  // Batch idle callbacks so that MutationObserver can batch the resulting mutations better, so we don't lose tons of CPU time to MutationObservers doing lots of things for each image
  // Happened on singular, they have some weird observer (+we also have one but ours is at least 3x more efficient)
  const executeWhenIdleBatched = (fn, isSizesUpdate) => {
    if (typeof requestIdleCallback !== "function") return setTimeout(fn); // Old browsers don't get optimisation
    if ((!isSizesUpdate || !sizeSetFastPath) && $8tj43$untrack(isPrioritisedImage)) return fn(); // If we're one of the first 8 images, execute the callbacks immediately (improves lighthouse metrics)
    // unless we're just a `sizes` update after the initial sizes setting (this optimisation makes the looks animation a lot smoother on low-cpu devices)
    const existingStack = listingContext === null || listingContext === void 0 ? void 0 : listingContext[$56047603f9d212b6$var$onIdleFunctionsSymbol];
    if (existingStack) return existingStack.add(fn);
    const newStack = new Set([fn]);
    if (listingContext) listingContext[$56047603f9d212b6$var$onIdleFunctionsSymbol] = newStack;
    const processStackWhenIdle = () => $29b3cf99ce390e3b$export$566cd7e46bad5c2d($8tj43$catchify1(deadline => {
      const start = performance.now();
      const thirdDeadlineTime = deadline.timeRemaining() / 3; // observers coming after this take up 2-3x the time so don't use all of it
      for (const fn of newStack) {
        newStack.delete(fn);
        fn();
        const timeTaken = performance.now() - start;
        if ((!deadline.timeRemaining() || timeTaken > thirdDeadlineTime) && newStack.size) {
          // There's still work to be done but no time, so schedule another idle callback
          processStackWhenIdle();
          return;
        }
      }
      // Stack is empty
      if (listingContext) delete listingContext[$56047603f9d212b6$var$onIdleFunctionsSymbol];
    }));
    processStackWhenIdle();
  };
  let sizeSetFastPath = false;
  let hasDecodedFastPath = false;
  let timeoutSet = false;
  let gotCleanedUp = false;
  let srcJustChanged = true;
  img.classList.add("s-responsive-image");
  if (listingContext) {
    let prevValue;
    const aspectRatios = listingContext[$56047603f9d212b6$export$f8945274f08a3105] || (listingContext[$56047603f9d212b6$export$f8945274f08a3105] = new Set());
    const [, setMostPrevalentAspectRatio] = listingContext[$56047603f9d212b6$export$6066eb417ed2e9f7] || (listingContext[$56047603f9d212b6$export$6066eb417ed2e9f7] = $8tj43$createSignal());
    img.addEventListener("load", $8tj43$catchify1(() => {
      const aspectRatio_ = img.naturalWidth / img.naturalHeight;
      if (srcJustChanged)
        // Always key object-fit-cover compensation to one src, to avoid loading-different-images-infinite-loop
        setOurRatioKeyed(aspectRatio_);else if (props.keyRatioUpdating) return;
      srcJustChanged = false;
      // Save our aspect ratio whenever it changes, so that we can base the containers on the most dominant aspect ratio, used in SearchModalV2 and LookItem
      if (prevValue) aspectRatios.delete(prevValue);
      const newValue = !isNaN(aspectRatio_) ? {
        aspectRatio_: aspectRatio_
      } : undefined;
      if (newValue) aspectRatios.add(newValue);
      prevValue = newValue;
      // Do all calculations resulting of an update directly, for performance
      const asArray = [...aspectRatios].map(_ref => {
        let {
          aspectRatio_: aspectRatio_
        } = _ref;
        return aspectRatio_;
      });
      const mostPrevalentAspectRatio = $8tj43$findMostFrequentItem(asArray);
      setMostPrevalentAspectRatio(mostPrevalentAspectRatio);
    }));
    $8tj43$onCleanup(() => prevValue && aspectRatios.delete(prevValue));
  }
  $8tj43$onCleanup(() => gotCleanedUp = true);
  $8tj43$spread(img, $8tj43$mergeProps(modifiedOtherAttributes), false, true);
  $8tj43$createRenderEffect(() => {
    props.src;
    srcJustChanged = true;
  });
  $8tj43$createEffect(() => {
    if (!sizeToUse()) return; // wait until we have a size, run every time the size changes
    if (timeoutSet) return;
    const handler = $8tj43$catchify1(() => {
      if (gotCleanedUp) return;
      img.sizes = "".concat(sizeToUse(), "px"); // use latest available value of size in case it has changed
      if (!sizeSetFastPath) {
        setHasSetSize(true);
        sizeSetFastPath = true;
      }
      timeoutSet = false;
    });
    // Throttle the updating of sizes to avoid unnecessary image re-fetches during resize
    // And also because we first set src after sizes has been set, wait with loading and decoding images until browser is idle
    // This greatly improves performance when loading (more) products
    // See https://depictaiworkspace.slack.com/archives/C05NJ0K3WRL/p1698220617663139
    timeoutSet = true; // Important to set timeoutSet before the call to executeWhenIdleBatched since if this is an important image executeWhenIdleBatched will execute fn immediately
    executeWhenIdleBatched(handler, true);
  });
  const dontLoadImageYet = $8tj43$createMemo(() => !sizeToUse() || !hasSetSize()); // Moving this condition into a memo saves us from re-setting src and srcset (expensive) if just props.size changes
  $8tj43$createEffect(() => {
    if (dontLoadImageYet()) return; // If size isn't known or set, don't assign src yet since it would cause the most low res image to load
    Object.assign(img, src_options());
    // Add to DOM once decoded to not require/block any paints before image has completed loading and avoid showing broken image symbol
    // We can do this because there has to be a container around us giving us a size
    // No need to listen if we're already in the DOM
    if (hasDecodedFastPath) return;
    if (shouldActuallyEnableLazyLoading()) {
      // For lazy loading there's no decoding to wait for as it only occurs when the image is visible
      // Make sure src is set before we put the image into the DOM though so no broken image symbol is shown
      setHasDecoded(true);
      hasDecodedFastPath = true;
      return;
    }
    img.decode().catch(e => $8tj43$dwarn("Failed to decode image", e, img)) // Display the image also if loading failed so webdev can debug and doesn't get "no image"
    .then(async () => {
      var _props$onDecoded;
      // Also wait with inserting image (i.e. paint) until browser is idle
      await new Promise(r => executeWhenIdleBatched(r, false));
      if (gotCleanedUp) return;
      setHasDecoded(true);
      hasDecodedFastPath = true;
      (_props$onDecoded = props.onDecoded) === null || _props$onDecoded === void 0 || _props$onDecoded.call(props);
    });
  });
  $8tj43$createEffect(() => hasDecoded() && requestAnimationFrame($8tj43$catchify1(() => setRAFSinceReturned(prev => !prev))));
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return hasDecoded();
    },
    children: img
  });
}
function $56047603f9d212b6$var$make_srcset(url, resolutions, customGenerateImageUrl_) {
  return resolutions.map(width => "".concat((customGenerateImageUrl_ || $56047603f9d212b6$export$1d6267828870adda)(url, width), " ").concat(width, "w")).join(", ");
}
function $56047603f9d212b6$export$1d6267828870adda(url, width) {
  // Even just creating one `URL` object per image src and then setting the search parameter is quite slow (0.25ms to set the width param)
  // We're making the assumptions that the url has already at least one query parameter and that the image resizing service will choose the last one out of a duplicate width parameter (shopify's does)
  // That way we can just to string concatenation which is insanely fast
  return url + "&width=" + encodeURIComponent(width);
}
var $5eaa00b951637e96$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=instant-card><div class=img-part></div><div class=right-part><div class=title-brand-tagline><span class=title></span></div><div class=price-container>`);
const $5eaa00b951637e96$export$8a2234b5b1a5ebd4 = "--image-aspect-ratio";
function $5eaa00b951637e96$export$ee1733d9a8495996() {
  return (() => {
    var _el$ = $8tj43$getNextElement($5eaa00b951637e96$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.firstChild,
      _el$6 = _el$4.nextSibling;
    $8tj43$insert(_el$2, $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
      aspectRatio: "var(".concat($5eaa00b951637e96$export$8a2234b5b1a5ebd4, ", 1)")
    }));
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
      width: "20ch",
      height: "1em"
    }));
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
      width: "5ch",
      height: "1em",
      "class": "price"
    }));
    return _el$;
  })();
}
function $4be619ec2cd7bba3$export$54c6d6ff54e72743(whatToWatch) {
  const [width, setWidth] = $8tj43$createSignal(0);
  const [height, setHeight] = $8tj43$createSignal(0);
  const resizeObserver = new ResizeObserver($8tj43$catchify1(records => $8tj43$batch(() => {
    for (let j = 0; j < records.length; j++) {
      const {
        width: width,
        height: height
      } = records[j].contentRect;
      // Padding hack makes that we can't use contentRect to get the height since that's apparently without padding
      const definitiveHeight = height || whatToWatch.getBoundingClientRect().height;
      if (definitiveHeight) setHeight(Math.ceil(definitiveHeight));
      if (width) setWidth(Math.ceil(width));
    }
  })));
  // If we start observing elements before they're in the DOM Chrome (Version 117.0.5938.92 (Official Build) (arm64)) sometimes gives us a resize event with a width of 0 and then doesn't dispatch one with the actual width once it's in the DOM. So we wait until the element is in the DOM before we start observing it.
  // It doesn't seem to work even when waiting for it to be in the DOM, also wait an animation frame
  const disconnect = (0, $8tj43$observer).onexists(whatToWatch, _ref => {
    let {
      element: element
    } = _ref;
    return requestAnimationFrame($8tj43$catchify1(() => resizeObserver.observe(element)));
  });
  $8tj43$onCleanup(() => {
    resizeObserver.disconnect();
    disconnect();
  });
  return [width, height];
}
const $4df489344a0f97c7$var$backupSizeSignal = /*@__PURE__*/$8tj43$createSignal();
const $4df489344a0f97c7$export$d7b7ab832c20e2f4 = /*@__PURE__*/Symbol("ShopifyContainedImage");
function $4df489344a0f97c7$export$e4b984597b71e989(props) {
  const context = $5441862cd2f5e111$export$8d0c4fdbb05a2f2e();
  if (context && !context[$4df489344a0f97c7$export$d7b7ab832c20e2f4])
    // create a signal that's the same for all items in this listing
    context[$4df489344a0f97c7$export$d7b7ab832c20e2f4] = $8tj43$createSignal();
  const [currentImageSize, setCurrentImageSize] = (context === null || context === void 0 ? void 0 : context[$4df489344a0f97c7$export$d7b7ab832c20e2f4]) || $4df489344a0f97c7$var$backupSizeSignal; // use global fallback signal (might lead to blurry images) if no context is available
  const [mostPrevalentAspectRatio] = context ? context[(0, $56047603f9d212b6$export$6066eb417ed2e9f7)] || (context[(0, $56047603f9d212b6$export$6066eb417ed2e9f7)] = $8tj43$createSignal()) : [];
  const container = $801e8845d3fa3653$export$94026ee33dbabc26({
    // Write getters manually instead of using JSX, so we can do more complex logic in the aspectRatio getter without increasing bundle size
    get class() {
      return props.class;
    },
    get aspectRatio() {
      if (props.autoAdjustAspectRatio) {
        const targetRatio = mostPrevalentAspectRatio === null || mostPrevalentAspectRatio === void 0 ? void 0 : mostPrevalentAspectRatio();
        if (targetRatio != undefined) return "var(".concat((0, $5eaa00b951637e96$export$8a2234b5b1a5ebd4), ", ").concat(targetRatio, ")");
      }
      return props.aspectRatio;
    }
  });
  const owner = $8tj43$getOwner();
  let createdSizeAccessor = false;
  let wasCleanedUp = false;
  $8tj43$createEffect(() => {
    if (currentImageSize() || wasCleanedUp) return; // We get into the effect when onCleanup is called if we don't have wasCleanedUp
    // ensure we always have a size accessor
    // what this whole thing does is set the sizes attribute to the actual size of one of the existing image containers, therefore the value doesn't have to manually be specified
    createdSizeAccessor = true;
    setCurrentImageSize(() => $8tj43$runWithOwner(owner, () => $4be619ec2cd7bba3$export$54c6d6ff54e72743(container)));
  });
  $8tj43$onCleanup(() => {
    wasCleanedUp = true; // important to set this before the function call below and always, so the dead effects don't create dead size accessors
    if (!createdSizeAccessor) return;
    $8tj43$queueMacroTask(() => setCurrentImageSize()); // unset the size accessor next event loop iteration, so that all onCleanup's have time to run, since the effects run more aggressively and can create a size accessor with a cleaned up owner otherwise
  });

  $8tj43$insert(container, $8tj43$createComponent((0, $56047603f9d212b6$export$6e5611bc7e57e477), $8tj43$mergeProps1({
    size: () => {
      var _currentImageSize, _currentImageSize$;
      return ((_currentImageSize = currentImageSize()) === null || _currentImageSize === void 0 ? void 0 : (_currentImageSize$ = _currentImageSize[0]) === null || _currentImageSize$ === void 0 ? void 0 : _currentImageSize$.call(_currentImageSize)) || 0;
    },
    sizeHeight: () => {
      var _currentImageSize2, _currentImageSize2$;
      return ((_currentImageSize2 = currentImageSize()) === null || _currentImageSize2 === void 0 ? void 0 : (_currentImageSize2$ = _currentImageSize2[1]) === null || _currentImageSize2$ === void 0 ? void 0 : _currentImageSize2$.call(_currentImageSize2)) || 0;
    },
    get src() {
      return props.src;
    }
  }, () => props.imgProps, {
    get style() {
      var _props$imgProps;
      return (_props$imgProps = props.imgProps) === null || _props$imgProps === void 0 ? void 0 : _props$imgProps.style;
    }
  })));
  return container;
}
const $98688279b9059f50$var$customUrls = (url, width) => {
  var _url$startsWith;
  if (url !== null && url !== void 0 && (_url$startsWith = url.startsWith) !== null && _url$startsWith !== void 0 && _url$startsWith.call(url, "https://cdn.shopify.com"))
    // The shopify image resizing CDN blocks Cloudflare's image resizer. It's possible that we can't detect shopify image URLs sometimes because they go to the merchant's domain,
    // but it seems like the URLs returned by the Depict API always goes to the cdn.shopify.com version of an image, so this simple workaround works.
    return $56047603f9d212b6$export$1d6267828870adda(url, width);
  // Use cloudflare image resizer instead of img.depict.ai because it's a lot faster (and also auto-chooses other formats if webp is not supported)
  return "https://app.depict.ai/cdn-cgi/image/width=".concat(width, ",format=auto/").concat(url);
};
function $98688279b9059f50$export$9d4a4b669b1929ab(props) {
  return $8tj43$createComponent((0, $4df489344a0f97c7$export$e4b984597b71e989), $8tj43$mergeProps1(props, {
    get imgProps() {
      return {
        ...props.imgProps,
        customUrls: $98688279b9059f50$var$customUrls
      };
    }
  }));
}
function $98688279b9059f50$export$140423fa4bfb6d63(props) {
  return $8tj43$createComponent((0, $56047603f9d212b6$export$6e5611bc7e57e477), $8tj43$mergeProps1(props, {
    customUrls: $98688279b9059f50$var$customUrls
  }));
}
let $e92c154db502596d$var$cachedHlsModule;
async function $e92c154db502596d$export$5d2f6cd705125cd3() {
  if ($e92c154db502596d$var$cachedHlsModule) return $e92c154db502596d$var$cachedHlsModule;
  const global_var_name = "_depict_ai_hls_polyfill";
  const scriptTag = document.createElement("script");
  scriptTag.type = "module";
  // Our build systems aren't set-up for dynamic imports, so do this instead
  scriptTag.append('import("https://cdn.jsdelivr.net/npm/hls.js/+esm").then(m=>window.'.concat(global_var_name, "=m)"));
  document.head.append(scriptTag);
  const hlsModule = await $8tj43$is_available_in(window, global_var_name);
  delete window[global_var_name];
  scriptTag.remove();
  $e92c154db502596d$var$cachedHlsModule = hlsModule;
  return hlsModule;
}
var $3b772ef9a35560fe$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<video class=d-standard-content>`);
function $3b772ef9a35560fe$export$780a853d15174484(_ref) {
  let {
    link_: link_,
    type_: type_,
    router_: router_,
    setAspectRatioWas_: setAspectRatioWas_,
    mediaUrl_: mediaUrl_,
    aspectRatioWhenAloneInRow_: aspectRatioWhenAloneInRow_
  } = _ref;
  let wroteAspectRatioToContainer = false; // Only write this once so we don't get into a aspect ratio changed -> size changed -> image source changed -> aspect ratio slightly changed infinite loop
  const [wrapperSize, setWrapperSize] = $8tj43$createSignal();
  const [hasLoaded, setHasLoaded] = $8tj43$createSignal(false);
  const isImage = type_ === "image";
  const setAspectRatio = aspectRatio => {
    if (wroteAspectRatioToContainer) return;
    wroteAspectRatioToContainer = true;
    setAspectRatioWas_(aspectRatio);
  };
  return $8tj43$createComponent((0, $8tj43$Dynamic), $8tj43$mergeProps1({
    component: link_ ? "a" : "div",
    "class": "d-standard-content-wrapper",
    get style() {
      return $8tj43$memo(() => !!aspectRatioWhenAloneInRow_())() ? "--media-aspect-ratio: ".concat(aspectRatioWhenAloneInRow_()) : "";
    },
    ref: el => isImage && setWrapperSize(() => $4be619ec2cd7bba3$export$54c6d6ff54e72743(el)),
    get onClick() {
      return $8tj43$catchify(ev => link_ && router_.navigate_.go_to_({
        new_url_: link_,
        is_replace_: false,
        event_: ev
      }));
    }
  }, link_ && {
    href: link_
  }, {
    get children() {
      return [$8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return !hasLoaded();
        },
        get children() {
          return $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
            width: "100%",
            height: "100%"
          });
        }
      }), $8tj43$createComponent((0, $8tj43$Switch), {
        get children() {
          return [$8tj43$createComponent((0, $8tj43$Match), {
            when: isImage,
            get children() {
              return $8tj43$createComponent((0, $98688279b9059f50$export$140423fa4bfb6d63), {
                size: () => {
                  var _wrapperSize, _wrapperSize$;
                  return ((_wrapperSize = wrapperSize()) === null || _wrapperSize === void 0 ? void 0 : (_wrapperSize$ = _wrapperSize[0]) === null || _wrapperSize$ === void 0 ? void 0 : _wrapperSize$.call(_wrapperSize)) || 0;
                },
                sizeHeight: () => {
                  var _wrapperSize2, _wrapperSize2$;
                  return ((_wrapperSize2 = wrapperSize()) === null || _wrapperSize2 === void 0 ? void 0 : (_wrapperSize2$ = _wrapperSize2[1]) === null || _wrapperSize2$ === void 0 ? void 0 : _wrapperSize2$.call(_wrapperSize2)) || 0;
                },
                src: mediaUrl_,
                "class": "d-standard-content",
                onDecoded: () => setHasLoaded(true),
                ref: el => el.addEventListener("load", $8tj43$catchify(() => setAspectRatio(el.naturalWidth / el.naturalHeight)))
              });
            }
          }), $8tj43$createComponent((0, $8tj43$Match), {
            when: type_ === "video",
            get children() {
              var _el$ = $8tj43$getNextElement($3b772ef9a35560fe$var$_tmpl$);
              var _ref$ = $8tj43$catchify(async element => {
                const pageVisible = $a35e6f680c5bbc60$export$54299a3c81f5425();
                const owner = $8tj43$getOwner();
                const [retryPlayToggle, setRetryPlayToggle] = $8tj43$createSignal(false);
                element.addEventListener("loadedmetadata", $8tj43$catchify(() => setAspectRatio(element.videoWidth / element.videoHeight)));
                // Work around https://github.com/ryansolid/dom-expressions/issues/384
                element.controls = false;
                element.muted = true;
                element.autoplay = true;
                element.playsInline = true;
                element.loop = true;
                // If hls is not supported, dynamically import hls.js as polyfill
                if (mediaUrl_.includes(".m3u8") && !element.canPlayType("application/vnd.apple.mpegurl")) {
                  const hlsJs = await $e92c154db502596d$export$5d2f6cd705125cd3().catch(e => $8tj43$report([e, "Failed to load hls.js"], "error"));
                  if (!hlsJs || !hlsJs.isSupported()) return;
                  const hls = new hlsJs.default();
                  hls.loadSource(mediaUrl_);
                  hls.attachMedia(element);
                }
                // need runWithOwner for createEffect, because we potentially awaited above
                $8tj43$runWithOwner(owner, () => $8tj43$createEffect(() => {
                  retryPlayToggle();
                  if (pageVisible()) element.play().catch(async e => {
                    $8tj43$dlog("Failed to play", e);
                    // If we're not in the DOM yet, wait until we are and then try again
                    if (!document.documentElement.contains(element)) {
                      await (0, $8tj43$observer1).wait_for_element(element);
                      setRetryPlayToggle(prev => !prev);
                    }
                  });else element.pause();
                }));
              });
              typeof _ref$ === "function" && $8tj43$use(_ref$, _el$);
              _el$.addEventListener("playing", () => setHasLoaded(true));
              $8tj43$setAttribute(_el$, "src", mediaUrl_);
              $8tj43$setAttribute(_el$, "disablepictureinpicture", true);
              return _el$;
            }
          })];
        }
      })];
    }
  }));
}
function $12ff24fdc4b26d88$export$7a92d995f1bf3592(history_content_blocks_, plp_meta, content_blocks_by_row_, router_) {
  let hasSeenContentBlock = false;
  const [historyContentBlocks, setHistoryContentBlocks] = history_content_blocks_;
  const contentComponents = new Map();
  $8tj43$createEffect(() => {
    var _plp_meta;
    const serverContentBlock = (_plp_meta = plp_meta()) === null || _plp_meta === void 0 ? void 0 : _plp_meta.content_blocks;
    const currentHistory = $8tj43$untrack(historyContentBlocks);
    // Only write to the history if the content blocks have changed when a new backend results arrives (we have them in history so scroll restoration works when going back, even when running shopify without single page navigations where our script dies inbetween pages).
    if (serverContentBlock && JSON.stringify(serverContentBlock) !== JSON.stringify(currentHistory.blocks)) setHistoryContentBlocks({
      ...currentHistory,
      blocks: serverContentBlock
    });
  });
  const contentBlocksByRow = $8tj43$createMemo(() => {
    const developerProvided = content_blocks_by_row_();
    const {
      blocks: blocksFromHistory
    } = historyContentBlocks();
    // If we didn't get any content blocks (backend always return empty array) and we haven't seen any content blocks yet, return undefined
    // This is so the result rendering (PLPResults) will still use flexbox provided rendering on existing customers, so adding this isn't a breaking change
    // We don't want to switch rendering method every time one switches between a collection that hasn't vs has content blocks though, so once we've seen one content block we'll switch to css-grid-based rendering
    if (!(blocksFromHistory !== null && blocksFromHistory !== void 0 && blocksFromHistory.length) && !hasSeenContentBlock) return developerProvided;
    const content = [...(developerProvided || [])];
    hasSeenContentBlock = true;
    blocksFromHistory.forEach(row => {
      const {
        content: {
          link: link,
          type: type,
          url: url
        }
      } = row;
      // Key the "content"-component by the link, type and url, so we can reuse the component (and later downstream the block elements) if it's the same
      // This makes the block not flicker when going backwards/forwards if the content is the same on both pages
      // Also it lets us rewrite the blocks state in the history based on the block aspect ratio without infinite looping
      const componentCacheKey = JSON.stringify([link, type, url]);
      let component = contentComponents.get(componentCacheKey);
      if (!component) {
        component = () => $8tj43$createComponent((0, $3b772ef9a35560fe$export$780a853d15174484), {
          link_: link,
          type_: type,
          mediaUrl_: url,
          router_: router_,
          aspectRatioWhenAloneInRow_: () => historyContentBlocks().aspectRatios[componentCacheKey],
          setAspectRatioWas_: aspectRatio => setHistoryContentBlocks(prev => ({
            ...prev,
            aspectRatios: {
              ...prev.aspectRatios,
              [componentCacheKey]: Math.round(aspectRatio * 100) / 100
            }
          }))
        });
        contentComponents.set(componentCacheKey, component);
      }
      const contentBlock = {
        span_columns: row.span_columns,
        span_rows: row.span_rows,
        position: row.position,
        content: component
      };
      content[row.row] = contentBlock;
    });
    return content;
  });
  return contentBlocksByRow;
}
function $0728458b46ee9d32$export$a86bc18439445599(plp_products_, _ref, currentlyLoadedDisplays) {
  let [allProductsLoaded] = _ref;
  return $8tj43$createMemo(() => {
    var _plp_products_;
    const backendSays = (_plp_products_ = plp_products_()) === null || _plp_products_ === void 0 ? void 0 : _plp_products_.n_hits;
    const loadedAll = allProductsLoaded();
    if (!backendSays || !loadedAll) return backendSays;
    // People can remove displays in the displayTransformers, for example houdini do it (https://depictaiworkspace.slack.com/archives/C061H2TF7K4/p1713261063439089). Correct the n_hits as well as possible in that case.
    return currentlyLoadedDisplays();
  });
}
var $4b4b262708b516ee$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=product-count><!$><!/> <!$><!/>`),
  $4b4b262708b516ee$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div>`),
  $4b4b262708b516ee$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=filter-results-for-one-row><!$><!/><!$><!/>`),
  $4b4b262708b516ee$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class="depict plp category"><div class=listing-page><!$><!/><!$><!/><!$><!/><!$><!/><!$><!/><!$><!/></div><!$><!/>`);
const $4b4b262708b516ee$var$PLPLayoutContext = /*@__PURE__*/$8tj43$createContext();
function $4b4b262708b516ee$export$f7d2f673fc2f091d(_ref) {
  let {
    depict_api_: depict_api_,
    id_to_query_for_: id_to_query_for_,
    id_type_: id_type_,
    current_sorting_: current_sorting_,
    min_products_to_fetch_: min_products_to_fetch_,
    category_filters_open_: category_filters_open_,
    category_sorting_open_: category_sorting_open_,
    expanded_filters_: expanded_filters_,
    selected_filters_: selected_filters_,
    get_quicklinks_accessor_: get_quicklinks_accessor_,
    i18n_: incoming_i18n,
    get_breadcrumb_accessor_: get_breadcrumb_accessor_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    local_filter_cache_: local_filter_cache_,
    merchant_: merchant_,
    market_: market_,
    router_: router_,
    show_quicklinks_: show_quicklinks_,
    category_title_: category_title_,
    show_breadcrumbs_: show_breadcrumbs_,
    layout_options_: layout_options_,
    scroll_restoration_data_: scroll_restoration_data_,
    history_content_blocks_: history_content_blocks_,
    product_card_template_: product_card_template_,
    sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    content_blocks_by_row_: content_blocks_by_row_,
    filterModalParent_: filterModalParent_,
    showSliderArrow_: showSliderArrow_,
    hideCount0FilterOptions_: hideCount0FilterOptions_
  } = _ref;
  let results_for;
  let only_show_filters_opener_;
  let middle_elements_;
  let on_filters_constructed_;
  const i18n_ = {
    ...incoming_i18n,
    show_n_results_: incoming_i18n.show_n_products_,
    no_results_text_: incoming_i18n.no_products_text_
  };
  const {
    backend_locale_: backend_locale_
  } = i18n_;
  const [get_sorting] = current_sorting_;
  const number_of_rendered_selected_filters_items_ = $8tj43$createSignal(0);
  const first_result_in_viewport_ = $8tj43$createSignal();
  const last_result_in_viewport_ = $8tj43$createSignal();
  const all_products_loaded_ = $8tj43$createSignal(false);
  const [, setAllProductsLoaded] = all_products_loaded_;
  const [currentlyLoadedDisplays, setCurrentlyLoadedDisplays_] = $8tj43$createSignal(0);
  const [can_write_scroll_restoration_, set_can_write_scroll_restoration] = $8tj43$createSignal(false);
  const owner = $8tj43$getOwner();
  const [metaRequestsForQuery, setMetaRequestsForQuery] = $8tj43$createSignal(new Map(), {
    equals: false
  });
  const products_query_base_ = $ec225bf1f1627ea8$export$210f130a61ac1e8d(() => {
    const sort_obj = get_sorting() && {
      ...get_sorting()
    };
    sort_obj === null || sort_obj === void 0 || delete sort_obj.meta;
    const f = selected_filters_[0]();
    return {
      merchant: merchant_(),
      market: market_(),
      locale: backend_locale_(),
      id_to_query_for_: id_to_query_for_(),
      id_type_: id_type_(),
      ...(f.length ? {
        filters: f
      } : {}),
      ...(sort_obj ? {
        sort: sort_obj
      } : {})
    };
  });
  // Make "Get products in listing" request to get products in listing
  const [plp_products_] = $8tj43$createResource(products_query_base_,
  // only first page of results, unless the history state says we should load more (can't do that in load more thing, I tested, they need to be added at once for the browser to not give up scroll restoration)
  $8tj43$catchify(base_query => {
    setAllProductsLoaded(false);
    return $5e6abec0dab4e610$export$cc42dd29bf655ab6({
      id_: $8tj43$untrack(id_to_query_for_),
      scroll_restoration_data_: scroll_restoration_data_,
      min_products_to_fetch_: min_products_to_fetch_,
      make_request_: (limit, cursor) => depict_api_.get_listing_products({
        ...base_query,
        limit: limit,
        ...(cursor ? {
          cursor: cursor
        } : {}),
        // This gets exposed to the products display transformer and gives it information about the listing the products are in
        // It's very hard to implement tracking that uses the collection title without this information
        currentListingForTransformer_: new Promise(resolve => $8tj43$createRoot(dispose => {
          $8tj43$createEffect($8tj43$catchify(() => {
            const key = base_query.id_type_ + base_query.id_to_query_for_;
            const metaResponsePromise = metaRequestsForQuery().get(key);
            if (!metaResponsePromise) return;
            resolve(metaResponsePromise);
            dispose();
            setMetaRequestsForQuery(prev => (prev.delete(key), prev));
          }));
          $8tj43$runWithOwner(owner, () => $8tj43$onCleanup(dispose));
        }))
      })
    });
  }));
  const meta_query_base = $ec225bf1f1627ea8$export$210f130a61ac1e8d(() => ({
    merchant: merchant_(),
    market: market_(),
    locale: backend_locale_(),
    id_to_query_for_: id_to_query_for_(),
    id_type_: id_type_()
  }));
  // Make "Get Listing" request to get quicklinks, breadcrumbs, title, etc
  const [plp_meta] = $8tj43$createResource(meta_query_base, $8tj43$catchify(async query => {
    const result = await depict_api_.get_listing(query);
    // In the following two lines, do not expose the finished breadcrumbs and quicklinks in the products display transformer since it's already exposed in the categories display transformer
    const {
      breadcrumbs: breadcrumbs,
      quick_links: quick_links,
      ...listing
    } = result;
    setMetaRequestsForQuery(prev => prev.set(query.id_type_ + query.id_to_query_for_, listing));
    return result;
  }));
  const contentBlocksByRow = $12ff24fdc4b26d88$export$7a92d995f1bf3592(history_content_blocks_, plp_meta, content_blocks_by_row_, router_);
  const countOfProductsForUI = $0728458b46ee9d32$export$a86bc18439445599(plp_products_, all_products_loaded_, currentlyLoadedDisplays);
  const available_sortings_ = $8tj43$createMemo(() => {
    var _plp_products_, _plp_products_$sorts;
    return (_plp_products_ = plp_products_()) === null || _plp_products_ === void 0 ? void 0 : (_plp_products_$sorts = _plp_products_.sorts) === null || _plp_products_$sorts === void 0 ? void 0 : _plp_products_$sorts.map(sort => {
      var _sort$order;
      return {
        ...sort,
        order: (_sort$order = sort.order) !== null && _sort$order !== void 0 ? _sort$order : "desc"
      };
    });
  });
  const available_filters_ = $8tj43$createMemo(() => {
    var _plp_products_2;
    return (_plp_products_2 = plp_products_()) === null || _plp_products_2 === void 0 ? void 0 : _plp_products_2.filters;
  });
  const title = $8tj43$createMemo(() => {
    var _plp_meta;
    return (_plp_meta = plp_meta()) === null || _plp_meta === void 0 ? void 0 : _plp_meta.title;
  });
  const crumb_data_ = $4b4b262708b516ee$var$add_us_to_crumbs(plp_meta);
  const quicklinks_data_ = $8tj43$createMemo(() => {
    var _plp_meta2;
    return (_plp_meta2 = plp_meta()) === null || _plp_meta2 === void 0 ? void 0 : _plp_meta2.quick_links;
  });
  const [sort_or_filter_open_, set_sort_or_filter_open_] = $8tj43$createSignal(false);
  const [desktop_filter_elements_, set_desktop_filter_elements] = $8tj43$createSignal();
  const formatted_number_of_results_ = $43fbdca0f726a34b$export$92f2da32c6e7e7ee({
    number_: countOfProductsForUI,
    i18n_: i18n_
  });
  const [sort_and_filter_element_, set_sort_and_filter_element_] = $8tj43$createSignal();
  // Sort and filter button
  const [results_filters, set_results_filters] = $8tj43$createSignal();
  // Cloned, invisible sort and filter button used for measuring the minimum size of the buttons if using embedded_num_products
  const [observed_results_filters_elements, set_observed_results_filters_elements_] = $8tj43$createSignal();
  const is_slim_ = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(max-width:600px)");
  // @ts-ignore - there's no type error here when writing the code, but parcel can't generate types that include the symbol, so we need to suppress the error that creates in our pipelines
  const category_title_type = category_title_[(0, $ec8a6e10026dcff9$export$5c28802497c8a83c)];
  const extra_sort_and_filter_args_ = {};
  const ConfiguredScrollStatus_ = function () {
    let extraProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Scroll status failed",
      get children() {
        return $b69740fc6de9f17e$export$83fd5de5504a7a67({
          first_result_in_viewport_: first_result_in_viewport_,
          last_result_in_viewport_: last_result_in_viewport_,
          formatted_number_of_results_: formatted_number_of_results_,
          i18n_: i18n_,
          number_of_results_: countOfProductsForUI,
          ...extraProps
        });
      }
    });
  };
  const make_product_count_ = () => (() => {
    var _el$ = $8tj43$getNextElement($4b4b262708b516ee$var$_tmpl$),
      _el$3 = _el$.firstChild,
      [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling),
      _el$2 = _el$4.nextSibling,
      _el$5 = _el$2.nextSibling,
      [_el$6, _co$2] = $8tj43$getNextMarker(_el$5.nextSibling);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return plp_products_.loading;
      },
      fallback: formatted_number_of_results_,
      get children() {
        return [" ", $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
          height: "1em",
          width: "3ch"
        })];
      }
    }), _el$4, _co$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return countOfProductsForUI() === 1;
      },
      get fallback() {
        return i18n_.products_();
      },
      get children() {
        return i18n_.product_();
      }
    }), _el$6, _co$2);
    return _el$;
  })();
  $3a2bed57c9a57e21$export$d31a1a1a83ad9413(plp_products_, selected_filters_);
  // aiming to have as little unneeded functionality in the bundle as possible, therefore we have two kinds of components that can "plug in" here depending on if there should be a title in the category page along with the count in a row above the buttons on mobile or if it should merge between the buttons when possible
  if (category_title_type === "simple") {
    const CategoryTitleComponent = category_title_;
    results_for = $8tj43$createComponent(CategoryTitleComponent, {
      category_title_: title,
      get product_count_() {
        return make_product_count_();
      }
    });
  } else if (category_title_type == "interactive") {
    ({
      middle_elements_: middle_elements_,
      only_show_filters_opener_: only_show_filters_opener_,
      on_filters_constructed_: on_filters_constructed_
    } = category_title_({
      make_product_count_: make_product_count_,
      is_slim_: is_slim_,
      set_observed_results_filters_elements_: set_observed_results_filters_elements_,
      extra_sort_and_filter_args_: extra_sort_and_filter_args_,
      sort_and_filter_element_: sort_and_filter_element_
    }));
    results_for = make_product_count_();
  } else {
    $8tj43$report(new Error("Unrecognised category_title_type, UI will look messed up"), "error");
    results_for = $8tj43$getNextElement($4b4b262708b516ee$var$_tmpl$2);
  }
  const sort_and_filter_disabled_ = $8tj43$createMemo(() => layout_options_().layout === "slider-without-filters");
  const filters_opener = $7396052a1484264f$export$d7841e452f2e59a8({
    set_sort_or_filter_open_: set_sort_or_filter_open_,
    set_extra_els_in_results_container_: set_desktop_filter_elements,
    i18n_: i18n_,
    search_sorting_open_: category_sorting_open_,
    available_filters_: available_filters_,
    available_sortings_: available_sortings_,
    middle_elements_: middle_elements_,
    search_filters_open_: category_filters_open_,
    set_sort_and_filter_element_: set_sort_and_filter_element_,
    current_sorting_: current_sorting_,
    expanded_filters_: expanded_filters_,
    selected_filters_: selected_filters_,
    formatted_number_of_results_: formatted_number_of_results_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
    sort_and_filter_disabled_: sort_and_filter_disabled_,
    filterModalParent_: filterModalParent_,
    hideCount0FilterOptions_: hideCount0FilterOptions_,
    ...extra_sort_and_filter_args_
  });
  $8tj43$catchify((0, $5e6abec0dab4e610$export$6e49da55e449af7c))({
    scroll_restoration_data_: scroll_restoration_data_,
    last_result_in_viewport_: last_result_in_viewport_,
    id_: id_to_query_for_,
    can_write_scroll_restoration_: can_write_scroll_restoration_
  });
  $8tj43$createEffect(() => {
    var _on_filters_construct;
    if (sort_and_filter_disabled_()) return;
    (_on_filters_construct = on_filters_constructed_) === null || _on_filters_construct === void 0 || _on_filters_construct();
  });
  $8tj43$createComputed(() => {
    if (plp_products_.loading) set_can_write_scroll_restoration(false);else if (plp_products_()) set_can_write_scroll_restoration(true);
  });
  $8tj43$createRenderEffect($8tj43$catchify(async () => {
    var _only_show_filters_op;
    const slim = is_slim_();
    const only_show_filters_opener = (_only_show_filters_op = only_show_filters_opener_) === null || _only_show_filters_op === void 0 ? void 0 : _only_show_filters_op();
    const owner = $8tj43$getOwner();
    await set_results_filters(); // remove elements, wait one microtask for updates to have been committed to the DOM, otherwise we'd try to do illegal DOM operations
    // signals can't be read reactively anymore after the await FYI
    $8tj43$runWithOwner(owner, () => set_results_filters(slim ? only_show_filters_opener ? filters_opener : [results_for, filters_opener] : (() => {
      var _el$8 = $8tj43$getNextElement($4b4b262708b516ee$var$_tmpl$3),
        _el$9 = _el$8.firstChild,
        [_el$10, _co$3] = $8tj43$getNextMarker(_el$9.nextSibling),
        _el$11 = _el$10.nextSibling,
        [_el$12, _co$4] = $8tj43$getNextMarker(_el$11.nextSibling);
      $8tj43$insert(_el$8, results_for, _el$10, _co$3);
      $8tj43$insert(_el$8, filters_opener, _el$12, _co$4);
      return _el$8;
    })()));
  }));
  $9b5022ae72f56399$export$e702733a056c40d6({
    selected_filters_: selected_filters_,
    available_filters_: available_filters_
  });
  $a4777acaffa35a82$export$3945d6db2dfd3d12({
    id_to_query_for_: id_to_query_for_,
    crumb_data_: crumb_data_,
    i18n_: i18n_,
    selected_filters_: selected_filters_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    plp_results_: plp_products_,
    sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
    id_type_: id_type_,
    expanded_filters_: expanded_filters_,
    filters_open_: category_filters_open_
  });
  get_breadcrumb_accessor_ === null || get_breadcrumb_accessor_ === void 0 || get_breadcrumb_accessor_(crumb_data_);
  get_quicklinks_accessor_ === null || get_quicklinks_accessor_ === void 0 || get_quicklinks_accessor_(quicklinks_data_);
  return [(0, $8tj43$isServer) ? "<!-- Category page based on Depict SDK -->" : document.createComment("Category page based on Depict SDK"), (() => {
    var _el$13 = $8tj43$getNextElement($4b4b262708b516ee$var$_tmpl$4),
      _el$14 = _el$13.firstChild,
      _el$15 = _el$14.firstChild,
      [_el$16, _co$5] = $8tj43$getNextMarker(_el$15.nextSibling),
      _el$17 = _el$16.nextSibling,
      [_el$18, _co$6] = $8tj43$getNextMarker(_el$17.nextSibling),
      _el$19 = _el$18.nextSibling,
      [_el$20, _co$7] = $8tj43$getNextMarker(_el$19.nextSibling),
      _el$21 = _el$20.nextSibling,
      [_el$22, _co$8] = $8tj43$getNextMarker(_el$21.nextSibling),
      _el$23 = _el$22.nextSibling,
      [_el$24, _co$9] = $8tj43$getNextMarker(_el$23.nextSibling),
      _el$25 = _el$24.nextSibling,
      [_el$26, _co$10] = $8tj43$getNextMarker(_el$25.nextSibling),
      _el$27 = _el$14.nextSibling,
      [_el$28, _co$11] = $8tj43$getNextMarker(_el$27.nextSibling);
    $8tj43$use(el => process.env.NODE_ENV === "development" && $1145661fd3ca5519$export$7af06a63c5a976c9(el, id_to_query_for_, i18n_), _el$13);
    $8tj43$insert(_el$14, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return show_breadcrumbs_();
      },
      get children() {
        return $8tj43$createComponent((0, $52efc9ae4382e25a$export$5646050d516e06bc), {
          crumb_data_: crumb_data_,
          router_: router_,
          i18n_: i18n_,
          sorting_query_param_: sorting_query_param_,
          filter_query_param_prefix_: filter_query_param_prefix_
        });
      }
    }), _el$16, _co$5);
    $8tj43$insert(_el$14, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return show_quicklinks_();
      },
      get children() {
        return $8tj43$createComponent((0, $43fbb365ed0ac99e$export$466cdc317043f6cb), {
          quicklinks_data_: quicklinks_data_,
          id_to_query_for_: id_to_query_for_,
          id_type_: id_type_,
          router_: router_,
          breadcrumb_data_: crumb_data_,
          i18n_: i18n_,
          sorting_query_param_: sorting_query_param_,
          filter_query_param_prefix_: filter_query_param_prefix_
        });
      }
    }), _el$18, _co$6);
    $8tj43$insert(_el$14, observed_results_filters_elements, _el$20, _co$7);
    $8tj43$insert(_el$14, results_filters, _el$22, _co$8);
    $8tj43$insert(_el$14, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        var _selected_filters_$;
        return (_selected_filters_$ = selected_filters_[0]()) === null || _selected_filters_$ === void 0 ? void 0 : _selected_filters_$.length;
      },
      get children() {
        return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
          severity_: "error",
          message_: "Selected filters failed",
          get children() {
            return $4711a82d08d2021b$export$fecbb157621501bd({
              i18n_: i18n_,
              selected_filters_: selected_filters_,
              local_filter_cache_: local_filter_cache_,
              get_search_filters_open_: category_filters_open_[0],
              get_search_sorting_open_: category_sorting_open_[0],
              number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
              expanded_hierarchical_filters_: expanded_hierarchical_filters_
            });
          }
        });
      }
    }), _el$24, _co$9);
    $8tj43$insert(_el$14, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Showing results failed",
      get children() {
        return $8tj43$createComponent($4b4b262708b516ee$var$PLPLayoutContext.Provider, {
          value: () => layout_options_().layout,
          get children() {
            return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
              get children() {
                return $7faea0096f14b59b$export$3925f87b1545cfc6({
                  min_products_to_fetch_:
                  // if you want to get if all products have been loaded you can add an optional signal here, see SearchPage
                  min_products_to_fetch_,
                  query_base_: products_query_base_,
                  plp_results_: plp_products_,
                  depict_api_: depict_api_,
                  first_result_in_viewport_: first_result_in_viewport_,
                  last_result_in_viewport_: last_result_in_viewport_,
                  scroll_restoration_data_: scroll_restoration_data_,
                  layout_options_: layout_options_,
                  product_card_template_: product_card_template_,
                  sort_or_filter_open_: sort_or_filter_open_,
                  desktop_filter_elements_: desktop_filter_elements_,
                  content_blocks_by_row_: contentBlocksByRow,
                  ConfiguredScrollStatus_: ConfiguredScrollStatus_,
                  id_currently_querying_for_: id_to_query_for_,
                  setCurrentlyLoadedDisplays_: setCurrentlyLoadedDisplays_,
                  showSliderArrow_: showSliderArrow_,
                  all_products_loaded_: all_products_loaded_,
                  no_results_options_: {
                    selected_filters_: selected_filters_,
                    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
                    i18n_: i18n_,
                    local_filter_cache_: local_filter_cache_
                  }
                });
              }
            });
          }
        });
      }
    }), _el$26, _co$10);
    $8tj43$insert(_el$13, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        var _layout_options_$layo;
        return !((_layout_options_$layo = layout_options_().layout) !== null && _layout_options_$layo !== void 0 && _layout_options_$layo.startsWith("slider"));
      },
      get children() {
        return [$8tj43$createComponent(ConfiguredScrollStatus_, {}), $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
          severity_: "error",
          message_: "Floating buttons failed",
          get children() {
            return $6a16b21155984cef$export$b23abd26de154ede({
              search_filters_open_: category_filters_open_,
              search_sorting_open_: category_sorting_open_,
              current_sorting_: current_sorting_,
              sort_and_filter_element_: sort_and_filter_element_,
              i18n_: i18n_
            });
          }
        })];
      }
    }), _el$28, _co$11);
    $8tj43$effect(() => $8tj43$setAttribute(_el$13, "id", (0, $c3820807ac1e6fd7$export$44dad306455dddf).PLP_CATEGORY));
    return _el$13;
  })()];
}
/**
 * Adds the current page as last breadcrumb to the breadcrumb trail
 */
function $4b4b262708b516ee$var$add_us_to_crumbs(plp_meta) {
  const href_accessor = $8tj43$use_href_accessor();
  return $8tj43$createMemo(() => {
    var _plp_meta3, _plp_meta4;
    const api_value = (_plp_meta3 = plp_meta()) === null || _plp_meta3 === void 0 ? void 0 : _plp_meta3.breadcrumbs;
    if (!api_value || ((_plp_meta4 = plp_meta()) === null || _plp_meta4 === void 0 ? void 0 : _plp_meta4.show_in_breadcrumbs) === false) return api_value;
    return [...api_value, $8tj43$mergeProps(plp_meta(), {
      get page_url() {
        return href_accessor();
      }
    })];
  });
}
function $4b4b262708b516ee$export$1d575f423147a8c() {
  return $8tj43$useContext($4b4b262708b516ee$var$PLPLayoutContext);
}

// Value first so shopify merchants can set (extra) display transformers in the shopify app
// Calling these functions normally doesn't do anything, but our shopify app respects them
// Them being here is value first too because this can be easily imported in the product card editor
let $80c7883e020be192$var$extraDisplayTransformers;
const $80c7883e020be192$export$b2d94be4f02525b2 = () => $80c7883e020be192$var$extraDisplayTransformers;
const $80c7883e020be192$export$f98b8d5ea7207a1 = displayTransformers => $80c7883e020be192$var$extraDisplayTransformers = displayTransformers; // These display transformers are "extra" so they don't have to return a page_url, we already do that in the shopify app

let $715f7f2e53146662$var$elementsHoveredSignal;
let $715f7f2e53146662$var$consumersSignal;
function $715f7f2e53146662$export$d4d96868197be50e() {
  if (!$715f7f2e53146662$var$elementsHoveredSignal || !$715f7f2e53146662$var$consumersSignal) $8tj43$createRoot(dispose => {
    $715f7f2e53146662$var$elementsHoveredSignal = $8tj43$createSignal(new Set());
    $715f7f2e53146662$var$consumersSignal = $8tj43$createSignal(0);
    const [consumers] = $715f7f2e53146662$var$consumersSignal;
    // No matter how often useMobileHover is called, only add one listener and get hovered elements once per touchmove event, for efficiency
    $715f7f2e53146662$var$doHeavyCalculations();
    $8tj43$createEffect(() => {
      // No-one needs information anymore, stop listening
      const users = consumers();
      if (users < 1) {
        $8tj43$dlog1("Stopping to listen for mobile hover");
        dispose();
        $715f7f2e53146662$var$elementsHoveredSignal = undefined;
        $715f7f2e53146662$var$consumersSignal = undefined;
      }
    });
  });
  const [elementsHovered] = $715f7f2e53146662$var$elementsHoveredSignal;
  const [, setConsumers] = $715f7f2e53146662$var$consumersSignal;
  setConsumers(prev => prev + 1);
  $8tj43$onCleanup(() => setConsumers(prev => prev - 1));
  return elementsHovered;
}
function $715f7f2e53146662$var$doHeavyCalculations() {
  $8tj43$dlog1("Starting to listen for mobile hover");
  const [, setElementsHovered] = $715f7f2e53146662$var$elementsHoveredSignal;
  const elementAtTouch = new Map();
  const updateSet = () => setElementsHovered(new Set([...elementAtTouch.values()].filter(v => v)));
  const setPositionHandler = $8tj43$catchify(evt => {
    for (const touch of evt.changedTouches) elementAtTouch.set(touch.identifier, document.elementFromPoint(touch.clientX, touch.clientY));
    updateSet();
  });
  const deleteTouchHandler = $8tj43$catchify(evt => {
    for (const touch of evt.changedTouches) elementAtTouch.delete(touch.identifier);
    updateSet();
  });
  addEventListener("touchstart", setPositionHandler, {
    passive: true
  });
  addEventListener("touchend", deleteTouchHandler, {
    passive: true
  });
  addEventListener("touchcancel", deleteTouchHandler, {
    passive: true
  });
  $8tj43$onCleanup(() => {
    removeEventListener("touchstart", setPositionHandler);
    removeEventListener("touchend", deleteTouchHandler);
    removeEventListener("touchcancel", deleteTouchHandler);
  });
}
const $a9c7ba6087881ac2$var$transform_elements = sorted_cols_at_size => {
  const cols_at_size = [];
  for (let i = 0; i < sorted_cols_at_size.length; i++) {
    var _sorted_cols_at_size;
    const [nb_cols, width] = sorted_cols_at_size[i];
    const next_width = (_sorted_cols_at_size = sorted_cols_at_size[i + 1]) === null || _sorted_cols_at_size === void 0 ? void 0 : _sorted_cols_at_size[1];
    const max_width = i === 0 ? "" : "".concat(width, "px");
    const min_width = next_width !== undefined ? "".concat(next_width + 1, "px") : "";
    const col_at_size = [nb_cols, min_width, max_width];
    cols_at_size.push(col_at_size);
  }
  return cols_at_size;
};
const $a9c7ba6087881ac2$export$6daf8749b65a1b77 = cols_at_size => {
  var _cols_at_size$every;
  // Check that every element is an array
  const are_arrays = cols_at_size === null || cols_at_size === void 0 ? void 0 : (_cols_at_size$every = cols_at_size.every) === null || _cols_at_size$every === void 0 ? void 0 : _cols_at_size$every.call(cols_at_size, element => Array.isArray(element));
  if (!are_arrays) throw new Error("Every element in cols_at_size must be an array");
  // Check width duplicates
  const widths = cols_at_size.map(_ref => {
    let [_, width] = _ref;
    return width;
  });
  const widths_set = new Set(widths);
  if (widths_set.size < widths.length) throw new Error("There are duplicate widths in cols_at_size");
  if (cols_at_size.length === 1) {
    const [nb_cols, width] = cols_at_size[0];
    const max_width = width !== undefined ? "".concat(width, "px") : "";
    return [[nb_cols, "", max_width]];
  }
  // Sort widths in ascending order
  const sorted_cols_at_size = [...cols_at_size].sort((a, b) => {
    const [_b, width_A] = a;
    const [_a, width_b] = b;
    if (width_A === undefined) return -1;
    if (width_b === undefined) return 1;
    return width_b - width_A;
  });
  return $a9c7ba6087881ac2$var$transform_elements(sorted_cols_at_size);
};
var $39ddb986053fb759$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<h2 class=recs-title>`);
function $39ddb986053fb759$export$d41d19e89346fa2(_ref) {
  let {
    recommendations_resource_: recommendations_resource_,
    product_card_template_: product_card_template_,
    layout_options_: layout_options_,
    title_: title_,
    NoResultsFallback_: NoResultsFallback_,
    placeholderCacheKey_: placeholderCacheKey_,
    showSliderArrow_: showSliderArrow_
  } = _ref;
  const is_showing_something = $8tj43$createMemo(() => {
    var _recommendations_reso;
    return recommendations_resource_.loading || ((_recommendations_reso = recommendations_resource_()) === null || _recommendations_reso === void 0 ? void 0 : _recommendations_reso.length);
  });
  const title = $8tj43$createMemo(() => title_ === null || title_ === void 0 ? void 0 : title_()); // In case getter/accessor creates elements, don't create them twice
  const num_placeholders_ = () => 20;
  const slider = [$8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return title();
    },
    get children() {
      var _el$ = $8tj43$getNextElement($39ddb986053fb759$var$_tmpl$);
      $8tj43$insert(_el$, title);
      return _el$;
    }
  }), $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
    arrow_height_: 25,
    arrow_width_: 12.5,
    disable_fading_: true,
    get showArrow_() {
      return showSliderArrow_ === null || showSliderArrow_ === void 0 ? void 0 : showSliderArrow_();
    },
    slider_ref_: slider => {
      const {
        insert_here: insert_here,
        container: container
      } = slider;
      const Layout = props => $63f1f8dbcd07d3b0$export$445d8d3f5f706a40(props, insert_here, true);
      // Do like this, so we don't have to call mergeProps ourselves
      $8tj43$createComponent(Layout, $8tj43$mergeProps1({
        rows: "all",
        layout: "slider"
      }, layout_options_));
      $8tj43$slider_fractional_factory(0, 0.75).constructor_plugin.call(slider, {}); // enable fractional scrolling
      insert_here.before($ca55612a53dbbdd2$export$a2cc176055f8f08());
      container.classList.add("products");
    },
    get children() {
      return $8tj43$createComponent((0, $8tj43$Suspense), {
        get fallback() {
          return $bdd80c7862246dc2$export$f33414a4df0afd3f({
            num_placeholders_: num_placeholders_,
            product_card_template_: product_card_template_,
            placeholderCacheKey_: placeholderCacheKey_
          });
        },
        get children() {
          return (() => {
            // IIFE to make sure we access both the recommendations_resource and the resources containing the product card rendering results themselves within the Suspense boundary
            const displays_by_key_ = $2d7bad8684bc7f44$export$7f8bd308237ab5a5($8tj43$createMemo(() => recommendations_resource_() || []));
            const {
              renderedDisplays_: renderedDisplays_
            } = $618bd53ea0a41cd4$export$4a14175d33d81a96({
              displays_by_key_: displays_by_key_,
              product_card_template_: product_card_template_
            });
            return renderedDisplays_;
          })();
        }
      });
    }
  })];
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return is_showing_something();
    },
    get fallback() {
      return NoResultsFallback_ === null || NoResultsFallback_ === void 0 ? void 0 : NoResultsFallback_();
    },
    children: slider
  });
}
function $83e8cf2c0b87a58a$export$23fca46f3143581f(component, error_message) {
  const component_in_error_boundary = do_with_elements => {
    const error_boundary_wrapped = $74777e8fe65b3dcb$export$b69d0d92862de18b({
      severity_: "error",
      message_: error_message,
      get children() {
        const elements = $8tj43$createComponent1(component, {});
        do_with_elements === null || do_with_elements === void 0 || do_with_elements(elements);
        return elements;
      }
    });
    // This might return an accessor, in that case we need to "unwrap" it since our SDK consumers expect HTML elements or arrays thereof
    if (typeof error_boundary_wrapped === "function")
      // @ts-ignore
      return error_boundary_wrapped();
    // On the server it returns a string, so we just return that
    return error_boundary_wrapped;
  };
  const owner = $8tj43$getOwner();
  if (owner == null) return $8tj43$createRoot(dispose => {
    // if we're not already run in a root, create a root and automatically dispose it when the first returned element is removed from the DOM
    return component_in_error_boundary(elements => {
      const have_multiple = Array.isArray(elements);
      if (have_multiple ? !(elements !== null && elements !== void 0 && elements.length) : !elements) return;
      (0, $8tj43$observer).onremoved(have_multiple ? elements[0] : elements, _ref => {
        let {
          element: element
        } = _ref;
        if (document.documentElement.contains(element)) return; // If element has instantly been re-inserted, don't dispose
        // See https://depictaiworkspace.slack.com/archives/C050GHEPBTR/p1695809102791259?thread_ts=1695106805.459729&cid=C050GHEPBTR
        dispose();
      });
    });
  });else
    // we're already in a root so cleanups are handled
    return component_in_error_boundary();
}
var $f84b097e079b0a33$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=img-wrapper>`),
  $f84b097e079b0a33$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span class="d-price original">`),
  $f84b097e079b0a33$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=right-part><div class=text-container><span class="d-title line-clamp"></span><span class=d-price></span><!$><!/></div><!$><!/>`),
  $f84b097e079b0a33$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<a class=look-item><!$><!/><!$><!/>`);
function $f84b097e079b0a33$export$b73ed90f0ee50dc3(_ref) {
  let {
    display_: display_,
    FavoriteButton_: FavoriteButton_,
    userWantsExpandedSignal_: [userWantsExpanded, setUserWantsExpanded],
    textFadeInAnimationRunning_: textFadeInAnimationRunning_,
    outerRef_: outerRef_,
    animationDuration_: animationDuration_,
    priceFormatting_: priceFormatting_,
    pseudoRouter_: pseudoRouter_
  } = _ref;
  const variantToUse = $8tj43$createMemo(() => {
    const display = display_();
    return display === null || display === void 0 ? void 0 : display.variant_displays[display === null || display === void 0 ? void 0 : display.variant_index];
  });
  const imageUrl = $8tj43$createMemo(() => {
    var _variantToUse, _variantToUse$image_u;
    return (_variantToUse = variantToUse()) === null || _variantToUse === void 0 ? void 0 : (_variantToUse$image_u = _variantToUse.image_urls) === null || _variantToUse$image_u === void 0 ? void 0 : _variantToUse$image_u[0];
  });
  const [animationIsRunning, setAnimationIsRunning] = textFadeInAnimationRunning_;
  const [isExpandedThrottledByOurEffectRun, setIsExpandedThrottledByOurEffectRun] = $8tj43$createSignal($8tj43$untrack(userWantsExpanded));
  const [animationEffectExists, setAnimationEffectExists] = $8tj43$createSignal(false);
  const [salePrice] = $8tj43$createResource(() => {
    var _variantToUse2;
    return (_variantToUse2 = variantToUse()) === null || _variantToUse2 === void 0 ? void 0 : _variantToUse2.sale_price;
  });
  const [originalPrice] = $8tj43$createResource(() => {
    var _variantToUse3;
    return (_variantToUse3 = variantToUse()) === null || _variantToUse3 === void 0 ? void 0 : _variantToUse3.original_price;
  });
  const isOnSale = $8tj43$createMemo(() => !salePrice.loading && !originalPrice.loading && salePrice.latest !== originalPrice.latest); // .latest doesn't trigger suspense after the initial load
  const enableLink = $8tj43$createMemo(() => userWantsExpanded() && !animationIsRunning());
  const href = $8tj43$createMemo(() => {
    var _variantToUse4;
    return (_variantToUse4 = variantToUse()) === null || _variantToUse4 === void 0 ? void 0 : _variantToUse4.page_url;
  });
  const FavoriteButton = FavoriteButton_; // Just to get rid of the type error - TS doesn't understand <Show>
  const title = $8tj43$createMemo(() => {
    var _variantToUse5;
    return (_variantToUse5 = variantToUse()) === null || _variantToUse5 === void 0 ? void 0 : _variantToUse5.title;
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($f84b097e079b0a33$var$_tmpl$4),
      _el$12 = _el$.firstChild,
      [_el$13, _co$3] = $8tj43$getNextMarker(_el$12.nextSibling),
      _el$14 = _el$13.nextSibling,
      [_el$15, _co$4] = $8tj43$getNextMarker(_el$14.nextSibling);
    var _ref$ = outerRef_;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$) : outerRef_ = _el$;
    $8tj43$spread(_el$, $8tj43$mergeProps1(() => enableLink() ? {
      href: href()
    } : {}, {
      get onClick() {
        return $8tj43$catchify1(event_ => {
          if (enableLink()) {
            pseudoRouter_.navigate_.go_to_({
              new_url_: href(),
              is_replace_: false,
              event_: event_
            });
            if (!event_.defaultPrevented)
              // If the user opened in a new tab, prevent the event from propagating to the parent which would close the look
              event_.stopImmediatePropagation();
          }
        });
      }
    }), false, true);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      when: imageUrl,
      get fallback() {
        return $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
          aspectRatio: "var(".concat((0, $5eaa00b951637e96$export$8a2234b5b1a5ebd4), ", 0.75)")
        });
      },
      get children() {
        var _el$2 = $8tj43$getNextElement($f84b097e079b0a33$var$_tmpl$);
        $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return imageUrl();
          },
          get fallback() {
            return $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
              aspectRatio: 1
            });
          },
          get children() {
            return $8tj43$createComponent((0, $98688279b9059f50$export$9d4a4b669b1929ab), {
              get src() {
                return imageUrl();
              },
              get aspectRatio() {
                return userWantsExpanded() ? 0.75 : 1;
              },
              get autoAdjustAspectRatio() {
                return userWantsExpanded();
              },
              imgProps: {
                keyRatioUpdating: true
              }
            });
          }
        }));
        return _el$2;
      }
    }), _el$13, _co$3);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return (animationEffectExists() ? isExpandedThrottledByOurEffectRun() : userWantsExpanded()) || animationIsRunning();
      },
      get children() {
        var _el$3 = $8tj43$getNextElement($f84b097e079b0a33$var$_tmpl$3),
          _el$4 = _el$3.firstChild,
          _el$5 = _el$4.firstChild,
          _el$6 = _el$5.nextSibling,
          _el$8 = _el$6.nextSibling,
          [_el$9, _co$] = $8tj43$getNextMarker(_el$8.nextSibling),
          _el$10 = _el$4.nextSibling,
          [_el$11, _co$2] = $8tj43$getNextMarker(_el$10.nextSibling);
        $8tj43$use(element => {
          const owner = $8tj43$getOwner();
          $8tj43$onCleanup((0, $8tj43$observer).onexists(element, _ref2 => {
            let {
              element: element,
              disconnector: disconnector
            } = _ref2;
            const textContainerAnimation = element.animate({
              opacity: [0, 1]
            }, {
              duration: animationDuration_,
              fill: "both",
              easing: "ease-in-out"
            });
            setAnimationIsRunning(true);
            $8tj43$runWithOwner(owner, () => {
              $8tj43$createRenderEffect(() => {
                const expanded = userWantsExpanded();
                // Still glitches in chrome (probably not fixable) and sometimes the timing is off in Safari but fuck it, I couldn't massage the WAAPI to improve it in any way (without reading computed style) to make the reversing of animations glitch less
                textContainerAnimation.pause();
                textContainerAnimation.updatePlaybackRate(expanded ? 1 : -1);
                textContainerAnimation.play();
                // This call would be too late without making the Show only being able to read the updated isExpanded after this effect has ran, so this is why we have isExpandedThrottledByOurEffectRun and animationEffectExists
                setAnimationIsRunning(true);
                setIsExpandedThrottledByOurEffectRun(expanded);
              });
              setAnimationEffectExists(true);
              $8tj43$onCleanup(() => setAnimationEffectExists(false));
            });
            for (const ev of ["cancel", "finish"]) textContainerAnimation.addEventListener(ev, $8tj43$catchify1(() => setAnimationIsRunning(false)));
            disconnector();
          }));
        }, _el$3);
        $8tj43$spread(_el$5, $8tj43$mergeProps1(() => title() && {
          title: title()
        }), false, true);
        $8tj43$insert(_el$5, () => {
          var _title;
          return (_title = title()) !== null && _title !== void 0 ? _title : $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
            height: "1em",
            width: "20ch"
          });
        });
        $8tj43$insert(_el$6, $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return variantToUse() && !salePrice.loading;
          },
          get fallback() {
            return $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
              height: "1em",
              width: "20ch"
            });
          },
          get children() {
            return $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return salePrice.latest;
              },
              get children() {
                return [$8tj43$memo(() => priceFormatting_().pre_), $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
                  get price_() {
                    return salePrice();
                  },
                  get price_formatting_() {
                    return priceFormatting_();
                  }
                }), $8tj43$memo(() => priceFormatting_().post_)];
              }
            });
          }
        }));
        $8tj43$insert(_el$4, $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return isOnSale();
          },
          get children() {
            var _el$7 = $8tj43$getNextElement($f84b097e079b0a33$var$_tmpl$2);
            $8tj43$insert(_el$7, $8tj43$createComponent((0, $8tj43$Show), {
              get when() {
                return variantToUse() && !originalPrice.loading;
              },
              get fallback() {
                return $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
                  height: "1em",
                  width: "20ch"
                });
              },
              get children() {
                return $8tj43$createComponent((0, $8tj43$Show), {
                  get when() {
                    return salePrice.latest;
                  },
                  get children() {
                    return [$8tj43$memo(() => priceFormatting_().pre_), $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
                      get price_() {
                        return originalPrice();
                      },
                      get price_formatting_() {
                        return priceFormatting_();
                      }
                    }), $8tj43$memo(() => priceFormatting_().post_)];
                  }
                });
              }
            }));
            return _el$7;
          }
        }), _el$9, _co$);
        $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Show), {
          when: FavoriteButton_,
          get children() {
            return $8tj43$createComponent(FavoriteButton, {
              display_: display_
            });
          }
        }), _el$11, _co$2);
        $8tj43$effect(() => _el$6.classList.toggle("sale", !!isOnSale()));
        $8tj43$runHydrationEvents();
        return _el$3;
      }
    }), _el$15, _co$4);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $c4103af154850e50$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div style=position:absolute;width:10px;height:10px;overflow:hidden>`);
let $c4103af154850e50$var$cachedValue;
async function $c4103af154850e50$export$7b9a0e99f0aeb2f3() {
  if ($c4103af154850e50$var$cachedValue != undefined) return $c4103af154850e50$var$cachedValue;
  return $c4103af154850e50$var$cachedValue = $c4103af154850e50$var$checkIfIsAffectedByChromeBug326498383();
}
async function $c4103af154850e50$var$checkIfIsAffectedByChromeBug326498383() {
  let isAffected = true;
  let resolveTimeoutPromise;
  try {
    const div = $8tj43$getNextElement($c4103af154850e50$var$_tmpl$);
    const waitAFrame = () => new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
    const timeoutPromise = new Promise(r => {
      resolveTimeoutPromise = r;
      setTimeout($8tj43$catchify1(() => {
        r();
        div.remove();
      }), 500);
    });
    const {
      style: style
    } = div;
    // Just to get a long string
    div.append($c4103af154850e50$export$7b9a0e99f0aeb2f3 + "");
    document.documentElement.append(div);
    style.overflow = "auto";
    await waitAFrame();
    style.overflow = "hidden";
    await waitAFrame();
    div.scrollTo({
      left: 100,
      top: 100,
      behavior: "smooth"
    });
    div.addEventListener("scroll", () => {
      isAffected = false;
      // So the test goes fast on not-affected browsers
      resolveTimeoutPromise();
    },
    // Passive to make it more likely to run the callback before our timeout if the browser is under high load during the test
    {
      once: true,
      passive: false
    });
    await timeoutPromise;
  } catch (e) {
    $8tj43$dlog("Failed to check if affected by chrome bug 326498383", e);
  }
  return isAffected;
}
var $275d06a183ca0a29$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=scroll-padding><div class=look-overlay>`);
function $275d06a183ca0a29$export$ebf0b1d4f90c09ae(_ref) {
  let {
    displays_: displays_,
    FavoriteButton_: FavoriteButton_,
    userWantsExpandedSignal_: userWantsExpandedSignal_,
    containerWidth_: containerWidth_,
    animationDuration_: animationDuration_,
    supportsHover_: supportsHover_,
    priceFormatting_: priceFormatting_,
    pseudoRouter_: pseudoRouter_,
    containerHeight_: containerHeight_
  } = _ref;
  let isAffectedByChromeBug = false;
  // If the user requests the drawer to be expanded or not
  // ResizeObserver value containing the height of the first look item
  const [lookItemHeight, setLookItemHeight] = $8tj43$createSignal(0);
  // The following three signals just contain the state if the animations are actually running and should only be set by the respective animation code
  const textFadeInAnimationRunning = $8tj43$createSignal(false);
  const [getSecondPartAnimationRunning] = textFadeInAnimationRunning;
  const [userWantsExpanded, setUserWantsExpanded] = userWantsExpandedSignal_;
  //const elementsHovered = useMobileHover();
  $c4103af154850e50$export$7b9a0e99f0aeb2f3().then(is => isAffectedByChromeBug = is);
  return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
    get children() {
      return $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return containerWidth_() || !displays_();
        },
        get children() {
          var _el$ = $8tj43$getNextElement($275d06a183ca0a29$var$_tmpl$),
            _el$2 = _el$.firstChild;
          $8tj43$addEventListener(_el$2, "mouseleave", $8tj43$catchify1(() => supportsHover_() && setUserWantsExpanded(false)));
          $8tj43$addEventListener(_el$2, "mouseenter", $8tj43$catchify1(() => {
            var _displays_;
            return ((_displays_ = displays_()) === null || _displays_ === void 0 ? void 0 : _displays_.length) && supportsHover_() && setUserWantsExpanded(true);
          }));
          $8tj43$use(el => {
            $8tj43$createEffect(() => {
              if (userWantsExpanded()) return;
              if (isAffectedByChromeBug) {
                $275d06a183ca0a29$var$scrollingFunctionForChrome(el, 0, animationDuration_);
                return;
              }
              el.scrollTo({
                top: 0,
                behavior: "smooth"
              });
            });
            // createEffect(wasOpenedByHover => {
            //   if (supportsHover_()) return;
            //   const hovered = elementsHovered();
            //   checkHovered: {
            //     if (hovered.has(el)) break checkHovered;
            //     for (const element of hovered) {
            //       if (el.contains(element)) break checkHovered;
            //     }
            //     if (wasOpenedByHover) setUserWantsExpanded(false);
            //     return;
            //   }
            //   setUserWantsExpanded(true);
            //   return true;
            // });
          }, _el$2);
          $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              return displays_() || Array.from({
                length: 4
              });
            },
            children: (display, index) => {
              return $8tj43$createComponent((0, $f84b097e079b0a33$export$b73ed90f0ee50dc3), {
                pseudoRouter_: pseudoRouter_,
                animationDuration_: animationDuration_,
                display_: display,
                FavoriteButton_: FavoriteButton_,
                userWantsExpandedSignal_: userWantsExpandedSignal_,
                textFadeInAnimationRunning_: textFadeInAnimationRunning,
                priceFormatting_: priceFormatting_,
                outerRef_: el => $8tj43$createEffect(() => {
                  if (index !== 0) return;
                  const resizeObserver = new ResizeObserver($8tj43$catchify1(records => setLookItemHeight(records.at(-1).contentRect.height)));
                  resizeObserver.observe(el);
                  $8tj43$onCleanup(() => resizeObserver.disconnect());
                })
              });
            }
          }));
          $8tj43$effect(_p$ => {
            var _v$ = !!userWantsExpanded(),
              _v$2 = !!(!getSecondPartAnimationRunning() && userWantsExpanded()),
              _v$3 = displays_() &&
              // The styling is written like this to eke out animation smoothness on low CPU devices, git blame for previous, more readable versions.
              "--look-card-width:".concat(containerWidth_(), "px;--look-card-height:").concat(containerHeight_(), "px;--look-item-height:").concat(lookItemHeight() || 200, "px");
            _v$ !== _p$.e && _el$2.classList.toggle("expanded", _p$.e = _v$);
            _v$2 !== _p$.t && _el$2.classList.toggle("resting-fully-expanded", _p$.t = _v$2);
            _p$.a = $8tj43$style(_el$2, _v$3, _p$.a);
            return _p$;
          }, {
            e: undefined,
            t: undefined,
            a: undefined
          });
          return _el$;
        }
      });
    }
  });
}
/**
 * Workaround for Chrome bug 326498383, adapted version of https://stackoverflow.com/a/39494245
 */
function $275d06a183ca0a29$var$scrollingFunctionForChrome(element, targetScrollY, duration) {
  let start;
  const startingY = element.scrollTop;
  const diff = targetScrollY - startingY;
  const step = $8tj43$catchify1(timestamp => {
    if (!start) start = timestamp;
    // Elapsed milliseconds since start of scrolling.
    const time = timestamp - start;
    // Get percent of completion in range [0, 1].
    const percent = Math.min(time / duration, 1);
    element.scrollTo(0, startingY + diff * percent);
    // Proceed with animation as long as we wanted it to.
    if (time < duration) requestAnimationFrame(step);
  });
  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  requestAnimationFrame(step);
}
var $22dd375b476673e2$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=look-card><!$><!/><!$><!/>`);
function $22dd375b476673e2$export$44809a8a3e867e30(_ref) {
  let {
    display_: display_,
    expandedLooksSignal_: [expandedLooks_, setExpandedLooks],
    FavoriteButton_: FavoriteButton_,
    placeholderImageAspectRatio_: placeholderImageAspectRatio_,
    animationDuration_: animationDuration_,
    priceFormatting_: priceFormatting_,
    pseudoRouter_: pseudoRouter_
  } = _ref;
  let container;
  const useWantsExpandedSignal_ = $8tj43$createSignal(false);
  const [userWantsExpanded, setUserWantsExpanded] = useWantsExpandedSignal_;
  const supportsHover_ = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(hover: hover) and (pointer: fine)");
  const us = Symbol("look");
  const index = $1e69163caedaab4e$export$e3faf4d95300054f();
  const [containerWidth_, setContainerWidth] = $8tj43$createSignal();
  const [containerHeight_, setContainerHeight] = $8tj43$createSignal();
  const clickHandler = $8tj43$catchify1(_ref2 => {
    let {
      target: target
    } = _ref2;
    if (target !== container && !container.contains(target))
      // When clicking outside the look, close it
      setUserWantsExpanded(false);
  });
  const slidableInformation = $002f09d00aac50b2$export$eaa625fb39439e37();
  addEventListener("click", clickHandler);
  $8tj43$onCleanup(() => removeEventListener("click", clickHandler));
  $8tj43$createEffect(() => setExpandedLooks(prev => {
    if (userWantsExpanded()) {
      // Close the other expanded looks
      prev.clear();
      // Add us
      prev.add(us);
    } else prev.delete(us);
    return prev;
  }));
  $8tj43$createEffect(() => !display_() && setUserWantsExpanded(false));
  if (slidableInformation) {
    const ourVisiblityInSlider = $8tj43$createMemo(() => {
      var _slidableInformation$, _slidableInformation$2;
      const currentCard = index === null || index === void 0 ? void 0 : index();
      if (isNaN(currentCard)) return;
      slidableInformation === null || slidableInformation === void 0 || slidableInformation.intersectionEntries_();
      return slidableInformation === null || slidableInformation === void 0 ? void 0 : (_slidableInformation$ = slidableInformation.slider_.intersecting_items_object) === null || _slidableInformation$ === void 0 ? void 0 : (_slidableInformation$2 = _slidableInformation$[currentCard]) === null || _slidableInformation$2 === void 0 ? void 0 : _slidableInformation$2.intersectionRatio;
    });
    $8tj43$createEffect(prevVisibility => {
      // Have memo -> effect setup for diffing, so we do as little work as possible in unrelated cards
      // as number is safe because undefined and NaN are both not < 0.5
      const visibility = ourVisiblityInSlider();
      if (visibility < 0.9 && (isNaN(prevVisibility) || visibility - prevVisibility < 0))
        // When sliding this card completely into the background, collapse it
        // Don't collapse it if we're about to put it more into visibility, to fix what's described at the end of https://www.loom.com/share/8796209c68764b18a0d565010929f594
        setUserWantsExpanded(false);
      return visibility;
    });
  }
  // Close us if another look expands
  $8tj43$createEffect(() => !expandedLooks_().has(us) && setUserWantsExpanded(false));
  return (() => {
    var _el$ = $8tj43$getNextElement($22dd375b476673e2$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$addEventListener(_el$, "click", $8tj43$catchify1(() => display_() && setUserWantsExpanded(prev => !prev)), true);
    $8tj43$use(el => {
      container = el;
      const ro = new ResizeObserver($8tj43$catchify1(records => {
        const last = records.at(-1);
        if (!last) return;
        const {
          width: width,
          height: height
        } = last.contentRect;
        setContainerWidth(width);
        setContainerHeight(height);
      }));
      ro.observe(el);
      $8tj43$onCleanup(() => ro.disconnect());
    }, _el$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return display_();
      },
      get fallback() {
        return $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
          aspectRatio: "var(".concat((0, $5eaa00b951637e96$export$8a2234b5b1a5ebd4), ", ").concat(placeholderImageAspectRatio_, ")")
        });
      },
      get children() {
        return $8tj43$createComponent((0, $98688279b9059f50$export$9d4a4b669b1929ab), {
          get src() {
            var _display_, _display_$image_urls;
            return (_display_ = display_()) === null || _display_ === void 0 ? void 0 : (_display_$image_urls = _display_.image_urls) === null || _display_$image_urls === void 0 ? void 0 : _display_$image_urls[0];
          },
          aspectRatio: placeholderImageAspectRatio_,
          autoAdjustAspectRatio: true
        });
      }
    }), _el$3, _co$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $275d06a183ca0a29$export$ebf0b1d4f90c09ae), {
      displays_: () => {
        var _display_2;
        return (_display_2 = display_()) === null || _display_2 === void 0 ? void 0 : _display_2.displays;
      },
      userWantsExpandedSignal_: useWantsExpandedSignal_,
      containerWidth_: containerWidth_,
      animationDuration_: animationDuration_,
      supportsHover_: supportsHover_,
      FavoriteButton_: FavoriteButton_,
      priceFormatting_: priceFormatting_,
      pseudoRouter_: pseudoRouter_,
      containerHeight_: containerHeight_
    }), _el$5, _co$2);
    $8tj43$effect(() => _el$.classList.toggle("placeholder", !display_()));
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
$8tj43$delegateEvents(["click"]);
function $ac571292d606f30b$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $ac571292d606f30b$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $ac571292d606f30b$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $ac571292d606f30b$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
var $ac571292d606f30b$var$_throwing_on_navigation = /*#__PURE__*/new WeakSet();
var $ac571292d606f30b$var$_get_navigation_happened_promise = /*#__PURE__*/new WeakSet();
class $ac571292d606f30b$export$7e1297a3a19f10d8 {
  /**
  * Function that will be called when we want to navigate, or a string saying it's not an SPA. You can change this OTG
  */ /**
     * We store listing_id in history.state and do operate on this both here and in js-ui, this is the key to be used which js-ui provides
     */ /**
        * Vue has async router that needs to be awaited (it navigates after a microtask)
        * This standardises waiting for all kinds of routers
        */
  constructor(on_navigation, listing_query_state_key) {
    $ac571292d606f30b$var$_classPrivateMethodInitSpec(this, $ac571292d606f30b$var$_get_navigation_happened_promise);
    $ac571292d606f30b$var$_classPrivateMethodInitSpec(this, $ac571292d606f30b$var$_throwing_on_navigation);
    $8tj43$babelruntimehelpersdefineProperty(this, "on_navigation_", void 0);
    $8tj43$babelruntimehelpersdefineProperty(this, "listing_query_state_key", void 0);
    $8tj43$babelruntimehelpersdefineProperty(this, "navigate_", {
      /**
      * Call this if you *just* want to replace the state object in history.state
      */
      replace_state_: new_state => {
        var _globalThis$history;
        // This doesn't break any router, so we just do this directly for now, since many don't expose an interface for changing the state
        globalThis === null || globalThis === void 0 || (_globalThis$history = globalThis.history) === null || _globalThis$history === void 0 || _globalThis$history.replaceState(new_state, "");
      },
      /**
      * Call this to change the URL
      * @param new_url_ new URL to go to
      * @param event_ event if you have this in a click handler, will not do anything on cmd/ctrl or non-left click then
      * @param force_spa_navigation_ if you want to force SPA navigation even if on_navigation_ is set to "hard_navigation". You should only set this to true for inter-SDK-page navigations
      * @param is_replace_ if you want to replace the current URL in history instead of pushing a new one
      * @param listing_id_ If you are navigating to a category and know the listing_id of, please provide it. This is for making a better devEx in js-ui
      */
      go_to_: $8tj43$catchify1(async _ref => {
        let {
          new_url_: raw_new_url,
          event_: event_,
          force_spa_navigation_: force_spa_navigation_,
          is_replace_: is_replace_,
          listing_query_: listing_query_,
          scroll = true
        } = _ref;
        const new_url_ = raw_new_url instanceof URL ? raw_new_url : new URL(raw_new_url, location.href);
        const wants_hard_navigation = this.on_navigation_ === "hard_navigation";
        if ($9b35d1384e31813a$export$29d28dadc2d6b631(event_)) return;
        const different_origin = new_url_.origin !== location.origin;
        if (wants_hard_navigation && (!force_spa_navigation_ || different_origin)) {
          if (force_spa_navigation_ && different_origin)
            // If we call history.pushState on a different origin, it will throw an error, so fallback to hard navigations
            $8tj43$dwarn("Can't single page navigate to", new_url_.href, "due to different origin, this MIGHT mean you should fix the URLs");
          if (!event_)
            // If we haven't gotten an event, nothing will happen by not calling prevent default, so we need to change the URL
            location.assign(new_url_);
          return;
        }
        event_ === null || event_ === void 0 || event_.preventDefault();
        const promise = $ac571292d606f30b$var$_classPrivateMethodGet(this, $ac571292d606f30b$var$_get_navigation_happened_promise, $ac571292d606f30b$var$_get_navigation_happened_promise2).call(this, true);
        if (force_spa_navigation_ && wants_hard_navigation) {
          // Don't allow hard navigation if we're forcing SPA navigation, which we do for things where PageReplacer can be used for performance
          const new_state = history.state;
          if (listing_query_) {
            // In JS-UI we need to know the listing_id of the current category, therefore push it into state
            if (!this.listing_query_state_key) $8tj43$report1(new Error("listing_query_state_key is not set"), "error");
            new_state[this.listing_query_state_key] = listing_query_;
          }
          history[is_replace_ ? "replaceState" : "pushState"](new_state, "", new_url_);
        } else $ac571292d606f30b$var$_classPrivateMethodGet(this, $ac571292d606f30b$var$_throwing_on_navigation, $ac571292d606f30b$var$_throwing_on_navigation2).call(this, {
          is_replace: is_replace_,
          new_url: new_url_ instanceof URL ? new_url_ : new URL(new_url_, location.href),
          scroll: scroll
        });
        await promise;
      })
    });
    this.listing_query_state_key = listing_query_state_key;
    this.on_navigation_ = on_navigation;
  }
}
function $ac571292d606f30b$var$_throwing_on_navigation2() {
  const {
    on_navigation_: on_navigation_
  } = this;
  if (typeof on_navigation_ !== "function") throw new Error("on_navigation_ is not a function");
  // make sure that we don't accidentally catchify if the SDK consumer has fucked up
  try {
    return on_navigation_(...arguments);
  } catch (e) {
    queueMicrotask(() => {
      throw e;
    });
  }
}
function $ac571292d606f30b$var$_get_navigation_happened_promise2(is_replace) {
  return new Promise(resolve => {
    const handler = what_happened => {
      if (what_happened === (is_replace ? "replaceState" : "pushState")) {
        resolve();
        (0, $8tj43$instant_exec_on_suspect_history_change).delete(handler);
      }
    };
    (0, $8tj43$instant_exec_on_suspect_history_change).add(handler);
  });
}
var $e3efeb558d952696$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button class="show-more major"type=button>`),
  $e3efeb558d952696$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<h2 class=recs-title>`),
  $e3efeb558d952696$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=recommendation-grid><!$><!/><!$><!/>`);
function $e3efeb558d952696$export$7da560f849543dff(_ref) {
  let {
    recommendations_resource_: recommendations_resource_,
    product_card_template_: product_card_template_,
    layout_options_: layout_options_,
    title_: title_,
    max_rows_: max_rows_,
    view_more_button_: view_more_button_,
    NoResultsFallback_: NoResultsFallback_,
    placeholderCacheKey_: placeholderCacheKey_
  } = _ref;
  const rows_object_ = $8tj43$createMemo(() => {
    var _view_more_button$row;
    const view_more_button = view_more_button_ === null || view_more_button_ === void 0 ? void 0 : view_more_button_();
    const max_rows = max_rows_ === null || max_rows_ === void 0 ? void 0 : max_rows_();
    if (!view_more_button) {
      if (max_rows) return {
        max_rows: max_rows
      };
      return "all";
    }
    return {
      max_rows: max_rows,
      start_rows: view_more_button.start_rows,
      rows_per_click: (_view_more_button$row = view_more_button.rows_per_click) !== null && _view_more_button$row !== void 0 ? _view_more_button$row : 2,
      button: (() => {
        var _el$ = $8tj43$getNextElement($e3efeb558d952696$var$_tmpl$);
        $8tj43$insert(_el$, () => view_more_button.text);
        return _el$;
      })()
    };
  });
  const is_showing_something = $8tj43$createMemo(() => {
    var _recommendations_reso;
    return recommendations_resource_.loading || ((_recommendations_reso = recommendations_resource_()) === null || _recommendations_reso === void 0 ? void 0 : _recommendations_reso.length);
  });
  const title = $8tj43$createMemo(() => title_ === null || title_ === void 0 ? void 0 : title_()); // In case getter/accessor creates elements, don't create them twice
  const num_placeholders_ = () => 20;
  const elements = [$8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return title();
    },
    get children() {
      var _el$2 = $8tj43$getNextElement($e3efeb558d952696$var$_tmpl$2);
      $8tj43$insert(_el$2, title);
      return _el$2;
    }
  }), (() => {
    var _el$3 = $8tj43$getNextElement($e3efeb558d952696$var$_tmpl$3),
      _el$4 = _el$3.firstChild,
      [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
      _el$6 = _el$5.nextSibling,
      [_el$7, _co$2] = $8tj43$getNextMarker(_el$6.nextSibling);
    $8tj43$insert(_el$3, (0, $ca55612a53dbbdd2$export$a2cc176055f8f08), _el$5, _co$);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $63f1f8dbcd07d3b0$export$d21e32dfedac04be), $8tj43$mergeProps1({
      get rows() {
        return rows_object_();
      },
      layout: "grid",
      element_attributes: {
        class: "cards"
      }
    }, layout_options_, {
      get children() {
        return $8tj43$createComponent((0, $8tj43$Suspense), {
          get fallback() {
            return $bdd80c7862246dc2$export$f33414a4df0afd3f({
              num_placeholders_: num_placeholders_,
              product_card_template_: product_card_template_,
              placeholderCacheKey_: placeholderCacheKey_
            });
          },
          get children() {
            return (() => {
              // IIFE to make sure we access both the recommendations_resource and the resources containing the product card rendering results themselves within the Suspense boundary
              const displays_by_key_ = $2d7bad8684bc7f44$export$7f8bd308237ab5a5($8tj43$createMemo(() => recommendations_resource_() || []));
              const {
                renderedDisplays_: renderedDisplays_
              } = $618bd53ea0a41cd4$export$4a14175d33d81a96({
                displays_by_key_: displays_by_key_,
                product_card_template_: product_card_template_
              });
              return renderedDisplays_;
            })();
          }
        });
      }
    })), _el$7, _co$2);
    return _el$3;
  })()];
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return is_showing_something();
    },
    get fallback() {
      return NoResultsFallback_ === null || NoResultsFallback_ === void 0 ? void 0 : NoResultsFallback_();
    },
    children: elements
  });
}
var $bb34cd283e904784$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div style=--animation-duration:240ms>`);
let $bb34cd283e904784$var$expandedLooksSignal_;
const $bb34cd283e904784$var$placeholderCacheKey_ = /*@__PURE__*/Symbol("Looks");
function $bb34cd283e904784$export$2c9f9bf2092486aa(props) {
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    $bb34cd283e904784$var$expandedLooksSignal_ || ($bb34cd283e904784$var$expandedLooksSignal_ = $8tj43$createSignal(new Set(), {
      equals: false
    }));
    const expandingAnimationDuration = 240;
    const pseudoRouter = new (0, $ac571292d606f30b$export$7e1297a3a19f10d8)("hard_navigation");
    const grid_spacing_override = $8tj43$createMemo(() => {
      const {
        gridSpacing_: gridSpacing_
      } = props; // can be reactive
      return typeof gridSpacing_ === "string" ? {
        grid_spacing: gridSpacing_
      } : {
        override_vertical_spacing: gridSpacing_.vertical,
        grid_spacing: gridSpacing_.horizontal
      };
    });
    const [looksResource] = $8tj43$createResource(() => [props.productId_, props.merchant_, props.market_, props.locale_], async _ref => {
      var _json, _ref2;
      let [product_id, merchant, market, locale] = _ref;
      const body = {
        merchant: merchant,
        market: market,
        locale: locale,
        product_id: product_id,
        "collection_type": "look"
      };
      const response = await $8tj43$fetch_retry("".concat((0, $8tj43$base_url), "/v3/featured_in"), {
        method: "POST",
        body: JSON.stringify(body)
      });
      const decoded = await (response === null || response === void 0 ? void 0 : (_json = (_ref2 = response).json) === null || _json === void 0 ? void 0 : _json.call(_ref2).catch(() => false));
      if (!decoded)
        // If network fails, make sure to return empty array and SolidRecommendationSlider will remove its elements
        return [];
      const {
        listings: listings
      } = decoded;
      if (!listings)
        // Sometimes backend returns a JSON containing an error instead, bail in that case
        return [];
      const baseData = {
        merchant: merchant,
        market: market,
        locale: locale
      };
      return $bb34cd283e904784$var$runDisplayTransformersForLooks(baseData, listings, props.displayTransformers_);
    });
    const sharedOptions = {
      product_card_template_: display => $22dd375b476673e2$export$44809a8a3e867e30({
        display_: () => display,
        FavoriteButton_: props.FavoriteButton_,
        placeholderImageAspectRatio_: props.imagePlaceholderAspectRatio_,
        animationDuration_: expandingAnimationDuration,
        expandedLooksSignal_: $bb34cd283e904784$var$expandedLooksSignal_,
        priceFormatting_: () => props.priceFormatting_,
        pseudoRouter_: pseudoRouter
      }),
      recommendations_resource_: looksResource,
      title_: () => props.title_,
      layout_options_: $8tj43$createMemo(() => ({
        cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77(props.columnsAtSize_),
        ...grid_spacing_override()
      })),
      NoResultsFallback_: () => props.NoResultsFallback_,
      placeholderCacheKey_: $bb34cd283e904784$var$placeholderCacheKey_
    };
    $8tj43$createEffect(() => {
      const {
        onNavigation_: onNavigation_
      } = props;
      if (onNavigation_) pseudoRouter.on_navigation_ = onNavigation_;
    });
    return (() => {
      var _el$ = $8tj43$getNextElement($bb34cd283e904784$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          return $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return props.gridOptions_;
            },
            get fallback() {
              return $8tj43$createComponent((0, $39ddb986053fb759$export$d41d19e89346fa2), sharedOptions);
            },
            get children() {
              return $8tj43$createComponent((0, $e3efeb558d952696$export$7da560f849543dff), $8tj43$mergeProps1(sharedOptions, {
                view_more_button_: () => {
                  var _props$gridOptions_;
                  return (_props$gridOptions_ = props.gridOptions_) === null || _props$gridOptions_ === void 0 ? void 0 : _props$gridOptions_.view_more_button;
                },
                max_rows_: () => {
                  var _props$gridOptions_2;
                  return (_props$gridOptions_2 = props.gridOptions_) === null || _props$gridOptions_2 === void 0 ? void 0 : _props$gridOptions_2.max_rows;
                }
              }));
            }
          });
        }
      }));
      $8tj43$effect(() => $8tj43$className(_el$, "depict recommendations looks".concat(props.class_ ? " ".concat(props.class_) : "")));
      return _el$;
    })();
  }, "LookSlider failed");
}
async function $bb34cd283e904784$var$runDisplayTransformersForLooks(baseData, listings, displayTransformers) {
  try {
    const {
      products: productTransformer,
      categories: providedListingTransformer
    } = displayTransformers || {};
    if (!productTransformer && !providedListingTransformer) return listings;
    const listingTransformer = providedListingTransformer || (_ref3 => {
      let {
        data: data
      } = _ref3;
      return data;
    });
    const displaysToTransform = [];
    const displayIdsPerListingId = {};
    const transformedListingsPromise = listingTransformer({
      ...baseData,
      data: listings.map(_ref4 => {
        let {
          displays: displays,
          ...listing
        } = _ref4;
        // Populate our displays by id and displayIdToListings object in the .map where we add ancestors to the listings, for peak efficiency
        for (let i = 0; i < displays.length; i++) {
          var _listing$listing_id;
          const display = displays[i];
          const uniqueIdOfDisplay = $6a4c7ed6d005505c$export$548d053aba053d79(display);
          displaysToTransform.push(display);
          (displayIdsPerListingId[_listing$listing_id = listing.listing_id] || (displayIdsPerListingId[_listing$listing_id] = [])).push(uniqueIdOfDisplay);
        }
        return {
          ...listing,
          ancestors: []
        };
      })
    });
    // This allows the person providing the displayTransformer to re-order and remove displays
    const transformedProducts = productTransformer ? await productTransformer({
      ...baseData,
      displays: displaysToTransform
    }) : displaysToTransform;
    const transformedListings = await transformedListingsPromise;
    const transformedDisplayById = Object.fromEntries(transformedProducts.map(display => [$6a4c7ed6d005505c$export$548d053aba053d79(display), display]));
    return transformedListings.map(listing => $8tj43$mergeProps(listing, {
      // use mergeProps because in preview browser we add getters in this object, that would be called too early otherwise
      displays: (displayIdsPerListingId[listing.listing_id] || []).map(displayId => transformedDisplayById[displayId]).filter(v => v)
    }));
  } catch (e) {
    $8tj43$dwarn("Displaytransformers threw", e);
    return [];
  }
}
const $68e6625c8d51f847$export$3064e1e8c6513da3 = new Set();
let $68e6625c8d51f847$var$has_ran = false;
function $68e6625c8d51f847$export$5162a71f252e6122() {
  if ($68e6625c8d51f847$var$has_ran || typeof history !== "object") return;
  $68e6625c8d51f847$var$has_ran = true;
  for (const function_name of ["replaceState", "pushState"]) {
    if (Object.getOwnPropertyNames(history).includes(function_name)) $68e6625c8d51f847$var$proxy_push_state(function_name, history);
    $68e6625c8d51f847$var$proxy_push_state(function_name, History.prototype);
  }
}
function $68e6625c8d51f847$var$proxy_push_state(function_name, thing) {
  thing[function_name] = new Proxy(thing[function_name], {
    apply(target, this_arg, arg_list) {
      try {
        const old_state = history.state;
        if (typeof old_state == "object" && old_state !== null) {
          var _arg_list$;
          // This effectively disallows the user from passing in a string, number, null or undefined
          const intended_new_value_as_obj = typeof arg_list[0] === "object" ? (_arg_list$ = arg_list[0]) !== null && _arg_list$ !== void 0 ? _arg_list$ : {} : {};
          const cloned_object = {
            ...intended_new_value_as_obj
          };
          for (const key in old_state) {
            if (!$68e6625c8d51f847$var$starts_with_any_prefix(key)) continue;
            if (!(key in cloned_object)) cloned_object[key] = old_state[key];
          }
          arg_list[0] = cloned_object;
        }
      } catch (e) {
        $8tj43$report1([e, "Failed to preserve items in history.state"], "error");
      }
      return Reflect.apply(target, this_arg, arg_list);
    }
  });
}
function $68e6625c8d51f847$var$starts_with_any_prefix(key) {
  for (const prefix of $68e6625c8d51f847$export$3064e1e8c6513da3) {
    if (key.startsWith(prefix)) return true;
  }
}

/**
 * Symbol used to identify the version of a SearchModal function. Values right now: 1 = 1st gen classic modal, 2 = second gen modal
 */
const $b026fa9c9c904a98$export$1ea76ea778b880dd = Symbol("modalVersion");
const $b026fa9c9c904a98$export$89890212b43f1b60 = Symbol("backIcon");
function $a604a8ffa4e4c03f$export$e417c49320921907(dependency, fetcher) {
  const [promiseOfCurrentFetcherRun, setPromiseOfCurrentFetcherRun] = $8tj43$createSignal();
  const deparallelizedFetcher = $8tj43$deparallelize_no_drop(async dependencyValue => {
    const promise = fetcher(dependencyValue);
    setPromiseOfCurrentFetcherRun(promise); // give the promise of our actually running fetcher to the resource, so it gets an accurate .loading and return value
    return await promise; // await so that deparallelize knows when we're finished and can "unblock" at the right time
  });
  // We can't use the return value of the deparallelized function in createResource because it leads to getting stale data
  // So instead we just call our deparallelized function when we get new data. When the deparallelized function actually runs it makes the resource think it's working with the work that's being done in the deparallelized function
  const [resource] = $8tj43$createResource(promiseOfCurrentFetcherRun, promise => promise);
  $8tj43$createEffect(() => {
    const dependencyValue = dependency();
    if (!dependencyValue) return; // regular createResource also discards falsey values
    deparallelizedFetcher(dependencyValue);
  });
  return resource;
}

/**
 * Wraps a function in a try/catch block and throws the error globally. If undefined is provided as fn, a no-op is returned.
 * @param fn the function to wrap
 */
function $01c33966d9ddb108$export$f50b88e2a00918b5(fn) {
  return function () {
    if (!fn) return;
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
      return Reflect.apply(fn, this, args);
    } catch (e) {
      queueMicrotask(() => {
        throw e;
      });
    }
  };
}
function $d0883254246d3eb6$export$fb40a80c530e5f2b(selectedIndex, groupIndex, indexInGroup) {
  const isSelected = $8tj43$createMemo(() => {
    const selectedValue = selectedIndex();
    return (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue[0]) === groupIndex() && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue[1]) === indexInGroup();
  });
  const selectedDueToKeyboardNavigation = $8tj43$createMemo(() => {
    var _selectedIndex;
    return !!(isSelected() && (_selectedIndex = selectedIndex()) !== null && _selectedIndex !== void 0 && _selectedIndex[2]);
  });
  return [isSelected, selectedDueToKeyboardNavigation];
}
function $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions, itemIndex, itemsWeAreShowing) {
  const isEmpty = $8tj43$createMemo(() => {
    var _itemsWeAreShowing;
    return !((_itemsWeAreShowing = itemsWeAreShowing()) !== null && _itemsWeAreShowing !== void 0 && _itemsWeAreShowing.length);
  });
  $8tj43$createComputed(() => {
    // If empty, remove us from the currently showing suggestions since I'm not sure the code in autocomplete_keyboard_navigation can handle empty groups
    if (isEmpty()) return;
    $8tj43$createComputed(() => {
      const index = itemIndex();
      set_currently_showing_suggestions(value => {
        value[index] = () => itemsWeAreShowing() || [];
        return value;
      });
      $8tj43$onCleanup(() => set_currently_showing_suggestions(value => {
        delete value[index];
        return value;
      }));
    });
  });
}
function $d0883254246d3eb6$export$12761f53d7ab7f27(element, selectedDueToKeyboardNavigation) {
  $8tj43$createEffect(() => {
    if (selectedDueToKeyboardNavigation()) element.scrollIntoView({
      block: "nearest",
      behavior: "smooth"
    });
  });
}
var $9a693c7e832d3f18$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class="title line-clamp">`),
  $9a693c7e832d3f18$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<span class=brand>`),
  $9a693c7e832d3f18$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class="tagline line-clamp">`),
  $9a693c7e832d3f18$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<span class="orig price"><!$><!/><!$><!/><!$><!/>`),
  $9a693c7e832d3f18$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<span class=price><!$><!/><!$><!/><!$><!/>`),
  $9a693c7e832d3f18$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<a class=instant-card><div class=img-part><!$><!/><!$><!/></div><div class=right-part><!$><!/><div class=price-container><!$><!/><!$><!/>`),
  $9a693c7e832d3f18$var$_tmpl$7 = /*#__PURE__*/$8tj43$template(`<div class=title-brand-tagline>`);
const $9a693c7e832d3f18$export$b05c0ae390cf3e06 = _ref => {
  var _variant$image_urls;
  let {
    display_: display_,
    router_: router_,
    InstantCardImageComponent_: InstantCardImageComponent_,
    i18n_: i18n_,
    keyboardNavigationGroupIndex_: keyboardNavigationGroupIndex_,
    index_: index_,
    selected_index_: selected_index_
  } = _ref;
  // <- SearchModalV2
  const [get_selected_index_, set_selected_index_] = selected_index_ || [];
  const variant = display_.variant_displays[display_.variant_index];
  const href = $8tj43$createMemo(() => variant.page_url); // <- could be made reactive getter in displayTransformers, read it in memo here since it might create computations (for example in the preview-brower), and there's no owner in the onClick handler
  // Prices can be promises, for example in our shopify app. Always assume they are (will work the same when they aren't)
  const [salePrice] = $8tj43$createResource(() => variant.sale_price);
  const [originalPrice] = $8tj43$createResource(() => variant.original_price);
  const isOnSale = $8tj43$createMemo(() => salePrice() !== originalPrice());
  const supports_hover = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(hover: hover) and (pointer: fine)");
  const [isSelected, selectedDueToKeyboardNavigation] = selected_index_ ? $d0883254246d3eb6$export$fb40a80c530e5f2b(get_selected_index_, keyboardNavigationGroupIndex_, index_) : [];
  const secondary_image_url = ((_variant$image_urls = variant.image_urls) === null || _variant$image_urls === void 0 ? void 0 : _variant$image_urls[1]) || variant.secondary_image_url || variant.alternative_display_image_url;
  const brandInTagline = selected_index_ && variant.brand;
  const TitleBrandTagline = () => [!selected_index_ && (() => {
    var _el$2 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$2);
    $8tj43$insert(_el$2, () => variant.brand);
    return _el$2;
  })(), (() => {
    var _el$ = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$);
    $8tj43$insert(_el$, () => variant.title);
    $8tj43$effect(() => $8tj43$setAttribute(_el$, "title", variant.title));
    return _el$;
  })(), $8tj43$memo(() => $8tj43$memo(() => !!(variant.sub_heading_1 || variant.sub_heading_2 || brandInTagline))() && (() => {
    var _el$3 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$3);
    $8tj43$insert(_el$3, () => [brandInTagline, variant.sub_heading_1, variant.sub_heading_2].filter(v => v).join(" | "));
    return _el$3;
  })())];
  return (() => {
    var _el$4 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$6),
      _el$5 = _el$4.firstChild,
      _el$6 = _el$5.firstChild,
      [_el$7, _co$] = $8tj43$getNextMarker(_el$6.nextSibling),
      _el$8 = _el$7.nextSibling,
      [_el$9, _co$2] = $8tj43$getNextMarker(_el$8.nextSibling),
      _el$10 = _el$5.nextSibling,
      _el$30 = _el$10.firstChild,
      [_el$31, _co$11] = $8tj43$getNextMarker(_el$30.nextSibling),
      _el$11 = _el$31.nextSibling,
      _el$26 = _el$11.firstChild,
      [_el$27, _co$9] = $8tj43$getNextMarker(_el$26.nextSibling),
      _el$28 = _el$27.nextSibling,
      [_el$29, _co$10] = $8tj43$getNextMarker(_el$28.nextSibling);
    $8tj43$use(element => $d0883254246d3eb6$export$12761f53d7ab7f27(element, () => {
      var _selectedDueToKeyboar;
      return (_selectedDueToKeyboar = selectedDueToKeyboardNavigation === null || selectedDueToKeyboardNavigation === void 0 ? void 0 : selectedDueToKeyboardNavigation()) !== null && _selectedDueToKeyboar !== void 0 ? _selectedDueToKeyboar : false;
    }), _el$4);
    $8tj43$addEventListener(_el$4, "mouseleave", $8tj43$catchify1(() => set_selected_index_ === null || set_selected_index_ === void 0 ? void 0 : set_selected_index_()));
    $8tj43$addEventListener(_el$4, "mouseenter", $8tj43$catchify1(() => set_selected_index_ === null || set_selected_index_ === void 0 ? void 0 : set_selected_index_([keyboardNavigationGroupIndex_(), index_()])));
    $8tj43$addEventListener(_el$4, "click", $8tj43$catchify1(event_ => router_.navigate_.go_to_({
      new_url_: href(),
      is_replace_: false,
      event_: event_
    })), true);
    $8tj43$insert(_el$5, $8tj43$createComponent(InstantCardImageComponent_, {
      get src_() {
        var _variant$image_urls2;
        return ((_variant$image_urls2 = variant.image_urls) === null || _variant$image_urls2 === void 0 ? void 0 : _variant$image_urls2[0]) || variant.image_url || variant.display_image_url;
      }
    }), _el$7, _co$);
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return selected_index_ && secondary_image_url && supports_hover();
      },
      get children() {
        return $8tj43$createComponent(InstantCardImageComponent_, {
          src_: secondary_image_url,
          class_: "secondary"
        });
      }
    }), _el$9, _co$2);
    $8tj43$insert(_el$10, selected_index_ ? $8tj43$createComponent(TitleBrandTagline, {}) : (() => {
      var _el$32 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$7);
      $8tj43$insert(_el$32, $8tj43$createComponent(TitleBrandTagline, {}));
      return _el$32;
    })(), _el$31, _co$11);
    $8tj43$insert(_el$11, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return isOnSale();
      },
      get children() {
        var _el$12 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$4),
          _el$13 = _el$12.firstChild,
          [_el$14, _co$3] = $8tj43$getNextMarker(_el$13.nextSibling),
          _el$15 = _el$14.nextSibling,
          [_el$16, _co$4] = $8tj43$getNextMarker(_el$15.nextSibling),
          _el$17 = _el$16.nextSibling,
          [_el$18, _co$5] = $8tj43$getNextMarker(_el$17.nextSibling);
        $8tj43$insert(_el$12, () => i18n_.price_formatting_().pre_, _el$14, _co$3);
        $8tj43$insert(_el$12, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
          get price_() {
            return originalPrice();
          },
          get price_formatting_() {
            return i18n_.price_formatting_();
          }
        }), _el$16, _co$4);
        $8tj43$insert(_el$12, () => i18n_.price_formatting_().post_, _el$18, _co$5);
        return _el$12;
      }
    }), _el$27, _co$9);
    $8tj43$insert(_el$11, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !salePrice.loading && salePrice.latest != undefined;
      },
      get fallback() {
        return [$8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
          width: "5ch",
          height: "max(1em, 100%)",
          "class": "price"
        }), "\xa0"];
      },
      get children() {
        var _el$19 = $8tj43$getNextElement($9a693c7e832d3f18$var$_tmpl$5),
          _el$20 = _el$19.firstChild,
          [_el$21, _co$6] = $8tj43$getNextMarker(_el$20.nextSibling),
          _el$22 = _el$21.nextSibling,
          [_el$23, _co$7] = $8tj43$getNextMarker(_el$22.nextSibling),
          _el$24 = _el$23.nextSibling,
          [_el$25, _co$8] = $8tj43$getNextMarker(_el$24.nextSibling);
        $8tj43$insert(_el$19, () => i18n_.price_formatting_().pre_, _el$21, _co$6);
        $8tj43$insert(_el$19, $8tj43$createComponent((0, $60ec7a29849d81db$export$a71e92cfbb498adc), {
          get price_() {
            return salePrice();
          },
          get price_formatting_() {
            return i18n_.price_formatting_();
          }
        }), _el$23, _co$7);
        $8tj43$insert(_el$19, () => i18n_.price_formatting_().post_, _el$25, _co$8);
        $8tj43$effect(() => _el$19.classList.toggle("sales-price", !!isOnSale()));
        return _el$19;
      }
    }), _el$29, _co$10);
    $8tj43$effect(_p$ => {
      var _v$ = href(),
        _v$2 = display_.search_result_id,
        _v$3 = !!(isSelected !== null && isSelected !== void 0 && isSelected()),
        _v$4 = isSelected === null || isSelected === void 0 ? void 0 : isSelected();
      _v$ !== _p$.e && $8tj43$setAttribute(_el$4, "href", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$4, "data-search-result-id", _p$.t = _v$2);
      _v$3 !== _p$.a && _el$4.classList.toggle("selected", _p$.a = _v$3);
      _v$4 !== _p$.o && $8tj43$setAttribute(_el$4, "aria-selected", _p$.o = _v$4);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$4;
  })();
};
$8tj43$delegateEvents(["click"]);
var $f7414b949aeabc90$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=instant-results>`);
function $f7414b949aeabc90$export$62f101a8aa597bf8(_ref) {
  let {
    depict_api_: depict_api_,
    search_field_value_: [get_search_field_value],
    merchant_: merchant_,
    market_: market_,
    min_products_to_fetch_: min_products_to_fetch_,
    has_sort_or_filters_: has_sort_or_filters_,
    i18n_: i18n_,
    router_: router_,
    set_modal_search_results_: set_modal_search_results_,
    InstantCardImageComponent_: InstantCardImageComponent_,
    itemIndex_: itemIndex_,
    selected_index_: selected_index_,
    currently_showing_suggestions_: currently_showing_suggestions_
  } = _ref;
  const max_cards = itemIndex_ ? 5 : 4;
  const [read_current_instant_query, write_current_instant_query] = $8tj43$createSignal("");
  let timeout;
  $8tj43$createComputed(() => {
    const value = get_search_field_value();
    if (timeout == null)
      // don't wait if it's the first request
      write_current_instant_query(value);
    clearTimeout(timeout);
    timeout = setTimeout($8tj43$catchify1(() => write_current_instant_query(value)), 250);
  });
  const [search_results] = $8tj43$createResource($8tj43$createMemo(() => ({
    // <-- key order important, see comment below
    merchant: merchant_(),
    market: market_(),
    locale: i18n_.backend_locale_(),
    query: read_current_instant_query()
  })), $8tj43$catchify1(async variable_data => {
    return depict_api_.query({
      // here it is (unfortunately) important that the keys in the object are in the same order as in SearchPage.tsx, because when JSON-encoding them to compare for caching the strings will be different otherwise
      limit: $8tj43$untrack(has_sort_or_filters_) ? max_cards : min_products_to_fetch_,
      // if there's no sorting or filters we can fetch min_products_to_fetch_ many since then the cached request can be re-used by the search page, otherwise, no reason to waste bytes
      ...variable_data
    });
  }));
  const sliced_displays = $8tj43$createMemo(() => {
    var _search_results, _search_results$displ;
    return (_search_results = search_results()) === null || _search_results === void 0 ? void 0 : (_search_results$displ = _search_results.displays) === null || _search_results$displ === void 0 ? void 0 : _search_results$displ.slice(0, max_cards);
  });
  const displays_by_key_ = $2d7bad8684bc7f44$export$7f8bd308237ab5a5(() => sliced_displays() || []);
  // Maybe we should move this createResource out of this component, on the other hand it bloats the parent component and if it fails it takes more than needed with it, so I think writing the content results from here is better
  // This is for the press-enter-to-instant-content-result feature which gets called from Autocomplete.tsx/TextSuggestions.tsx
  set_modal_search_results_(() => search_results);
  $8tj43$onCleanup(() => set_modal_search_results_(undefined)); // for consistency, in case this component crashes
  if (itemIndex_) {
    const [, set_currently_showing_suggestions] = currently_showing_suggestions_;
    $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions, itemIndex_, $8tj43$createMemo(() => {
      var _sliced_displays;
      return ((_sliced_displays = sliced_displays()) === null || _sliced_displays === void 0 ? void 0 : _sliced_displays.map(display => {
        const variant = display.variant_displays[display.variant_index];
        return {
          title_: variant.title,
          page_url_: variant.page_url
        };
      })) || [];
    }));
  }
  let placeholder;
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _sliced_displays2;
      return ((_sliced_displays2 = sliced_displays()) === null || _sliced_displays2 === void 0 ? void 0 : _sliced_displays2.length) !== 0;
    },
    get children() {
      var _el$ = $8tj43$getNextElement($f7414b949aeabc90$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          var _sliced_displays3;
          return (_sliced_displays3 = sliced_displays()) === null || _sliced_displays3 === void 0 ? void 0 : _sliced_displays3.length;
        },
        get fallback() {
          return $8tj43$createMemo(() => {
            var _search_results2;
            if (Array.isArray((_search_results2 = search_results()) === null || _search_results2 === void 0 ? void 0 : _search_results2.displays))
              // remove placeholders if we have a response but no results
              return undefined;
            return new Array(max_cards).fill(1).map(() => (placeholder || (placeholder = $5eaa00b951637e96$export$ee1733d9a8495996())).cloneNode(true));
          })();
        },
        get children() {
          return (() => {
            return $2d7bad8684bc7f44$export$43f0fb951fcb0c54({
              displays_by_key_: displays_by_key_,
              product_card_template_: (display, info) => {
                const [index, setIndex] = $8tj43$createSignal(0);
                info.set_on_index_change(newIndex => setIndex(newIndex));
                return $8tj43$createComponent((0, $9a693c7e832d3f18$export$b05c0ae390cf3e06), {
                  display_: display,
                  i18n_: i18n_,
                  router_: router_,
                  InstantCardImageComponent_: InstantCardImageComponent_,
                  index_: index,
                  keyboardNavigationGroupIndex_: itemIndex_,
                  selected_index_: selected_index_
                });
              }
            });
          })();
        }
      }));
      $8tj43$effect(_$p => $8tj43$style(_el$, itemIndex_ && {
        order: itemIndex_()
      }, _$p));
      return _el$;
    }
  });
}
let $9974e016866745eb$var$last_sent_value;
function $9974e016866745eb$export$c7e181728ad525f(url) {
  // @ts-ignore
  if (typeof ga !== "function" || process.env.GA === "false") return;
  const new_value = url.pathname + url.search + url.hash;
  if ($9974e016866745eb$var$last_sent_value === new_value)
    // don't send the same event twice in a row
    return;
  $9974e016866745eb$var$last_sent_value = new_value;
  const args = ["depict.send", "pageview", new_value];
  $8tj43$dlog("Calling ga with args", ...args);
  // @ts-ignore
  ga(...args);
}
function $a09bb7c652acf957$export$3340fdd8259bd4fd(_ref) {
  let {
    get_search_field_value_: get_search_field_value_,
    search_query_url_param_name_: search_query_url_param_name_,
    url_transformer_: url_transformer_,
    get_search_query_: get_search_query_
  } = _ref;
  // @ts-ignore
  if (process.env.GA === "false") return;
  let debounce_timeout;
  const stop_timeout = () => clearTimeout(debounce_timeout);
  const send_to_ga = $8tj43$catchify1(() => {
    const fake_url = new URL(location.href);
    const {
      searchParams: searchParams
    } = fake_url;
    searchParams.set(search_query_url_param_name_, $8tj43$untrack(get_search_field_value_));
    searchParams.set("instant_result", "true");
    url_transformer_ === null || url_transformer_ === void 0 || url_transformer_(fake_url);
    $9974e016866745eb$export$c7e181728ad525f(fake_url);
  });
  $8tj43$onCleanup(() => {
    setTimeout(
    // do it next event loop because search_field_value_ is wrong this one and search_query might be too because we want the old value to be put into the history entry and a framework like NextJS might take some time to navigate
    $8tj43$catchify1(() => {
      if ($8tj43$untrack(get_search_query_) === $8tj43$untrack(get_search_field_value_)) stop_timeout();
    }));
  });
  let first_call = true;
  $8tj43$createEffect($8tj43$catchify1(() => {
    get_search_field_value_();
    if (first_call) {
      // we only want to do stuff when it changes
      first_call = false;
      return;
    }
    stop_timeout();
    debounce_timeout = setTimeout(send_to_ga, 2000);
  }));
}
var $558d0596fcf0e0b0$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div style=position:absolute;z-index:-1;pointer-events:none;width:100%;height:200%;top:-100%;>`),
  $558d0596fcf0e0b0$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div style=position:absolute;z-index:-1;pointer-events:none;width:100%;height:200%;>`);
function $558d0596fcf0e0b0$export$50b90be27d8502d9(el, _ref, bottom_distance) {
  let [get_style_props, set_style_props] = _ref;
  const overflow_style_beginning = "position:absolute;z-index:-1;pointer-events:none;width:100%;height:200%;";
  const upper_overflowing_box = $8tj43$getNextElement($558d0596fcf0e0b0$var$_tmpl$);
  const lower_overflowing_box = $8tj43$getNextElement($558d0596fcf0e0b0$var$_tmpl$2);
  const do_positioning = () => {
    var _ref2;
    const windowHeight = innerHeight;
    const new_value = "".concat(windowHeight - el.parentElement.getBoundingClientRect().top - windowHeight * ((_ref2 = bottom_distance ? $8tj43$untrack(bottom_distance) : undefined) !== null && _ref2 !== void 0 ? _ref2 : 0.1), "px");
    const key = "max-height";
    const old_value = $8tj43$untrack(get_style_props);
    if (old_value[key] !== new_value) set_style_props({
      ...old_value,
      [key]: new_value
    });
  };
  const is = new IntersectionObserver($8tj43$catchify1(_records => {
    do_positioning();
  }), {
    threshold: $8tj43$buildThresholdList(100)
  });
  is.observe(upper_overflowing_box);
  is.observe(lower_overflowing_box);
  $8tj43$onCleanup(() => is.disconnect());
  el.after(upper_overflowing_box, lower_overflowing_box);
  if (bottom_distance) $8tj43$createEffect($8tj43$on(bottom_distance, do_positioning, {
    defer: true
  }));
}
function $e8776b492383c292$export$91c3b6774e8be0f5(_ref) {
  let {
    param_: param_,
    value_: value_,
    url_transformer_: url_transformer_
  } = _ref;
  const [get_current_href, set_current_href] = $8tj43$createSignal(location.href);
  const [exit_iterable, exitable_iterable] = $8tj43$make_asyncIterable_exiter((0, $8tj43$href_change_ipns));
  $8tj43$onCleanup(exit_iterable);
  $8tj43$catchify1(async () => {
    for await (const href of exitable_iterable)
    // use native links so ppl can cmdclick/right click and open in new tab and see target URL
    set_current_href(href);
  })();
  return $8tj43$createMemo(() => {
    const u_o = new URL(get_current_href());
    url_transformer_ === null || url_transformer_ === void 0 || url_transformer_(u_o);
    u_o.searchParams.set(param_, value_());
    return u_o.href;
  });
}
var $6d95ef50ee01d5a1$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=12 height=13><path d="M6 12.598a5.88 5.88 0 0 1-1.611-.223c-.52-.145-1.008-.352-1.465-.621s-.875-.605-1.254-.996-.693-.83-.955-1.318c-.039-.07-.047-.145-.023-.223s.072-.143.146-.182.145-.047.223-.023.143.072.182.146a5.54 5.54 0 0 0 .861 1.184c.34.352.715.65 1.125.897s.85.435 1.318.568A5.5 5.5 0 0 0 6 12a5.24 5.24 0 0 0 2.098-.422c.656-.285 1.229-.672 1.717-1.16s.879-1.061 1.16-1.717a5.22 5.22 0 0 0 .428-2.104c0-.742-.143-1.441-.428-2.098s-.668-1.229-1.16-1.717a5.42 5.42 0 0 0-1.717-1.154A5.18 5.18 0 0 0 6 1.201c-.496 0-.979.066-1.447.199s-.904.316-1.318.563-.785.539-1.125.891a5.31 5.31 0 0 0-.855 1.172.32.32 0 0 1-.164.141c-.066.023-.135.023-.205 0a.3.3 0 0 1-.158-.135C.691 3.965.682 3.895.697 3.82l.51-2.385c.016-.078.059-.141.129-.187a.28.28 0 0 1 .229-.041c.078.016.141.059.188.129a.28.28 0 0 1 .041.229l-.211.973a5.91 5.91 0 0 1 .926-.814 5.78 5.78 0 0 1 1.066-.609A5.79 5.79 0 0 1 4.746.732C5.156.643 5.574.598 6 .598c.402 0 .795.039 1.178.117s.76.191 1.119.34a5.95 5.95 0 0 1 1.031.551c.328.219.633.469.914.75s.535.592.75.92a5.77 5.77 0 0 1 .551 1.025 5.53 5.53 0 0 1 .34 1.119c.078.387.117.779.117 1.178s-.039.797-.117 1.184-.187.754-.34 1.113a5.96 5.96 0 0 1-.551 1.031 5.56 5.56 0 0 1-.75.914c-.281.285-.586.537-.914.756a5.95 5.95 0 0 1-1.031.551c-.359.148-.732.26-1.119.334s-.775.117-1.178.117zm0-5.695c-.023 0-.049-.004-.076-.012s-.047-.018-.07-.029l-2.701-1.5c-.07-.039-.117-.098-.141-.176a.29.29 0 0 1 .023-.229c.043-.074.104-.123.182-.146s.158-.014.229.029l2.543 1.412 3.152-2.004c.07-.047.145-.061.223-.041a.29.29 0 0 1 .188.135c.047.066.061.141.041.223a.27.27 0 0 1-.129.188L6.158 6.855a.27.27 0 0 1-.076.035c-.027.008-.055.012-.082.012z"fill=#0f0f0f>`);
function $6d95ef50ee01d5a1$export$5d2caaa6b530761c() {
  return $8tj43$getNextElement($6d95ef50ee01d5a1$var$_tmpl$);
}
var $01dd2bfbbae020bc$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=previous-searches><h2 class=text></h2><div class=list>`),
  $01dd2bfbbae020bc$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<a class=item><div class=left><!$><!/><span class=line-clamp></span></div><button class=delete>`);
function $01dd2bfbbae020bc$export$a146ac6fa8346a25(_ref) {
  let {
    text_: text_,
    previous_searches_: previous_searches_,
    search_query_param_name_: search_query_param_name_,
    currently_showing_suggestions_: [, set_currently_showing_suggestions_],
    set_unfiltered_previous_searches_: set_unfiltered_previous_searches_,
    selected_index_: [read_selected_index_, write_selected_index_],
    url_transformer_: url_transformer_,
    i18n_: i18n_,
    submit_query_: submit_query_
  } = _ref;
  const has_entries = $8tj43$createMemo(() => previous_searches_().length >= 1);
  $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions_, () => 0, $8tj43$createMemo(() => previous_searches_().map(item => ({
    title_: item
  }))));
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return has_entries();
    },
    get children() {
      var _el$ = $8tj43$getNextElement($01dd2bfbbae020bc$var$_tmpl$),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.nextSibling;
      $8tj43$insert(_el$2, text_);
      $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Index), {
        get each() {
          return previous_searches_();
        },
        children: (item, index) => {
          const href = $e8776b492383c292$export$91c3b6774e8be0f5({
            param_: search_query_param_name_,
            value_: item,
            url_transformer_: url_transformer_
          });
          return (() => {
            var _el$4 = $8tj43$getNextElement($01dd2bfbbae020bc$var$_tmpl$2),
              _el$5 = _el$4.firstChild,
              _el$7 = _el$5.firstChild,
              [_el$8, _co$] = $8tj43$getNextMarker(_el$7.nextSibling),
              _el$6 = _el$8.nextSibling,
              _el$9 = _el$5.nextSibling;
            $8tj43$use(element => element.addEventListener(
            // Viskan's Oscar Jacobson site requires us to add the event listener normally here. They do too much when this element is clicked. We work around it by blocking the event and just dispatching it non-bubbling on this element.
            "click", $8tj43$catchify1(ev => {
              if ($9b35d1384e31813a$export$29d28dadc2d6b631(ev))
                // not button 0 or cmd/ctrl click
                return;
              ev.preventDefault();
              submit_query_(item());
            })), _el$4);
            $8tj43$addEventListener(_el$4, "mouseleave", $8tj43$catchify1(() => write_selected_index_()));
            $8tj43$addEventListener(_el$4, "mouseenter", $8tj43$catchify1(() => write_selected_index_([0, index])));
            $8tj43$insert(_el$5, $8tj43$createComponent((0, $6d95ef50ee01d5a1$export$5d2caaa6b530761c), {}), _el$8, _co$);
            $8tj43$insert(_el$6, item);
            $8tj43$use(element => element.addEventListener("click", $8tj43$catchify1(e => {
              // Viskan's Oscar Jacobson site requires us to add the event listener normally here. They do too much when this element is clicked. We work around it by blocking the event and just dispatching it non-bubbling on this element.
              set_unfiltered_previous_searches_(prev => {
                const new_value = [...prev];
                const index = new_value.indexOf(item());
                if (index < 0)
                  // should never happen but what do I know
                  return prev;
                new_value.splice(index, 1);
                return new_value;
              });
              e.stopPropagation();
              e.preventDefault();
            })), _el$9);
            $8tj43$insert(_el$9, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}));
            $8tj43$effect(_p$ => {
              var _v$ = !!$8tj43$createMemo(() => {
                  var _read_selected_index_, _read_selected_index_2;
                  return ((_read_selected_index_ = read_selected_index_()) === null || _read_selected_index_ === void 0 ? void 0 : _read_selected_index_[0]) === 0 && ((_read_selected_index_2 = read_selected_index_()) === null || _read_selected_index_2 === void 0 ? void 0 : _read_selected_index_2[1]) === index;
                })(),
                _v$2 = href(),
                _v$3 = item(),
                _v$4 = i18n_.previous_searches_delete_entry_from_history_();
              _v$ !== _p$.e && _el$4.classList.toggle("selected", _p$.e = _v$);
              _v$2 !== _p$.t && $8tj43$setAttribute(_el$4, "href", _p$.t = _v$2);
              _v$3 !== _p$.a && $8tj43$setAttribute(_el$6, "title", _p$.a = _v$3);
              _v$4 !== _p$.o && $8tj43$setAttribute(_el$9, "title", _p$.o = _v$4);
              return _p$;
            }, {
              e: undefined,
              t: undefined,
              a: undefined,
              o: undefined
            });
            return _el$4;
          })();
        }
      }));
      return _el$;
    }
  });
}
var $3c5e15c6ee4227a9$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=32 height=32 viewBox="0 0 256 256"><path d="M56 26.455a13.71 13.71 0 0 0-9.578 3.967A13.71 13.71 0 0 0 42.455 40v176a13.71 13.71 0 0 0 3.967 9.578A13.71 13.71 0 0 0 56 229.545h144A13.71 13.71 0 0 0 213.545 216V88a2.456 2.456 0 0 1 0-.002c.001-1.452-.597-2.895-1.623-3.922l-55.998-55.998a5.61 5.61 0 0 0-3.922-1.623 2.456 2.456 0 0 1-.002 0zm0 11.09h88A2.456 2.456 0 0 1 146.455 40v48c0 2.903 2.642 5.545 5.545 5.545h48A2.456 2.456 0 0 1 202.455 96v120a2.456 2.456 0 0 1-2.455 2.455H56A2.456 2.456 0 0 1 53.545 216V40A2.456 2.456 0 0 1 56 37.545zm103.061 11.498a2.456 2.456 0 0 1 2.676.531l28.689 28.689a2.456 2.456 0 0 1-1.736 4.191H160A2.456 2.456 0 0 1 157.545 80V51.311a2.456 2.456 0 0 1 1.516-2.268zM96 130.455c-2.903 0-5.545 2.642-5.545 5.545s2.642 5.545 5.545 5.545h64c2.903 0 5.545-2.642 5.545-5.545s-2.642-5.545-5.545-5.545zm0 32c-2.903 0-5.545 2.642-5.545 5.545s2.642 5.545 5.545 5.545h64c2.903 0 5.545-2.642 5.545-5.545s-2.642-5.545-5.545-5.545z">`);
function $3c5e15c6ee4227a9$export$605674723bcc715c() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($3c5e15c6ee4227a9$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $b055f9e9aeceeb48$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a class=suggestion>`),
  $b055f9e9aeceeb48$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=search-icon>`),
  $b055f9e9aeceeb48$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<span class=type>`),
  $b055f9e9aeceeb48$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class=with-parent-title><!$><!/><span class="value line-clamp">`),
  $b055f9e9aeceeb48$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<div class=with-icon><!$><!/><!$><!/>`),
  $b055f9e9aeceeb48$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<h2 class=text>`),
  $b055f9e9aeceeb48$var$_tmpl$7 = /*#__PURE__*/$8tj43$template(`<div class="suggestion-container query"><!$><!/><!$><!/>`),
  $b055f9e9aeceeb48$var$_tmpl$8 = /*#__PURE__*/$8tj43$template(`<div class="suggestion-container page">`),
  $b055f9e9aeceeb48$var$_tmpl$9 = /*#__PURE__*/$8tj43$template(`<div class=suggestions><!$><!/><!$><!/><!$><!/>`);
function $b055f9e9aeceeb48$export$e872e2339fb04a7f(_ref) {
  let {
    suggestion_memo_: suggestion_memo_,
    search_query_url_param_name_: search_query_url_param_name_,
    selected_index_: [read_selected_index_, write_selected_index_],
    url_transformer_: url_transformer_,
    filtered_previous_searches_: filtered_previous_searches_,
    currently_showing_suggestions_: [, set_currently_showing_suggestions_],
    on_previous_searches_page_: on_previous_searches_page_,
    i18n_: i18n_,
    include_category_suggestions_: include_category_suggestions_,
    searching_for_value_: searching_for_value_,
    router_: router_,
    submit_query_: submit_query_,
    get_content_results_: get_content_results_
  } = _ref;
  const queries_memo = $8tj43$createMemo(() => suggestion_memo_().filter(suggestion => suggestion.type === (0, $a5541dc94070b75b$export$3cf9497e790da491) && !filtered_previous_searches_().includes(suggestion.query) // don't show the ones we already show from the history
  ) // + limit to three query suggestions, API sends more sometimes
  .slice(0, 3));
  const not_queries_memo = $8tj43$createMemo(() => {
    // For the section that shows categories and content results
    // We want to limit to 3 items, and we want to show the categories first
    const content_results = get_content_results_() || [];
    const from_suggest_request = include_category_suggestions_ ? suggestion_memo_().filter(_ref2 => {
      let {
        type: type
      } = _ref2;
      return type !== (0, $a5541dc94070b75b$export$3cf9497e790da491);
    }) : [];
    return [...from_suggest_request.slice(0, content_results.length ? 2 : 3), ...content_results.slice(0, 1)];
  });
  const render_entry = function (input_obj, autocomplete_data_index, index) {
    let is_history = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const is_query = $8tj43$createMemo(() => input_obj().type === (0, $a5541dc94070b75b$export$3cf9497e790da491));
    const href_with_changed_params_accessor = $8tj43$createMemo(() => is_query() ? $e8776b492383c292$export$91c3b6774e8be0f5({
      param_: search_query_url_param_name_,
      value_: $8tj43$createMemo(() => input_obj().query),
      url_transformer_: url_transformer_
    }) : undefined);
    const href = $8tj43$createMemo(() => is_query() ? href_with_changed_params_accessor()() : input_obj().page_url);
    const [is_selected] = $d0883254246d3eb6$export$fb40a80c530e5f2b(read_selected_index_, () => autocomplete_data_index, () => index);
    const parent_title_if_exists = $8tj43$createMemo(() => {
      var _item$ancestors$at;
      const item = input_obj();
      if (!("ancestors" in item)) return;
      return (_item$ancestors$at = item.ancestors.at(-1)) === null || _item$ancestors$at === void 0 ? void 0 : _item$ancestors$at.title;
    });
    return (() => {
      var _el$ = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$);
      $8tj43$use(element => element.addEventListener("click", $8tj43$catchify1(ev => {
        // Viskan's Oscar Jacobson site requires us to add the event listener normally here. They do too much when this element is clicked. We work around it by blocking the event and just dispatching it non-bubbling on this element.
        if (is_query()) {
          if ($9b35d1384e31813a$export$29d28dadc2d6b631(ev))
            // not button 0 or cmd/ctrl click
            return;
          const input = input_obj();
          ev.preventDefault();
          submit_query_(is_query() ? input.query : input.title);
          return;
        }
        router_.navigate_.go_to_({
          new_url_: href(),
          is_replace_: false,
          event_: ev
        });
      })), _el$);
      $8tj43$addEventListener(_el$, "mouseleave", $8tj43$catchify1(() => write_selected_index_(undefined)));
      $8tj43$addEventListener(_el$, "mouseenter", $8tj43$catchify1(() => write_selected_index_([autocomplete_data_index, index])));
      $8tj43$insert(_el$, (() => {
        var _c$ = $8tj43$memo(() => !!is_query());
        return () => _c$() ? [$8tj43$createComponent((0, $8tj43$Show), {
          when: is_history,
          get fallback() {
            return (() => {
              var _el$2 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$2);
              $8tj43$insert(_el$2, $8tj43$createComponent((0, $ef0f18a578b32578$export$82eafebb825fc23f), {}));
              return _el$2;
            })();
          },
          get children() {
            return $8tj43$createComponent((0, $6d95ef50ee01d5a1$export$5d2caaa6b530761c), {});
          }
        }), $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
          class_: "value line-clamp",
          get whole_text_to_display_() {
            return $8tj43$createMemo(() => input_obj().query);
          },
          searching_for_value_: searching_for_value_
        })] : [$8tj43$memo(() => $8tj43$memo(() => !!parent_title_if_exists())() ? (() => {
          var _el$4 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$4),
            _el$6 = _el$4.firstChild,
            [_el$7, _co$] = $8tj43$getNextMarker(_el$6.nextSibling),
            _el$5 = _el$7.nextSibling;
          $8tj43$insert(_el$4, $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
            class_: "category line-clamp",
            get whole_text_to_display_() {
              return $8tj43$createMemo(() => input_obj().title);
            },
            searching_for_value_: searching_for_value_
          }), _el$7, _co$);
          $8tj43$insert(_el$5, parent_title_if_exists);
          return _el$4;
        })() : $8tj43$memo(() => input_obj().type === "content")() ? (() => {
          var _el$8 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$5),
            _el$9 = _el$8.firstChild,
            [_el$10, _co$2] = $8tj43$getNextMarker(_el$9.nextSibling),
            _el$11 = _el$10.nextSibling,
            [_el$12, _co$3] = $8tj43$getNextMarker(_el$11.nextSibling);
          $8tj43$insert(_el$8, $8tj43$createComponent((0, $3c5e15c6ee4227a9$export$605674723bcc715c), {
            width: "16",
            height: "16"
          }), _el$10, _co$2);
          $8tj43$insert(_el$8, $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
            class_: "content line-clamp",
            get whole_text_to_display_() {
              return $8tj43$createMemo(() => input_obj().title);
            },
            searching_for_value_: searching_for_value_
          }), _el$12, _co$3);
          return _el$8;
        })() : $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
          class_: "category line-clamp",
          get whole_text_to_display_() {
            return $8tj43$createMemo(() => input_obj().title);
          },
          searching_for_value_: searching_for_value_
        })), (() => {
          var _el$3 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$3);
          $8tj43$insert(_el$3, () => $8tj43$createMemo(() => {
            if (input_obj().type === "content") return i18n_.content_();
            if (input_obj().listing_type === "brand") return i18n_.brand_();
            return i18n_.category_();
          })());
          return _el$3;
        })()];
      })());
      $8tj43$effect(_p$ => {
        var _v$ = {
            selected: is_selected(),
            history: is_history,
            ["type-" + input_obj().type]: true
          },
          _v$2 = href();
        _p$.e = $8tj43$classList(_el$, _v$, _p$.e);
        _v$2 !== _p$.t && $8tj43$setAttribute(_el$, "href", _p$.t = _v$2);
        return _p$;
      }, {
        e: undefined,
        t: undefined
      });
      return _el$;
    })();
  };
  const should_show_previous_searches_in_query_part = $8tj43$createMemo(() => !on_previous_searches_page_());
  const should_show_at_all = $8tj43$createMemo(() => {
    var _suggestion_memo_, _get_content_results_;
    return ((_suggestion_memo_ = suggestion_memo_()) === null || _suggestion_memo_ === void 0 ? void 0 : _suggestion_memo_.length) || should_show_previous_searches_in_query_part() && filtered_previous_searches_().length || ((_get_content_results_ = get_content_results_()) === null || _get_content_results_ === void 0 ? void 0 : _get_content_results_.length);
  });
  const should_show_query_part = $8tj43$createMemo(() => queries_memo().length || filtered_previous_searches_().length);
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return should_show_at_all();
    },
    get children() {
      var _el$13 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$9),
        _el$21 = _el$13.firstChild,
        [_el$22, _co$6] = $8tj43$getNextMarker(_el$21.nextSibling),
        _el$23 = _el$22.nextSibling,
        [_el$24, _co$7] = $8tj43$getNextMarker(_el$23.nextSibling),
        _el$25 = _el$24.nextSibling,
        [_el$26, _co$8] = $8tj43$getNextMarker(_el$25.nextSibling);
      $8tj43$insert(_el$13, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return on_previous_searches_page_();
        },
        get children() {
          var _el$14 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$6);
          $8tj43$insert(_el$14, () => i18n_.suggestions_());
          return _el$14;
        }
      }), _el$22, _co$6);
      $8tj43$insert(_el$13, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return should_show_query_part();
        },
        get children() {
          var _el$15 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$7),
            _el$16 = _el$15.firstChild,
            [_el$17, _co$4] = $8tj43$getNextMarker(_el$16.nextSibling),
            _el$18 = _el$17.nextSibling,
            [_el$19, _co$5] = $8tj43$getNextMarker(_el$18.nextSibling);
          $8tj43$insert(_el$15, $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return should_show_previous_searches_in_query_part();
            },
            keyed: false,
            get children() {
              return (() => {
                const mapped_history_results = $8tj43$createMemo(() => filtered_previous_searches_().map(result => ({
                  type: (0, $a5541dc94070b75b$export$3cf9497e790da491),
                  query: result,
                  suggestions_result_id: "history" // worthless to fix typing
                })));

                const index_in_autocomplete = 1;
                $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions_, () => index_in_autocomplete, $8tj43$createMemo(() => mapped_history_results().map(item => ({
                  title_: item.query
                }))));
                return $8tj43$createComponent((0, $8tj43$Index), {
                  get each() {
                    return mapped_history_results();
                  },
                  children: (item, index) => render_entry(item, index_in_autocomplete, index, true)
                });
              })();
            }
          }), _el$17, _co$4);
          $8tj43$insert(_el$15, () => {
            const index_in_autocomplete = 2;
            $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions_, () => index_in_autocomplete, $8tj43$createMemo(() => queries_memo().map(item => ({
              title_: item.query
            }))));
            return $8tj43$createComponent((0, $8tj43$Index), {
              get each() {
                return queries_memo();
              },
              children: (item, index) => render_entry(item, index_in_autocomplete, index)
            });
          }, _el$19, _co$5);
          return _el$15;
        }
      }), _el$24, _co$7);
      $8tj43$insert(_el$13, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return not_queries_memo().length;
        },
        keyed: false,
        get children() {
          var _el$20 = $8tj43$getNextElement($b055f9e9aeceeb48$var$_tmpl$8);
          $8tj43$insert(_el$20, () => {
            const index_in_autocomplete = 3;
            $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions_, () => index_in_autocomplete, $8tj43$createMemo(() => not_queries_memo().map(item => ({
              title_: item.title,
              page_url_: item.page_url
            }))));
            return $8tj43$createComponent((0, $8tj43$Index), {
              get each() {
                return not_queries_memo();
              },
              children: (item, index) => render_entry(item, index_in_autocomplete, index)
            });
          });
          return _el$20;
        }
      }), _el$26, _co$8);
      $8tj43$effect(() => _el$13.classList.toggle("compact", !!on_previous_searches_page_()));
      return _el$13;
    }
  });
}
var $76b6e14a50da4597$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a target=_blank>`);
function $76b6e14a50da4597$export$1efe1013da60d0e4(e, href) {
  if (e.metaKey || e.ctrlKey || e.shiftKey) {
    // Open link in a new tab/window with cmd/ctrl + enter.
    const link = (() => {
      var _el$ = $8tj43$getNextElement($76b6e14a50da4597$var$_tmpl$);
      $8tj43$setAttribute(_el$, "href", href);
      return _el$;
    })();
    document.body.append(link);
    link.click();
    link.remove();
    return true;
  }
  return false;
}
function $75e33704f2a83029$export$217899a935ef803b(_ref) {
  let {
    selected_index_: [read_selected_index, write_selected_index],
    currently_showing_suggestions_: [read_currently_showing_suggestions],
    ...rest_of_props
  } = _ref;
  const last_suggestion_index_ = $8tj43$createMemo(() => {
    const currently_showing_suggestions = read_currently_showing_suggestions();
    let total_length = 0;
    for (let i = 0; i < currently_showing_suggestions.length; i++) {
      const memo = currently_showing_suggestions[i];
      if (memo) total_length += memo().length;
    }
    return total_length - 1;
  });
  const read_selected_fake_index_ = $8tj43$createMemo(() => {
    const selected = read_selected_index();
    if (!selected) return selected;
    const currently_showing_suggestions = read_currently_showing_suggestions();
    let index = 0;
    for (let i = 0; i < currently_showing_suggestions.length; i++) {
      var _currently_showing_su;
      const contents = (_currently_showing_su = currently_showing_suggestions[i]) === null || _currently_showing_su === void 0 ? void 0 : _currently_showing_su.call(currently_showing_suggestions);
      if (!contents) continue;
      for (let j = 0; j < contents.length; j++) {
        if (i === selected[0] && j === selected[1]) return index;
        index++;
      }
    }
  });
  const write_selected_fake_index_ = index_to_select => {
    if (index_to_select == undefined || index_to_select < 0) {
      write_selected_index(undefined);
      return;
    }
    const currently_showing_suggestions = $8tj43$untrack(read_currently_showing_suggestions);
    let index = 0;
    for (let i = 0; i < currently_showing_suggestions.length; i++) {
      var _currently_showing_su2;
      const contents = (_currently_showing_su2 = currently_showing_suggestions[i]) === null || _currently_showing_su2 === void 0 ? void 0 : _currently_showing_su2.call(currently_showing_suggestions);
      if (!contents) continue;
      for (let j = 0; j < contents.length; j++) {
        if (index === index_to_select) {
          write_selected_index([i, j, true]);
          return contents[j];
        }
        index++;
      }
    }
  };
  // TODO: if selected item stops existing, remove it
  // Is above actually not done???
  $75e33704f2a83029$var$actual_navigation_working_on_fake_data({
    ...rest_of_props,
    last_suggestion_index_: last_suggestion_index_,
    read_selected_fake_index_: read_selected_fake_index_,
    write_selected_fake_index_: write_selected_fake_index_
  });
}
function $75e33704f2a83029$var$actual_navigation_working_on_fake_data(_ref2) {
  let {
    element_: element_,
    search_field_value_: [get_search_field_value, set_search_field_value],
    updating_blocked_: [read_updating_blocked, write_updating_blocked],
    last_suggestion_index_: last_suggestion_index_,
    read_selected_fake_index_: read_selected_fake_index_,
    write_selected_fake_index_: write_selected_fake_index_,
    set_override_on_enter_fn_: set_override_on_enter_fn_,
    url_transformer_: url_transformer_,
    search_query_param_name_: search_query_param_name_,
    router_: router_
  } = _ref2;
  let previous_value;
  $8tj43$createEffect(() => {
    const sfv = get_search_field_value();
    if (!$8tj43$untrack(() => read_updating_blocked())) previous_value = sfv;
  });
  const owner = $8tj43$getOwner();
  const handler = $8tj43$catchify1(_ref3 => {
    let {
      keyCode: keyCode
    } = _ref3;
    return $8tj43$untrack(() => {
      const up = keyCode === 38;
      const down = keyCode === 40;
      if (!up && !down) return;
      const current = read_selected_fake_index_();
      const to_select = !isNaN(current) && current >= 0 && current <= last_suggestion_index_() ? current + (down ? 1 : -1) : up ? last_suggestion_index_() : 0;
      const selected_entry = write_selected_fake_index_(to_select > last_suggestion_index_() ? undefined : to_select);
      const block_updating_for_one_change = () => {
        write_updating_blocked(true);
        let calls = 0;
        $8tj43$createEffect(() => {
          if (calls < 1) get_search_field_value();else write_updating_blocked(false);
          calls++;
        });
      };
      const override_on_enter_for_this_entry = new_fn => {
        set_override_on_enter_fn_(new_fn);
        // Only override while this item has been selected with the keyboard
        $8tj43$createComputed(run => {
          if (!run) read_selected_fake_index_();else set_override_on_enter_fn_(() => false);
          return run + 1;
        }, 0);
      };
      if (!selected_entry) {
        $8tj43$runWithOwner(owner, block_updating_for_one_change);
        set_search_field_value(previous_value);
        return;
      }
      // update text field value if needed
      if ("page_url_" in selected_entry) {
        $8tj43$runWithOwner(owner, () => override_on_enter_for_this_entry(e => {
          const {
            page_url_: page_url_
          } = selected_entry;
          if (!$76b6e14a50da4597$export$1efe1013da60d0e4(e, page_url_))
            // Above fn will return true if it opened a new tab, and we won't make these checks anymore
            router_.navigate_.go_to_({
              new_url_: page_url_,
              is_replace_: false
            });
          return true;
        }));
        return;
      }
      const {
        title_: title_
      } = selected_entry;
      $8tj43$runWithOwner(owner, block_updating_for_one_change);
      set_search_field_value(title_);
      $8tj43$runWithOwner(owner, () => override_on_enter_for_this_entry(e => {
        // Open search query in new tab on cmd+enter
        // If it's not cmd+enter, pressing enter will just submit the value that was put into the field while selecting with the arrow keys ;)
        const url = new URL(location);
        url_transformer_ === null || url_transformer_ === void 0 || url_transformer_(url);
        url.searchParams.set(search_query_param_name_, title_);
        return $76b6e14a50da4597$export$1efe1013da60d0e4(e, url.href);
      }));
    });
  });
  $8tj43$createEffect(() => {
    const el = element_();
    if (!el) return;
    el.addEventListener("keyup", handler);
    $8tj43$onCleanup($8tj43$catchify1(() => el.removeEventListener("keyup", handler)));
  });
}
function $c4dee1ef44de29ca$export$af0124069c150252(_ref) {
  let {
    set_override_on_enter_fn_: set_override_on_enter_fn_,
    get_modal_search_results_: get_modal_search_results_,
    suggestions_response_: suggestions_response_,
    router_: router_,
    content_results_: content_results_,
    has_previous_searches_matching_query_: has_previous_searches_matching_query_
  } = _ref;
  const [get_autocomplete_wants_override_function, set_autocomplete_wants_override_function] = $8tj43$createSignal(() => false);
  $8tj43$createComputed(() => {
    var _get_modal_search_res, _search_results$displ;
    const suggestions = suggestions_response_();
    const search_results = (_get_modal_search_res = get_modal_search_results_()) === null || _get_modal_search_res === void 0 ? void 0 : _get_modal_search_res();
    const content_results = content_results_();
    // If we only have one content result and nothing else, go there when pressing enter
    if (!(suggestions !== null && suggestions !== void 0 && suggestions.length) && !suggestions_response_.loading && !(search_results !== null && search_results !== void 0 && (_search_results$displ = search_results.displays) !== null && _search_results$displ !== void 0 && _search_results$displ.length) && (content_results === null || content_results === void 0 ? void 0 : content_results.length) === 1 && !has_previous_searches_matching_query_()) {
      const [onlyResult] = content_results;
      const page_url = onlyResult.page_url_ || onlyResult.page_url;
      set_override_on_enter_fn_(e => {
        if (!$76b6e14a50da4597$export$1efe1013da60d0e4(e, page_url))
          // Above fn will return true if it opened a new tab, and we won't make these checks anymore
          router_.navigate_.go_to_({
            new_url_: page_url,
            is_replace_: false
          });
        return true;
      });
      return;
    }
    set_override_on_enter_fn_(get_autocomplete_wants_override_function());
  });
  return new_fn => set_autocomplete_wants_override_function(() => new_fn);
}
const $a5541dc94070b75b$export$3cf9497e790da491 = "query";
function $a5541dc94070b75b$export$2f2b9559550c7bbc(_ref) {
  let {
    search_field_value_: search_field_value_,
    get_search_query_: get_search_query_,
    search_query_url_param_name_: search_query_url_param_name_,
    previous_searches_: [unfiltered_previous_searches, set_unfiltered_previous_searches_],
    previous_searches_text_: previous_searches_text_,
    depict_api_: depict_api_,
    merchant_: merchant_,
    market_: market_,
    input_field_: input_field_,
    url_transformer_: url_transformer_,
    currently_showing_suggestions_: currently_showing_suggestions_,
    set_override_on_enter_fn_: set_override_on_enter_fn_,
    selected_index_: selected_index_,
    i18n_: i18n_,
    include_category_suggestions_: include_category_suggestions_,
    submit_query_: submit_query_,
    router_: router_,
    get_modal_search_results_: get_modal_search_results_,
    content_search_enabled_: content_search_enabled_
  } = _ref;
  const [searching_for_value, set_searching_for_value] = $8tj43$createSignal();
  const [show_stale_content_results, set_show_stale_content_results] = $8tj43$createSignal(false);
  const [read_search_field_value] = search_field_value_;
  const updating_blocked = $8tj43$createSignal(false);
  const [read_suggestion_signal_, write_suggestion_signal] = $8tj43$createSignal([]);
  const previous_searches_without_current_query = $8tj43$createMemo(() => [...unfiltered_previous_searches()].reverse().filter(q => q !== get_search_query_()));
  const previous_searches_matching_query = $8tj43$createMemo(() => {
    return previous_searches_without_current_query().filter(cs_search => {
      var _searching_for_value;
      const search = cs_search.toLowerCase();
      const value = (_searching_for_value = searching_for_value()) === null || _searching_for_value === void 0 ? void 0 : _searching_for_value.toLowerCase();
      if (!value) return false;
      return search.includes(value) || value.includes(search);
    }).slice(0, 2);
  });
  const deparallelized_fn = $8tj43$deparallelize_no_drop(async request_obj => {
    var _api_response$suggest;
    const api_response = await depict_api_.suggest(request_obj);
    if (!(api_response !== null && api_response !== void 0 && (_api_response$suggest = api_response.suggestions) !== null && _api_response$suggest !== void 0 && _api_response$suggest.length)) {
      write_suggestion_signal([]);
      return;
    }
    const new_value = api_response.suggestions.sort((_ref2, _ref3 // this is probably stupid? But in the UI we show query suggestions first so for the keyboard suggestions to make sense with the index we sort them first here
    ) => {
      let {
        type: a_type
      } = _ref2;
      let {
        type: b_type
      } = _ref3;
      return a_type === $a5541dc94070b75b$export$3cf9497e790da491 && b_type === $a5541dc94070b75b$export$3cf9497e790da491 || a_type !== $a5541dc94070b75b$export$3cf9497e790da491 && b_type !== $a5541dc94070b75b$export$3cf9497e790da491 ? 0 : a_type === $a5541dc94070b75b$export$3cf9497e790da491 ? -1 : 1;
    });
    write_suggestion_signal(new_value);
    selected_index_[1](undefined); // reset selected index on new results
  });

  const show_previous_searches_component = $8tj43$createMemo(() => !read_search_field_value() || $8tj43$untrack(updating_blocked[0]) && !$8tj43$untrack(searching_for_value));
  const get_content_results_ = $8tj43$createMemo(prev => {
    var _get_modal_search_res, _get_modal_search_res2, _get_modal_search_res3;
    if (!content_search_enabled_()) return [];
    if (show_stale_content_results())
      // don't update content results when query suggestions don't update because otherwise they disappear when trying to keyboard navigate to them
      return prev;
    return (_get_modal_search_res = get_modal_search_results_()) === null || _get_modal_search_res === void 0 ? void 0 : (_get_modal_search_res2 = _get_modal_search_res()) === null || _get_modal_search_res2 === void 0 ? void 0 : (_get_modal_search_res3 = _get_modal_search_res2.content_search_links) === null || _get_modal_search_res3 === void 0 ? void 0 : _get_modal_search_res3.map(link => ({
      page_url: link.page_url,
      type: "content",
      title: link.title
    }));
  });
  // Ideally we'd propagate up the suggestion signal too and call this from SearchModal.tsx? Because it's not super related with autocomplete, but it's not a huge feature, and it's easier here so keeping it.
  // It's the functionality to open the content results page when you press enter, in the modal, when there's only one content result
  const manipulated_set_override_on_enter_fn_ = $c4dee1ef44de29ca$export$af0124069c150252({
    set_override_on_enter_fn_: set_override_on_enter_fn_,
    get_modal_search_results_: get_modal_search_results_,
    suggestions_response_: read_suggestion_signal_,
    router_: router_,
    content_results_: get_content_results_,
    has_previous_searches_matching_query_: $8tj43$createMemo(() => previous_searches_matching_query().length > 0)
  });
  $8tj43$createComputed(() => {
    const field_value = read_search_field_value();
    if ($8tj43$untrack(updating_blocked[0]))
      // not using updating_blocked instead of below signal since I presume they'd start updating too early then
      set_show_stale_content_results(true);else {
      set_searching_for_value(field_value);
      deparallelized_fn({
        merchant: merchant_(),
        market: market_(),
        locale: i18n_.backend_locale_(),
        query: field_value
      });
      set_show_stale_content_results(false);
    }
  });
  $8tj43$createComputed($8tj43$on(search_field_value_[0], () => !updating_blocked[0]() && selected_index_[1](undefined), {
    defer: true
  })); // reset autocomplete position if query changes
  $75e33704f2a83029$export$217899a935ef803b({
    element_: input_field_,
    selected_index_: selected_index_,
    search_field_value_: search_field_value_,
    updating_blocked_: updating_blocked,
    currently_showing_suggestions_: currently_showing_suggestions_,
    set_override_on_enter_fn_: manipulated_set_override_on_enter_fn_,
    search_query_param_name_: search_query_url_param_name_,
    url_transformer_: url_transformer_,
    router_: router_
  });
  return [$8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return show_previous_searches_component();
    },
    get children() {
      return $8tj43$createComponent((0, $01dd2bfbbae020bc$export$a146ac6fa8346a25), {
        i18n_: i18n_,
        set_unfiltered_previous_searches_: set_unfiltered_previous_searches_,
        search_query_param_name_: search_query_url_param_name_,
        text_: previous_searches_text_,
        get previous_searches_() {
          return $8tj43$createMemo(() => previous_searches_without_current_query().slice(0, 3));
        },
        selected_index_: selected_index_,
        currently_showing_suggestions_: currently_showing_suggestions_,
        url_transformer_: url_transformer_,
        submit_query_: submit_query_
      });
    }
  }), $8tj43$createComponent((0, $b055f9e9aeceeb48$export$e872e2339fb04a7f), {
    filtered_previous_searches_: previous_searches_matching_query,
    on_previous_searches_page_: show_previous_searches_component,
    i18n_: i18n_,
    get_content_results_: get_content_results_,
    url_transformer_: url_transformer_,
    searching_for_value_: searching_for_value,
    search_query_url_param_name_: search_query_url_param_name_,
    selected_index_: selected_index_,
    suggestion_memo_: read_suggestion_signal_,
    currently_showing_suggestions_: currently_showing_suggestions_,
    include_category_suggestions_: include_category_suggestions_,
    router_: router_,
    submit_query_: submit_query_
  })];
}
const $cc64aabf2c7a1f1a$export$af8311b651139246 = css_properties => {
  return Object.entries(css_properties).map(_ref => {
    let [key, value] = _ref;
    return "".concat(key, ": ").concat(value, ";");
  }).join(" ");
};
const $cc64aabf2c7a1f1a$export$1233ca167bf71f9a = styles => {
  return Object.entries(styles).map(_ref2 => {
    let [selector, css_properties] = _ref2;
    return "".concat(selector, " { ").concat($cc64aabf2c7a1f1a$export$af8311b651139246(css_properties), " }");
  }).join(" ");
};
var $a86e71c0015bd8ab$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<style>`);
function $a86e71c0015bd8ab$export$f021bdedd3ec901a(props) {
  const valid_css_string = $8tj43$createMemo(() => {
    return $cc64aabf2c7a1f1a$export$1233ca167bf71f9a(props.styles());
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($a86e71c0015bd8ab$var$_tmpl$);
    $8tj43$insert(_el$, valid_css_string);
    return _el$;
  })();
}
var $83c36ed4520d0335$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=21 height=20 viewBox="0 0 21 20"fill=none><path fill-rule=evenodd d="M9.563 3.438c-3.107 0-5.625 2.518-5.625 5.625s2.518 5.625 5.625 5.625 5.625-2.518 5.625-5.625-2.518-5.625-5.625-5.625zm-7.5 5.625a7.5 7.5 0 1 1 15 0c0 1.733-.588 3.329-1.575 4.599l3.176 3.176a.94.94 0 0 1 0 1.326.94.94 0 0 1-1.326 0l-3.176-3.176a7.47 7.47 0 0 1-4.599 1.575 7.5 7.5 0 0 1-7.5-7.5z"fill=#0f0f0f>`);
function $83c36ed4520d0335$export$f7658c347b037c3f() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (() => {
    var _el$ = $8tj43$getNextElement($83c36ed4520d0335$var$_tmpl$);
    $8tj43$spread(_el$, props, true, true);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
var $584c06c09cf4609d$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button class=back type=button>`),
  $584c06c09cf4609d$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button type=button class=clear>`),
  $584c06c09cf4609d$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=spacer>`),
  $584c06c09cf4609d$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<button class="submit major"type=button>`),
  $584c06c09cf4609d$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<div><!$><!/><!$><!/><div class=field><!$><!/><input class=query tabindex=0 enterkeyhint=search><!$><!/></div><!$><!/><!$><!/>`);
function $584c06c09cf4609d$export$b94867ecbd698f21(_ref) {
  let {
    search_field_value_: [searchFieldValue, setSearchFieldValue],
    input_field_ref_: input_field_ref_,
    field_element_ref_: field_element_ref_,
    submit_query_: submit_query_,
    override_on_enter_: override_on_enter_,
    clear_filters_: clear_filters_,
    disabled_ = false,
    on_back_: on_back_,
    i18n_: i18n_,
    after_focusing_: after_focusing_,
    BackIcon_: BackIcon_,
    buttonInFieldRef_: buttonInFieldRef_,
    class_: class_,
    setSearchRoleOnContainer_ = true,
    ariaControls: ariaControls
  } = _ref;
  let input_element;
  // This is the div where we recommend (and ourselves do) attach the event listener to that opens the search modal.
  let field_div;
  $8tj43$createEffect($8tj43$catchify1(async () => {
    if (disabled_) return;
    // we aren't in DOM yet unfortunately, wouldn't even be with onMount
    await (0, $8tj43$observer).wait_for_element(input_element);
    input_element.focus();
    after_focusing_ === null || after_focusing_ === void 0 || after_focusing_(input_element);
  })); // focus field on render
  const owner_of_field_element = $8tj43$getOwner();
  const isNewModal = BackIcon_[(0, $b026fa9c9c904a98$export$1ea76ea778b880dd)] === 2;
  const [backButtonWidthAccessor, setBackButtonWidthAccessor] = $8tj43$createSignal();
  const getBackButtonWidth = () => {
    var _backButtonWidthAcces;
    return (_backButtonWidthAcces = backButtonWidthAccessor()) === null || _backButtonWidthAcces === void 0 ? void 0 : _backButtonWidthAcces();
  };
  const searchFieldEmpty = $8tj43$createMemo(() => !searchFieldValue());
  const BackButton = () => $8tj43$createComponent((0, $8tj43$Show), {
    when: on_back_,
    get children() {
      var _el$ = $8tj43$getNextElement($584c06c09cf4609d$var$_tmpl$);
      $8tj43$spread(_el$, $8tj43$mergeProps1({
        get onClick() {
          return $8tj43$catchify1(on_back_);
        },
        get ["aria-label"]() {
          return i18n_.back_();
        }
      }, isNewModal && {
        ref: el => {
          setBackButtonWidthAccessor(() => $fc830a7ee59416ef$export$ebdc3711f7e02ccd(el));
          $8tj43$onCleanup(() => setBackButtonWidthAccessor());
        }
      }), false, true);
      $8tj43$insert(_el$, isNewModal ? $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}) : $8tj43$createComponent(BackIcon_, {}));
      $8tj43$runHydrationEvents();
      return _el$;
    }
  });
  const ClearButton = () => (() => {
    var _el$2 = $8tj43$getNextElement($584c06c09cf4609d$var$_tmpl$2);
    var _ref$ = buttonInFieldRef_;
    typeof _ref$ === "function" ? $8tj43$use(_ref$, _el$2) : buttonInFieldRef_ = _el$2;
    $8tj43$spread(_el$2, $8tj43$mergeProps1({
      get classList() {
        return {
          empty: searchFieldEmpty()
        };
      },
      get style() {
        return isNewModal || !searchFieldEmpty() ? "" : "display: none";
      },
      get onClick() {
        return $8tj43$catchify1(() => {
          if (isNewModal && searchFieldEmpty()) return;
          setSearchFieldValue("");
          clear_filters_(true);
          if (!disabled_) input_element.focus();
        });
      }
    }, () => searchFieldEmpty() ? {
      "aria-hidden": "true",
      tabIndex: -1
    } : {
      title: i18n_.clear_filters_query_sorting_after_submit_()
    }), false, true);
    $8tj43$insert(_el$2, isNewModal ? $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !searchFieldEmpty();
      },
      get fallback() {
        return $8tj43$createComponent((0, $83c36ed4520d0335$export$f7658c347b037c3f), {});
      },
      get children() {
        return $8tj43$createComponent(BackIcon_, {});
      }
    }) : $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {}));
    $8tj43$runHydrationEvents();
    return _el$2;
  })();
  return (() => {
    var _el$3 = $8tj43$getNextElement($584c06c09cf4609d$var$_tmpl$5),
      _el$12 = _el$3.firstChild,
      [_el$13, _co$3] = $8tj43$getNextMarker(_el$12.nextSibling),
      _el$14 = _el$13.nextSibling,
      [_el$15, _co$4] = $8tj43$getNextMarker(_el$14.nextSibling),
      _el$5 = _el$15.nextSibling,
      _el$7 = _el$5.firstChild,
      [_el$8, _co$] = $8tj43$getNextMarker(_el$7.nextSibling),
      _el$6 = _el$8.nextSibling,
      _el$9 = _el$6.nextSibling,
      [_el$10, _co$2] = $8tj43$getNextMarker(_el$9.nextSibling),
      _el$16 = _el$5.nextSibling,
      [_el$17, _co$5] = $8tj43$getNextMarker(_el$16.nextSibling),
      _el$18 = _el$17.nextSibling,
      [_el$19, _co$6] = $8tj43$getNextMarker(_el$18.nextSibling);
    $8tj43$spread(_el$3, $8tj43$mergeProps1({
      get ["class"]() {
        return "search-field".concat(on_back_ ? " in-modal" : "").concat(class_ !== null && class_ !== void 0 && class_() ? " ".concat(class_()) : "");
      }
    }, setSearchRoleOnContainer_ && {
      role: "search"
    }), false, true);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return getBackButtonWidth() !== undefined && on_back_;
      },
      get children() {
        var _el$4 = $8tj43$getNextElement($584c06c09cf4609d$var$_tmpl$3);
        $8tj43$effect(_$p => (_$p = getBackButtonWidth() + "px", _el$4.style.setProperty("width", _$p)));
        return _el$4;
      }
    }), _el$13, _co$3);
    $8tj43$insert(_el$3, !isNewModal && $8tj43$createComponent(BackButton, {}), _el$15, _co$4);
    $8tj43$use(el => {
      field_div = el;
      field_element_ref_ === null || field_element_ref_ === void 0 || field_element_ref_(el);
    }, _el$5);
    $8tj43$addEventListener(_el$5, "click", $8tj43$catchify1(_ref2 => {
      let {
        target: target,
        currentTarget: currentTarget,
        detail: detail
      } = _ref2;
      if (target !== currentTarget || disabled_) return;
      if (detail === 3)
        // triple click, select all
        input_element.select();
      input_element.focus();
      if (detail === 2) {
        // Double click, select last word
        const value = input_element.value;
        // Use a regular expression to find the last word
        // This pattern looks for a word at the end of the string
        const lastWordMatch = value.match(/\b(\w+)$/);
        if (lastWordMatch) {
          // Get the index of the last word
          const start = value.lastIndexOf(lastWordMatch[0]);
          // Set the selection range to the last word
          input_element.setSelectionRange(start, start + lastWordMatch[0].length);
        }
      }
    }), true);
    $8tj43$insert(_el$5, isNewModal && $8tj43$createComponent(ClearButton, {}), _el$8, _co$);
    var _ref$2 = $8tj43$catchify1(el => {
      input_element = el;
      input_field_ref_ === null || input_field_ref_ === void 0 || input_field_ref_(el);
    });
    typeof _ref$2 === "function" && $8tj43$use(_ref$2, _el$6);
    _el$6.classList.toggle("has-adjacent-back-button", !!!!on_back_);
    $8tj43$spread(_el$6, $8tj43$mergeProps1(() => setSearchRoleOnContainer_ ? {
      "aria-label": i18n_.search_field_field_aria_label_()
    } :
    // Searchbox announces basically the same as our aria-label, we could explore always using searchbox in the future
    {
      role: "searchbox"
    }, {
      get value() {
        return searchFieldValue();
      },
      get onKeyDown() {
        return $8tj43$catchify1(e => {
          if (disabled_) {
            if (e.key !== "Tab" && e.key !== "Shift")
              // alow tab-selecting the input field and then open the modal when the user start writing but also to move past the field with tab
              input_element.click();
          } else if (e.key === "Enter") {
            const dont_submit = override_on_enter_ === null || override_on_enter_ === void 0 ? void 0 : override_on_enter_(e);
            if (!dont_submit) submit_query_();
          }
        });
      },
      get onInput() {
        return $8tj43$catchify1(() => {
          const {
            value: value
          } = input_element;
          if (!disabled_ && !value.length) clear_filters_(false); // if the user clears the whole field, reset filters on next submit
          setSearchFieldValue(value);
        });
      },
      get onSelect() {
        return $8tj43$catchify1(() => {
          if (disabled_)
            // just in case. The field not actually being disabled when being disabled_ is so that you can focus it and open the modal. We don't want any of the other input-field-interaction features to work
            return;
          if (input_element.selectionStart === 0 && input_element.selectionEnd === input_element.value.length)
            // everything was selected, clear filters on next submit on next input
            input_element.addEventListener("input", $8tj43$catchify1(() => clear_filters_(false)),
            // We don't count this as user triggered since it wasn't explicit
            {
              once: true
            });
        });
      },
      "onPointerDown": _ref3 => {
        let {
          pointerType: pointerType
        } = _ref3;
        // When selecting text with a mouse we want a SearchField to be focussed even when releasing the mouse outside the .field element (we assume the event listener which opens the modal is attached to that).
        if (pointerType === "mouse") {
          const handler = $8tj43$catchify1(_ref4 => {
            let {
              pointerType: pointerType,
              target: target
            } = _ref4;
            if (pointerType !== "mouse" || !(target instanceof Node) || target === field_div || field_div.contains(target)) return;
            input_element.click();
          });
          window.addEventListener("pointerup", handler, {
            once: true
          });
          $8tj43$runWithOwner(owner_of_field_element, () => $8tj43$onCleanup(() => window.removeEventListener("pointerup", handler)));
        }
      },
      get placeholder() {
        return i18n_.placeholder_text_();
      },
      "aria-autocomplete": "list",
      "aria-haspopup": "dialog"
    }, ariaControls && {
      "aria-controls": ariaControls
    }), false, false);
    $8tj43$insert(_el$5, !isNewModal && $8tj43$createComponent(ClearButton, {}), _el$10, _co$2);
    $8tj43$insert(_el$3, isNewModal && $8tj43$createComponent(BackButton, {}), _el$17, _co$5);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Show), {
      when: !isNewModal,
      get children() {
        var _el$11 = $8tj43$getNextElement($584c06c09cf4609d$var$_tmpl$4);
        $8tj43$addEventListener(_el$11, "click", $8tj43$catchify1(() => submit_query_()), true);
        $8tj43$insert(_el$11, $8tj43$createComponent((0, $ef0f18a578b32578$export$82eafebb825fc23f), {}));
        $8tj43$effect(() => $8tj43$setAttribute(_el$11, "aria-label", i18n_.search_submit_button_aria_label_()));
        $8tj43$runHydrationEvents();
        return _el$11;
      }
    }), _el$19, _co$6);
    $8tj43$runHydrationEvents();
    return _el$3;
  })();
}
$8tj43$delegateEvents(["click"]);
var $fac58b5610eec6a9$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=24 height=16><path d="M.773 7.371L7.98.176C8.098.059 8.238 0 8.402 0s.305.059.422.176S9 .434 9 .598s-.059.305-.176.422L2.648 7.195h19.547a.59.59 0 0 1 .609.609c0 .172-.059.305-.176.422s-.262.176-.434.176H2.648l6.176 6.176a.59.59 0 0 1 .176.426c0 .16-.059.301-.176.422-.055.059-.121.109-.199.137s-.148.039-.223.039-.156-.012-.234-.039a.54.54 0 0 1-.187-.137L.773 8.227c-.117-.117-.176-.258-.176-.422a.6.6 0 0 1 .176-.434zm0 0">`);
function $fac58b5610eec6a9$export$8d8893ffd8aca39a() {
  return $8tj43$getNextElement($fac58b5610eec6a9$var$_tmpl$);
}
function $a82a41ab7188eda2$export$93d9bfd0c9c1a5b8(close_modal, search_query_url_param_name_) {
  const [exit_iterable, exitable_iterable] = $8tj43$make_asyncIterable_exiter((0, $8tj43$href_change_ipns));
  let set_initial_values = false;
  let old_pathname;
  let old_param_value;
  $8tj43$onCleanup($8tj43$catchify1(exit_iterable));
  $8tj43$catchify1(async () => {
    for await (const href of exitable_iterable) {
      const u_o = new URL(href);
      const new_pathname = u_o.pathname;
      const new_param_value = u_o.searchParams.get(search_query_url_param_name_);
      if (set_initial_values) {
        if (new_param_value !== old_param_value || new_pathname !== old_pathname) {
          // close modal when pathname or query changes
          close_modal();
          break;
        }
      } else set_initial_values = true;
      old_pathname = new_pathname;
      old_param_value = new_param_value;
    }
  })();
}
var $40411f2ec772c376$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=discover-more><button class=major type=button>`),
  $40411f2ec772c376$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<b>`),
  $40411f2ec772c376$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=depict-search-modal><div class=body role=search aria-label="Search modal with search field, query suggestions and result preview"><!$><!/><div id=depict-suggestions-and-result-preview class=padded><!$><!/><!$><!/><!$><!/></div><!$><!/></div><!$><!/>`),
  $40411f2ec772c376$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class="depict plp search"role=dialog><div class=depict-search-modal-backdrop></div><!$><!/>`);
/**
 * First generation (classic) search modal - the solid component that gets added to <body> when the search modal is opened
 */
function $40411f2ec772c376$var$RawClassicSearchModal(_ref) {
  let {
    search_field_value_: props_search_field_value,
    get_search_query_: get_search_query_,
    search_query_url_param_name_: search_query_url_param_name_,
    previous_searches_: previous_searches_,
    close_modal_: close_modal_,
    depict_api_: depict_api_,
    merchant_: merchant_,
    market_: market_,
    submit_query_: props_submit_query,
    instant_results_options_: instant_results_options_,
    register_closing_animation_: register_closing_animation_,
    url_transformer_: url_transformer_,
    closing_animation_: closing_animation_,
    clear_filters_: clear_filters_,
    i18n_: i18n_,
    disable_scrolling_ = true,
    enable_category_suggestions_: enable_category_suggestions_,
    class_list_: class_list_,
    bottom_distance_under_modal_: bottom_distance_under_modal_,
    selected_text_range_: selected_text_range_,
    dont_sync_search_field_value_except_on_submit_ = false,
    router_: router_,
    content_search_enabled_: content_search_enabled_,
    alignmentSignals_: alignmentSignals_
  } = _ref;
  let on_enter_in_search_field_function;
  // As per feedback from stronger we sometimes want a modal with the search field value disconnected from the one in the rest of the UI, see https://depictaiworkspace.slack.com/archives/C02J16R9XEH/p1679065878487709.
  // This is desired for when the modal is opened from a UI element that visually does not look connected with the search page or current query
  // Basically the UI signals that the button that opens the modal starts a new search.
  const search_field_value_ = dont_sync_search_field_value_except_on_submit_ ? $8tj43$createSignal("") : props_search_field_value;
  const propagate_search_field_value_back = dont_sync_search_field_value_except_on_submit_ ? () => props_search_field_value[1]($8tj43$untrack(search_field_value_[0])) // Set actual search field value to the throwaway internal one before submitting
  : undefined;
  const submit_query_ = function () {
    // submit_query expects to read the current search field value which is why we have to write the current one to the signal before calling it
    // It will write the old one back and then write the new one after submit
    propagate_search_field_value_back === null || propagate_search_field_value_back === void 0 || propagate_search_field_value_back();
    return props_submit_query(...arguments);
  };
  const [input_field, set_input_field] = $8tj43$createSignal();
  const [get_search_field_value_] = search_field_value_;
  // Search field alignment unused in ClassicSearchModal since the search field spans the whole modal
  const {
    body_: bodyAlignmentSignal = $8tj43$createSignal({})
  } = alignmentSignals_ || {};
  const [bodyAlignmentStyle] = bodyAlignmentSignal;
  const [get_modal_search_results, set_modal_search_results_] = $8tj43$createSignal();
  const close_on_escape_handler = $8tj43$catchify1(_ref2 => {
    let {
      key: key
    } = _ref2;
    if (key === "Escape") close_modal_();
  });
  // total number of results = content results + product results
  const totalNumberOfResults = $8tj43$createMemo(() => {
    var _get_modal_search_res, _results$content_sear;
    const results = (_get_modal_search_res = get_modal_search_results()) === null || _get_modal_search_res === void 0 ? void 0 : _get_modal_search_res();
    const hits = results === null || results === void 0 ? void 0 : results.n_hits;
    const content_results = results === null || results === void 0 ? void 0 : (_results$content_sear = results.content_search_links) === null || _results$content_sear === void 0 ? void 0 : _results$content_sear.length;
    if (!content_results || !content_search_enabled_()) return hits;
    return (hits !== null && hits !== void 0 ? hits : 0) + content_results;
  });
  const formattedTotalNumberResults = $43fbdca0f726a34b$export$92f2da32c6e7e7ee({
    number_: totalNumberOfResults,
    i18n_: i18n_
  });
  const selected_index = $8tj43$createSignal();
  const currently_showing_suggestions_ = $8tj43$createSignal([], {
    equals: false
  });
  const less_than_700_high = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(max-height:700px)");
  const DiscoverMoreSection = () => (() => {
    var _el$ = $8tj43$getNextElement($40411f2ec772c376$var$_tmpl$),
      _el$2 = _el$.firstChild;
    $8tj43$addEventListener(_el$2, "click", $8tj43$catchify1(() => submit_query_()), true);
    $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return get_search_field_value_();
      },
      get fallback() {
        return i18n_.modal_discover_more_();
      },
      get children() {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return totalNumberOfResults();
          },
          get fallback() {
            return i18n_.modal_view_all_no_results_();
          },
          get children() {
            return i18n_.modal_view_all_results_()((() => {
              var _el$3 = $8tj43$getNextElement($40411f2ec772c376$var$_tmpl$2);
              $8tj43$insert(_el$3, formattedTotalNumberResults);
              return _el$3;
            })());
          }
        });
      }
    }));
    $8tj43$runHydrationEvents();
    return _el$;
  })();
  if (disable_scrolling_) $e56d241d0f33d459$export$fe334901e8bebd57();
  $a82a41ab7188eda2$export$93d9bfd0c9c1a5b8(close_modal_, search_query_url_param_name_);
  window.addEventListener("keydown", close_on_escape_handler);
  $8tj43$onCleanup($8tj43$catchify1(() => window.removeEventListener("keydown", close_on_escape_handler)));
  if (closing_animation_) register_closing_animation_(closing_animation_);
  $a09bb7c652acf957$export$3340fdd8259bd4fd({
    get_search_field_value_: get_search_field_value_,
    url_transformer_: url_transformer_,
    search_query_url_param_name_: search_query_url_param_name_,
    get_search_query_: get_search_query_
  });
  const random_classname = $8tj43$make_random_classname();
  const body_style = $8tj43$createMemo(() => {
    const style_obj = {
      width: "80vw",
      position: "absolute",
      ...bodyAlignmentStyle()
    };
    return {
      [".depict .".concat(random_classname)]: style_obj
    };
  });
  const search_field = $584c06c09cf4609d$export$b94867ecbd698f21({
    BackIcon_: (0, $fac58b5610eec6a9$export$8d8893ffd8aca39a),
    input_field_ref_: element => set_input_field(element),
    override_on_enter_: e => {
      var _on_enter_in_search_f;
      return (_on_enter_in_search_f = on_enter_in_search_field_function) === null || _on_enter_in_search_f === void 0 ? void 0 : _on_enter_in_search_f(e);
    },
    on_back_: close_modal_,
    search_field_value_: search_field_value_,
    submit_query_: submit_query_,
    clear_filters_: clear_filters_,
    i18n_: i18n_,
    after_focusing_: input_el => {
      // Restore the selection range from the SearchField that was used to open the modal, if it was saved.
      if (!selected_text_range_) return;
      const [start, end] = selected_text_range_;
      if (start === null || end === null) return;
      input_el.setSelectionRange(start, end);
    },
    setSearchRoleOnContainer_: false,
    ariaControls: "depict-suggestions-and-result-preview"
  });
  const modal_element = (() => {
    var _el$4 = $8tj43$getNextElement($40411f2ec772c376$var$_tmpl$3),
      _el$5 = _el$4.firstChild,
      _el$13 = _el$5.firstChild,
      [_el$14, _co$4] = $8tj43$getNextMarker(_el$13.nextSibling),
      _el$6 = _el$14.nextSibling,
      _el$7 = _el$6.firstChild,
      [_el$8, _co$] = $8tj43$getNextMarker(_el$7.nextSibling),
      _el$9 = _el$8.nextSibling,
      [_el$10, _co$2] = $8tj43$getNextMarker(_el$9.nextSibling),
      _el$11 = _el$10.nextSibling,
      [_el$12, _co$3] = $8tj43$getNextMarker(_el$11.nextSibling),
      _el$15 = _el$6.nextSibling,
      [_el$16, _co$5] = $8tj43$getNextMarker(_el$15.nextSibling),
      _el$17 = _el$5.nextSibling,
      [_el$18, _co$6] = $8tj43$getNextMarker(_el$17.nextSibling);
    $8tj43$addEventListener(_el$4, "click", $8tj43$catchify1(_ref3 => {
      let {
        target: target
      } = _ref3;
      if (target === modal_element) close_modal_();
    }), true);
    $8tj43$insert(_el$5, search_field, _el$14, _co$4);
    $8tj43$use(el => $8tj43$catchify1((0, $558d0596fcf0e0b0$export$50b90be27d8502d9))(el, bodyAlignmentSignal, bottom_distance_under_modal_), _el$6);
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Autocomplete/suggestions failed",
      get children() {
        return $8tj43$createComponent((0, $a5541dc94070b75b$export$2f2b9559550c7bbc), {
          set_override_on_enter_fn_: new_fn => on_enter_in_search_field_function = new_fn,
          input_field_: input_field,
          search_field_value_: search_field_value_,
          get previous_searches_text_() {
            return i18n_.previous_searches_text_;
          },
          get_search_query_: get_search_query_,
          previous_searches_: previous_searches_,
          search_query_url_param_name_: search_query_url_param_name_,
          market_: market_,
          merchant_: merchant_,
          selected_index_: selected_index,
          currently_showing_suggestions_: currently_showing_suggestions_,
          depict_api_: depict_api_,
          url_transformer_: url_transformer_,
          i18n_: i18n_,
          include_category_suggestions_: enable_category_suggestions_ !== null && enable_category_suggestions_ !== void 0 ? enable_category_suggestions_ : true,
          router_: router_,
          submit_query_: submit_query_,
          get_modal_search_results_: get_modal_search_results,
          content_search_enabled_: content_search_enabled_
        });
      }
    }), _el$8, _co$);
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Instant results failed",
      get children() {
        return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
          get children() {
            return $f7414b949aeabc90$export$62f101a8aa597bf8({
              search_field_value_: search_field_value_,
              depict_api_: depict_api_,
              merchant_: merchant_,
              i18n_: i18n_,
              market_: market_,
              router_: router_,
              set_modal_search_results_: set_modal_search_results_,
              InstantCardImageComponent_: props => $8tj43$createMemo(() => $8tj43$ContainedImage({
                loading: "lazy",
                aspect_ratio: 1,
                alt: "",
                rendering_options: {},
                "src": props.src_,
                srcset_opts: {
                  set_dataset: false
                },
                sizes: "0px"
              })),
              ...instant_results_options_
            });
          }
        });
      }
    }), _el$10, _co$2);
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return less_than_700_high();
      },
      get children() {
        return $8tj43$createComponent(DiscoverMoreSection, {});
      }
    }), _el$12, _co$3);
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return !less_than_700_high();
      },
      get children() {
        return $8tj43$createComponent(DiscoverMoreSection, {});
      }
    }), _el$16, _co$5);
    $8tj43$insert(_el$4, $8tj43$createComponent((0, $a86e71c0015bd8ab$export$f021bdedd3ec901a), {
      styles: body_style
    }), _el$18, _co$6);
    $8tj43$effect(_$p => $8tj43$classList(_el$5, {
      [random_classname]: true
    }, _$p));
    $8tj43$runHydrationEvents();
    return _el$4;
  })();
  return [(() => {
    var _el$19 = $8tj43$getNextElement($40411f2ec772c376$var$_tmpl$4),
      _el$20 = _el$19.firstChild,
      _el$21 = _el$20.nextSibling,
      [_el$22, _co$7] = $8tj43$getNextMarker(_el$21.nextSibling);
    $8tj43$addEventListener(_el$20, "click", close_modal_, true);
    $8tj43$insert(_el$19, modal_element, _el$22, _co$7);
    $8tj43$effect(_p$ => {
      var _v$ = (0, $c3820807ac1e6fd7$export$44dad306455dddf).SEARCH_MODAL,
        _v$2 = class_list_ === null || class_list_ === void 0 ? void 0 : class_list_();
      _v$ !== _p$.e && $8tj43$setAttribute(_el$19, "id", _p$.e = _v$);
      _p$.t = $8tj43$classList(_el$19, _v$2, _p$.t);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$19;
  })()];
}
const $40411f2ec772c376$export$9265e66f26f8e383 = /*@__PURE__*/(() => {
  $40411f2ec772c376$var$RawClassicSearchModal[(0, $b026fa9c9c904a98$export$1ea76ea778b880dd)] = 1;
  $40411f2ec772c376$var$RawClassicSearchModal[(0, $b026fa9c9c904a98$export$89890212b43f1b60)] = (0, $fac58b5610eec6a9$export$8d8893ffd8aca39a);
  return $40411f2ec772c376$var$RawClassicSearchModal;
})();
$8tj43$delegateEvents(["click"]);
var $4a3ed70b3b7c60d5$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=32 height=32 fill=none><path d="M28.061 17.061l-9 9c-.282.282-.664.44-1.062.44a1.5 1.5 0 0 1-1.062-.44c-.282-.282-.44-.664-.44-1.062s.158-.781.44-1.062l6.439-6.436H5A1.5 1.5 0 0 1 3.5 16 1.5 1.5 0 0 1 5 14.5h18.375l-6.436-6.44c-.282-.282-.44-.664-.44-1.063s.158-.781.44-1.062.664-.44 1.063-.44a1.5 1.5 0 0 1 1.063.44l9 9a1.5 1.5 0 0 1 .441 1.064 1.5 1.5 0 0 1-.443 1.063z"fill=#868689>`);
function $4a3ed70b3b7c60d5$export$9ca09caa9c849d9c() {
  return $8tj43$getNextElement($4a3ed70b3b7c60d5$var$_tmpl$);
}
var $26db6925469636a4$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a>`),
  $26db6925469636a4$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=images-wrapper>`),
  $26db6925469636a4$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class=listing-card><!$><!/><!$><!/><h3 class=title>`),
  $26db6925469636a4$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class=empty-image>`);
const $26db6925469636a4$var$aspectRatioWidthComponent = 400;
const $26db6925469636a4$var$aspectRatioHeightComponent = 200;
const $26db6925469636a4$var$listingSuggestionCollageAspectRatio = $26db6925469636a4$var$aspectRatioWidthComponent / $26db6925469636a4$var$aspectRatioHeightComponent;
function $26db6925469636a4$export$67152d26d4f56ee8(_ref) {
  let {
    listing_: listing_,
    router_: router_,
    i18n_: i18n_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    sorting_query_param_: sorting_query_param_,
    merchant_: merchant_,
    keyboardNavigationGroupIndex_: keyboardNavigationGroupIndex_,
    index_: index_,
    selected_index_: [read_selected_index_, write_selected_index_]
  } = _ref;
  const href = $8tj43$createMemo(() => {
    var _listing_;
    return (_listing_ = listing_()) === null || _listing_ === void 0 ? void 0 : _listing_.page_url;
  }); // <- could be made reactive getter created in displayTransformers, read it in memo here since it might create computations (for example in the preview-brower), and there's no owner in the onClick handler
  const LinkToListing = props => (() => {
    var _el$ = $8tj43$getNextElement($26db6925469636a4$var$_tmpl$);
    $8tj43$spread(_el$, $8tj43$mergeProps1(props, {
      get href() {
        return href();
      },
      get onClick() {
        return $8tj43$catchify1(ev => href() && router_.navigate_.go_to_({
          new_url_: href(),
          is_replace_: false,
          event_: ev,
          listing_query_: {
            id: listing_().listing_id,
            type: $397620a4d7958ed1$export$74ee7529ce0f8a00
          }
        }));
      }
    }), false, false);
    $8tj43$runHydrationEvents();
    return _el$;
  })();
  const image_urls = $8tj43$createMemo(() => {
    var _listing_2, _listing_2$image_urls;
    return (_listing_2 = listing_()) === null || _listing_2 === void 0 ? void 0 : (_listing_2$image_urls = _listing_2.image_urls) === null || _listing_2$image_urls === void 0 ? void 0 : _listing_2$image_urls.slice(0, 3);
  });
  const [isSelected, selectedDueToKeyboardNavigation] = $d0883254246d3eb6$export$fb40a80c530e5f2b(read_selected_index_, keyboardNavigationGroupIndex_, index_);
  const crumbData = $8tj43$createMemo(() => {
    var _listing_3;
    return (_listing_3 = listing_()) === null || _listing_3 === void 0 ? void 0 : _listing_3.ancestors;
  });
  return (() => {
    var _el$2 = $8tj43$getNextElement($26db6925469636a4$var$_tmpl$3),
      _el$5 = _el$2.firstChild,
      [_el$6, _co$] = $8tj43$getNextMarker(_el$5.nextSibling),
      _el$7 = _el$6.nextSibling,
      [_el$8, _co$2] = $8tj43$getNextMarker(_el$7.nextSibling),
      _el$4 = _el$8.nextSibling;
    $8tj43$use(element => $d0883254246d3eb6$export$12761f53d7ab7f27(element, selectedDueToKeyboardNavigation), _el$2);
    $8tj43$addEventListener(_el$2, "mouseleave", $8tj43$catchify1(() => write_selected_index_()));
    $8tj43$addEventListener(_el$2, "mouseover", $8tj43$catchify1(_ref2 => {
      let {
        target: target
      } = _ref2;
      // Using onMouseOver instead of onMouseEnter to also trigger when the hovered child changes
      const crumbsSelector = ".crumbs";
      if (target.matches(crumbsSelector) || target.closest(crumbsSelector)) {
        write_selected_index_();
        return;
      }
      write_selected_index_([keyboardNavigationGroupIndex_(), index_()]);
    }), true);
    $8tj43$insert(_el$2, $8tj43$createComponent(LinkToListing, {
      "class": "image-part",
      get style() {
        var _image_urls$length, _image_urls;
        return "--image-count: ".concat((_image_urls$length = (_image_urls = image_urls()) === null || _image_urls === void 0 ? void 0 : _image_urls.length) !== null && _image_urls$length !== void 0 ? _image_urls$length : 0);
      },
      tabIndex: -1,
      get children() {
        var _el$3 = $8tj43$getNextElement($26db6925469636a4$var$_tmpl$2);
        $8tj43$insert(_el$3, $8tj43$createComponent($26db6925469636a4$export$ea41102db9bd68c3, {
          image_urls_: image_urls
        }));
        return _el$3;
      }
    }), _el$6, _co$);
    $8tj43$insert(_el$2, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        var _crumbData;
        return ((_crumbData = crumbData()) === null || _crumbData === void 0 ? void 0 : _crumbData.length) !== 0;
      },
      get children() {
        return $8tj43$createComponent((0, $52efc9ae4382e25a$export$5646050d516e06bc), {
          crumb_data_: crumbData,
          router_: router_,
          i18n_: i18n_,
          sorting_query_param_: sorting_query_param_,
          filter_query_param_prefix_: filter_query_param_prefix_,
          placeholderData_: [,,]
        });
      }
    }), _el$8, _co$2);
    $8tj43$insert(_el$4, $8tj43$createComponent(LinkToListing, {
      get children() {
        var _listing_4;
        return ((_listing_4 = listing_()) === null || _listing_4 === void 0 ? void 0 : _listing_4.title) || $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
          height: "1em",
          width: "15ch"
        });
      }
    }));
    $8tj43$effect(_p$ => {
      var _v$ = !!isSelected(),
        _v$2 = isSelected();
      _v$ !== _p$.e && _el$2.classList.toggle("selected", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$setAttribute(_el$2, "aria-selected", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    $8tj43$runHydrationEvents();
    return _el$2;
  })();
}
function $26db6925469636a4$export$ea41102db9bd68c3(_ref3) {
  let {
    image_urls_: image_urls_
  } = _ref3;
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _image_urls_;
      return (_image_urls_ = image_urls_()) === null || _image_urls_ === void 0 ? void 0 : _image_urls_.length;
    },
    get fallback() {
      return $8tj43$createComponent($26db6925469636a4$var$EmptyImage, {});
    },
    get children() {
      return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          return $8tj43$createComponent((0, $8tj43$For), {
            get each() {
              return image_urls_();
            },
            children: url => $8tj43$createComponent((0, $98688279b9059f50$export$9d4a4b669b1929ab), {
              src: url,
              get aspectRatio() {
                return $26db6925469636a4$var$aspectRatioWidthComponent / image_urls_().length / $26db6925469636a4$var$aspectRatioHeightComponent;
              },
              imgProps: {
                style: "object-fit: cover;"
              }
            })
          });
        }
      });
    }
  });
}
function $26db6925469636a4$var$EmptyImage() {
  return (() => {
    var _el$9 = $8tj43$getNextElement($26db6925469636a4$var$_tmpl$4);
    _el$9.style.setProperty("aspect-ratio", "2");
    $8tj43$insert(_el$9, $8tj43$createComponent((0, $4a3ed70b3b7c60d5$export$9ca09caa9c849d9c), {}));
    return _el$9;
  })();
}
$8tj43$delegateEvents(["mouseover"]);
var $ab401afaded322ab$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=visual-listing-suggestions><h2></h2><!$><!/>`),
  $ab401afaded322ab$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=suggestion-container>`);
function $ab401afaded322ab$export$c8d7e00464029b45(_ref) {
  let {
    listing_suggestions_: listing_suggestions_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    sorting_query_param_: sorting_query_param_,
    router_: router_,
    i18n_: i18n_,
    merchant_: merchant_,
    itemIndex_: itemIndex_,
    selected_index_: selected_index_,
    modalLayoutStacked_: modalLayoutStacked_,
    showPlaceholders_: showPlaceholders_,
    currently_showing_suggestions_: [, set_currently_showing_suggestions]
  } = _ref;
  const listings_by_id = $8tj43$createMemo(() => Object.fromEntries((listing_suggestions_() || []).map(listing => [listing.listing_id, listing])));
  const productCards = $8tj43$createComponent((0, $8tj43$For), {
    get each() {
      return $8tj43$memo(() => !!showPlaceholders_())() ? [,,,] : Object.keys(listings_by_id());
    },
    children: (listingId, index) => {
      const listing = $8tj43$createMemo(() => listingId == undefined ? undefined : listings_by_id()[listingId]);
      return $8tj43$createComponent((0, $26db6925469636a4$export$67152d26d4f56ee8), {
        listing_: listing,
        i18n_: i18n_,
        router_: router_,
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_,
        merchant_: merchant_,
        keyboardNavigationGroupIndex_: itemIndex_,
        index_: index,
        selected_index_: selected_index_
      });
    }
  });
  $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions, itemIndex_, $8tj43$createMemo(() => {
    var _listing_suggestions_;
    return ((_listing_suggestions_ = listing_suggestions_()) === null || _listing_suggestions_ === void 0 ? void 0 : _listing_suggestions_.map(suggestion => ({
      title_: suggestion.title,
      page_url_: suggestion.page_url
    }))) || [];
  }));
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _listing_suggestions_2;
      return ((_listing_suggestions_2 = listing_suggestions_()) === null || _listing_suggestions_2 === void 0 ? void 0 : _listing_suggestions_2.length) || showPlaceholders_();
    },
    get children() {
      var _el$ = $8tj43$getNextElement($ab401afaded322ab$var$_tmpl$),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.nextSibling,
        [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling);
      $8tj43$insert(_el$2, () => i18n_.listing_suggestions_());
      $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return modalLayoutStacked_();
        },
        get fallback() {
          return (() => {
            var _el$5 = $8tj43$getNextElement($ab401afaded322ab$var$_tmpl$2);
            $8tj43$insert(_el$5, productCards);
            return _el$5;
          })();
        },
        get children() {
          return $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
            fadingThreshold_: 0.5,
            snapAlign_: "center",
            slider_ref_: slider => {
              const {
                insert_here: insert_here,
                container: container
              } = slider;
              const Layout = props => $63f1f8dbcd07d3b0$export$445d8d3f5f706a40(props, insert_here, true);
              // Do like this, so we don't have to call mergeProps ourselves
              $8tj43$createComponent(Layout, {
                rows: "all",
                layout: "slider",
                grid_spacing: "12px",
                cols_at_size: [[1.25, "0px"]]
              });
              container.classList.add("products");
            },
            children: productCards
          });
        }
      }), _el$4, _co$);
      $8tj43$effect(_$p => (_$p = itemIndex_()) != null ? _el$.style.setProperty("order", _$p) : _el$.style.removeProperty("order"));
      return _el$;
    }
  });
}
var $5175a47d13b7c228$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div><div class=title-row><h2></h2><!$><!/></div><div class=suggestion-container>`),
  $5175a47d13b7c228$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<a class=suggestion>`);
function $5175a47d13b7c228$export$d4994a86c6235f72(_ref) {
  let {
    search_query_url_param_name_: search_query_url_param_name_,
    selected_index_: [read_selected_index_, write_selected_index_],
    url_transformer_: url_transformer_,
    currently_showing_suggestions_: [, set_currently_showing_suggestions],
    extraTitleRowElements_: extraTitleRowElements_,
    title_: title_,
    searching_for_value_: searching_for_value_,
    submit_query_: submit_query_,
    class_: class_,
    itemIndex_: itemIndex_,
    itemsToShow_: itemsToShow_,
    router_: router_,
    showPlaceholders_: showPlaceholders_
  } = _ref;
  const currentHref = $8tj43$use_href_accessor1();
  $d0883254246d3eb6$export$c2da72ac4e439a0e(set_currently_showing_suggestions, itemIndex_, itemsToShow_);
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _itemsToShow_;
      return ((_itemsToShow_ = itemsToShow_()) === null || _itemsToShow_ === void 0 ? void 0 : _itemsToShow_.length) || showPlaceholders_();
    },
    get children() {
      var _el$ = $8tj43$getNextElement($5175a47d13b7c228$var$_tmpl$),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.firstChild,
        _el$4 = _el$3.nextSibling,
        [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
        _el$6 = _el$2.nextSibling;
      $8tj43$className(_el$, "suggestions " + class_);
      $8tj43$insert(_el$3, title_);
      $8tj43$insert(_el$2, () => extraTitleRowElements_ === null || extraTitleRowElements_ === void 0 ? void 0 : extraTitleRowElements_(), _el$5, _co$);
      $8tj43$insert(_el$6, $8tj43$createComponent((0, $8tj43$Show), {
        get when() {
          return !showPlaceholders_();
        },
        get fallback() {
          return Array.from({
            length: 3
          }).map(() => $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
            "class": "suggestion line-clamp",
            width: "min(100%, 25ch)",
            height: "1em"
          }));
        },
        get children() {
          return $8tj43$createComponent((0, $8tj43$Index), {
            get each() {
              return itemsToShow_();
            },
            children: (item, index) => {
              const href = $8tj43$createMemo(() => {
                const itemContents = item();
                if ("page_url_" in itemContents) return itemContents.page_url_;
                const urlObject = new URL(currentHref());
                url_transformer_ === null || url_transformer_ === void 0 || url_transformer_(urlObject);
                urlObject.searchParams.set(search_query_url_param_name_, itemContents.title_);
                return urlObject.href;
              });
              const [isSelected, selectedDueToKeyboardNavigation] = $d0883254246d3eb6$export$fb40a80c530e5f2b(read_selected_index_, itemIndex_, () => index);
              const wholeTextToDisplay = $8tj43$createMemo(() => item().title_);
              return (() => {
                var _el$7 = $8tj43$getNextElement($5175a47d13b7c228$var$_tmpl$2);
                $8tj43$use(element => {
                  $d0883254246d3eb6$export$12761f53d7ab7f27(element, selectedDueToKeyboardNavigation);
                  element.addEventListener("click", $8tj43$catchify1(ev => {
                    // Viskan's Oscar Jacobson site requires us to add the event listener normally here. They do too much when this element is clicked. We work around it by blocking the event and just dispatching it non-bubbling on this element.
                    const itemContents = item();
                    if ("page_url_" in itemContents) {
                      router_.navigate_.go_to_({
                        new_url_: href(),
                        is_replace_: false,
                        event_: ev
                      });
                      return;
                    }
                    if ($9b35d1384e31813a$export$29d28dadc2d6b631(ev)) return; // not button 0 or cmd/ctrl click
                    ev.preventDefault();
                    submit_query_(itemContents.title_);
                  }));
                }, _el$7);
                $8tj43$addEventListener(_el$7, "mouseleave", $8tj43$catchify1(() => write_selected_index_()));
                $8tj43$addEventListener(_el$7, "mouseenter", $8tj43$catchify1(() => write_selected_index_([itemIndex_(), index])));
                $8tj43$insert(_el$7, $8tj43$createComponent((0, $02b6641aa50ce528$export$ba17c5b7e6dda39f), {
                  class_: "title line-clamp",
                  whole_text_to_display_: wholeTextToDisplay,
                  searching_for_value_: searching_for_value_
                }));
                $8tj43$effect(_p$ => {
                  var _v$ = !!isSelected(),
                    _v$2 = isSelected(),
                    _v$3 = href(),
                    _v$4 = wholeTextToDisplay();
                  _v$ !== _p$.e && _el$7.classList.toggle("selected", _p$.e = _v$);
                  _v$2 !== _p$.t && $8tj43$setAttribute(_el$7, "aria-selected", _p$.t = _v$2);
                  _v$3 !== _p$.a && $8tj43$setAttribute(_el$7, "href", _p$.a = _v$3);
                  _v$4 !== _p$.o && $8tj43$setAttribute(_el$7, "aria-label", _p$.o = _v$4);
                  return _p$;
                }, {
                  e: undefined,
                  t: undefined,
                  a: undefined,
                  o: undefined
                });
                return _el$7;
              })();
            }
          });
        }
      }));
      $8tj43$effect(_$p => (_$p = itemIndex_()) != null ? _el$.style.setProperty("order", _$p) : _el$.style.removeProperty("order"));
      return _el$;
    }
  });
}
var $4acc866f8fdfc002$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<button class=delete type=button>`);
const $4acc866f8fdfc002$var$MAX_PREVIOUS = 3;
function $4acc866f8fdfc002$export$af1fb307bbba2417(_ref) {
  let {
    search_field_value_: search_field_value_,
    search_query_url_param_name_: search_query_url_param_name_,
    previous_searches_: [, set_unfiltered_previous_searches_],
    url_transformer_: url_transformer_,
    currently_showing_suggestions_: currently_showing_suggestions_,
    selected_index_: selected_index_,
    i18n_: i18n_,
    submit_query_: submit_query_,
    router_: router_,
    suggestions_response_: suggestions_response_,
    suggestions_updating_blocked_: suggestions_updating_blocked_,
    searching_for_value_: searching_for_value_,
    contentResultsToShow_: contentResultsToShow_,
    previous_searches_matching_query_: previous_searches_matching_query_,
    itemIndexes_: itemIndexes_,
    noResults_: noResults_,
    depict_api_: depict_api_,
    merchant_: merchant_,
    market_: market_,
    get_modal_search_results_: get_modal_search_results_
  } = _ref;
  const [suggestions_updating_blocked] = suggestions_updating_blocked_;
  const [, set_selected_index] = selected_index_;
  const previousSuggestionsToShow = $8tj43$createMemo(() => previous_searches_matching_query_().map(result => ({
    title_: result
  })).slice(0, $4acc866f8fdfc002$var$MAX_PREVIOUS));
  const requestPopularSuggestions = $8tj43$createMemo(prev => prev || noResults_());
  // When no results, request popular suggestions and show those
  const [noResultsPopularSuggestions] = $8tj43$createResource(() => requestPopularSuggestions() && {
    merchant: merchant_(),
    market: market_(),
    locale: i18n_.backend_locale_(),
    query: ""
  }, async requestObject => {
    const api_response = await depict_api_.suggest(requestObject);
    return api_response === null || api_response === void 0 ? void 0 : api_response.suggestions;
  });
  const filterOutQuerySuggestions = suggestions => {
    const prevMatchingQuery = previous_searches_matching_query_();
    return suggestions === null || suggestions === void 0 ? void 0 : suggestions.filter(suggestion => suggestion.type === "query" && !prevMatchingQuery.slice(0, $4acc866f8fdfc002$var$MAX_PREVIOUS).includes(suggestion.query) // don't show the ones we already show from the history
    ) // + limit to three query suggestions, API sends more sometimes
    .slice(0, 3).map(suggestion => ({
      title_: suggestion.query
    }));
  };
  // When no results, show popular suggestions
  const querySuggestionsToShow = $8tj43$createMemo(prev => {
    var _get_modal_search_res;
    const forQuery = filterOutQuerySuggestions(suggestions_response_());
    const forEmptyQuery = filterOutQuerySuggestions(noResultsPopularSuggestions());
    if (noResults_()) return forEmptyQuery;
    if (!(forQuery !== null && forQuery !== void 0 && forQuery.length) && (suggestions_response_.loading || (_get_modal_search_res = get_modal_search_results_()) !== null && _get_modal_search_res !== void 0 && _get_modal_search_res.loading))
      // Ensure we always show something while typing and loading
      return prev;
    return forQuery;
  });
  const sharedSuggestionProps = {
    searching_for_value_: searching_for_value_,
    search_query_url_param_name_: search_query_url_param_name_,
    selected_index_: selected_index_,
    currently_showing_suggestions_: currently_showing_suggestions_,
    submit_query_: submit_query_,
    url_transformer_: url_transformer_,
    router_: router_
  };
  const showPlaceholders = $8tj43$createMemo(() => !suggestions_response_.latest); // Only show placeholders on initial modal opening;
  $8tj43$createComputed($8tj43$on(search_field_value_[0], () => !suggestions_updating_blocked() && set_selected_index(undefined), {
    defer: true
  })); // reset autocomplete position if query changes
  return [$8tj43$createComponent((0, $5175a47d13b7c228$export$d4994a86c6235f72), $8tj43$mergeProps1(sharedSuggestionProps, {
    get title_() {
      return i18n_.popular_;
    },
    class_: "query-suggestions",
    itemsToShow_: querySuggestionsToShow,
    get itemIndex_() {
      return itemIndexes_.suggestionsIndex_;
    },
    showPlaceholders_: () => showPlaceholders() || noResults_() && !noResultsPopularSuggestions.latest
  })), $8tj43$createComponent((0, $5175a47d13b7c228$export$d4994a86c6235f72), $8tj43$mergeProps1(sharedSuggestionProps, {
    get title_() {
      return i18n_.previous_;
    },
    class_: "previous-searches",
    itemsToShow_: previousSuggestionsToShow,
    get itemIndex_() {
      return itemIndexes_.previousSearchesIndex_;
    },
    extraTitleRowElements_: () => (() => {
      var _el$ = $8tj43$getNextElement($4acc866f8fdfc002$var$_tmpl$);
      $8tj43$addEventListener(_el$, "click", $8tj43$catchify1(() => set_unfiltered_previous_searches_([])), true);
      $8tj43$insert(_el$, () => i18n_.clear_all_from_filter_crumbs_());
      $8tj43$runHydrationEvents();
      return _el$;
    })(),
    showPlaceholders_: () => false
  })), $8tj43$createComponent((0, $5175a47d13b7c228$export$d4994a86c6235f72), $8tj43$mergeProps1(sharedSuggestionProps, {
    get title_() {
      return i18n_.content_;
    },
    class_: "content-suggestions",
    itemsToShow_: contentResultsToShow_,
    get itemIndex_() {
      return itemIndexes_.contentResultsIndex_;
    },
    showPlaceholders_: showPlaceholders
  }))];
}
$8tj43$delegateEvents(["click"]);
function $6cd081415b01a112$export$b608d7df125109f1(_ref) {
  let {
    depict_api_: depict_api_,
    selected_index_: [, set_selected_index],
    search_field_value_: search_field_value_,
    suggestions_updating_blocked_: suggestions_updating_blocked_,
    merchant_: merchant_,
    market_: market_,
    i18n_: i18n_,
    set_show_stale_content_results_: set_show_stale_content_results_,
    set_searching_for_value_: set_searching_for_value_
  } = _ref;
  const [requestObject, setRequestObject] = $8tj43$createSignal();
  const suggestionsResource = $a604a8ffa4e4c03f$export$e417c49320921907(requestObject, async request_obj => {
    const api_response = await depict_api_.suggest(request_obj);
    return api_response === null || api_response === void 0 ? void 0 : api_response.suggestions;
  });
  $8tj43$createComputed(() => {
    const field_value = search_field_value_();
    if ($8tj43$untrack(suggestions_updating_blocked_))
      // not using updating_blocked instead of below signal since I presume they'd start updating too early then
      set_show_stale_content_results_(true);else {
      set_searching_for_value_(field_value);
      setRequestObject({
        merchant: merchant_(),
        market: market_(),
        locale: i18n_.backend_locale_(),
        query: field_value
      });
      set_show_stale_content_results_(false);
    }
  });
  $8tj43$createComputed(() => {
    if (suggestionsResource()) set_selected_index(undefined); // reset selected index on new results
  });

  return suggestionsResource;
}
var $c2fe922d21c40514$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<svg xmlns=http://www.w3.org/2000/svg width=20 height=20><path d="M8.089 16.288l-5.625-5.625a.94.94 0 0 1-.276-.664c0-.123.024-.246.072-.36a.94.94 0 0 1 .204-.305L8.089 3.71a.94.94 0 0 1 1.328 0 .94.94 0 0 1 0 1.328L5.393 9.063h11.484a.94.94 0 0 1 .938.937c0 .249-.099.487-.275.663s-.414.275-.663.275H5.393l4.025 4.024a.94.94 0 0 1 0 1.328.94.94 0 0 1-1.328 0v-.002z">`);
function $c2fe922d21c40514$export$3fcbcd8bd3e0290f() {
  return $8tj43$getNextElement($c2fe922d21c40514$var$_tmpl$);
}
const $c2fe922d21c40514$export$11e9f390c90a537f = /*@__PURE__*/(() => {
  $c2fe922d21c40514$export$3fcbcd8bd3e0290f[(0, $b026fa9c9c904a98$export$1ea76ea778b880dd)] = 2; // Lil hack so that we can identify this back icon in SearchField.tsx and set the correct tabindex
  return $c2fe922d21c40514$export$3fcbcd8bd3e0290f;
})();
function $1abb91ab5abc8994$export$66d1697a0f27069c(modalLayoutStacked) {
  const suggestionsIndex_ = $8tj43$createMemo(() => 1);
  const previousSearchesIndex_ = $8tj43$createMemo(() => 2);
  const contentResultsIndex_ = $8tj43$createMemo(() => modalLayoutStacked() ? 5 : 3);
  const instantResultsIndex_ = $8tj43$createMemo(() => 4);
  const listingSuggestionsIndex_ = $8tj43$createMemo(() => modalLayoutStacked() ? 3 : 5);
  return {
    suggestionsIndex_: suggestionsIndex_,
    listingSuggestionsIndex_: listingSuggestionsIndex_,
    previousSearchesIndex_: previousSearchesIndex_,
    contentResultsIndex_: contentResultsIndex_,
    instantResultsIndex_: instantResultsIndex_
  };
}
var $06fcd2a345efd24d$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=instant-results-wrapper><h2></h2><!$><!/>`),
  $06fcd2a345efd24d$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div>`),
  $06fcd2a345efd24d$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<dialog>`),
  $06fcd2a345efd24d$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class=discover-more><button class=major type=button>`),
  $06fcd2a345efd24d$var$_tmpl$5 = /*#__PURE__*/$8tj43$template(`<b>`),
  $06fcd2a345efd24d$var$_tmpl$6 = /*#__PURE__*/$8tj43$template(`<div class=depict-search-modal-backdrop>`),
  $06fcd2a345efd24d$var$_tmpl$7 = /*#__PURE__*/$8tj43$template(`<div class=depict-search-modal><div class=body role=search aria-label="Search modal with search field, query suggestions and result preview"><!$><!/><div id=depict-suggestions-and-result-preview class=padded></div></div><!$><!/>`),
  $06fcd2a345efd24d$var$_tmpl$8 = /*#__PURE__*/$8tj43$template(`<div class=left>`),
  $06fcd2a345efd24d$var$_tmpl$9 = /*#__PURE__*/$8tj43$template(`<div class=right>`);
/**
 * Second generation search modal - the solid component that gets added to <body> when the search modal is opened
 */
function $06fcd2a345efd24d$var$RawSearchModalV2(_ref) {
  let {
    search_field_value_: props_search_field_value,
    get_search_query_: get_search_query_,
    search_query_url_param_name_: search_query_url_param_name_,
    previous_searches_: previous_searches_,
    close_modal_: close_modal_,
    alignmentSignals_: alignmentSignals_,
    depict_api_: depict_api_,
    merchant_: merchant_,
    market_: market_,
    submit_query_: props_submit_query,
    instant_results_options_: instant_results_options_,
    register_closing_animation_: register_closing_animation_,
    url_transformer_: url_transformer_,
    closing_animation_: closing_animation_,
    clear_filters_: clear_filters_,
    i18n_: i18n_,
    disable_scrolling_ = true,
    enable_category_suggestions_: enable_category_suggestions_,
    class_list_: class_list_,
    bottom_distance_under_modal_: bottom_distance_under_modal_,
    selected_text_range_: selected_text_range_,
    dont_sync_search_field_value_except_on_submit_ = false,
    router_: router_,
    content_search_enabled_: content_search_enabled_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_,
    setSearchFieldOuterWidth_: setSearchFieldOuterWidth_,
    forceUseDiv_: forceUseDiv_
  } = _ref;
  let on_enter_in_search_field_function;
  let listingSuggestionsDebounceTimeout;
  // As per feedback from stronger we sometimes want a modal with the search field value disconnected from the one in the rest of the UI, see https://depictaiworkspace.slack.com/archives/C02J16R9XEH/p1679065878487709.
  // This is desired for when the modal is opened from a UI element that visually does not look connected with the search page or current query
  // Basically the UI signals that the button that opens the modal starts a new search.
  const search_field_value_ = dont_sync_search_field_value_except_on_submit_ ? $8tj43$createSignal("") : props_search_field_value;
  const propagate_search_field_value_back = dont_sync_search_field_value_except_on_submit_ ? () => props_search_field_value[1]($8tj43$untrack(search_field_value_[0])) // Set actual search field value to the throwaway internal one before submitting
  : undefined;
  const submit_query_ = function () {
    // submit_query expects to read the current search field value which is why we have to write the current one to the signal before calling it
    // It will write the old one back and then write the new one after submit
    propagate_search_field_value_back === null || propagate_search_field_value_back === void 0 || propagate_search_field_value_back();
    return props_submit_query(...arguments);
  };
  const [input_field, set_input_field] = $8tj43$createSignal();
  const [searching_for_value_, set_searching_for_value_] = $8tj43$createSignal();
  const [show_stale_content_results_, set_show_stale_content_results_] = $8tj43$createSignal(false);
  // For fake debounce
  const [showStaleListingSuggestions, setShowStaleListingSuggestions] = $8tj43$createSignal(false);
  const suggestions_updating_blocked_ = $8tj43$createSignal(false);
  const [modalBodyWidth, setModalBodyWidth] = $8tj43$createSignal(0);
  const modalLayoutStacked_ = $8tj43$createMemo(() => modalBodyWidth() < 650);
  const itemIndexes = $1abb91ab5abc8994$export$66d1697a0f27069c(modalLayoutStacked_);
  const [get_search_field_value_] = search_field_value_;
  const [suggestions_updating_blocked] = suggestions_updating_blocked_;
  const [unfiltered_previous_searches] = previous_searches_;
  const random_classname_body = $8tj43$make_random_classname();
  const backdropRandomClassname = $8tj43$make_random_classname();
  const [get_modal_search_results_, set_modal_search_results_] = $8tj43$createSignal();
  const close_on_escape_handler = $8tj43$catchify1(evt => {
    if (evt.key === "Escape") {
      evt.preventDefault(); // Prevent the browser from closing/cancelling the modal so our animations have time to run
      close_modal_();
    }
  });
  const selected_index_ = $8tj43$createSignal();
  const currently_showing_suggestions_ = $8tj43$createSignal([], {
    equals: false
  });
  const suggestions_response_ = $6cd081415b01a112$export$b608d7df125109f1({
    depict_api_: depict_api_,
    search_field_value_: get_search_field_value_,
    selected_index_: selected_index_,
    merchant_: merchant_,
    market_: market_,
    i18n_: i18n_,
    suggestions_updating_blocked_: suggestions_updating_blocked,
    set_searching_for_value_: set_searching_for_value_,
    set_show_stale_content_results_: set_show_stale_content_results_
  });
  const listing_suggestions_ = $8tj43$createMemo(prev => {
    var _suggestions_response;
    const all = enable_category_suggestions_ ? (_suggestions_response = suggestions_response_()) === null || _suggestions_response === void 0 ? void 0 : _suggestions_response.filter(item => item.type === "listing") : [];
    // To prevent jumping of the modal when the visual listing suggestions exist/don't exist we debounce it the same way as the product results
    if (showStaleListingSuggestions() && !(all !== null && all !== void 0 && all.length)) return prev;
    if (modalLayoutStacked_()) return all;
    return all === null || all === void 0 ? void 0 : all.slice(0, 3);
  });
  const previous_searches_without_current_query = $8tj43$createMemo(() => [...unfiltered_previous_searches()].reverse().filter(q => q !== get_search_query_()));
  const previous_searches_matching_query = $8tj43$createMemo(() => {
    return previous_searches_without_current_query().filter(cs_search => {
      var _searching_for_value_;
      const search = cs_search.toLowerCase();
      const value = (_searching_for_value_ = searching_for_value_()) === null || _searching_for_value_ === void 0 ? void 0 : _searching_for_value_.toLowerCase();
      if (!value) return cs_search;
      return search.includes(value) || value.includes(search);
    }).slice(0, 3);
  });
  const contentResultsToShow_ = $8tj43$createMemo(prev => {
    var _get_modal_search_res, _get_modal_search_res2, _get_modal_search_res3;
    if (!content_search_enabled_()) return [];
    // don't update content results when query suggestions don't update because otherwise they disappear when trying to keyboard navigate to them
    if (show_stale_content_results_()) return prev;
    return ((_get_modal_search_res = get_modal_search_results_()) === null || _get_modal_search_res === void 0 ? void 0 : (_get_modal_search_res2 = _get_modal_search_res()) === null || _get_modal_search_res2 === void 0 ? void 0 : (_get_modal_search_res3 = _get_modal_search_res2.content_search_links) === null || _get_modal_search_res3 === void 0 ? void 0 : _get_modal_search_res3.map(link => ({
      page_url_: link.page_url,
      title_: link.title
    })).slice(0, 3)) || [];
  }, []);
  // Ideally we'd propagate up the suggestion signal too and call this from SearchModal.tsx? Because it's not super related with autocomplete, but it's not a huge feature, and it's easier here so keeping it.
  // It's the functionality to open the content results page when you press enter, in the modal, when there's only one content result
  const manipulated_set_override_on_enter_fn_ = $c4dee1ef44de29ca$export$af0124069c150252({
    set_override_on_enter_fn_: new_fn => on_enter_in_search_field_function = new_fn,
    get_modal_search_results_: get_modal_search_results_,
    suggestions_response_: suggestions_response_,
    router_: router_,
    content_results_: contentResultsToShow_,
    has_previous_searches_matching_query_: $8tj43$createMemo(() => previous_searches_matching_query().length > 0)
  });
  // total number of results = content results + product results + category suggestions
  const totalNumberResults = $8tj43$createMemo(() => {
    var _get_modal_search_res4, _results$displays, _results$content_sear, _listing_suggestions_;
    const results = (_get_modal_search_res4 = get_modal_search_results_()) === null || _get_modal_search_res4 === void 0 ? void 0 : _get_modal_search_res4();
    // Show actual number of result (more accurate) if there's no cursor (backend doesn't have more products)
    const hits = results !== null && results !== void 0 && results.cursor ? results === null || results === void 0 ? void 0 : results.n_hits : results === null || results === void 0 ? void 0 : (_results$displays = results.displays) === null || _results$displays === void 0 ? void 0 : _results$displays.length;
    const content_results = content_search_enabled_() && (results === null || results === void 0 ? void 0 : (_results$content_sear = results.content_search_links) === null || _results$content_sear === void 0 ? void 0 : _results$content_sear.length) || 0;
    const category_results = ((_listing_suggestions_ = listing_suggestions_()) === null || _listing_suggestions_ === void 0 ? void 0 : _listing_suggestions_.length) || 0;
    return (hits !== null && hits !== void 0 ? hits : 0) + content_results + category_results;
  });
  const formattedTotalNumberResults = $43fbdca0f726a34b$export$92f2da32c6e7e7ee({
    number_: totalNumberResults,
    i18n_: i18n_
  });
  const {
    body_: bodyAlignmentSignal = $8tj43$createSignal({}),
    field_: [getFieldAlignmentStyling] = $8tj43$createSignal({}),
    backdrop_: [getBackdropStyling] = $8tj43$createSignal({})
  } = alignmentSignals_ || {};
  const [bodyAlignmentStyle] = bodyAlignmentSignal;
  const mergedCssObject = $8tj43$createMemo(() => {
    // We can't set the alignment styling as inline styles due to them getting a too high precedence (not easy to override) so we put them into a <style> tag
    // In the V2 modal, we need to be able to target both the search field and modal body from align_field which does the alignment because the search field doesn't take the whole width of the modal
    const modalBodyStyle = {
      width: "80vw",
      position: "absolute",
      ...bodyAlignmentStyle()
    };
    return {
      [".depict .".concat(random_classname_body)]: modalBodyStyle,
      [".depict .".concat(backdropRandomClassname)]: getBackdropStyling(),
      [".depict .".concat(random_classname_body, " .search-field .field")]: getFieldAlignmentStyling()
    };
  });
  const noResults = $8tj43$createMemo(prev => {
    var _get_modal_search_res5;
    return (((_get_modal_search_res5 = get_modal_search_results_()) === null || _get_modal_search_res5 === void 0 ? void 0 : _get_modal_search_res5.loading) === false && !suggestions_response_.loading || !!prev) && totalNumberResults() === 0 && previous_searches_matching_query().length === 0;
  });
  if (disable_scrolling_) $e56d241d0f33d459$export$fe334901e8bebd57();
  $a82a41ab7188eda2$export$93d9bfd0c9c1a5b8(close_modal_, search_query_url_param_name_);
  addEventListener("keydown", close_on_escape_handler);
  $8tj43$onCleanup(() => removeEventListener("keydown", close_on_escape_handler));
  $8tj43$createEffect($8tj43$on(get_search_field_value_, () => {
    setShowStaleListingSuggestions(true);
    clearTimeout(listingSuggestionsDebounceTimeout);
    listingSuggestionsDebounceTimeout = setTimeout($8tj43$catchify1(() => setShowStaleListingSuggestions(false)), 350);
  }, {
    defer: true
  }));
  if (closing_animation_) register_closing_animation_(closing_animation_);
  $a09bb7c652acf957$export$3340fdd8259bd4fd({
    get_search_field_value_: get_search_field_value_,
    url_transformer_: url_transformer_,
    search_query_url_param_name_: search_query_url_param_name_,
    get_search_query_: get_search_query_
  });
  $75e33704f2a83029$export$217899a935ef803b({
    element_: input_field,
    selected_index_: selected_index_,
    search_field_value_: search_field_value_,
    updating_blocked_: suggestions_updating_blocked_,
    currently_showing_suggestions_: currently_showing_suggestions_,
    set_override_on_enter_fn_: manipulated_set_override_on_enter_fn_,
    search_query_param_name_: search_query_url_param_name_,
    url_transformer_: url_transformer_,
    router_: router_
  });
  const renderedTextSuggestions = $cb64b315b25cfc59$export$2f0cbfbb4354bb52($8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    severity_: "error",
    message_: "Query suggestions failed",
    get children() {
      return $8tj43$createComponent((0, $4acc866f8fdfc002$export$af1fb307bbba2417), {
        search_field_value_: search_field_value_,
        previous_searches_: previous_searches_,
        search_query_url_param_name_: search_query_url_param_name_,
        selected_index_: selected_index_,
        currently_showing_suggestions_: currently_showing_suggestions_,
        url_transformer_: url_transformer_,
        i18n_: i18n_,
        router_: router_,
        submit_query_: submit_query_,
        suggestions_response_: suggestions_response_,
        suggestions_updating_blocked_: suggestions_updating_blocked_,
        searching_for_value_: searching_for_value_,
        previous_searches_matching_query_: previous_searches_matching_query,
        contentResultsToShow_: contentResultsToShow_,
        itemIndexes_: itemIndexes,
        noResults_: noResults,
        merchant_: merchant_,
        market_: market_,
        depict_api_: depict_api_,
        get_modal_search_results_: get_modal_search_results_
      });
    }
  }));
  const renderedVisualSuggestions = $cb64b315b25cfc59$export$2f0cbfbb4354bb52([$8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    severity_: "error",
    message_: "Instant results failed",
    get children() {
      return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          var _el$ = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$),
            _el$2 = _el$.firstChild,
            _el$3 = _el$2.nextSibling,
            [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling);
          $8tj43$insert(_el$2, () => i18n_.products_());
          $8tj43$insert(_el$, () => $f7414b949aeabc90$export$62f101a8aa597bf8({
            search_field_value_: search_field_value_,
            depict_api_: depict_api_,
            merchant_: merchant_,
            i18n_: i18n_,
            market_: market_,
            router_: router_,
            set_modal_search_results_: set_modal_search_results_,
            itemIndex_: itemIndexes.instantResultsIndex_,
            selected_index_: selected_index_,
            currently_showing_suggestions_: currently_showing_suggestions_,
            InstantCardImageComponent_: props => $8tj43$createComponent((0, $98688279b9059f50$export$9d4a4b669b1929ab), {
              get src() {
                return props.src_;
              },
              autoAdjustAspectRatio: true,
              aspectRatio: 1,
              get ["class"]() {
                return props.class_;
              },
              imgProps: {
                alt: "Product image"
              }
            }),
            ...instant_results_options_
          }), _el$4, _co$);
          $8tj43$effect(_$p => (_$p = itemIndexes.instantResultsIndex_()) != null ? _el$.style.setProperty("order", _$p) : _el$.style.removeProperty("order"));
          return _el$;
        }
      });
    }
  }), $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
    severity_: "error",
    message_: "Visual listing suggestions failed",
    get children() {
      return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          return $8tj43$createComponent((0, $8tj43$Show), {
            when: enable_category_suggestions_ !== null && enable_category_suggestions_ !== void 0 ? enable_category_suggestions_ : true,
            get children() {
              return $8tj43$createComponent((0, $ab401afaded322ab$export$c8d7e00464029b45), {
                listing_suggestions_: listing_suggestions_,
                i18n_: i18n_,
                router_: router_,
                sorting_query_param_: sorting_query_param_,
                filter_query_param_prefix_: filter_query_param_prefix_,
                merchant_: merchant_,
                get itemIndex_() {
                  return itemIndexes.listingSuggestionsIndex_;
                },
                selected_index_: selected_index_,
                currently_showing_suggestions_: currently_showing_suggestions_,
                modalLayoutStacked_: modalLayoutStacked_,
                showPlaceholders_: () => !suggestions_response_.latest
              });
            }
          });
        }
      });
    }
  })]);
  const DialogElement = props => {
    if (forceUseDiv_) return (() => {
      var _el$5 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$2);
      $8tj43$spread(_el$5, props, false, true);
      $8tj43$insert(_el$5, () => props.children);
      $8tj43$runHydrationEvents();
      return _el$5;
    })();
    return (() => {
      var _el$6 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$3);
      $8tj43$spread(_el$6, props, false, true);
      $8tj43$insert(_el$6, () => props.children);
      $8tj43$runHydrationEvents();
      return _el$6;
    })();
  };
  const discoverMoreSection = (() => {
    var _el$7 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$4),
      _el$8 = _el$7.firstChild;
    $8tj43$addEventListener(_el$8, "click", $8tj43$catchify1(() => submit_query_()), true);
    $8tj43$insert(_el$8, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return get_search_field_value_();
      },
      get fallback() {
        return i18n_.modal_discover_more_();
      },
      get children() {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return totalNumberResults();
          },
          get fallback() {
            return i18n_.modal_view_all_no_results_();
          },
          get children() {
            return i18n_.modal_view_all_results_()((() => {
              var _el$9 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$5);
              $8tj43$insert(_el$9, formattedTotalNumberResults);
              return _el$9;
            })());
          }
        });
      }
    }));
    $8tj43$runHydrationEvents();
    return _el$7;
  })();
  const search_field = $584c06c09cf4609d$export$b94867ecbd698f21({
    BackIcon_: (0, $c2fe922d21c40514$export$11e9f390c90a537f),
    input_field_ref_: element => set_input_field(element),
    override_on_enter_: e => {
      var _on_enter_in_search_f;
      return (_on_enter_in_search_f = on_enter_in_search_field_function) === null || _on_enter_in_search_f === void 0 ? void 0 : _on_enter_in_search_f(e);
    },
    on_back_: close_modal_,
    search_field_value_: search_field_value_,
    submit_query_: submit_query_,
    clear_filters_: clear_filters_,
    i18n_: i18n_,
    after_focusing_: input_el => {
      // Restore the selection range from the SearchField that was used to open the modal, if it was saved.
      if (!selected_text_range_) return;
      const [start, end] = selected_text_range_;
      if (start === null || end === null) return;
      input_el.setSelectionRange(start, end);
    },
    setSearchRoleOnContainer_: false,
    ariaControls: "depict-suggestions-and-result-preview"
  });
  if (setSearchFieldOuterWidth_) {
    const resizeObserver = new ResizeObserver($8tj43$catchify1(records => setSearchFieldOuterWidth_(records.at(-1).contentRect.width)));
    resizeObserver.observe(search_field);
    $8tj43$onCleanup(() => resizeObserver.disconnect());
  }
  return [$8tj43$createComponent(DialogElement, {
    get id() {
      return (0, $c3820807ac1e6fd7$export$44dad306455dddf).SEARCH_MODAL;
    },
    "class": "depict plp search",
    get classList() {
      return class_list_ === null || class_list_ === void 0 ? void 0 : class_list_();
    },
    onClose: close_modal_,
    ref: element => {
      if (forceUseDiv_) return;
      const disconnect = (0, $8tj43$observer).onexists(element, _ref2 => {
        let {
          element: element,
          disconnector: disconnector
        } = _ref2;
        element.showModal();
        disconnector();
      });
      $8tj43$onCleanup(disconnect);
    },
    get children() {
      return [(() => {
        var _el$10 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$6);
        $8tj43$addEventListener(_el$10, "click", close_modal_, true);
        $8tj43$effect(_$p => $8tj43$classList(_el$10, {
          [backdropRandomClassname]: true
        }, _$p));
        $8tj43$runHydrationEvents();
        return _el$10;
      })(), (() => {
        var _el$11 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$7),
          _el$12 = _el$11.firstChild,
          _el$14 = _el$12.firstChild,
          [_el$15, _co$2] = $8tj43$getNextMarker(_el$14.nextSibling),
          _el$13 = _el$15.nextSibling,
          _el$16 = _el$12.nextSibling,
          [_el$17, _co$3] = $8tj43$getNextMarker(_el$16.nextSibling);
        $8tj43$addEventListener(_el$11, "click", $8tj43$catchify1(_ref3 => {
          let {
            target: target,
            currentTarget: currentTarget
          } = _ref3;
          if (target === currentTarget) close_modal_();
        }), true);
        $8tj43$use(element => {
          // We don't have contained queries in JS so use ResizeObserver instead. This is so that the modal automatically assumes a mobile layout when aligning with a short SearchField.
          const resizeObserver = new ResizeObserver($8tj43$catchify1(records => setModalBodyWidth(records.at(-1).contentRect.width)));
          resizeObserver.observe(element);
          $8tj43$onCleanup(() => resizeObserver.disconnect());
        }, _el$12);
        $8tj43$insert(_el$12, search_field, _el$15, _co$2);
        $8tj43$use(el => {
          $8tj43$catchify1((0, $558d0596fcf0e0b0$export$50b90be27d8502d9))(el, bodyAlignmentSignal, bottom_distance_under_modal_ || (() => 0.03 // 3% under SearchModalV2 by default
          ));
          // Workaround part 2 of https://github.com/solidjs/solid/issues/2030
          // We can't just re-render the components in the two different <Show> branches because <Show> would infinite loop because it depends on the resource created by the components
          // We could also lift out the createResource from InstantResults into this component, but this component is already huge.
          // When no results, also don't show left/right separation
          const showStackedDOM = $8tj43$createMemo(() => modalLayoutStacked_() || noResults());
          $8tj43$createEffect(() => {
            if (showStackedDOM()) {
              el.replaceChildren(...renderedTextSuggestions(), ...renderedVisualSuggestions(), discoverMoreSection);
              return;
            }
            el.replaceChildren(...[(() => {
              var _el$18 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$8);
              $8tj43$insert(_el$18, renderedTextSuggestions);
              return _el$18;
            })(), (() => {
              var _el$19 = $8tj43$getNextElement($06fcd2a345efd24d$var$_tmpl$9);
              $8tj43$insert(_el$19, renderedVisualSuggestions);
              return _el$19;
            })(), discoverMoreSection]);
          });
        }, _el$13);
        $8tj43$insert(_el$11, $8tj43$createComponent((0, $a86e71c0015bd8ab$export$f021bdedd3ec901a), {
          styles: mergedCssObject
        }), _el$17, _co$3);
        $8tj43$effect(_p$ => {
          var _v$ = !!modalLayoutStacked_(),
            _v$2 = {
              [random_classname_body]: true
            },
            _v$3 = !!noResults();
          _v$ !== _p$.e && _el$11.classList.toggle("stacked", _p$.e = _v$);
          _p$.t = $8tj43$classList(_el$12, _v$2, _p$.t);
          _v$3 !== _p$.a && _el$13.classList.toggle("no-results", _p$.a = _v$3);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        $8tj43$runHydrationEvents();
        return _el$11;
      })()];
    }
  })];
}
const $06fcd2a345efd24d$export$b0c55aa2e87c4be7 = /*@__PURE__*/(() => {
  $06fcd2a345efd24d$var$RawSearchModalV2[(0, $b026fa9c9c904a98$export$1ea76ea778b880dd)] = 2;
  $06fcd2a345efd24d$var$RawSearchModalV2[(0, $b026fa9c9c904a98$export$89890212b43f1b60)] = (0, $c2fe922d21c40514$export$11e9f390c90a537f);
  return $06fcd2a345efd24d$var$RawSearchModalV2;
})();
$8tj43$delegateEvents(["click"]);
var $6a439680ae7e9ba3$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<section aria-live=polite role=region class=tabs-body>`),
  $6a439680ae7e9ba3$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<nav role=tablist class=tabs-bar>`),
  $6a439680ae7e9ba3$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<article role=tabpanel>`);
const $6a439680ae7e9ba3$var$TabsContext = /*@__PURE__*/$8tj43$createContext();
const $6a439680ae7e9ba3$var$useTabs = () => $8tj43$useContext($6a439680ae7e9ba3$var$TabsContext);
function $6a439680ae7e9ba3$export$b2539bed5023c21c(props) {
  return $8tj43$createComponent($6a439680ae7e9ba3$var$TabsContext.Provider, {
    value: new (0, $8tj43$ListenableSet)(),
    get children() {
      return $8tj43$createComponent($6a439680ae7e9ba3$var$ActualTabs, $8tj43$mergeProps1(props, {
        get children() {
          return props.children;
        }
      }));
    }
  });
}
function $6a439680ae7e9ba3$var$ActualTabs(props) {
  const [tabsReactive, setTabsReactive] = $8tj43$createSignal([]); // Can't have a store since reconciling with a store would call the children getters, and we could get x-tle rendered components
  const [currentlySelected, setCurrentlySelected] = $8tj43$createSignal();
  const [tabsVisitedOnce, setTabsVisitedOnce] = $8tj43$createSignal(new Set(), {
    equals: false
  });
  const isSelected = $8tj43$createSelector(currentlySelected);
  const owner = $8tj43$getOwner();
  const updateTabsSignal = $8tj43$catchify(() => $8tj43$runWithOwner(owner, () => setTabsReactive([...ourTabsSet])));
  const ourTabsSet = $6a439680ae7e9ba3$var$useTabs();
  const location = $8tj43$use_href_accessor();
  const linkWithChangedHash = hash => {
    const u_o = new URL(location());
    u_o.hash = hash;
    return u_o.href;
  };
  const headerItems = $8tj43$createComponent((0, $8tj43$Index), {
    get each() {
      return tabsReactive();
    },
    children: item => {
      const weSelected = $8tj43$createMemo(() => isSelected(item().id));
      return $8tj43$createComponent((0, $8tj43$Dynamic), $8tj43$mergeProps1({
        get component() {
          return props.AnchorComponent;
        },
        get ["aria-controls"]() {
          return item().id;
        },
        role: "tab",
        get classList() {
          return {
            selected: weSelected()
          };
        }
      }, () => weSelected() ? {} : {
        href: linkWithChangedHash(item().id)
      }, {
        get children() {
          return item().label;
        }
      }));
    }
  });
  // Enable nice pattern of doing <Tabs><Tab>Content</Tab><Tab>More content</Tab></Tabs>
  $8tj43$children(() => props.children); // "Render" children (.children is a getter), this means that we now can connect the children with the parent
  for (const event of ["add", "delete"]) {
    ourTabsSet.addEventListener(event, updateTabsSignal);
    $8tj43$onCleanup(() => ourTabsSet.removeEventListener(event, updateTabsSignal));
  }
  updateTabsSignal();
  $8tj43$createEffect(() => {
    const {
      hash: hash
    } = new URL(location());
    const id = hash.slice(1);
    if (tabsReactive().some(item => item.id === id)) {
      setCurrentlySelected(id);
      return;
    }
    if (!currentlySelected() || !tabsReactive().some(item => item.id === currentlySelected())) {
      var _tabsReactive$;
      // Select first one by default if possible
      const firstTab = (_tabsReactive$ = tabsReactive()[0]) === null || _tabsReactive$ === void 0 ? void 0 : _tabsReactive$.id;
      if (!firstTab) return;
      setCurrentlySelected(firstTab);
    }
  });
  return [$8tj43$memo(() => (props.wrapTabBar || (v => v))((() => {
    var _el$2 = $8tj43$getNextElement($6a439680ae7e9ba3$var$_tmpl$2);
    $8tj43$insert(_el$2, (() => {
      var _c$ = $8tj43$memo(() => !!props.slidable);
      return () => _c$() ? $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
        children: headerItems
      }) : headerItems;
    })());
    return _el$2;
  })())), (() => {
    var _el$ = $8tj43$getNextElement($6a439680ae7e9ba3$var$_tmpl$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Index), {
      get each() {
        return tabsReactive();
      },
      children: item => {
        const weSelected = $8tj43$createMemo(() => isSelected(item().id));
        $8tj43$createEffect(() => {
          if (weSelected()) {
            setTabsVisitedOnce(prev => {
              prev.add(item().id);
              return prev;
            });
            $8tj43$untrack(() => {
              var _item$onSelected, _item;
              return (_item$onSelected = (_item = item()).onSelected) === null || _item$onSelected === void 0 ? void 0 : _item$onSelected.call(_item);
            });
          }
        });
        $8tj43$onCleanup(() => setTabsVisitedOnce(prev => (prev.delete(item().id), prev)));
        return (() => {
          var _el$3 = $8tj43$getNextElement($6a439680ae7e9ba3$var$_tmpl$3);
          $8tj43$insert(_el$3, $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return tabsVisitedOnce().has(item().id);
            },
            get children() {
              return item().children;
            }
          }));
          $8tj43$effect(_p$ => {
            var _v$ = item().id,
              _v$2 = !!weSelected(),
              _v$3 = weSelected() ? "" : "none";
            _v$ !== _p$.e && $8tj43$setAttribute(_el$3, "id", _p$.e = _v$);
            _v$2 !== _p$.t && _el$3.classList.toggle("selected", _p$.t = _v$2);
            _v$3 !== _p$.a && ((_p$.a = _v$3) != null ? _el$3.style.setProperty("display", _v$3) : _el$3.style.removeProperty("display"));
            return _p$;
          }, {
            e: undefined,
            t: undefined,
            a: undefined
          });
          return _el$3;
        })();
      }
    }));
    return _el$;
  })()];
}
function $6a439680ae7e9ba3$export$3e41faf802a29e71(props) {
  const currentTabs = $6a439680ae7e9ba3$var$useTabs();
  if (!currentTabs) throw new Error("Tab must be a child of Tabs");
  const id = $8tj43$createUniqueId();
  const ourSet = currentTabs;
  const extendedProps = $8tj43$mergeProps({
    id: id
  }, props);
  ourSet.add(extendedProps);
  $8tj43$onCleanup(() => ourSet.delete(extendedProps));
  return undefined;
}
var $b652875d5a5139ec$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=image-container>`);
function $b652875d5a5139ec$export$41e1a079d40a0d58(props) {
  const [display] = $8tj43$createResource(() => ({
    merchant: props.merchant_,
    market: props.market_,
    locale: props.locale_,
    product_ids: [props.productId_]
  }), async request => {
    const response = await fetch($8tj43$add_version_query_params("".concat((0, $8tj43$base_url), "/v3/get-displays")), {
      method: "POST",
      body: JSON.stringify(request)
    });
    const decoded = await response.json();
    return decoded.displays[0];
  });
  const placeholder = $8tj43$createComponent((0, $3ab4aa97880fb88d$export$3f37af283f8fb843), {
    get aspectRatio() {
      return props.imageAspectRatio_;
    }
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($b652875d5a5139ec$var$_tmpl$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Suspense), {
      fallback: placeholder,
      get children() {
        return (() => {
          const imageUrl = $8tj43$createMemo(() => {
            var _variant$image_urls;
            const d = display();
            const variant = d === null || d === void 0 ? void 0 : d.variant_displays[d === null || d === void 0 ? void 0 : d.variant_index];
            return (variant === null || variant === void 0 ? void 0 : (_variant$image_urls = variant.image_urls) === null || _variant$image_urls === void 0 ? void 0 : _variant$image_urls[0]) || (variant === null || variant === void 0 ? void 0 : variant.display_image_url);
          });
          return $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return imageUrl();
            },
            fallback: "Cannot load image",
            get children() {
              return $8tj43$createComponent((0, $8tj43$ContainedImage), {
                loading: "lazy",
                srcset_opts: {
                  set_dataset: false
                },
                get src() {
                  return imageUrl();
                },
                get aspect_ratio() {
                  return props.imageAspectRatio_;
                },
                rendering_options: {},
                alt: "Product image showing the current product with other outfits highlighted on the model"
              });
            }
          });
        })();
      }
    }));
    return _el$;
  })();
}
var $fa332ea03168857c$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=category-title><h1 class=title></h1><span class=explanation> \u{2014} <!$><!/>`);
const $fa332ea03168857c$export$b91cec6bdc6b32a1 = /*@__PURE__*/(() => {
  const actual_function = _ref => {
    let {
      category_title_: category_title_,
      product_count_: product_count_
    } = _ref;
    return (() => {
      var _el$ = $8tj43$getNextElement($fa332ea03168857c$var$_tmpl$),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.nextSibling,
        _el$4 = _el$3.firstChild,
        _el$5 = _el$4.nextSibling,
        [_el$6, _co$] = $8tj43$getNextMarker(_el$5.nextSibling);
      $8tj43$insert(_el$2, () => category_title_() || $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
        height: "1em",
        width: "10ch"
      }));
      $8tj43$insert(_el$3, product_count_, _el$6, _co$);
      return _el$;
    })();
  };
  // This is wrong but parcel can't build correctly, it says unexpected undefined
  actual_function[(0, $ec8a6e10026dcff9$export$5c28802497c8a83c)] = "simple";
  return actual_function;
})();
const $d399250dfa491636$export$c3834fa86c616831 = [[4], [3, 1024], [2, 901]];
const $d399250dfa491636$export$864d304a0bc46829 = "2%";
const $d399250dfa491636$export$7bf543b9d9be2c22 = (0, $fa332ea03168857c$export$b91cec6bdc6b32a1);
var $b432b11321ad4c97$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`);
function $b432b11321ad4c97$export$9756467d34d91cdb(props) {
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    const grid_spacing_override = $8tj43$createMemo(() => {
      const {
        grid_spacing: grid_spacing
      } = props; // can be reactive
      return typeof grid_spacing === "string" ? {
        grid_spacing: grid_spacing
      } : {
        override_vertical_spacing: grid_spacing.vertical,
        grid_spacing: grid_spacing.horizontal
      };
    });
    const [recommendations_resource_] = $8tj43$createResource(() => props.recommendations, recs => recs);
    return (() => {
      var _el$ = $8tj43$getNextElement($b432b11321ad4c97$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          return $e3efeb558d952696$export$7da560f849543dff({
            max_rows_: () => props.max_rows,
            view_more_button_: () => props.view_more_button,
            product_card_template_: function () {
              return props.product_card_template(...arguments);
            },
            recommendations_resource_: recommendations_resource_,
            title_: () => props.title,
            layout_options_: $8tj43$createMemo(() => ({
              cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77(props.cols_at_size),
              ...grid_spacing_override()
            }))
          });
        }
      }));
      $8tj43$effect(() => $8tj43$className(_el$, "depict plp recommendations".concat(props.class ? " ".concat(props.class) : "")));
      return _el$;
    })();
  }, "RecommendationGrid failed");
}
var $0706a7702baafc06$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a>`);
function $0706a7702baafc06$export$6b35356958ae5587(props) {
  const gridSpacing = (0, $d399250dfa491636$export$864d304a0bc46829);
  const columnsAtSize = [[3], [2, 901]];
  const href = $8tj43$use_href_accessor1();
  const hrefWithoutHash = $8tj43$createMemo(() => {
    // Don't let the hash count for knowing when the user navigated away as we change the hash when different tabs are selected
    const url = new URL(href());
    url.hash = "";
    return "" + url;
  });
  const makeJSXElementCloseModalWhenClicked = returnValue => {
    const resolved = $cb64b315b25cfc59$export$2f0cbfbb4354bb52(() => returnValue);
    $8tj43$createEffect(() => {
      // If someone clicks on a product card in the shop the look modal, close the modal the next time the href changes
      for (const item of resolved()) {
        if (!(item instanceof Element)) return;
        item.addEventListener("click", $8tj43$catchify1(() =>
        // run with modal owner so we don't do stuff after the modal closes
        // can't have the owner of the product card as that gets disposed if the productId changes which might be too early (before location.href has changed)
        $8tj43$runWithOwner(props.modalOwner_, () => $8tj43$createEffect($8tj43$on(hrefWithoutHash, props.actually_close_modal_, {
          defer: true
        })))), {
          capture: true
        });
      }
    });
    return resolved;
  };
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return !props.products_to_shop_.error;
    },
    fallback: "Failed fetching shop by look recommendations",
    get children() {
      return $8tj43$createComponent((0, $6a439680ae7e9ba3$export$b2539bed5023c21c), {
        AnchorComponent: anchorProps => (() => {
          var _el$ = $8tj43$getNextElement($0706a7702baafc06$var$_tmpl$);
          _el$.$$click = e => {
            const {
              href: href
            } = anchorProps;
            if (!href) return;
            props.pseudo_router_.navigate_.go_to_({
              scroll: false,
              is_replace_: false,
              new_url_: new URL(href),
              event_: e
            });
          };
          $8tj43$spread(_el$, anchorProps, false, true);
          $8tj43$insert(_el$, () => anchorProps.children);
          $8tj43$runHydrationEvents();
          return _el$;
        })(),
        get children() {
          return $8tj43$createComponent((0, $8tj43$Suspense), {
            get fallback() {
              return $8tj43$createComponent((0, $8tj43$Index), {
                get each() {
                  return Array.from({
                    length: 2
                  });
                },
                children: () => $8tj43$createComponent((0, $6a439680ae7e9ba3$export$3e41faf802a29e71), {
                  get label() {
                    return $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
                      height: "1em",
                      width: "10ch"
                    });
                  },
                  get children() {
                    return $8tj43$createComponent((0, $b432b11321ad4c97$export$9756467d34d91cdb), {
                      grid_spacing: gridSpacing,
                      cols_at_size: columnsAtSize,
                      recommendations: new Promise(r => $8tj43$onCleanup(() => r([]))),
                      get product_card_template() {
                        return props.productCardTemplate_;
                      },
                      max_rows: 2
                    });
                  }
                })
              });
            },
            get children() {
              return (() => {
                const groups = $8tj43$createMemo(() => {
                  var _props$products_to_sh;
                  return Object.keys(((_props$products_to_sh = props.products_to_shop_()) === null || _props$products_to_sh === void 0 ? void 0 : _props$products_to_sh.shop_the_look) || {});
                });
                return $8tj43$createComponent((0, $8tj43$For), {
                  get each() {
                    return groups();
                  },
                  children: group => $8tj43$createComponent((0, $6a439680ae7e9ba3$export$3e41faf802a29e71), {
                    label: group,
                    get id() {
                      return "shop-the-look-" + group.replaceAll(" ", "-").toLowerCase();
                    },
                    get children() {
                      return $8tj43$createComponent((0, $b432b11321ad4c97$export$9756467d34d91cdb), {
                        grid_spacing: gridSpacing,
                        cols_at_size: columnsAtSize,
                        get recommendations() {
                          return Promise.resolve(props.products_to_shop_().shop_the_look[group]);
                        },
                        product_card_template: function () {
                          const returnValue = props.productCardTemplate_(...arguments);
                          // Product card template can return promise, handle that
                          if (typeof returnValue === "object" && returnValue && "then" in returnValue) {
                            const owner = $8tj43$getOwner();
                            return returnValue.then(returnValue => $8tj43$runWithOwner(owner, () => makeJSXElementCloseModalWhenClicked(returnValue)));
                          }
                          return makeJSXElementCloseModalWhenClicked(returnValue);
                        }
                      });
                    }
                  })
                });
              })();
            }
          });
        }
      });
    }
  });
}
$8tj43$delegateEvents(["click"]);
var $d2a67555f75bef95$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=top-bar><button class=close>`),
  $d2a67555f75bef95$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=below-top-bar><h2>Outfit recommendations</h2><div class=image-and-suggestions><!$><!/><div class=tabs>`),
  $d2a67555f75bef95$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div id=depict-shop-the-look-modal class="depict shop-the-look"><div class=shop-the-look-backdrop></div><div class=modal-contents>`);
function $d2a67555f75bef95$export$a3cbef418994a664(props) {
  const pseudo_router_ = new (0, $ac571292d606f30b$export$7e1297a3a19f10d8)(props.onNavigation);
  const closing_animations = [];
  const owner = $8tj43$getOwner();
  const isBig = () => matchMedia("(min-height: 740px) and (min-width: 740px)").matches;
  props.register_closing_animation_(() => Promise.all(closing_animations.map(animation => animation().finished)));
  $e56d241d0f33d459$export$fe334901e8bebd57();
  return [(() => {
    var _el$ = $8tj43$getNextElement($d2a67555f75bef95$var$_tmpl$3),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    var _ref$ = $8tj43$catchify1(element => {
      const disconnect = (0, $8tj43$observer).onexists(element, _ref => {
        let {
          element: element
        } = _ref;
        const animation = element.animate({
          opacity: [0, 1],
          backdropFilter: ["blur(0)", "blur(3px)"]
        }, {
          duration: 150,
          fill: "forwards",
          easing: "ease-in-out"
        });
        closing_animations.push(() => (animation.reverse(), animation));
      });
      $8tj43$onCleanup(disconnect);
    });
    typeof _ref$ === "function" && $8tj43$use(_ref$, _el$2);
    $8tj43$addEventListener(_el$2, "click", props.actually_close_modal_, true);
    $8tj43$use(element => {
      const disconnect = (0, $8tj43$observer).onexists(element, _ref2 => {
        let {
          element: element
        } = _ref2;
        return element.animate({
          opacity: [0, 1],
          transform: isBig() ? ["translate(-50%,-150%)", "translate(-50%,-50%)"] : ["translate(-50%,80%)", "translate(-50%,0%)"]
        }, {
          duration: 250,
          easing: "ease-in"
        });
      });
      closing_animations.push(() => element.animate({
        opacity: [1, 0],
        transform: isBig() ? ["translate(-50%,-50%)", "translate(-50%,-150%)"] : ["translate(-50%,0%)", "translate(-50%,80%)"]
      }, {
        duration: 150,
        easing: "ease-out"
      }));
      $8tj43$onCleanup(disconnect);
    }, _el$3);
    $8tj43$insert(_el$3, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      message_: "ShopTheLookModal failed",
      severity_: "error",
      get children() {
        return [(() => {
          var _el$4 = $8tj43$getNextElement($d2a67555f75bef95$var$_tmpl$),
            _el$5 = _el$4.firstChild;
          $8tj43$addEventListener(_el$5, "click", props.actually_close_modal_, true);
          $8tj43$insert(_el$5, $8tj43$createComponent((0, $9783d437ad61594c$export$3b621d86b1566b2), {
            width: 16,
            height: 16
          }));
          $8tj43$runHydrationEvents();
          return _el$4;
        })(), (() => {
          var _el$6 = $8tj43$getNextElement($d2a67555f75bef95$var$_tmpl$2),
            _el$7 = _el$6.firstChild,
            _el$8 = _el$7.nextSibling,
            _el$10 = _el$8.firstChild,
            [_el$11, _co$] = $8tj43$getNextMarker(_el$10.nextSibling),
            _el$9 = _el$11.nextSibling;
          $8tj43$insert(_el$8, $8tj43$createComponent((0, $b652875d5a5139ec$export$41e1a079d40a0d58), {
            get locale_() {
              return props.locale;
            },
            get market_() {
              return props.market;
            },
            get merchant_() {
              return props.merchant;
            },
            get imageAspectRatio_() {
              return props.imageAspectRatio;
            },
            get productId_() {
              return props.productId;
            }
          }), _el$11, _co$);
          $8tj43$insert(_el$9, $8tj43$createComponent((0, $0706a7702baafc06$export$6b35356958ae5587), {
            modalOwner_: owner,
            pseudo_router_: pseudo_router_,
            get productCardTemplate_() {
              return props.productCardTemplate;
            },
            get products_to_shop_() {
              return props.products_to_shop_;
            },
            get actually_close_modal_() {
              return props.actually_close_modal_;
            }
          }));
          return _el$6;
        })()];
      }
    }));
    $8tj43$runHydrationEvents();
    return _el$;
  })()];
}
$8tj43$delegateEvents(["click"]);
var $6b0fd8fd20df8ccf$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>Failed fetching shop the look recommendations`),
  $6b0fd8fd20df8ccf$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button>`);
const $6b0fd8fd20df8ccf$var$CANT_FETCH = "Failed fetching shop the look recommendations";
let $6b0fd8fd20df8ccf$var$setModalShouldBeOpen;
let $6b0fd8fd20df8ccf$var$modalProps;
function $6b0fd8fd20df8ccf$export$d4973c31938cbfd1(props) {
  return $8tj43$createComponent((0, $8tj43$ErrorBoundary), {
    fallback: () => $8tj43$getNextElement($6b0fd8fd20df8ccf$var$_tmpl$),
    get children() {
      return $8tj43$createComponent($6b0fd8fd20df8ccf$var$ActualShopTheLookButton, props);
    }
  });
}
function $6b0fd8fd20df8ccf$var$ActualShopTheLookButton(props) {
  const [products_to_shop_] = $8tj43$createResource(() => ({
    merchant: props.merchant,
    market: props.market,
    locale: props.locale,
    product_ids: [props.productId],
    type: "shop_the_look",
    session_id: $8tj43$get_session_id()
  }), async request => {
    const response = await fetch($8tj43$add_version_query_params("".concat((0, $8tj43$base_url), "/v3/shop-the-look")), {
      method: "POST",
      body: JSON.stringify(request)
    });
    if (!response.ok) {
      $8tj43$dwarn(response);
      throw new Error($6b0fd8fd20df8ccf$var$CANT_FETCH);
    }
    const decoded = await response.json();
    return decoded;
  });
  const [localProps, partForModal] = $8tj43$splitProps(props, ["buttonAttributes"]);
  const {
    openModal: openModal,
    closeModal: closeModal
  } = $6b0fd8fd20df8ccf$var$useShopTheLookModal();
  const hasAnythingToShow = $8tj43$createMemo(() => {
    var _products_to_shop_;
    return Object.entries(((_products_to_shop_ = products_to_shop_()) === null || _products_to_shop_ === void 0 ? void 0 : _products_to_shop_.shop_the_look) || {}).length;
  });
  const displayStyleValue = $8tj43$createMemo(() => hasAnythingToShow() ? "" : "none");
  const button = (() => {
    var _el$2 = $8tj43$getNextElement($6b0fd8fd20df8ccf$var$_tmpl$2);
    $8tj43$spread(_el$2, $8tj43$mergeProps1(() => localProps.buttonAttributes), false, true);
    $8tj43$insert(_el$2, () => {
      var _localProps$buttonAtt;
      return (localProps === null || localProps === void 0 ? void 0 : (_localProps$buttonAtt = localProps.buttonAttributes) === null || _localProps$buttonAtt === void 0 ? void 0 : _localProps$buttonAtt.children) || "Shop the look";
    });
    $8tj43$runHydrationEvents();
    return _el$2;
  })();
  $8tj43$createEffect(() => button.style.display = displayStyleValue()); // Set our attributes like this, so we allow total control over the button from the outside via buttonAttributes
  $8tj43$createEffect(() => !hasAnythingToShow() && closeModal()); // close modal if we ever get into the state of having it open and not having anything to show
  $6b0fd8fd20df8ccf$var$modalProps = $8tj43$mergeProps(partForModal, {
    products_to_shop_: products_to_shop_
  });
  button.addEventListener("click", openModal);
  return button;
}
/**
 * This does not need to be run in a root at all, it will create a root every time the modal is opened and then tear it down when the modal is closed again
 */
function $6b0fd8fd20df8ccf$var$useShopTheLookModal() {
  if ($6b0fd8fd20df8ccf$var$setModalShouldBeOpen) return $6b0fd8fd20df8ccf$var$setModalShouldBeOpen;
  return $6b0fd8fd20df8ccf$var$setModalShouldBeOpen = $8tj43$createRoot(() => $6b0fd8fd20df8ccf$var$actualSetupModal());
}
function $6b0fd8fd20df8ccf$var$actualSetupModal() {
  // Save modal state in history so modal is still open after people go back
  const history_key = "depict_shop_the_look_open";
  const {
    [history_key]: [history_value, set_history_value]
  } = $972f6bce0f9d61be$export$e183a13865960371({
    [history_key]: false
  }, {
    navigate_: {
      replace_state_: new_state => {
        var _globalThis$history;
        return globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$history = globalThis.history) === null || _globalThis$history === void 0 ? void 0 : _globalThis$history.replaceState(new_state, "");
      }
    }
  });
  (0, $68e6625c8d51f847$export$3064e1e8c6513da3).add(history_key);
  const actually_close_modal_ = () => set_history_value(false);
  const owner = $8tj43$getOwner();
  $8tj43$catchify1(async () => {
    const {
      open_modal_: open_modal_,
      close_modal_: close_modal_
    } = await $d5f1e6a0f9117286$export$79b1565500412d9b((0, $d2a67555f75bef95$export$a3cbef418994a664), {
      actually_close_modal_: actually_close_modal_
    });
    $8tj43$runWithOwner(owner, () => $8tj43$createEffect(() => {
      if (history_value()) open_modal_($6b0fd8fd20df8ccf$var$modalProps);else close_modal_();
    }));
  })();
  return {
    openModal: () => set_history_value(true),
    closeModal: actually_close_modal_
  };
}
var $d5d7e58c5c9d8db0$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div>`);
function $d5d7e58c5c9d8db0$export$9574e176201e5e8d(props) {
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    const grid_spacing_override = $8tj43$createMemo(() => {
      const {
        grid_spacing: grid_spacing
      } = props; // can be reactive
      return typeof grid_spacing === "string" ? {
        grid_spacing: grid_spacing
      } : {
        override_vertical_spacing: grid_spacing.vertical,
        grid_spacing: grid_spacing.horizontal
      };
    });
    const [recommendations_resource_] = $8tj43$createResource(() => props.recommendations, recs => recs);
    return (() => {
      var _el$ = $8tj43$getNextElement($d5d7e58c5c9d8db0$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
        get children() {
          return $39ddb986053fb759$export$d41d19e89346fa2({
            product_card_template_: function () {
              return props.product_card_template(...arguments);
            },
            recommendations_resource_: recommendations_resource_,
            showSliderArrow_: () => props.showSliderArrow_,
            title_: () => props.title,
            layout_options_: $8tj43$createMemo(() => ({
              cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77(props.cols_at_size),
              ...grid_spacing_override()
            }))
          });
        }
      }));
      $8tj43$effect(() => $8tj43$className(_el$, "depict recommendations".concat(props.class ? " ".concat(props.class) : "")));
      return _el$;
    })();
  }, "RecommendationSlider failed");
}
function $e18ab2868df26f40$export$f091cbac892643a4(obj) {
  const mapfn = key => [key, $8tj43$createMemo(() => obj()[key])];
  const keys = Object.keys($8tj43$untrack(() => obj()));
  const mapped_stuff = keys.map(mapfn);
  return Object.fromEntries(mapped_stuff); // FUCK TYPESCRIPT, WHY CAN'T YOU DO THIS CORRECTLY???
}

async function $50aebf5b445518eb$export$58e808b1db15d3bc(options) {
  const headers = options.headers;
  const product_id = options.productId || options.product_id; // Second fallback here is just because there was very little missing to make this work with snake_case input and in case someone puts in snake case'd stuff already (preview browser did) we can easily not break it
  const cleaned_up_options = $8tj43$snakeCasifyObject(options);
  delete cleaned_up_options.headers;
  delete cleaned_up_options.product_id;
  cleaned_up_options.session_id || (cleaned_up_options.session_id = $8tj43$get_session_id());
  if (product_id && !cleaned_up_options.product_ids) cleaned_up_options.product_ids = [product_id];
  const options_to_send = cleaned_up_options;
  const url = $8tj43$add_version_query_params("".concat((0, $8tj43$base_url), "/v3/recommend/products"));
  return await $8tj43$fetch_retry(url, {
    body: JSON.stringify(options_to_send),
    ...(headers ? {
      headers: headers
    } : {}),
    method: "POST"
  }).catch(e => $8tj43$dlog("fetch_retry threw", e)).then(async maybe_response => {
    var _decoded;
    if (!maybe_response) return [];
    let decoded;
    try {
      decoded = await maybe_response.json();
    } catch (e) {
      $8tj43$dlog("Failed to decode JSON", e);
    }
    return ((_decoded = decoded) === null || _decoded === void 0 ? void 0 : _decoded.displays) || [];
  });
}
var $702d7656a373973e$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class="sort-and-filter-buttons fake"aria-hidden=true style=position:absolute;z-index:-1;pointer-events:none;opacity:0><div class=outer><div class=inner><!$><!/><!$><!/><!$><!/>`);
const $702d7656a373973e$export$824dde41348efed1 = /*@__PURE__*/(() => {
  const actual_function = _ref => {
    let {
      make_product_count_: make_product_count_,
      set_observed_results_filters_elements_: set_observed_results_filters_elements_,
      is_slim_: is_slim_,
      sort_and_filter_element_: sort_and_filter_element_,
      extra_sort_and_filter_args_: extra_sort_and_filter_args_
    } = _ref;
    // this does two things: make the sorting and filters button the same width and move the number of products out of the SortAndFilter middle_elements_ if it doesn't fit
    let extra_sort_button_;
    let extra_filter_button_;
    const [only_show_filters_opener_, set_only_show_filters_opener] = $8tj43$createSignal(true);
    const embedded_product_count = make_product_count_();
    const [middle_elements_, set_middle_elements] = $8tj43$createSignal(embedded_product_count);
    const [sort_button_width_, set_sort_button_width] = $8tj43$createSignal();
    const [filter_button_width_, set_filter_button_width] = $8tj43$createSignal();
    const extra_count = make_product_count_();
    [extra_count, embedded_product_count].forEach(el => el.style.whiteSpace = "nowrap");
    extra_sort_and_filter_args_.get_extra_filters_button_ = button => extra_filter_button_ = button; // ugly assumption, I wrote a comment in OpenSortingButton and OpenFiltersButton about it
    extra_sort_and_filter_args_.get_extra_sorting_button_ = button => extra_sort_button_ = button;
    extra_sort_and_filter_args_.filter_button_width_ = filter_button_width_;
    extra_sort_and_filter_args_.sort_button_width_ = sort_button_width_;
    const on_filters_constructed_ = () => {
      const active_sort_and_filter_element = $8tj43$untrack(sort_and_filter_element_); // We assume that this doesn't change which it currently doesn't after the filters have been constructed
      const extra_sort_and_filter_container_ = (() => {
        var _el$ = $8tj43$getNextElement($702d7656a373973e$var$_tmpl$),
          _el$2 = _el$.firstChild,
          _el$3 = _el$2.firstChild,
          _el$4 = _el$3.firstChild,
          [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling),
          _el$6 = _el$5.nextSibling,
          [_el$7, _co$2] = $8tj43$getNextMarker(_el$6.nextSibling),
          _el$8 = _el$7.nextSibling,
          [_el$9, _co$3] = $8tj43$getNextMarker(_el$8.nextSibling);
        $8tj43$insert(_el$3, extra_filter_button_, _el$5, _co$);
        $8tj43$insert(_el$3, extra_count, _el$7, _co$2);
        $8tj43$insert(_el$3, extra_sort_button_, _el$9, _co$3);
        return _el$;
      })();
      set_observed_results_filters_elements_(extra_sort_and_filter_container_);
      const [total_available_width, set_total_available_width] = $8tj43$createSignal();
      const [filter_button_required_width, set_filter_button_required_width] = $8tj43$createSignal();
      const [sort_button_required_width, set_sort_button_required_width] = $8tj43$createSignal();
      const [count_required_width, set_count_required_width] = $8tj43$createSignal();
      const larger_button_width = $8tj43$createMemo(() => Math.max(sort_button_required_width(), filter_button_required_width()) // might be NaN
      );

      const calculated_required_width = $8tj43$createMemo(() => count_required_width() + larger_button_width() * 2 // might be NaN
      );

      const observe_to_signal = (element, setter) => {
        const computed_style = getComputedStyle(element);
        const resize_observer = new ResizeObserver($8tj43$catchify1(() => {
          setter(element.getBoundingClientRect().width + parseFloat(computed_style.marginLeft) + parseFloat(computed_style.marginRight) + parseFloat(computed_style.borderRightWidth) + parseFloat(computed_style.borderLeftWidth));
        }));
        resize_observer.observe(element);
        $8tj43$onCleanup(() => resize_observer.disconnect());
      };
      observe_to_signal(active_sort_and_filter_element, set_total_available_width);
      observe_to_signal(extra_filter_button_, set_filter_button_required_width);
      observe_to_signal(extra_sort_button_, set_sort_button_required_width);
      observe_to_signal(extra_count, set_count_required_width);
      $8tj43$createEffect(() => {
        if (!is_slim_()) {
          set_middle_elements();
          return;
        }
        const required = calculated_required_width();
        const available = total_available_width();
        if (isNaN(required) || isNaN(available)) return;
        const fits = required <= available;
        // move things in / out of inbetween the filter buttons depending on if it fits
        set_only_show_filters_opener(fits);
        set_middle_elements(fits && embedded_product_count);
      });
      $8tj43$createEffect(() => {
        const biggest_size = larger_button_width();
        // set smaller button to be size of largest button
        if (isNaN(biggest_size)) return;
        if (sort_button_required_width() === biggest_size) {
          set_sort_button_width();
          set_filter_button_width(biggest_size);
        } else {
          set_filter_button_width();
          set_sort_button_width(biggest_size);
        }
      });
    };
    return {
      only_show_filters_opener_: only_show_filters_opener_,
      middle_elements_: middle_elements_,
      on_filters_constructed_: on_filters_constructed_
    };
  };
  actual_function[(0, $ec8a6e10026dcff9$export$5c28802497c8a83c)] = "interactive";
  return actual_function;
})();
const $160ea2b55d8772d2$var$TEN_MINUTES = 600000;
const $160ea2b55d8772d2$var$TWENTY_FOUR_HOURS = 86400000;
async function $160ea2b55d8772d2$export$c1a6b039e689a58e(merchant, market, locale) {
  var _localstorage_value, _localstorage_value2;
  let localstorage_value;
  const localstorage_key = "depict_listings_".concat(JSON.stringify([merchant, market, locale]), "}");
  try {
    const in_ls = localStorage[localstorage_key];
    if (in_ls) localstorage_value = JSON.parse(in_ls);
  } catch (e) {
    $8tj43$dlog("Failed parsing JSON from localStorage", e);
  }
  const updated = (_localstorage_value = localstorage_value) === null || _localstorage_value === void 0 ? void 0 : _localstorage_value.updated;
  const now = +new Date();
  const stored_queries = (_localstorage_value2 = localstorage_value) === null || _localstorage_value2 === void 0 ? void 0 : _localstorage_value2.queries;
  if (Array.isArray(stored_queries) && typeof updated === "number") {
    const age = now - updated;
    if (stored_queries.length && age < $160ea2b55d8772d2$var$TEN_MINUTES)
      // if younger than 10 minutes and probably valid data, just return stored value
      return stored_queries;else if (age < $160ea2b55d8772d2$var$TWENTY_FOUR_HOURS) {
      // if younger than a day, return stored value but still trigger re-fetch, so we have fresh data next page load (stale data this one but never a delay)
      $160ea2b55d8772d2$var$fetch_and_store_categories(merchant, market, locale, localstorage_key).catch(e => $8tj43$report1([e, "couldn't fetch categories"], "warning"));
      return stored_queries;
    }
    // else: we are older and just fetch, store and return new queries
  }

  return await $160ea2b55d8772d2$var$fetch_and_store_categories(merchant, market, locale, localstorage_key);
}
async function $160ea2b55d8772d2$var$fetch_and_store_categories(merchant, market, locale, localstorage_key) {
  const new_categories = await $160ea2b55d8772d2$var$download_categories(merchant, market, locale);
  try {
    localStorage[localstorage_key] = JSON.stringify({
      updated: +new Date(),
      queries: new_categories
    });
  } catch (e) {
    $8tj43$report1([e, "couldn't store queries in localStorage"], "warning"); // in case of full localStorage, still function
  }

  return new_categories;
}
async function $160ea2b55d8772d2$var$download_categories(merchant, market, locale) {
  const url = new URL((0, $8tj43$base_url) + "/v3/listings");
  const request = {
    merchant: merchant,
    market: market,
    locale: locale
  };
  url.search = "" + new URLSearchParams(request);
  const fetched = await $8tj43$fetch_retry(url.href);
  if (!fetched) return [];
  try {
    if (fetched.status !== 200) {
      $8tj43$dlog("failed to fetch queries, server responded with", fetched.status, fetched, await fetched.text());
      return [];
    }
    return await fetched.json();
  } catch (e) {
    $8tj43$dlog("failed to decode queries json", fetched, e);
    return [];
  }
}
function $bc811d9630f9579b$export$9862539c89138352(_ref) {
  let {
    get_default_values_: get_default_values_,
    router_: router_,
    prefix_: prefix_,
    preserveKeys_: preserveKeys_
  } = _ref;
  const get_prefixed_default_values_ = () => {
    const default_values = get_default_values_();
    return Object.fromEntries(Object.entries(default_values).map(_ref2 => {
      let [key, value] = _ref2;
      return [prefix_ + key, value];
    }));
  };
  const prefixed_state = $972f6bce0f9d61be$export$e183a13865960371(get_prefixed_default_values_(), router_);
  const prefixedPreserveKeys = preserveKeys_ === null || preserveKeys_ === void 0 ? void 0 : preserveKeys_.map(key => prefix_ + key);
  const reset_state = () => {
    const new_defaults = get_prefixed_default_values_();
    for (const key in prefixed_state) {
      if (prefixedPreserveKeys !== null && prefixedPreserveKeys !== void 0 && prefixedPreserveKeys.includes(key)) continue;
      const new_value = new_defaults[key];
      prefixed_state[key][1](new_value);
    }
  };
  let unprefixed_state;
  unprefixed_state = Object.fromEntries(Object.entries(prefixed_state).map(_ref3 => {
    let [key, value] = _ref3;
    return [key.slice(prefix_.length), value];
  }));
  (0, $68e6625c8d51f847$export$3064e1e8c6513da3).add(prefix_);
  // There's intentionally no onCleanup here since we want to preserve the state even if all components (in i.e. react-ui) that use the provider running this are unmounted and the provider is destroyed, since it might be re-created and need the old state (for example for doing scroll restoration)
  return [reset_state, unprefixed_state];
}

/**
 * We use group_title for more beautiful urls if possible, this function modifies the search filters in an API response to have group_title as field, when possible.
 * Backend supports accepting group_title as field, so we just pretend it was field in the whole app to avoid major refactoring.
 * But also because it would be a lot more code since it's not guaranteed for group_title to exist. So at all places where we take `field` to send it to the API we'd have to check if group_title exists and use that instead and at all places where we try to pair filters sent from the API and filters set we'd have to both check if `op` and `field` match or if `op` and `group_title` match.
 *
 * This way it's just much simpler - group_title _is_ field for all intents and purposes if it exists, and we don't have to change anything/add lots of if-statements. The only reason we need the old field (actual_field) is for the compatibility with the old filters (see fix_old_filter_links).
 */
function $ed0fefda39a0f15d$export$967e966fca9515e(api_response) {
  if ("filters" in api_response) {
    const filters = api_response.filters;
    if (!filters) return api_response;
    const new_filters = [];
    for (let i = 0; i < filters.length; i++) {
      var _filter$meta, _filter$meta$group_ti;
      const filter = filters[i];
      const group_title = (_filter$meta = filter.meta) === null || _filter$meta === void 0 ? void 0 : (_filter$meta$group_ti = _filter$meta.group_title) === null || _filter$meta$group_ti === void 0 ? void 0 : _filter$meta$group_ti.toLowerCase();
      const new_filter = {
        ...filter
      };
      if (group_title) {
        new_filter.field = group_title;
        new_filter.actual_field = filter.field;
      }
      new_filters.push(new_filter);
    }
    return {
      ...api_response,
      filters: new_filters
    };
  }
  return api_response;
}

/**
 * Converts a v3 API response into something that has quick_links and breadcrumbs that behave as in v2 instead of ancestors, children and siblings, but gives every quicklink and breadcrumb's transformer the ancestors of the listing they are for.
 */
async function $f454ce4c74ef4dc0$export$d9792230b7c0203e(_ref) {
  let {
    input_data_: {
      ancestors: ancestors,
      children: children,
      siblings: siblings,
      ...clonedInputData
    },
    category_transformer_ = v => v.data,
    merchant_:
    // in case no display transformer just pass the data through, so we don't break
    merchant_,
    market_: market_,
    locale_: locale_
  } = _ref;
  const breadcrumbs = [];
  const clonedAncestors = [...ancestors];
  while (clonedAncestors.length) {
    const ancestor = clonedAncestors.pop();
    if (!ancestor.show_in_breadcrumbs) continue;
    breadcrumbs.push({
      ...ancestor,
      ancestors: [...clonedAncestors]
    });
  }
  breadcrumbs.reverse();
  const quicklinksIsChildren = children.length;
  const quickLinks = (quicklinksIsChildren ? children : siblings).filter(_ref2 => {
    let {
      show_in_quicklinks: show_in_quicklinks
    } = _ref2;
    return show_in_quicklinks;
  }).map(productListing => {
    const ancestorsForUs = [...ancestors];
    if (quicklinksIsChildren) ancestorsForUs.push({
      ...clonedInputData
    });
    return {
      ...productListing,
      ancestors: ancestorsForUs
    };
  });
  const [transformedBreadcrumbs, transformedQuickLinks] = await Promise.all([category_transformer_({
    merchant: merchant_,
    market: market_,
    locale: locale_,
    data: breadcrumbs
  }), category_transformer_({
    merchant: merchant_,
    market: market_,
    locale: locale_,
    data: quickLinks
  })]);
  return {
    ...clonedInputData,
    breadcrumbs: transformedBreadcrumbs,
    quick_links: transformedQuickLinks
  };
}
function $284849364a6ef73a$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $284849364a6ef73a$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $284849364a6ef73a$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $284849364a6ef73a$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $284849364a6ef73a$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $284849364a6ef73a$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
const $284849364a6ef73a$var$v3_base_url = (0, $8tj43$base_url) + "/v3/";
const $284849364a6ef73a$var$search_base_url = $284849364a6ef73a$var$v3_base_url + "search/";
var $284849364a6ef73a$var$_supports_finalization_registry = /*#__PURE__*/new WeakMap();
var $284849364a6ef73a$var$_cache_objs = /*#__PURE__*/new WeakMap();
var $284849364a6ef73a$var$_get_cache_obj_for_endpoint = /*#__PURE__*/new WeakSet();
var $284849364a6ef73a$var$_add_ids_to_request = /*#__PURE__*/new WeakMap();
var $284849364a6ef73a$var$_get_metadata = /*#__PURE__*/new WeakMap();
var $284849364a6ef73a$var$_get_session_id = /*#__PURE__*/new WeakMap();
var $284849364a6ef73a$var$_run_url_creator_for_suggest = /*#__PURE__*/new WeakSet();
var $284849364a6ef73a$var$_run_display_transformers_for_rest = /*#__PURE__*/new WeakSet();
var $284849364a6ef73a$var$_cached_request = /*#__PURE__*/new WeakSet();
class $284849364a6ef73a$export$e015ed2f2950f2e3 {
  /**
  * Runs the displayTransformer for the suggest endpoints results
  */ /**
     * rest = everything except query suggestions
     */
  constructor(options) {
    $284849364a6ef73a$var$_classPrivateMethodInitSpec(this, $284849364a6ef73a$var$_cached_request);
    $284849364a6ef73a$var$_classPrivateMethodInitSpec(this, $284849364a6ef73a$var$_run_display_transformers_for_rest);
    $284849364a6ef73a$var$_classPrivateMethodInitSpec(this, $284849364a6ef73a$var$_run_url_creator_for_suggest);
    $284849364a6ef73a$var$_classPrivateMethodInitSpec(this, $284849364a6ef73a$var$_get_cache_obj_for_endpoint);
    $8tj43$babelruntimehelpersdefineProperty(this, "display_transformers", void 0);
    $284849364a6ef73a$var$_classPrivateFieldInitSpec(this, $284849364a6ef73a$var$_supports_finalization_registry, {
      writable: true,
      value: typeof FinalizationRegistry === "function"
    });
    $284849364a6ef73a$var$_classPrivateFieldInitSpec(this, $284849364a6ef73a$var$_cache_objs, {
      writable: true,
      value: {}
    });
    $284849364a6ef73a$var$_classPrivateFieldInitSpec(this, $284849364a6ef73a$var$_add_ids_to_request, {
      writable: true,
      value: input_req => {
        var _request$session_id, _classPrivateFieldGet2;
        const request = {
          ...input_req
        };
        (_request$session_id = request.session_id) !== null && _request$session_id !== void 0 ? _request$session_id : request.session_id = ((_classPrivateFieldGet2 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_get_session_id)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.call(this)) || $8tj43$get_session_id();
        return request;
      }
    });
    $284849364a6ef73a$var$_classPrivateFieldInitSpec(this, $284849364a6ef73a$var$_get_metadata, {
      writable: true,
      value: void 0
    });
    $284849364a6ef73a$var$_classPrivateFieldInitSpec(this, $284849364a6ef73a$var$_get_session_id, {
      writable: true,
      value: void 0
    });
    const {
      get_metadata: get_metadata,
      get_session_id: _get_session_id2,
      display_transformers: _display_transformers
    } = options !== null && options !== void 0 ? options : {};
    $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $284849364a6ef73a$var$_get_metadata, get_metadata);
    $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $284849364a6ef73a$var$_get_session_id, _get_session_id2);
    this.display_transformers = _display_transformers;
  }
  async suggest(input_req) {
    var _classPrivateFieldGet3;
    const with_ids = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_add_ids_to_request).call(this, input_req);
    const metaData = await ((_classPrivateFieldGet3 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_get_metadata)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.call(this));
    const request = metaData ? Object.assign(with_ids, {
      metadata: JSON.stringify(metaData)
    }) : with_ids;
    const url = $8tj43$make_url_with_query_params($284849364a6ef73a$var$search_base_url + "suggestions", request);
    const results = await $8tj43$fetch_retry($8tj43$add_version_query_params(url));
    attempt_to_return_api_response: {
      if (!results) break attempt_to_return_api_response;
      const decoded_json = await results.json();
      if (!Array.isArray(decoded_json === null || decoded_json === void 0 ? void 0 : decoded_json.suggestions)) break attempt_to_return_api_response;
      try {
        return await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_run_url_creator_for_suggest, $284849364a6ef73a$var$_run_url_creator_for_suggest2).call(this, input_req.merchant, input_req.market, input_req.locale, decoded_json);
      } catch (e) {
        $8tj43$dwarn("displayTransformer failed", e);
      }
    }
    return {
      "suggestions_request_id": "error",
      "suggestions": [],
      failed: true
    };
  }
  async query(input_req) {
    return await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_cached_request, $284849364a6ef73a$var$_cached_request2).call(this, {
      endpoint_: $284849364a6ef73a$var$search_base_url + "results",
      input_req_: input_req,
      fallback_response_: () => ({
        "n_hits": 0,
        "displays": [],
        "sorts": [],
        "filters": [],
        "search_request_id": "error",
        failed: true
      })
    });
  }
  async get_listing(_ref) {
    let {
      id_type_: id_type_,
      id_to_query_for_: id_to_query_for_,
      ...input_req
    } = _ref;
    return await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_cached_request, $284849364a6ef73a$var$_cached_request2).call(this, {
      endpoint_: $284849364a6ef73a$var$v3_base_url + "listings/" + (id_type_ === $397620a4d7958ed1$export$5aae649db1b959fc ? "external_id/" : "") + encodeURIComponent(id_to_query_for_),
      input_req_: input_req,
      fallback_response_: () => ({
        listing_id: "",
        listing_type: "category",
        title: "",
        slug: "",
        show_in_breadcrumbs: false,
        show_in_quicklinks: false,
        breadcrumbs: [],
        quick_links: [],
        image_urls: [],
        failed: true,
        content_blocks: []
      }),
      method_: "GET"
    });
  }
  async get_listing_products(_ref2) {
    let {
      id_to_query_for_: id_to_query_for_,
      id_type_: id_type_,
      currentListingForTransformer_: currentListingForTransformer_,
      ...input_req_
    } = _ref2;
    return await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_cached_request, $284849364a6ef73a$var$_cached_request2).call(this, {
      endpoint_: $284849364a6ef73a$var$v3_base_url + "listings/" + (id_type_ === $397620a4d7958ed1$export$5aae649db1b959fc ? "external_id/" : "") + encodeURIComponent(id_to_query_for_) + "/products",
      input_req_: input_req_,
      currentListingForTransformer_: currentListingForTransformer_,
      fallback_response_: () => ({
        "n_hits": 0,
        "displays": [],
        "sorts": [],
        "filters": [],
        "product_listing_request_id": "error",
        failed: true
      })
    });
  }
  async get_recommended(input_req) {
    return await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_cached_request, $284849364a6ef73a$var$_cached_request2).call(this, {
      endpoint_: $284849364a6ef73a$var$search_base_url + "related",
      input_req_: input_req,
      fallback_response_: () => ({
        displays: []
      })
    });
  }
}
function $284849364a6ef73a$var$_get_cache_obj_for_endpoint2(endpoint) {
  var _classPrivateFieldGet4;
  return (_classPrivateFieldGet4 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_cache_objs))[endpoint] || (_classPrivateFieldGet4[endpoint] = {
    in_progress_: {},
    cache_: {},
    finalization_registry_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_supports_finalization_registry) ? new FinalizationRegistry($8tj43$catchify1(key => {
      const our_cache = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_cache_objs)[endpoint].cache_;
      $8tj43$dlog("[Search API]: removing", key, "from", our_cache);
      delete our_cache[key];
    })) : undefined
  });
}
async function $284849364a6ef73a$var$_run_url_creator_for_suggest2(merchant, market, locale, response) {
  var _this$display_transfo;
  const category_transformer = (_this$display_transfo = this.display_transformers) === null || _this$display_transfo === void 0 ? void 0 : _this$display_transfo.categories;
  if (!category_transformer) return response;
  const incoming_suggestions = response.suggestions;
  const type_to_transform = "listing";
  // find category suggestions, run thing with them, and then replace them
  // Also give the transformer (deduplicated) all ancestors along with a way to tell them apart, so we can create breadcrumbs
  const category_suggestions = incoming_suggestions.filter(suggestion => suggestion.type === type_to_transform);
  const ancestorsByListingId = Object.fromEntries(category_suggestions // Deduplicate by listing_id since we don't need to mention the same listing twice. Also add in ancestors, so they can be used for constructing the page_url
  .flatMap(_ref3 => {
    let {
      ancestors: ancestors
    } = _ref3;
    return ancestors.map((item, index) => ({
      ...item,
      ancestors: ancestors.slice(0, index)
    }));
  }).map(ancestor => [ancestor.listing_id, ancestor]));
  const forTransformer = [...category_suggestions.map(suggestion => ({
    ...suggestion,
    is_suggestion: true
  })), ...Object.values(ancestorsByListingId).map(ancestor => ({
    ...ancestor,
    is_suggestion: false
  }))];
  const transformerResult = [...(await category_transformer({
    market: market,
    merchant: merchant,
    locale: locale,
    data: forTransformer
  }))];
  // Filter out our transformed ancestors
  const transformedAncestors = Object.fromEntries(transformerResult.filter(item => item.is_suggestion === false).map(item => [item.listing_id, item]));
  // Add the now transformed ancestors into the ancestors of the listing suggestions
  const transformedSuggestions = transformerResult.filter(item => item.is_suggestion !== false).map(item => $8tj43$mergeProps(item, {
    // Use mergeProps instead of spread since page_url and other properties could be a getter that solid components should call
    ancestors: item.ancestors.map(ancestor => {
      const newAncestor = transformedAncestors[ancestor.listing_id];
      if (!newAncestor) throw new Error("Failed populating ancestors of listing suggestions with transformed ancestors (that have page_url). No new ancestor for " + JSON.stringify(ancestor));
      return newAncestor;
    })
  }));
  // Then add-back query suggestions at their original indices
  for (let i = 0; i < incoming_suggestions.length; i++) {
    const item = incoming_suggestions[i];
    if (item.type === type_to_transform) continue;
    transformedSuggestions.splice(i, 0, item);
  }
  response.suggestions = transformedSuggestions;
  return response;
}
async function $284849364a6ef73a$var$_run_display_transformers_for_rest2(merchant, market, locale, input_data, currentListingForTransformer) {
  const {
    display_transformers: display_transformers
  } = this;
  const product_transformer = display_transformers === null || display_transformers === void 0 ? void 0 : display_transformers.products;
  const category_transformer = display_transformers === null || display_transformers === void 0 ? void 0 : display_transformers.categories;
  const content_result_transformer = display_transformers === null || display_transformers === void 0 ? void 0 : display_transformers.contentResults;
  const displays = input_data.displays;
  const {
    content_search_links: content_search_links
  } = input_data;
  if (displays && product_transformer) {
    const transformed_displays = await product_transformer({
      merchant: merchant,
      market: market,
      locale: locale,
      displays: [...displays],
      currentListing: currentListingForTransformer
    });
    input_data.displays = transformed_displays;
  }
  if (content_search_links !== null && content_search_links !== void 0 && content_search_links.length && content_result_transformer) input_data.content_search_links = await content_result_transformer({
    merchant: merchant,
    market: market,
    locale: locale,
    data: [...content_search_links]
  });
  if (input_data.ancestors) return await $f454ce4c74ef4dc0$export$d9792230b7c0203e({
    input_data_: input_data,
    category_transformer_: category_transformer,
    merchant_: merchant,
    market_: market,
    locale_: locale
  });
  return input_data;
}
async function $284849364a6ef73a$var$_cached_request2(_ref4) {
  var _classPrivateFieldGet5, _cache_obj$cache_$bod, _cache_obj$cache_$bod2;
  let {
    endpoint_: endpoint_,
    input_req_: input_req_,
    fallback_response_: fallback_response_,
    method_ = "POST",
    currentListingForTransformer_: currentListingForTransformer_
  } = _ref4;
  const cache_obj = $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_get_cache_obj_for_endpoint, $284849364a6ef73a$var$_get_cache_obj_for_endpoint2).call(this, endpoint_);
  const with_ids = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_add_ids_to_request).call(this, input_req_);
  const metaData = await ((_classPrivateFieldGet5 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_get_metadata)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.call(this));
  const request = metaData ? Object.assign(with_ids, {
    metadata: metaData
  }) : with_ids;
  const sorted_request = $8tj43$sort_obj(request);
  const body = JSON.stringify(sorted_request);
  const response_from_cache = (_cache_obj$cache_$bod = cache_obj.cache_[body]) === null || _cache_obj$cache_$bod === void 0 ? void 0 : (_cache_obj$cache_$bod2 = _cache_obj$cache_$bod.deref) === null || _cache_obj$cache_$bod2 === void 0 ? void 0 : _cache_obj$cache_$bod2.call(_cache_obj$cache_$bod);
  if (response_from_cache) return response_from_cache;
  const in_progress_request = cache_obj.in_progress_[body];
  if (in_progress_request) return in_progress_request;
  let resolve_in_progress;
  cache_obj.in_progress_[body] = new Promise(r => resolve_in_progress = r);
  try {
    const is_post = method_ === "POST";
    const url_to_request = is_post ? endpoint_ : $8tj43$make_url_with_query_params(endpoint_, sorted_request);
    const api_response = await $8tj43$fetch_retry($8tj43$add_version_query_params(url_to_request), {
      method: method_,
      ...(is_post ? {
        body: body
      } : {})
    });
    return_successfully: {
      if (!api_response || api_response.status !== 200) break return_successfully;
      let result;
      try {
        const unmodified_result = await api_response.json();
        result = await $284849364a6ef73a$var$_classPrivateMethodGet(this, $284849364a6ef73a$var$_run_display_transformers_for_rest, $284849364a6ef73a$var$_run_display_transformers_for_rest2).call(this, input_req_.merchant, input_req_.market, input_req_.locale, unmodified_result, currentListingForTransformer_);
      } catch (e) {
        $8tj43$dwarn("displayTransformer or json decoding failed", e);
        break return_successfully;
      }
      // Here result actually becomes O
      result = $ed0fefda39a0f15d$export$967e966fca9515e(result);
      cache_obj.cache_[body] = new WeakRef(result);
      resolve_in_progress(result);
      setTimeout($8tj43$catchify1(() => {
        if ($8tj43$babelruntimehelpersclassPrivateFieldGet(this, $284849364a6ef73a$var$_supports_finalization_registry)) cache_obj.finalization_registry_.register(result, body); // delete key from cache when value (WeakRefs) are collected
        else
          // delete things from cache after 5 minutes, so it doesn't get too heavy
          setTimeout($8tj43$catchify1(() => delete cache_obj.cache_[body]), 300000);
      }), 60000 // cache values for at least 60 seconds
      );

      return result;
    }
    // If we get here, the request failed
    const retval = fallback_response_(input_req_);
    resolve_in_progress(retval);
    return retval;
  } finally {
    delete cache_obj.in_progress_[body];
  }
}
function $9d3d794b62318ecc$export$477caf01aecaeb2a(options) {
  var _globalThis$location$, _globalThis$location;
  const router_ = options.router_;
  const search_query_url_param_name_ = "search_query_url_param_name_" in options ? options.search_query_url_param_name_ : undefined;
  const search_query_ = search_query_url_param_name_ ? $8tj43$createSignal("") : undefined;
  const override_listing_id_query_param_names_ = "override_listing_id_query_param_names_" in options ? options.override_listing_id_query_param_names_ : undefined;
  const override_listing_id_ = override_listing_id_query_param_names_ ? $8tj43$createSignal(null) : undefined;
  const get_search_query_ = search_query_ === null || search_query_ === void 0 ? void 0 : search_query_[0];
  const set_search_query = search_query_ === null || search_query_ === void 0 ? void 0 : search_query_[1];
  const get_override_listing_id_ = override_listing_id_ === null || override_listing_id_ === void 0 ? void 0 : override_listing_id_[0];
  const set_override_listing_id = override_listing_id_ === null || override_listing_id_ === void 0 ? void 0 : override_listing_id_[1];
  const current_sorting_ = $8tj43$createSignal();
  const selected_filters_ = $8tj43$createSignal([]);
  const sideways_filter_clearing_flag_ = $8tj43$createSignal(false);
  const [get_sorting_, set_sorting] = current_sorting_;
  const [get_selected_filters_, set_selected_filters] = selected_filters_;
  const [get_has_sideways_filter_clearing_flag_, set_has_sideways_filter_clearing_flag] = sideways_filter_clearing_flag_;
  const [get_current_href, set_current_href] = $8tj43$createSignal((_globalThis$location$ = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.href) !== null && _globalThis$location$ !== void 0 ? _globalThis$location$ : "https://example.com");
  const history_change_handler = $8tj43$catchify1(() => set_current_href(location.href));
  const owner = $8tj43$getOwner() || $8tj43$createRoot(() => $8tj43$getOwner());
  const {
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_
  } = options;
  let writer_started = false;
  (0, $8tj43$instant_exec_on_suspect_history_change).add(history_change_handler);
  $8tj43$onCleanup(() => (0, $8tj43$instant_exec_on_suspect_history_change).delete(history_change_handler));
  $8tj43$createComputed(() => {
    const {
      searchParams: searchParams,
      hash: hash
    } = new URL(get_current_href());
    $8tj43$batch(() => {
      const found_sorting = $2855bffe06ef7a03$export$766e9676e74997d3(searchParams, sorting_query_param_);
      if (found_sorting) {
        const current_sorting = $8tj43$untrack(get_sorting_);
        // Do some diffing since we might assume in certain places of the code that if the signal changes it means the sorting has changed
        if ((current_sorting === null || current_sorting === void 0 ? void 0 : current_sorting.field) !== found_sorting.field || (current_sorting === null || current_sorting === void 0 ? void 0 : current_sorting.order) !== found_sorting.order) set_sorting(found_sorting);
      } else set_sorting();
      const found_filters = $2855bffe06ef7a03$export$f934fa24c3a86811(searchParams, filter_query_param_prefix_);
      const selected_filters = $8tj43$untrack(get_selected_filters_);
      const found_filters_map = new Map(found_filters.map(_ref => {
        let {
          field: field,
          op: op,
          data: data
        } = _ref;
        return [JSON.stringify([field, op]), data];
      }));
      // Sorry for this diffing algorithm lol. Looking forwards to Records and Tuples.
      if (selected_filters.length !== found_filters.length || !selected_filters.every(_ref2 => {
        let {
          field: field,
          op: op,
          data: data
        } = _ref2;
        return JSON.stringify(found_filters_map.get(JSON.stringify([field, op]))) === JSON.stringify(data);
      })) set_selected_filters(found_filters);
      if (search_query_url_param_name_) {
        const found_query = searchParams.get(search_query_url_param_name_);
        set_search_query(found_query || "");
      }
      if (override_listing_id_query_param_names_) {
        const found_override_listing_id = override_listing_id_query_param_names_.map(n => searchParams.get(n)).find(n => n);
        set_override_listing_id(found_override_listing_id || null);
        if (found_override_listing_id) $8tj43$dlog("Found override query id:", found_override_listing_id); // This stuff might get confusing so better log it
      }

      if (hash === (0, $2855bffe06ef7a03$export$84daa4fa1471698b)) set_has_sideways_filter_clearing_flag(true);
      if (!writer_started) {
        // The owner here is the createComputed which gets disposed the next time the computation runs - but we actually just want to delay the start of the href_writer until our signals contain the current value of the URL, therefore the runWithOwner
        $8tj43$runWithOwner(owner, () => $9d3d794b62318ecc$var$start_href_writer({
          get_sorting_: get_sorting_,
          get_selected_filters_: get_selected_filters_,
          router_: router_,
          get_has_sideways_filter_clearing_flag_: get_has_sideways_filter_clearing_flag_,
          sorting_query_param_: sorting_query_param_,
          filter_query_param_prefix_: filter_query_param_prefix_
        }));
        writer_started = true;
      }
    });
  });
  // @ts-ignore
  return {
    current_sorting_: current_sorting_,
    selected_filters_: selected_filters_,
    ...(typeof search_query_url_param_name_ === "string" ? {
      search_query_accessor_: get_search_query_
    } : {
      sideways_filter_clearing_flag_: sideways_filter_clearing_flag_
    }),
    ...(typeof override_listing_id_query_param_names_ === "object" ? {
      override_listing_id_accessor_: get_override_listing_id_
    } : {})
  };
}
/**
 * Writes the sorting and filters to the URL query parameters when they change.
 */
function $9d3d794b62318ecc$var$start_href_writer(_ref3) {
  let {
    get_sorting_: get_sorting_,
    get_selected_filters_: get_selected_filters_,
    router_: router_,
    get_has_sideways_filter_clearing_flag_: get_has_sideways_filter_clearing_flag_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_
  } = _ref3;
  $8tj43$createEffect($8tj43$on([get_sorting_, get_selected_filters_, get_has_sideways_filter_clearing_flag_], _ref4 => {
    let [sorting, filters, has_sideways_filter_clearing_flag] = _ref4;
    const url_object = new URL(location.href);
    const unmodified_search_params = [...url_object.searchParams];
    const unmodified_hash = url_object.hash;
    const {
      searchParams: searchParams
    } = url_object;
    $2855bffe06ef7a03$export$916e6850778505f6(searchParams, filter_query_param_prefix_, sorting_query_param_);
    $2855bffe06ef7a03$export$62acb285a7579555(sorting, searchParams, sorting_query_param_);
    $2855bffe06ef7a03$export$58aa3f171519b6d7(filters, searchParams, filter_query_param_prefix_);
    if (!has_sideways_filter_clearing_flag) $9d3d794b62318ecc$var$delete_sideways_param_flag(url_object);
    // We can't just check if the URL is equal since sometimes the order of the parameters in the URL changes (randomly?) so we need to compare them one by one
    const new_search_params = [...searchParams];
    // Having the array middle step because if we'd check the "size" property of the map the algorithm could be fooled if there were two query parameters with the same key
    const new_search_params_map = new Map(new_search_params);
    if (unmodified_search_params.length !== new_search_params.length || !unmodified_search_params.every(_ref5 => {
      let [key, value] = _ref5;
      return new_search_params_map.get(key) === value;
    }) || unmodified_hash !== url_object.hash)
      // Only update URL if it actually changed
      router_.navigate_.go_to_({
        is_replace_: true,
        new_url_: url_object.href,
        force_spa_navigation_: true,
        scroll: false
      });
  }, {
    defer: true
  }));
}
function $9d3d794b62318ecc$var$delete_sideways_param_flag(url_object) {
  if (url_object.hash === (0, $2855bffe06ef7a03$export$84daa4fa1471698b)) url_object.hash = "";
}
function $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $f5f54892fd0c7d9f$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $f5f54892fd0c7d9f$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $f5f54892fd0c7d9f$var$_classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
  $f5f54892fd0c7d9f$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
  $f5f54892fd0c7d9f$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "get");
  return $f5f54892fd0c7d9f$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $f5f54892fd0c7d9f$var$_classCheckPrivateStaticFieldDescriptor(descriptor, action) {
  if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}
function $f5f54892fd0c7d9f$var$_classCheckPrivateStaticAccess(receiver, classConstructor) {
  if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}
function $f5f54892fd0c7d9f$var$_classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) return descriptor.get.call(receiver);
  return descriptor.value;
}
// We just pass page_url_creator to DepictAPI when we instantiate it, so don't allow it to be specified if api is already specified
/**
 * Type for the private properties that are shared between the different exported search SDK wrapper functions.
 * SDK users are not allowed to change/access these, they're an internal implementation detail.
 */
const $f5f54892fd0c7d9f$var$privately_shared_properties = /*@__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_router = /*#__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_localization_signal = /*#__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_merchant_signal = /*#__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_market_signal = /*#__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_listing_query_signal = /*#__PURE__*/new WeakMap();
var $f5f54892fd0c7d9f$var$_disable_override_listing_id = /*#__PURE__*/new WeakMap();
class $f5f54892fd0c7d9f$export$f34314aa9505732e {
  /**
  * Used internally in @depict-ai/react-ui for `useCategoryFilterHelpers`. These are solid-js signals that contain the value of the state for this DepictCategory instance that's currently in history.state. Calling the setters updates history.state with history.replaceState.
  */ /**
     * Signal representing the currently selected filters. Will update to always reflect the state of the current URL. Calling the setter triggers a navigation (replaceState) to an updated URL.
     */
  get localization() {
    // allow reactive access
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_localization_signal)[0]();
  }
  set localization(locale_obj) {
    if (typeof locale_obj === "string")
      // Prevent people not using typescript from accidentally passing a string instead of an object, see https://depictaiworkspace.slack.com/archives/C04RF3KTK0A/p1707211551951239
      throw new Error("locale must be an object, see the TypeScript definitions");
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_localization_signal)[1](locale_obj);
  }
  get listing_query() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_listing_query_signal)[0]();
  }
  set listing_query(query) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_listing_query_signal)[1](query);
  }
  get merchant() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_merchant_signal)[0]();
  }
  set merchant(merchant) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_merchant_signal)[1](merchant);
  }
  get market() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_market_signal)[0]();
  }
  set market(market) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_market_signal)[1](market);
  }
  get disable_override_listing_id() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_disable_override_listing_id)[0]();
  }
  set disable_override_listing_id(new_value) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_disable_override_listing_id)[1](new_value);
  }
  get on_navigation() {
    // The only non-reactive public property on the class (I don't see it making sense to have it reactive)
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router).on_navigation_;
  }
  set on_navigation(new_function) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router).on_navigation_ = new_function;
  }
  constructor(_ref) {
    let {
      api: api,
      on_navigation: on_navigation,
      display_transformers: display_transformers,
      unique_instance_key_for_state = "",
      listing_query_state_key: listing_query_state_key,
      ...props_on_class
    } = _ref;
    $8tj43$babelruntimehelpersdefineProperty(this, "historyStateSignals_", void 0);
    $8tj43$babelruntimehelpersdefineProperty(this, "selectedFilters_", void 0);
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_router, {
      writable: true,
      value: void 0
    });
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_localization_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_merchant_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_market_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_listing_query_signal, {
      writable: true,
      value: $8tj43$createSignal({})
    });
    $f5f54892fd0c7d9f$var$_classPrivateFieldInitSpec(this, $f5f54892fd0c7d9f$var$_disable_override_listing_id, {
      writable: true,
      value: $8tj43$createSignal()
    });
    const owner = $8tj43$getOwner() || $8tj43$createRoot(() => $8tj43$getOwner()); // we might have an owner, if so, pass it on. Otherwise, create one so solid doesn't print warnings to the console
    $8tj43$runWithOwner(owner, () => {
      if ($f5f54892fd0c7d9f$var$_classStaticPrivateFieldSpecGet($f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$var$_keys_constructed_with).has(unique_instance_key_for_state) && !(0, $8tj43$isServer))
        // on the server we can't write stuff to history.state anyway so can have multiple
        throw new Error("You can only have one instance of DepictCategory with the same uniqueInstanceKeyForState");
      Object.assign(this, props_on_class); // set initial signal values
      $68e6625c8d51f847$export$5162a71f252e6122();
      $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $f5f54892fd0c7d9f$var$_router, new (0, $ac571292d606f30b$export$7e1297a3a19f10d8)("hard_navigation", listing_query_state_key));
      if (on_navigation) $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router).on_navigation_ = on_navigation;
      const override_listing_id_query_param_names_ = ["listing_id_" + unique_instance_key_for_state, "listing_id"]; // If you're wondering why this is an array https://gitlab.com/depict-ai/depict.ai/-/merge_requests/7958#note_1511700842
      const sorting_query_param_ = "sorting" + unique_instance_key_for_state;
      const filter_query_param_prefix_ = "f" + unique_instance_key_for_state + "_";
      const {
        selected_filters_: selected_filters_,
        current_sorting_: current_sorting_,
        sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
        override_listing_id_accessor_: override_listing_id_accessor_
      } = $9d3d794b62318ecc$export$477caf01aecaeb2a({
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router),
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_,
        override_listing_id_query_param_names_: override_listing_id_query_param_names_
      });
      const [reset_history_state_, state_] = $bc811d9630f9579b$export$9862539c89138352({
        get_default_values_: () => ({
          filters_open: false,
          sorting_open: false,
          expanded_filters: [],
          // Please make sure that the signal created by below line always updates AFTER selected_filters_ updates on a "popstate" event. If the filter cache is popped before the selected filters are the code in create_modified_filters() is going to re-calculate search_local_filter_cache without knowing the real value of search_selected_filters, and we'll end up with too few filters in search_local_filter_cache in some cases
          local_filter_cache: [],
          expanded_hierarchical_filters: [],
          scroll_restoration_data: [],
          history_content_blocks: {
            blocks: [],
            aspectRatios: {}
          }
        }),
        // Don't reset content block stuff when leaving category page as we need it for scroll restoration, same with scroll restoration data (actually a bit unsure if this is needed, I think it depends on if someone cleans up our elements before the location changes or after, and maybe some of the test flakyness we have seen is due to this not existing before?)
        preserveKeys_: ["history_content_blocks", "scroll_restoration_data"],
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router),
        prefix_: "category" + unique_instance_key_for_state + "_"
      });
      const i18n_ = $e18ab2868df26f40$export$f091cbac892643a4($8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_localization_signal)[0]);
      this.historyStateSignals_ = state_;
      this.selectedFilters_ = selected_filters_;
      $f5f54892fd0c7d9f$var$privately_shared_properties.set(this, {
        breadcrumb_signal_: $8tj43$createSignal(),
        quicklinks_signal_: $8tj43$createSignal(),
        i18n_: i18n_,
        reset_history_state_: reset_history_state_,
        // @ts-ignore
        depict_api_: api !== null && api !== void 0 ? api : new (0, $284849364a6ef73a$export$e015ed2f2950f2e3)({
          display_transformers: display_transformers
        }),
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f5f54892fd0c7d9f$var$_router),
        selected_filters_: selected_filters_,
        current_sorting_: current_sorting_,
        override_listing_id_accessor_: override_listing_id_accessor_,
        sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_
      });
      $f5f54892fd0c7d9f$var$_classStaticPrivateFieldSpecGet($f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$var$_keys_constructed_with).add(unique_instance_key_for_state);
      $8tj43$onCleanup(() => $f5f54892fd0c7d9f$var$_classStaticPrivateFieldSpecGet($f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$export$f34314aa9505732e, $f5f54892fd0c7d9f$var$_keys_constructed_with).delete(unique_instance_key_for_state));
    });
  }
}
/**
 * Gets private properties that are shared between the different exported category SDK wrapper functions. SDK users are not allowed to change/access these, they're an internal implementation detail.
 * Only access this in exported SDK functions (not the solid components).
 * @param depict_category The DepictCategory instance to get the shared properties for
 */
var $f5f54892fd0c7d9f$var$_keys_constructed_with = {
  writable: true,
  value: /*@__PURE__*/new Set()
};
function $f5f54892fd0c7d9f$export$1bc6f63c09b1a481(depict_category) {
  const shared_properties = $f5f54892fd0c7d9f$var$privately_shared_properties.get(depict_category);
  if (!shared_properties) throw new Error("Can't connect to provided DepictCategory instance");
  return shared_properties;
}
var $dea31647b99a443b$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<span class=parent-title>`),
  $dea31647b99a443b$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<a class=category-suggestion><span class=title></span><!$><!/>`);
function $dea31647b99a443b$export$d757d54550ebfb3d(_ref) {
  let {
    category_suggestion_: category_suggestion_,
    router_: router_
  } = _ref;
  const parentTitle = $8tj43$createMemo(() => {
    var _category_suggestion_;
    return (_category_suggestion_ = category_suggestion_().ancestors.at(-1)) === null || _category_suggestion_ === void 0 ? void 0 : _category_suggestion_.title;
  });
  return (() => {
    var _el$ = $8tj43$getNextElement($dea31647b99a443b$var$_tmpl$2),
      _el$2 = _el$.firstChild,
      _el$4 = _el$2.nextSibling,
      [_el$5, _co$] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$addEventListener(_el$, "click", $8tj43$catchify1(e => {
      router_.navigate_.go_to_({
        new_url_: category_suggestion_().page_url,
        is_replace_: false,
        event_: e
      });
    }), true);
    $8tj43$insert(_el$2, () => category_suggestion_().title);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return parentTitle();
      },
      get children() {
        var _el$3 = $8tj43$getNextElement($dea31647b99a443b$var$_tmpl$);
        $8tj43$insert(_el$3, parentTitle);
        return _el$3;
      }
    }), _el$5, _co$);
    $8tj43$effect(() => $8tj43$setAttribute(_el$, "href", category_suggestion_().page_url));
    $8tj43$runHydrationEvents();
    return _el$;
  })();
}
$8tj43$delegateEvents(["click"]);
var $8ef6232475d44150$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=search-recs><h3 class=search-recs-title></h3><!$><!/><!$><!/>`),
  $8ef6232475d44150$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button class="show-more major"type=button>`);
const $8ef6232475d44150$export$1c8c715550dc689d = 2;
function $8ef6232475d44150$export$7de92c4c2205ebf3(_ref) {
  let {
    depict_api_: depict_api_,
    i18n_: i18n_,
    search_query_base_: search_query_base_,
    product_card_template_: product_card_template_,
    showing_recommendation_rows_: showing_recommendation_rows_,
    layout_options_: layout_options_,
    all_products_loaded_: all_products_loaded_
  } = _ref;
  const [get_showing_recommendation_rows] = showing_recommendation_rows_; // We reset this in after_submit in search.tsx FYI
  const rows_object = $8ef6232475d44150$var$make_state_saved_rows(showing_recommendation_rows_, i18n_);
  const [recommendations_resource] = $8tj43$createResource(() => all_products_loaded_() && search_query_base_(),
  // only fetch/refetch if all products are loaded
  query => query && depict_api_.get_recommended(query).then(r => r.displays));
  const should_show = $8tj43$createMemo(() => {
    var _recommendations_reso;
    return !!((recommendations_resource.loading || (_recommendations_reso = recommendations_resource()) !== null && _recommendations_reso !== void 0 && _recommendations_reso.length) && all_products_loaded_());
  });
  const num_placeholders_ = $8tj43$createMemo(() => {
    const possible_num_columns = layout_options_().cols_at_size.map(_ref2 => {
      let [per_column] = _ref2;
      return per_column;
    });
    if (!possible_num_columns.length)
      // Empty cols_at_size, for example artilleriet has that
      // Assume there will be 4 columns
      possible_num_columns.push(4);
    return (0, $981356a8bf29ad72$export$6c9030e511152266) + get_showing_recommendation_rows() * Math.max(...possible_num_columns);
  });
  // Don't tear down elements every time one updates the page - don't put them within <Show>
  const elements = (() => {
    var _el$ = $8tj43$getNextElement($8ef6232475d44150$var$_tmpl$),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling,
      [_el$4, _co$] = $8tj43$getNextMarker(_el$3.nextSibling),
      _el$5 = _el$4.nextSibling,
      [_el$6, _co$2] = $8tj43$getNextMarker(_el$5.nextSibling);
    $8tj43$insert(_el$2, () => i18n_.search_recs_title_());
    $8tj43$insert(_el$, (0, $ca55612a53dbbdd2$export$a2cc176055f8f08), _el$4, _co$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $63f1f8dbcd07d3b0$export$d21e32dfedac04be), $8tj43$mergeProps1({
      rows: rows_object,
      layout: "grid",
      element_attributes: {
        class: "cards"
      }
    }, layout_options_, {
      get children() {
        return $8tj43$createComponent((0, $8tj43$Suspense), {
          get fallback() {
            return $bdd80c7862246dc2$export$f33414a4df0afd3f({
              num_placeholders_: num_placeholders_,
              product_card_template_: product_card_template_
            });
          },
          get children() {
            return (() => {
              // IIFE to make sure we access both the recommendations_resource and the resources containing the product card rendering results themselves within the Suspense boundary
              const displays_by_key_ = $2d7bad8684bc7f44$export$7f8bd308237ab5a5($8tj43$createMemo(prev => {
                if (!should_show() && prev) return prev; // When we're invisible, don't update what we're rendering to be possibly undefined to preserve the same products if possible
                return recommendations_resource() || [];
              }));
              const {
                renderedDisplays_: renderedDisplays_
              } = $618bd53ea0a41cd4$export$4a14175d33d81a96({
                displays_by_key_: displays_by_key_,
                product_card_template_: product_card_template_
              });
              return renderedDisplays_;
            })();
          }
        });
      }
    })), _el$6, _co$2);
    return _el$;
  })();
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      return should_show();
    },
    children: elements
  });
}
function $8ef6232475d44150$var$make_state_saved_rows(_ref3, i18n_) {
  let [get_showing_recommendation_rows, set_showing_recommendation_rows] = _ref3;
  const currently_visible = $8tj43$createSignal($8tj43$untrack(get_showing_recommendation_rows));
  const [get_currently_visible, set_currently_visible] = currently_visible;
  const rows = {
    currently_visible: currently_visible,
    start_rows: $8ef6232475d44150$export$1c8c715550dc689d,
    rows_per_click: 3,
    button: (() => {
      var _el$7 = $8tj43$getNextElement($8ef6232475d44150$var$_tmpl$2);
      $8tj43$insert(_el$7, () => i18n_.view_more_());
      return _el$7;
    })()
  };
  $8tj43$createComputed($8tj43$on(get_currently_visible, new_visible => set_showing_recommendation_rows(new_visible), {
    defer: true
  }));
  $8tj43$createComputed($8tj43$on(get_showing_recommendation_rows, function () {
    let new_rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $8ef6232475d44150$export$1c8c715550dc689d;
    return set_currently_visible(new_rows);
  }, {
    defer: true
  }));
  return rows;
}
function $d8a66ba54a42eb3e$export$e026af0c7b64ea5f(_ref) {
  let {
    selected_filters_: selected_filters_,
    get_search_query_: get_search_query_,
    current_sorting_: current_sorting_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    i18n_: i18n_,
    local_filter_cache_: local_filter_cache_,
    expanded_filters_: expanded_filters_,
    filters_open_: filters_open_
  } = _ref;
  const [get_selected_filters] = selected_filters_;
  // Possible values:
  // 0 - we should not clear next submit
  // 1 - we should clear next submit due to internal heuristics
  // 2 - we should clear next submit due to EXPLICIT user action (i.e. clear button pressed)
  const clear_filters_next_submit_ = $8tj43$createSignal(0); // we store this here (and not in history.state) (maybe there's a better place) because it's a very temporary thing. I.e. as soon as anything breaks the "flow of intent" to make a new search we want this reset
  const [get_clear_filters_next_submit, set_clear_filters_next_submit] = clear_filters_next_submit_;
  const clear_filters = user_triggered => set_clear_filters_next_submit(user_triggered ? 2 : 1);
  $8tj43$createComputed($8tj43$on(get_selected_filters, () => {
    // if the selected filters update, clear the clearing signal
    set_clear_filters_next_submit(0);
  }, {
    defer: true
  }));
  $8tj43$createComputed($8tj43$on(get_search_query_, $8tj43$catchify1(() => {
    // when a query was submitted, clear filters if clear was pressed before
    const clear_value = $8tj43$untrack(get_clear_filters_next_submit);
    if (clear_value) {
      set_clear_filters_next_submit(0);
      $b4465d8d605f61e9$export$8895d39404bd2bb1({
        user_triggered_: clear_value === 2,
        selected_filters_: selected_filters_,
        i18n_: i18n_,
        also_clear_sorting_: true,
        current_sorting_: current_sorting_,
        expanded_hierarchical_filters_: expanded_hierarchical_filters_,
        local_filter_cache_: local_filter_cache_,
        expanded_filters_: expanded_filters_,
        filters_open_: filters_open_
      });
    }
  }), {
    defer: true
  }));
  return clear_filters;
}
function $07d90b8270ece8de$export$84bba84a7b837187(read_search_query) {
  const ls = (globalThis === null || globalThis === void 0 ? void 0 : globalThis.localStorage) || {};
  const key = "depict_searches";
  const previous_searches = $8tj43$createSignal(JSON.parse(ls[key] || "[]"));
  const [read_previous_searches, write_previous_searches] = previous_searches;
  $8tj43$createEffect($8tj43$catchify1(() => {
    const json_encoded = JSON.stringify(read_previous_searches());
    if (ls[key] !== json_encoded) ls[key] = json_encoded;
  }));
  $8tj43$createComputed($8tj43$catchify1(() => {
    const searches = $8tj43$untrack(read_previous_searches);
    const current_query = read_search_query();
    if (!current_query)
      // don't save no query in history
      return;
    const new_value = [...searches.filter(value => value !== current_query), current_query].slice(-30); // keep max 30 values (one could be deleted later because it's the search query), if value we add already exists remove it first
    write_previous_searches(new_value);
  }));
  return previous_searches;
}
async function $86b0ff0c85e5fc6c$export$e16630ecb9644a1c(_ref) {
  let {
    on_submit_with_unchanged_value_: on_submit_with_unchanged_value_,
    search_param_name_: search_param_name_,
    set_search_field_value_: set_search_field_value_,
    get_search_query_: get_search_query_,
    url_transformer_: url_transformer_,
    router_: router_,
    after_submit_: after_submit_,
    get_new_query: get_new_query
  } = _ref;
  const new_search_query = get_new_query();
  const previous_query = $8tj43$untrack(get_search_query_);
  if (previous_query === new_search_query && new URLSearchParams(location.search).has(search_param_name_)) {
    // don't push a history entry / re-search if someone submits a search again
    // do close the modal though
    on_submit_with_unchanged_value_ === null || on_submit_with_unchanged_value_ === void 0 || on_submit_with_unchanged_value_();
    return;
  }
  set_search_field_value_(previous_query); // restore the value to the previous query since this one goes to the new history entry
  const target_url = new URL(location.href);
  url_transformer_ === null || url_transformer_ === void 0 || url_transformer_(target_url);
  target_url.searchParams.set(search_param_name_, new_search_query);
  await router_.navigate_.go_to_({
    new_url_: target_url,
    is_replace_: false,
    force_spa_navigation_: true
  });
  set_search_field_value_(new_search_query);
  scrollTo(0, 0);
  after_submit_ === null || after_submit_ === void 0 || after_submit_();
}
function $96d57a48e7bce64f$export$181cceed5c91919e(callback, alsoRaF, passiveListener) {
  let aligned_this_microtask = false;
  const probablyCallCallback = () => {
    if (aligned_this_microtask) return;
    aligned_this_microtask = true;
    queueMicrotask(() => aligned_this_microtask = false);
    callback();
  };
  $8tj43$createEffect(() => {
    if (alsoRaF !== null && alsoRaF !== void 0 && alsoRaF()) {
      let disposed = false;
      const fn = $8tj43$catchify1(() => {
        if (disposed) return;
        probablyCallCallback();
        requestAnimationFrame(fn);
      });
      fn();
      $8tj43$onCleanup(() => disposed = true);
    }
  });
  $33e7d1906c93db7d$export$205efb947c7ffd78(probablyCallCallback, passiveListener);
  // "resize" doesn't fire sometimes when it should, also it doesn't when showing/hiding scrollbars which disabling scrolling does
  // this works
  // keeping resize just in case
  const resize_resize_observer = new ResizeObserver($8tj43$catchify1(probablyCallCallback));
  resize_resize_observer.observe(document.documentElement);
  (0, $8tj43$observer).wait_for_element("body").then(resize_resize_observer.observe.bind(resize_resize_observer));
  $8tj43$onCleanup($8tj43$catchify1(() => resize_resize_observer.disconnect()));
  return probablyCallCallback;
}
const $1308a7816c3d4f2d$export$3f238c96c45e6cc6 = 1;
const $1308a7816c3d4f2d$export$7895aadd1956b1c7 = 2;
const $1308a7816c3d4f2d$export$902f8b4a7dae5d78 = 4;
const $1308a7816c3d4f2d$export$5097308c5200105a = 8;
const $1308a7816c3d4f2d$export$6060bc6bee850eb6 = 16;
function $1308a7816c3d4f2d$export$b3ad617e9036868(_ref, input_field, alignment, includeScroll) {
  let {
    body_: [, setModalBodyStyle],
    field_: [, setModalFiedlStyle]
  } = _ref;
  let pollAlignment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : () => false;
  const ensureAlignedPosition = $96d57a48e7bce64f$export$181cceed5c91919e(() => {
    const rect = input_field.getBoundingClientRect(); /* for some reason contentRect.top and contentRect.left is 0 from the RO */
    const addToLeftValue = alignment & $1308a7816c3d4f2d$export$6060bc6bee850eb6 ? rect.width / 2 : 0;
    const leftWithoutScroll = rect.left + addToLeftValue;
    const topValue = rect.top + (includeScroll ? scrollY : 0);
    setModalBodyStyle(old_value => ({
      ...old_value,
      // Do not allow top values under 0, this usually happens when aligning to an element that's absolutely positioned and the user is scrolled down - in that case we want to sacrifice alignment for the modal being visible
      ...(alignment & $1308a7816c3d4f2d$export$3f238c96c45e6cc6 ? {
        top: "".concat(topValue >= 0 ? topValue : 0, "px")
      } : {}),
      ...(alignment & $1308a7816c3d4f2d$export$7895aadd1956b1c7 ? {
        left: "".concat(leftWithoutScroll + (includeScroll ? scrollX : 0), "px")
      } : {}),
      ...(alignment & $1308a7816c3d4f2d$export$6060bc6bee850eb6 ? {
        transform: "translateX(-50%)"
      } : {})
    }));
  }, pollAlignment);
  let ro;
  if (alignment & $1308a7816c3d4f2d$export$902f8b4a7dae5d78 || alignment & $1308a7816c3d4f2d$export$5097308c5200105a) {
    ro = new ResizeObserver($8tj43$catchify1(records => {
      records.forEach(_ref2 => {
        let {
          contentRect: {
            width: width
          }
        } = _ref2;
        if (alignment & $1308a7816c3d4f2d$export$5097308c5200105a) {
          setModalFiedlStyle(old_value => ({
            ...old_value,
            "max-width": "".concat(width, "px")
          }));
          return;
        }
        setModalBodyStyle(old_value => ({
          ...old_value,
          "max-width": "unset",
          width: "".concat(width, "px")
        }));
      });
      ensureAlignedPosition();
    }));
    ro.observe(input_field);
  }
  $8tj43$onCleanup($8tj43$catchify1(() => {
    var _ro;
    return (_ro = ro) === null || _ro === void 0 ? void 0 : _ro.disconnect();
  }));
  return ensureAlignedPosition;
}
var $754f319a849bfdbc$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=category-suggestions>`),
  $754f319a849bfdbc$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=category-suggestion>`);
function $754f319a849bfdbc$export$c05a196222ba1302(_ref) {
  let {
    suggestions_: suggestions_,
    children: children
  } = _ref;
  const category_suggestions_ = $8tj43$createMemo(() => {
    var _suggestions_;
    return (_suggestions_ = suggestions_()) === null || _suggestions_ === void 0 ? void 0 : _suggestions_.suggestions.filter(s => s.type === "listing");
  });
  return $8tj43$createComponent((0, $8tj43$Show), {
    get when() {
      var _category_suggestions;
      return ((_category_suggestions = category_suggestions_()) === null || _category_suggestions === void 0 ? void 0 : _category_suggestions.length) || suggestions_.loading;
    },
    get children() {
      var _el$ = $8tj43$getNextElement($754f319a849bfdbc$var$_tmpl$);
      $8tj43$insert(_el$, $8tj43$createComponent((0, $002f09d00aac50b2$export$6649caad96ef8870), {
        faded_opacity_: 0.7,
        get children() {
          return $8tj43$createComponent((0, $8tj43$Show), {
            get when() {
              return !suggestions_.loading;
            },
            get fallback() {
              return (() => {
                var _el$2 = $8tj43$getNextElement($754f319a849bfdbc$var$_tmpl$2);
                $8tj43$insert(_el$2, $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
                  height: "19px",
                  width: "133px"
                }));
                return _el$2;
              })();
            },
            get children() {
              return $8tj43$createComponent((0, $8tj43$Index), {
                get each() {
                  return category_suggestions_();
                },
                children: (suggestion, index) => children(suggestion, index)
              });
            }
          });
        }
      }));
      return _el$;
    }
  });
}
var $69602b3d8fd54c38$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<b>`),
  $69602b3d8fd54c38$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div class=results-for>`);
function $69602b3d8fd54c38$export$9dd50d35b9d94fdf(_ref) {
  let {
    get_search_query_: get_search_query_,
    i18n_: i18n_,
    formatted_number_of_results_: formatted_number_of_results_,
    number_of_results_: number_of_results_,
    type: type
  } = _ref;
  const contents = $8tj43$createMemo($8tj43$catchify1(() => {
    const q = get_search_query_();
    return i18n_[type === $69602b3d8fd54c38$export$2452208c79fe93ea.content ? "get_showing_pages_for_" : "get_showing_results_for_"]()((() => {
      var _el$ = $8tj43$getNextElement($69602b3d8fd54c38$var$_tmpl$);
      $8tj43$insert(_el$, q);
      return _el$;
    })(), (() => {
      var _el$2 = $8tj43$getNextElement($69602b3d8fd54c38$var$_tmpl$);
      $8tj43$insert(_el$2, formatted_number_of_results_);
      return _el$2;
    })(), !!q, number_of_results_());
  }));
  return (() => {
    var _el$3 = $8tj43$getNextElement($69602b3d8fd54c38$var$_tmpl$2);
    $8tj43$insert(_el$3, contents);
    return _el$3;
  })();
}
let $69602b3d8fd54c38$export$2452208c79fe93ea;
(function (ShowingResultsForType) {
  ShowingResultsForType[ShowingResultsForType["products"] = 0] = "products";
  ShowingResultsForType[ShowingResultsForType["content"] = 1] = "content";
})($69602b3d8fd54c38$export$2452208c79fe93ea || ($69602b3d8fd54c38$export$2452208c79fe93ea = {}));
function $8e8ce3f7a5eb11a6$export$41b4894022a3580f() {
  let {
    alignmentSignals_: alignmentSignals_
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  alignmentSignals_ = {
    body_: $8tj43$createSignal({}),
    field_: $8tj43$createSignal({}),
    backdrop_: $8tj43$createSignal({}),
    ...alignmentSignals_
  };
  const [, set_style_props] = alignmentSignals_.body_;
  const supports_hover = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(hover: hover) and (pointer: fine)");
  const desktop_short = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(max-height: 790px)");
  const mobile_short = $00a5b94f0c11efbb$export$d9f36cf74e24d595("(max-height: 1000px)");
  const transform_y = $8tj43$createMemo(() => supports_hover() ? !desktop_short() : !mobile_short());
  set_style_props({
    position: "fixed",
    top: "50%"
  });
  $8tj43$createComputed(() => set_style_props(old_value => ({
    ...old_value,
    transform: transform_y() ? "translateY(-50%)" : "unset"
  })));
  return alignmentSignals_;
}
var $22470de5f42cc35d$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<a>`),
  $22470de5f42cc35d$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div>`),
  $22470de5f42cc35d$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<div class="description line-clamp">`),
  $22470de5f42cc35d$var$_tmpl$4 = /*#__PURE__*/$8tj43$template(`<div class=content-card><div class=image></div><div class=info><!$><!/><!$><!/>`);
function $22470de5f42cc35d$export$f631859cab12b342(_ref) {
  let {
    router_: router_,
    content_result_: content_result_
  } = _ref;
  const make_link_attributes = () => {
    const result = content_result_ === null || content_result_ === void 0 ? void 0 : content_result_();
    if (!result) return;
    return {
      href: result.page_url,
      onClick: $8tj43$catchify1(ev => router_.navigate_.go_to_({
        new_url_: result.page_url,
        is_replace_: false,
        event_: ev
      }))
    };
  };
  const LinkIfPossible = _ref2 => {
    let {
      children: children,
      ...attributes
    } = _ref2;
    if (content_result_) return (() => {
      var _el$ = $8tj43$getNextElement($22470de5f42cc35d$var$_tmpl$);
      $8tj43$spread(_el$, attributes, false, true);
      $8tj43$insert(_el$, children);
      $8tj43$runHydrationEvents();
      return _el$;
    })();
    return (() => {
      var _el$2 = $8tj43$getNextElement($22470de5f42cc35d$var$_tmpl$2);
      $8tj43$spread(_el$2, attributes, false, true);
      $8tj43$insert(_el$2, children);
      $8tj43$runHydrationEvents();
      return _el$2;
    })();
  };
  return (() => {
    var _el$3 = $8tj43$getNextElement($22470de5f42cc35d$var$_tmpl$4),
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$7 = _el$5.firstChild,
      [_el$8, _co$] = $8tj43$getNextMarker(_el$7.nextSibling),
      _el$9 = _el$8.nextSibling,
      [_el$10, _co$2] = $8tj43$getNextMarker(_el$9.nextSibling);
    $8tj43$insert(_el$4, $8tj43$createComponent(LinkIfPossible, $8tj43$mergeProps1(make_link_attributes, {
      tabIndex: "-1",
      get children() {
        return $8tj43$createComponent((0, $3c5e15c6ee4227a9$export$605674723bcc715c), {
          width: "28",
          height: "28"
        });
      }
    })));
    $8tj43$insert(_el$5, $8tj43$createComponent(LinkIfPossible, $8tj43$mergeProps1({
      "class": "content-title line-clamp"
    }, make_link_attributes, {
      get title() {
        return content_result_ === null || content_result_ === void 0 ? void 0 : content_result_().title;
      },
      get children() {
        return content_result_ ? $8tj43$createComponent((0, $f3a159279dc1a8fb$export$e1a98a189fd2c0e7), {
          content_result_: content_result_,
          key_: "title",
          cut_when_possible_: false
        }) : $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
          height: "1em",
          width: "10ch"
        });
      }
    })), _el$8, _co$);
    $8tj43$insert(_el$5, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        return content_result_ === null || content_result_ === void 0 ? void 0 : content_result_().description;
      },
      get children() {
        var _el$6 = $8tj43$getNextElement($22470de5f42cc35d$var$_tmpl$3);
        $8tj43$insert(_el$6, $8tj43$createComponent((0, $8tj43$Show), {
          when: content_result_,
          get fallback() {
            return Array.from({
              length: 4
            }).map(() => $8tj43$createComponent((0, $ceafb6fb91c6f394$export$89c6019e4baa40b1), {
              height: "1em",
              width: "min(50ch, 100%)"
            }));
          },
          get children() {
            return $8tj43$createComponent((0, $f3a159279dc1a8fb$export$e1a98a189fd2c0e7), {
              content_result_: content_result_,
              key_: "description",
              cut_when_possible_: true
            });
          }
        }));
        return _el$6;
      }
    }), _el$10, _co$2);
    return _el$3;
  })();
}
function $881e8953a9103f10$export$9ff751cd77687edc(_ref) {
  let {
    search_results_: search_results_,
    router_: router_,
    setNumberContentResultsPerQuery_: setNumberContentResultsPerQuery_,
    get_search_query_: get_search_query_
  } = _ref;
  const content_results = $8tj43$createMemo(() => {
    var _search_results_;
    return (_search_results_ = search_results_()) === null || _search_results_ === void 0 ? void 0 : _search_results_.content_search_links;
  });
  const content_results_by_page_url = $8tj43$createMemo(() => {
    const map = new Map();
    const results = content_results();
    if (!results) return map;
    for (let i = 0; i < results.length; i++) {
      const content_result = results[i];
      map.set(content_result.page_url, content_result);
    }
    return map;
  });
  $8tj43$createEffect(() => {
    const results = content_results();
    const numberResults = Array.isArray(results) ? results.length : 0;
    setNumberContentResultsPerQuery_(prev => {
      prev.set($8tj43$untrack(get_search_query_), numberResults);
      return prev;
    });
  });
  return $8tj43$createComponent((0, $8tj43$For), {
    get each() {
      return [...content_results_by_page_url().keys()];
    },
    children: page_url => {
      const content_result = $8tj43$createMemo(() => content_results_by_page_url().get(page_url));
      return $8tj43$createComponent((0, $22470de5f42cc35d$export$f631859cab12b342), {
        content_result_: content_result,
        router_: router_
      });
    }
  });
}
function $ad4f3c9872fbeb48$export$4405d077f0a20494(_ref) {
  let {
    content_results_rows_: [get_history_state_content_results_rows],
    cols_at_size_: cols_at_size_,
    overrideAmount_: overrideAmount_
  } = _ref;
  const colsShowingNow = $40e2fa435715a1a0$export$a79e666719b3647c(cols_at_size_);
  const largest_column = $8tj43$createMemo(() => {
    const largest_in_cols_at_size = Math.max(...cols_at_size_().map(_ref2 => {
      let [cols] = _ref2;
      return cols;
    }));
    if (isNaN(largest_in_cols_at_size) || Math.abs(largest_in_cols_at_size) === Infinity) return 4; // fallback to something big so we always have the right amount of placeholders
    return largest_in_cols_at_size;
  });
  const num_placeholders = $8tj43$createMemo(() => {
    var _get_history_state_co;
    const override = overrideAmount_();
    if (override !== undefined) return override;
    // Use how many columns we're actually showing, if available, so that we're showing exactly as many placeholders as we'd show content, so that the view more button doesn't appear/disappear and makes the layout shift
    return ((_get_history_state_co = get_history_state_content_results_rows()) !== null && _get_history_state_co !== void 0 ? _get_history_state_co : (0, $d53ebed6f63304e4$export$70ceae36059a1036)) * (colsShowingNow() || largest_column());
  });
  return $8tj43$createComponent((0, $8tj43$Index), {
    get each() {
      return Array.from({
        length: num_placeholders()
      });
    },
    children: () => $8tj43$createComponent((0, $22470de5f42cc35d$export$f631859cab12b342), {})
  });
}
var $d53ebed6f63304e4$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=content-results><!$><!/><!$><!/>`),
  $d53ebed6f63304e4$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<button class=view-more>`),
  $d53ebed6f63304e4$var$_tmpl$3 = /*#__PURE__*/$8tj43$template(`<button class=view-less>`);
const $d53ebed6f63304e4$export$70ceae36059a1036 = 1;
function $d53ebed6f63304e4$export$6d0c9c22f6652669(_ref) {
  let {
    search_results_: search_results_,
    get_search_query_: get_search_query_,
    i18n_: i18n_,
    layout_options_: layout_options_,
    router_: router_,
    query_base_: query_base_,
    content_results_rows_: content_results_rows_
  } = _ref;
  const content_results = $8tj43$createMemo(() => {
    var _search_results_;
    return (_search_results_ = search_results_()) === null || _search_results_ === void 0 ? void 0 : _search_results_.content_search_links;
  });
  const num_results = $8tj43$createMemo(() => {
    var _content_results;
    return (_content_results = content_results()) === null || _content_results === void 0 ? void 0 : _content_results.length;
  });
  const is_loading_ = $8tj43$createMemo(() => search_results_.loading || query_base_.loading); // See comment in PLPResults/index.tsx on why we need this
  const formatted_number_of_results_ = $43fbdca0f726a34b$export$92f2da32c6e7e7ee({
    number_: num_results,
    i18n_: i18n_
  });
  const [numberContentResultsPerQuery, setNumberContentResultsPerQuery_] = $8tj43$createSignal(new Map(), {
    equals: false
  });
  const contentResultsForCurrentQuery = $8tj43$createMemo(() => numberContentResultsPerQuery().get(get_search_query_()));
  // Don't show placeholder if we know there will not be any content results and someone is just toggling filters
  const placeholders_enabled = $8tj43$createMemo(() => contentResultsForCurrentQuery() !== 0);
  const rows_object = $d53ebed6f63304e4$var$make_state_saved_rows(content_results_rows_, i18n_);
  return (() => {
    var _el$ = $8tj43$getNextElement($d53ebed6f63304e4$var$_tmpl$),
      _el$2 = _el$.firstChild,
      [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
      _el$4 = _el$3.nextSibling,
      [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $69602b3d8fd54c38$export$9dd50d35b9d94fdf), {
      get_search_query_: get_search_query_,
      i18n_: i18n_,
      formatted_number_of_results_: formatted_number_of_results_,
      get type() {
        return (0, $69602b3d8fd54c38$export$2452208c79fe93ea).content;
      },
      number_of_results_: num_results
    }), _el$3, _co$);
    $8tj43$insert(_el$, $8tj43$createComponent((0, $63f1f8dbcd07d3b0$export$d21e32dfedac04be), $8tj43$mergeProps1({
      layout: "grid",
      element_attributes: {
        class: "cards"
      }
    }, layout_options_, {
      rows: rows_object,
      get children() {
        return $8tj43$createComponent((0, $8tj43$Suspense), {
          get fallback() {
            return $8tj43$createComponent((0, $ad4f3c9872fbeb48$export$4405d077f0a20494), {
              content_results_rows_: content_results_rows_,
              get cols_at_size_() {
                return $8tj43$createMemo(() => layout_options_().cols_at_size);
              },
              overrideAmount_: contentResultsForCurrentQuery
            });
          },
          get children() {
            return $8tj43$createComponent((0, $881e8953a9103f10$export$9ff751cd77687edc), {
              router_: router_,
              search_results_: search_results_,
              setNumberContentResultsPerQuery_: setNumberContentResultsPerQuery_,
              get_search_query_: get_search_query_
            });
          }
        });
      }
    })), _el$5, _co$2);
    $8tj43$effect(_$p => {
      var _content_results2;
      return _$p = is_loading_() && placeholders_enabled() || ((_content_results2 = content_results()) === null || _content_results2 === void 0 ? void 0 : _content_results2.length) > 0 ? "" : "none", _el$.style.setProperty("display", _$p);
    });
    return _el$;
  })();
}
function $d53ebed6f63304e4$var$make_state_saved_rows(_ref2, i18n_) {
  let [get_showing_content_results_rows, set_showing_content_results_rows] = _ref2;
  const currently_visible = $8tj43$createSignal($8tj43$untrack(get_showing_content_results_rows));
  const [get_currently_visible, set_currently_visible] = currently_visible;
  const rows = {
    currently_visible: currently_visible,
    start_rows: $d53ebed6f63304e4$export$70ceae36059a1036,
    button: (() => {
      var _el$6 = $8tj43$getNextElement($d53ebed6f63304e4$var$_tmpl$2);
      $8tj43$insert(_el$6, () => i18n_.view_more_());
      return _el$6;
    })(),
    view_less_button: (() => {
      var _el$7 = $8tj43$getNextElement($d53ebed6f63304e4$var$_tmpl$3);
      $8tj43$insert(_el$7, () => i18n_.view_less_());
      return _el$7;
    })(),
    rows_per_click: 3
  };
  $8tj43$createComputed($8tj43$on(get_currently_visible, new_visible => set_showing_content_results_rows(new_visible), {
    defer: true
  }));
  $8tj43$createComputed($8tj43$on(get_showing_content_results_rows, function () {
    let new_rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d53ebed6f63304e4$export$70ceae36059a1036;
    return set_currently_visible(new_rows);
  }, {
    defer: true
  }));
  return rows;
}
function $d7833ca17fc05c5e$export$e06dee46ebe7faa9(_ref) {
  let {
    setBackdropStyle_: setBackdropStyle_,
    setBodyAlignment_: setBodyAlignment_,
    openDuration_: openDuration_
  } = _ref;
  setBackdropStyle_(prev => ({
    ...prev,
    opacity: 0,
    transition: "opacity ".concat(openDuration_, "ms ease-in")
  }));
  requestAnimationFrame(() => setBackdropStyle_(prev => ({
    ...prev,
    opacity: 1
  })));
  setBodyAlignment_(prev => ({
    ...prev,
    opacity: 0,
    transition: "opacity ".concat(openDuration_, "ms ease-in ").concat(openDuration_ / 5, "ms"),
    // Add a slight delay so the brightness of the modal isn't so jarring before the background has gotten darkened
    "--js-animation-duration": "".concat(openDuration_, "ms")
  }));
  requestAnimationFrame(() => setBodyAlignment_(prev => ({
    ...prev,
    opacity: 1
  })));
}
function $d7833ca17fc05c5e$export$23d40cc5971c3acd(_ref2) {
  let {
    setBackdropStyle_: setBackdropStyle_,
    setBodyAlignment_: setBodyAlignment_,
    closeDuration_: closeDuration_
  } = _ref2;
  setBackdropStyle_(prev => ({
    ...prev,
    opacity: 0,
    transition: "opacity ".concat(closeDuration_, "ms ease-out")
  }));
  setBodyAlignment_(prev => ({
    ...prev,
    opacity: 0,
    transition: "opacity ".concat(closeDuration_, "ms ease-out")
  }));
}
function $d7833ca17fc05c5e$export$dab9321f3c157061(alignmentSignals, modalVersion) {
  const [, setBodyAlignment_] = alignmentSignals.body_;
  const [, setBackdropStyle_] = alignmentSignals.backdrop_ || $8tj43$createSignal({});
  // For default centered modal, also run our fading animations if search modal v2
  modalVersion === 2 && $d7833ca17fc05c5e$export$e06dee46ebe7faa9({
    openDuration_: 125,
    setBodyAlignment_: setBodyAlignment_,
    setBackdropStyle_: setBackdropStyle_
  });
  const closingAnimation = modalVersion === 2 ? async () => {
    $d7833ca17fc05c5e$export$23d40cc5971c3acd({
      closeDuration_: 100,
      setBodyAlignment_: setBodyAlignment_,
      setBackdropStyle_: setBackdropStyle_
    });
    await new Promise(r => setTimeout(r, 100));
  } : undefined;
  return closingAnimation;
}
var $937791b86d3d1509$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class="depict plp search">`);
function $937791b86d3d1509$export$44f738469d5570cf(_ref) {
  let {
    actualField_: actualField_,
    makeFakeField_: makeFakeField_,
    wrap_: wrap_,
    bodyAlignmentSignal_: [, setBodyAlignment_],
    backdropStyleSignal_: [, setBackdropStyle_],
    setPollAlignment_: setPollAlignment_,
    buttonInField_: buttonInField_,
    modalSearchFieldOuterWidth_: modalSearchFieldOuterWidth_
  } = _ref;
  return $8tj43$createRoot(dispose => {
    const [innerWidthReactive, setInnerWidthReactive] = $8tj43$createSignal(innerWidth);
    const [innerHeightReactive, setInnerHeightReactive] = $8tj43$createSignal(innerHeight);
    const {
      left: left,
      top: top,
      width: width
    } = actualField_.getBoundingClientRect();
    const fakeField = makeFakeField_();
    const owner = $8tj43$getOwner();
    const inModalFieldWidth = $8tj43$createMemo(
    // Can't have `min(${modalSearchFieldOuterWidth_()}px, var(--field-max-width, 600px))` because the WAAPI doesn't support that, so we need ot calculate it in JS
    () => Math.min(modalSearchFieldOuterWidth_(), parseFloat(getComputedStyle(actualField_).getPropertyValue("--field-max-width") || "600")));
    const inModalFieldWidthPx = $8tj43$createMemo(() => inModalFieldWidth() + "px");
    let disableResizePollingTimeout;
    actualField_.replaceWith(fakeField);
    // Don't move the wrapped div since that would confuse run_in_root_or_auto_cleanup, but do actually move the field the user clicked around so that all selection stuff etc. is easier
    const addedToBody = wrap_ ? (() => {
      var _el$ = $8tj43$getNextElement($937791b86d3d1509$var$_tmpl$);
      $8tj43$insert(_el$, actualField_);
      return _el$;
    })() : actualField_;
    document.body.append(addedToBody);
    const zIndexOfFake = getComputedStyle(fakeField).zIndex;
    Object.assign(addedToBody.style, {
      position: "fixed",
      top: top + "px",
      left: left + "px",
      width: width + "px",
      ...(zIndexOfFake !== "auto" ? {
        zIndex: +zIndexOfFake + 1
      } : {})
    });
    const absoluteFieldTop = $8tj43$createMemo(() => {
      innerHeightReactive();
      innerWidthReactive();
      // This is very semi-scientific but I hope it works (seems to, albeit laggy see comment where this value gets used)
      return fakeField.getBoundingClientRect().top;
    });
    const pxOffCenter = Math.abs($8tj43$untrack(innerWidthReactive) / 2 - (left + width / 2));
    const openDuration_ = pxOffCenter > 100 ? 250 : 125; // faster animations if little left-right movement
    const closeDuration_ = pxOffCenter > 100 ? 150 : 100;
    setPollAlignment_(true);
    // Fade out submit button so there aren't two overlapping buttons for a split second
    if (pxOffCenter > 10) buttonInField_.animate([{
      opacity: 1
    }, {
      opacity: 0
    }], {
      duration: openDuration_ / 3,
      fill: "forwards"
    });
    $8tj43$createEffect(finished => {
      if (finished) return finished;
      if (!modalSearchFieldOuterWidth_()) return false;
      // Wait until the ResizeObserver has delivered a value in case that the modal is small or has much padding so we know that we can't animate our fake field to be wider than that
      addedToBody.animate([{
        left: left + "px",
        width: width + "px"
      }, {
        left: "".concat($8tj43$untrack(innerWidthReactive) / 2 - $8tj43$untrack(inModalFieldWidth) / 2, "px"),
        width: $8tj43$untrack(inModalFieldWidthPx)
      }], {
        duration: openDuration_,
        easing: "ease-in"
      }).finished.then(() => {
        setPollAlignment_(false);
        $8tj43$runWithOwner(owner, () => $8tj43$createEffect(() => {
          // When animation has finished, still dynamically set the size of the search field behind in case the user resizes the window
          Object.assign(addedToBody.style, {
            // This is left: 50%, transform: translateX(-50) with extra steps but when using it safari and firefox glitch out like crazy
            left: "".concat(innerWidthReactive() / 2 - inModalFieldWidth() / 2, "px"),
            width: inModalFieldWidthPx(),
            // Lord forgive me for this is laggy. Example: on preview browser when resizing the screen in both x and y direction at the sam time. But it's too hard to change the code now, so that it doesn't happen.
            // Basically we'd want one align_field running in only the y-axis on the field that's still in the DOM and another one in the x-axis on the fake field. Or something…
            top: absoluteFieldTop() + "px"
          });
          // We might only have changed the left position which align_field doesn't know about, make it poll the position for a while
          setPollAlignment_(true);
          if (disableResizePollingTimeout) clearTimeout(disableResizePollingTimeout);
          disableResizePollingTimeout = setTimeout($8tj43$catchify1(() => {
            setPollAlignment_(false);
            disableResizePollingTimeout = undefined;
          }), 1000);
        }));
      });
      return true;
    }, false);
    $8tj43$onCleanup(() => {
      // If we get cleaned up, reset the state and cancel the timeout to make sure the timeout doesn't mess with the next animation
      clearTimeout(disableResizePollingTimeout);
      setPollAlignment_(false);
    });
    $d7833ca17fc05c5e$export$e06dee46ebe7faa9({
      setBackdropStyle_: setBackdropStyle_,
      setBodyAlignment_: setBodyAlignment_,
      openDuration_: openDuration_
    });
    $8tj43$onCleanup(() => {
      addedToBody.remove();
      fakeField.replaceWith(actualField_);
      setPollAlignment_(true);
      // Trigger a new alignment to make sure we are using the dimensions from the field being back in the DOM now, fixes https://depictaiworkspace.slack.com/archives/C06LVKNPLP5/p1710862260203749
      $8tj43$queueMacroTask1(() => setPollAlignment_(false));
    });
    $96d57a48e7bce64f$export$181cceed5c91919e(() => {
      setInnerWidthReactive(innerWidth);
      setInnerHeightReactive(innerHeight);
    });
    return async () => {
      const {
        width: width,
        left: left
      } = fakeField.getBoundingClientRect();
      // Just copy-pasted below line without thinking, it might be wrong
      const pxOffCenter = Math.abs($8tj43$untrack(innerWidthReactive) / 2 - (left + width / 2));
      $d7833ca17fc05c5e$export$23d40cc5971c3acd({
        setBackdropStyle_: setBackdropStyle_,
        setBodyAlignment_: setBodyAlignment_,
        closeDuration_: closeDuration_
      });
      await Promise.all([addedToBody.animate([{
        width: $8tj43$untrack(inModalFieldWidthPx),
        left: "".concat($8tj43$untrack(innerWidthReactive) / 2 - $8tj43$untrack(inModalFieldWidth) / 2, "px")
      }, {
        width: width + "px",
        left: left + "px"
      }], {
        duration: closeDuration_,
        fill: "forwards",
        easing: "ease-out"
      }).finished, buttonInField_.animate([{
        opacity: 0
      }, {
        opacity: 1
      }], {
        duration: pxOffCenter > 10 ? closeDuration_ / 3 : 1,
        delay: closeDuration_ * (2 / 3),
        fill: "forwards"
      }).finished]);
      setPollAlignment_(false);
      dispose();
    };
  });
}
var $da279c5a540c6846$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class=filter-results-for-one-row><!$><!/><!$><!/>`),
  $da279c5a540c6846$var$_tmpl$2 = /*#__PURE__*/$8tj43$template(`<div><div class=listing-page><!$><!/><!$><!/><!$><!/><!$><!/><!$><!/><!$><!/><!$><!/></div><!$><!/><!$><!/>`);
function $da279c5a540c6846$export$a54ec244c8863715(_ref) {
  let {
    depict_api_: depict_api_,
    search_field_value_: search_field_value_,
    get_search_query_: get_search_query_,
    open_modal_: open_modal_,
    submit_query_: submit_query_,
    current_sorting_: current_sorting_,
    min_products_to_fetch_: min_products_to_fetch_,
    search_filters_open_: search_filters_open_,
    search_sorting_open_: search_sorting_open_,
    expanded_filters_: expanded_filters_,
    input_modal_open_: input_modal_open_,
    selected_filters_: selected_filters_,
    i18n_: i18n_,
    make_category_suggestion_card_: make_category_suggestion_card_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    clear_filters_on_next_submit_: clear_filters_on_next_submit_,
    local_filter_cache_: local_filter_cache_,
    include_input_field_: include_input_field_,
    tenant_: tenant_,
    market_: market_,
    showing_recommendation_rows_: showing_recommendation_rows_,
    layout_options_: layout_options_,
    scroll_restoration_data_: scroll_restoration_data_,
    product_card_template_: product_card_template_,
    modalAlignmentSignalsRef_: modalAlignmentSignalsRef_,
    router_: router_,
    content_results_rows_: content_results_rows_,
    content_layout_options_: content_layout_options_,
    content_search_enabled_: content_search_enabled_,
    content_blocks_by_row_: content_blocks_by_row_,
    modalVersionUsed_: modalVersionUsed_,
    BackIcon_: BackIcon_,
    filterModalParent_: filterModalParent_,
    class_: class_,
    showSliderArrow_: showSliderArrow_,
    hideCount0FilterOptions_: hideCount0FilterOptions_
  } = _ref;
  const [get_sorting] = current_sorting_;
  const all_products_loaded_ = $8tj43$createSignal(false);
  const [currentlyLoadedDisplays, setCurrentlyLoadedDisplays_] = $8tj43$createSignal(0);
  const [get_all_products_loaded, set_all_products_loaded] = all_products_loaded_;
  const number_of_rendered_selected_filters_items_ = $8tj43$createSignal(0);
  const first_result_in_viewport_ = $8tj43$createSignal();
  const last_result_in_viewport_ = $8tj43$createSignal();
  const [can_write_scroll_restoration_, set_can_write_scroll_restoration] = $8tj43$createSignal(false);
  const {
    backend_locale_: backend_locale_
  } = i18n_;
  const search_query_base_ = $ec225bf1f1627ea8$export$210f130a61ac1e8d(() => {
    const sort_obj = get_sorting() && {
      ...get_sorting()
    };
    sort_obj === null || sort_obj === void 0 || delete sort_obj.meta;
    const f = selected_filters_[0]();
    return {
      merchant: tenant_(),
      market: market_(),
      locale: backend_locale_(),
      query: get_search_query_(),
      ...(f.length ? {
        filters: f
      } : {}),
      ...(sort_obj ? {
        sort: sort_obj
      } : {})
    };
  });
  const [search_results_] = $8tj43$createResource(search_query_base_, $8tj43$catchify1(async base_query => {
    set_all_products_loaded(false);
    // only first page of results
    return await $5e6abec0dab4e610$export$cc42dd29bf655ab6({
      id_: $8tj43$untrack(get_search_query_),
      min_products_to_fetch_: min_products_to_fetch_,
      scroll_restoration_data_: scroll_restoration_data_,
      make_request_: (limit, cursor) => depict_api_.query({
        ...base_query,
        limit: limit,
        ...(cursor ? {
          cursor: cursor
        } : {})
      })
    });
  }));
  const [suggestions] = $8tj43$createResource(() => ({
    query: get_search_query_(),
    merchant: tenant_(),
    market: market_(),
    locale: backend_locale_()
  }), opts => depict_api_.suggest(opts));
  const available_sortings_ = $8tj43$createMemo(() => {
    var _search_results_, _search_results_$sort;
    return (_search_results_ = search_results_()) === null || _search_results_ === void 0 ? void 0 : (_search_results_$sort = _search_results_.sorts) === null || _search_results_$sort === void 0 ? void 0 : _search_results_$sort.map(sort => {
      var _sort$order;
      return {
        ...sort,
        order: (_sort$order = sort.order) !== null && _sort$order !== void 0 ? _sort$order : "desc"
      };
    });
  });
  const available_filters_ = $8tj43$createMemo(() => {
    var _search_results_2;
    return (_search_results_2 = search_results_()) === null || _search_results_2 === void 0 ? void 0 : _search_results_2.filters;
  });
  const modal_body_style = $8tj43$createSignal({});
  const modal_backdrop_style = $8tj43$createSignal({});
  const modal_field_style = $8tj43$createSignal({});
  const alignmentSignals_ = {
    body_: modal_body_style,
    field_: modal_field_style,
    backdrop_: modal_backdrop_style
  };
  const [, setModalBodyStyle] = modal_body_style;
  const [, setModalFieldStyle] = modal_field_style;
  const [, setModalBackdropStyle] = modal_backdrop_style;
  const [get_search_field_elements, set_search_field_elements] = $8tj43$createSignal();
  const SafeSearchField = $8tj43$catchify1((0, $584c06c09cf4609d$export$b94867ecbd698f21));
  const [sort_or_filter_open_, set_sort_or_filter_open_] = $8tj43$createSignal(false);
  const [desktop_filter_elements_, set_desktop_filter_elements] = $8tj43$createSignal();
  const countOfProductsForUI = $0728458b46ee9d32$export$a86bc18439445599(search_results_, all_products_loaded_, currentlyLoadedDisplays);
  const formatted_number_of_results_ = $43fbdca0f726a34b$export$92f2da32c6e7e7ee({
    number_: countOfProductsForUI,
    i18n_: i18n_
  });
  const [sort_and_filter_element_, set_sort_and_filter_element_] = $8tj43$createSignal();
  const no_results_text_ = $8tj43$createMemo(() => {
    var _search_results_3, _search_results_3$con;
    return ((_search_results_3 = search_results_()) !== null && _search_results_3 !== void 0 && (_search_results_3$con = _search_results_3.content_search_links) !== null && _search_results_3$con !== void 0 && _search_results_3$con.length ? i18n_.no_products_ : i18n_.no_results_text_)();
  });
  const results_for = $8tj43$createComponent((0, $69602b3d8fd54c38$export$9dd50d35b9d94fdf), $8tj43$mergeProps1({
    get type() {
      return (0, $69602b3d8fd54c38$export$2452208c79fe93ea).products;
    },
    number_of_results_: countOfProductsForUI
  }, {
    get_search_query_: get_search_query_,
    i18n_: i18n_,
    formatted_number_of_results_: formatted_number_of_results_
  }));
  const filters_opener = $7396052a1484264f$export$d7841e452f2e59a8({
    set_sort_or_filter_open_: set_sort_or_filter_open_,
    set_extra_els_in_results_container_: set_desktop_filter_elements,
    i18n_: i18n_,
    search_sorting_open_: search_sorting_open_,
    available_filters_: available_filters_,
    available_sortings_: available_sortings_,
    search_filters_open_: search_filters_open_,
    set_sort_and_filter_element_: set_sort_and_filter_element_,
    current_sorting_: current_sorting_,
    input_modal_open_: input_modal_open_,
    expanded_filters_: expanded_filters_,
    selected_filters_: selected_filters_,
    formatted_number_of_results_: formatted_number_of_results_,
    local_filter_cache_: local_filter_cache_,
    expanded_hierarchical_filters_: expanded_hierarchical_filters_,
    number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
    filterModalParent_: filterModalParent_,
    hideCount0FilterOptions_: hideCount0FilterOptions_
  });
  const results_filters = $8tj43$createSignal();
  const shouldActuallyShowInputField = $8tj43$createMemo(() => {
    var _include_input_field_;
    return (_include_input_field_ = include_input_field_ === null || include_input_field_ === void 0 ? void 0 : include_input_field_()) !== null && _include_input_field_ !== void 0 ? _include_input_field_ : true;
  }); // default to showing input field
  const owner = $8tj43$getOwner();
  $8tj43$onCleanup($8tj43$javascript_media_query("(max-width:600px)", async _ref2 => {
    let {
      matches: matches
    } = _ref2;
    results_filters[1]();
    await new Promise(r => queueMicrotask(r));
    $8tj43$runWithOwner(owner, () => results_filters[1](matches ? [results_for, filters_opener] : (() => {
      var _el$ = $8tj43$getNextElement($da279c5a540c6846$var$_tmpl$),
        _el$2 = _el$.firstChild,
        [_el$3, _co$] = $8tj43$getNextMarker(_el$2.nextSibling),
        _el$4 = _el$3.nextSibling,
        [_el$5, _co$2] = $8tj43$getNextMarker(_el$4.nextSibling);
      $8tj43$insert(_el$, results_for, _el$3, _co$);
      $8tj43$insert(_el$, filters_opener, _el$5, _co$2);
      return _el$;
    })()));
  }).remove);
  $3a2bed57c9a57e21$export$d31a1a1a83ad9413(search_results_, selected_filters_);
  $8tj43$catchify1((0, $5e6abec0dab4e610$export$6e49da55e449af7c))({
    scroll_restoration_data_: scroll_restoration_data_,
    last_result_in_viewport_: last_result_in_viewport_,
    id_: get_search_query_,
    can_write_scroll_restoration_: can_write_scroll_restoration_
  });
  $8tj43$createComputed(() => {
    if (search_results_.loading) set_can_write_scroll_restoration(false);else if (search_results_()) set_can_write_scroll_restoration(true);
  });
  $9b5022ae72f56399$export$e702733a056c40d6({
    selected_filters_: selected_filters_,
    available_filters_: available_filters_
  });
  // @ts-ignore
  if (process.env.GA !== "false") $8tj43$createEffect(() => {
    get_search_query_();
    $9974e016866745eb$export$c7e181728ad525f(location);
  });
  $8tj43$createEffect(() => {
    // reactive include_input_field
    // this uses ~7 variables from outer scope which is why I didn't refactor it into a function
    // After above time has been wasted:
    // DO NOT ATTEMPT to consolidate this code and the code in sdks/search.ts (SDKSearchField) that both open modals aligned to a search field
    // Hours were wasted in https://github.com/depict-org/depict/pull/137/commits/ff6563a8deb7ba09e181a7a34831fb66997fa8aa and following commits
    // Reason it doesn't work is due to the complex alignment switching when the search field gets removed, and even after solving that: that opening a modal with unspecified alignment aligns it to the search field on the search page
    add_input_field: {
      const input_field_accessor_value = shouldActuallyShowInputField();
      if (!input_field_accessor_value) break add_input_field;
      let input_element;
      let div_with_field_class;
      let buttonInField;
      const search_field = SafeSearchField({
        i18n_: i18n_,
        search_field_value_: search_field_value_,
        submit_query_: submit_query_,
        clear_filters_: clear_filters_on_next_submit_,
        input_field_ref_: el => input_element = el,
        field_element_ref_: el => div_with_field_class = el,
        disabled_: true,
        BackIcon_: BackIcon_,
        buttonInFieldRef_: el => buttonInField = el
      });
      if (!search_field) break add_input_field;
      setModalBodyStyle({});
      modalAlignmentSignalsRef_ === null || modalAlignmentSignalsRef_ === void 0 || modalAlignmentSignalsRef_(alignmentSignals_);
      const [pollAlignment, setPollAlignment_] = $8tj43$createSignal(false);
      const align_position = $8tj43$catchify1((0, $1308a7816c3d4f2d$export$b3ad617e9036868))(alignmentSignals_, search_field, (0, $1308a7816c3d4f2d$export$3f238c96c45e6cc6) | (0, $1308a7816c3d4f2d$export$7895aadd1956b1c7) | (modalVersionUsed_ === 1 ? (0, $1308a7816c3d4f2d$export$902f8b4a7dae5d78) : (0, $1308a7816c3d4f2d$export$6060bc6bee850eb6) | (0, $1308a7816c3d4f2d$export$5097308c5200105a)), true, pollAlignment);
      div_with_field_class.addEventListener("click", $8tj43$catchify1(e => {
        var _target$matches, _target$closest, _on_open_, _ref4;
        const target = e.target;
        const sel = ".submit";
        if (target !== null && target !== void 0 && (_target$matches = target.matches) !== null && _target$matches !== void 0 && _target$matches.call(target, sel) || target !== null && target !== void 0 && (_target$closest = target.closest) !== null && _target$closest !== void 0 && _target$closest.call(target, sel))
          // the search button is just decor, don't do anything when clicked
          return;
        // When selecting text in the SearchField that's in the page we want the same selection to persist. It doesn't by itself, since the SearchModal has an entirely different SearchField. Therefore, we manually copy the selection over.
        const selected_text_range_ = [input_element.selectionStart, input_element.selectionEnd];
        let setModalSearchFieldOuterWidth_;
        let revert;
        if (modalVersionUsed_ === 2) {
          let modalSearchFieldOuterWidth_;
          [modalSearchFieldOuterWidth_, setModalSearchFieldOuterWidth_] = $8tj43$createSignal(0);
          revert = $937791b86d3d1509$export$44f738469d5570cf({
            actualField_: search_field,
            makeFakeField_: () => $8tj43$createComponent((0, $584c06c09cf4609d$export$b94867ecbd698f21), {
              BackIcon_: BackIcon_,
              search_field_value_: search_field_value_,
              submit_query_: submit_query_,
              clear_filters_: clear_filters_on_next_submit_,
              i18n_: i18n_,
              disabled_: true
            }),
            wrap_: true,
            bodyAlignmentSignal_: modal_body_style,
            backdropStyleSignal_: modal_backdrop_style,
            setPollAlignment_: setPollAlignment_,
            buttonInField_: buttonInField,
            modalSearchFieldOuterWidth_: modalSearchFieldOuterWidth_
          });
        }
        align_position === null || align_position === void 0 || align_position();
        open_modal_({
          alignmentSignals_: alignmentSignals_,
          selected_text_range_: selected_text_range_,
          closing_animation_: revert,
          setSearchFieldOuterWidth_: setModalSearchFieldOuterWidth_
        }, () => {
          var _on_close_, _ref3;
          // When modal is closed, reset style signals for next opening so all animation related stuff gets reset
          setModalBodyStyle({});
          setModalFieldStyle({});
          setModalBackdropStyle({});
          // And run the alignment code again so the modal is readily aligned when opened via a search button
          align_position === null || align_position === void 0 || align_position();
          input_field_accessor_value === null || input_field_accessor_value === void 0 || (_on_close_ = (_ref3 = input_field_accessor_value).on_close_) === null || _on_close_ === void 0 || _on_close_.call(_ref3);
        });
        input_field_accessor_value === null || input_field_accessor_value === void 0 || (_on_open_ = (_ref4 = input_field_accessor_value).on_open_) === null || _on_open_ === void 0 || _on_open_.call(_ref4);
      }));
      set_search_field_elements(search_field);
      return;
    }
    // We bailed out of adding the input field
    set_search_field_elements();
    // There *might* still be a modal open, either from depict_search.modal_open = true or clicking the SearchField which existed here. Said modal now doesn't have anything to align to anymore - it will still try to align to the style_props_ which it got through the modal_body_style_ref_ which are now no longer updated.
    // In that case, we write what's needed to center the modal to the modal_body_style for the lifetime of this effect function call to make sure the modal is centered and the UI doesn't look "botched".
    $8e8ce3f7a5eb11a6$export$41b4894022a3580f({
      alignmentSignals_: alignmentSignals_
    });
  });
  return [(0, $8tj43$isServer) ? "<!-- Search page based on Depict SDK -->" : document.createComment("Search page based on Depict SDK"), (() => {
    var _el$6 = $8tj43$getNextElement($da279c5a540c6846$var$_tmpl$2),
      _el$7 = _el$6.firstChild,
      _el$8 = _el$7.firstChild,
      [_el$9, _co$3] = $8tj43$getNextMarker(_el$8.nextSibling),
      _el$10 = _el$9.nextSibling,
      [_el$11, _co$4] = $8tj43$getNextMarker(_el$10.nextSibling),
      _el$12 = _el$11.nextSibling,
      [_el$13, _co$5] = $8tj43$getNextMarker(_el$12.nextSibling),
      _el$14 = _el$13.nextSibling,
      [_el$15, _co$6] = $8tj43$getNextMarker(_el$14.nextSibling),
      _el$16 = _el$15.nextSibling,
      [_el$17, _co$7] = $8tj43$getNextMarker(_el$16.nextSibling),
      _el$18 = _el$17.nextSibling,
      [_el$19, _co$8] = $8tj43$getNextMarker(_el$18.nextSibling),
      _el$20 = _el$19.nextSibling,
      [_el$21, _co$9] = $8tj43$getNextMarker(_el$20.nextSibling),
      _el$22 = _el$7.nextSibling,
      [_el$23, _co$10] = $8tj43$getNextMarker(_el$22.nextSibling),
      _el$24 = _el$23.nextSibling,
      [_el$25, _co$11] = $8tj43$getNextMarker(_el$24.nextSibling);
    $8tj43$insert(_el$7, get_search_field_elements, _el$9, _co$3);
    $8tj43$insert(_el$7, make_category_suggestion_card_ ? $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Category suggestions failed",
      get children() {
        return $8tj43$createComponent((0, $754f319a849bfdbc$export$c05a196222ba1302), {
          suggestions_: suggestions,
          children: make_category_suggestion_card_
        });
      }
    }) : null, _el$11, _co$4);
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "ContentResults failed",
      get children() {
        return $8tj43$createComponent((0, $8tj43$Show), {
          get when() {
            return content_search_enabled_();
          },
          get children() {
            return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
              get children() {
                return $8tj43$createComponent((0, $d53ebed6f63304e4$export$6d0c9c22f6652669), {
                  content_results_rows_: content_results_rows_,
                  search_results_: search_results_,
                  i18n_: i18n_,
                  get_search_query_: get_search_query_,
                  layout_options_: content_layout_options_,
                  router_: router_,
                  query_base_: search_query_base_
                });
              }
            });
          }
        });
      }
    }), _el$13, _co$5);
    $8tj43$insert(_el$7, () => results_filters[0](), _el$15, _co$6);
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $8tj43$Show), {
      get when() {
        var _selected_filters_$;
        return (_selected_filters_$ = selected_filters_[0]()) === null || _selected_filters_$ === void 0 ? void 0 : _selected_filters_$.length;
      },
      keyed: false,
      get children() {
        return $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
          message_: "Selected filters failed",
          severity_: "error",
          get children() {
            return $4711a82d08d2021b$export$fecbb157621501bd({
              i18n_: i18n_,
              selected_filters_: selected_filters_,
              local_filter_cache_: local_filter_cache_,
              get_search_filters_open_: search_filters_open_[0],
              get_search_sorting_open_: search_sorting_open_[0],
              number_of_rendered_selected_filters_items_: number_of_rendered_selected_filters_items_,
              expanded_hierarchical_filters_: expanded_hierarchical_filters_
            });
          }
        });
      }
    }), _el$17, _co$7);
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Search results failed",
      get children() {
        return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
          get children() {
            return $7faea0096f14b59b$export$3925f87b1545cfc6({
              all_products_loaded_: all_products_loaded_,
              min_products_to_fetch_: min_products_to_fetch_,
              query_base_: search_query_base_,
              plp_results_: search_results_,
              depict_api_: depict_api_,
              first_result_in_viewport_: first_result_in_viewport_,
              last_result_in_viewport_: last_result_in_viewport_,
              scroll_restoration_data_: scroll_restoration_data_,
              desktop_filter_elements_: desktop_filter_elements_,
              product_card_template_: product_card_template_,
              layout_options_: layout_options_,
              sort_or_filter_open_: sort_or_filter_open_,
              id_currently_querying_for_: get_search_query_,
              content_blocks_by_row_: content_blocks_by_row_,
              setCurrentlyLoadedDisplays_: setCurrentlyLoadedDisplays_,
              showSliderArrow_: showSliderArrow_,
              no_results_options_: {
                selected_filters_: selected_filters_,
                expanded_hierarchical_filters_: expanded_hierarchical_filters_,
                local_filter_cache_: local_filter_cache_,
                i18n_: {
                  ...i18n_,
                  no_results_text_: no_results_text_
                }
              }
            });
          }
        });
      }
    }), _el$19, _co$8);
    $8tj43$insert(_el$7, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      severity_: "error",
      message_: "Search recommendations failed",
      get children() {
        return $8tj43$createComponent((0, $5441862cd2f5e111$export$e68cff63f76bd15b), {
          get children() {
            return $8tj43$createComponent((0, $8ef6232475d44150$export$7de92c4c2205ebf3), {
              depict_api_: depict_api_,
              i18n_: i18n_,
              search_query_base_: search_query_base_,
              layout_options_: layout_options_,
              showing_recommendation_rows_: showing_recommendation_rows_,
              product_card_template_: product_card_template_,
              all_products_loaded_: get_all_products_loaded
            });
          }
        });
      }
    }), _el$21, _co$9);
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      message_: "Scroll status failed",
      severity_: "error",
      get children() {
        return $b69740fc6de9f17e$export$83fd5de5504a7a67({
          first_result_in_viewport_: first_result_in_viewport_,
          last_result_in_viewport_: last_result_in_viewport_,
          formatted_number_of_results_: formatted_number_of_results_,
          i18n_: i18n_,
          number_of_results_: countOfProductsForUI
        });
      }
    }), _el$23, _co$10);
    $8tj43$insert(_el$6, $8tj43$createComponent((0, $74777e8fe65b3dcb$export$b69d0d92862de18b), {
      message_: "Floating buttons failed",
      severity_: "error",
      get children() {
        return $6a16b21155984cef$export$b23abd26de154ede({
          search_filters_open_: search_filters_open_,
          search_sorting_open_: search_sorting_open_,
          current_sorting_: current_sorting_,
          sort_and_filter_element_: sort_and_filter_element_,
          i18n_: i18n_
        });
      }
    }), _el$25, _co$11);
    $8tj43$effect(_p$ => {
      var _v$ = (0, $c3820807ac1e6fd7$export$44dad306455dddf).SEARCH_PAGE,
        _v$2 = "depict plp search".concat(class_ !== null && class_ !== void 0 && class_() ? " ".concat(class_()) : "");
      _v$ !== _p$.e && $8tj43$setAttribute(_el$6, "id", _p$.e = _v$);
      _v$2 !== _p$.t && $8tj43$className(_el$6, _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$6;
  })()];
}

/**
 * Content results ContentCard look stupid on mobile if there are two columns of them, so we limit the number of columns to 1 if the screen is too small
 */
function $3f7203368ad0d3ca$export$ff7109b9b2b206ba(sdk_cols_at_size) {
  let min_width_for_more_than_one_column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  if (!sdk_cols_at_size.length) return sdk_cols_at_size;
  const sorted_sizes = sdk_cols_at_size.map(_ref => {
    let [cols, max_width] = _ref;
    return [cols, max_width !== null && max_width !== void 0 ? max_width : Infinity];
  }).sort((_ref2, _ref3) => {
    let [, a] = _ref2;
    let [, b] = _ref3;
    return a - b;
  });
  const [[, smallest_max_width]] = sorted_sizes;
  if (smallest_max_width > min_width_for_more_than_one_column)
    // If everything above min_width_for_more_than_one_column, we can just add a 1 column at the beginning
    return [[1, min_width_for_more_than_one_column], ...sdk_cols_at_size];
  const to_delete = [];
  for (let i = 0; i < sorted_sizes.length; i++) {
    const [, max_width] = sorted_sizes[i];
    if (max_width > min_width_for_more_than_one_column) continue;
    to_delete.push(i);
  }
  while (to_delete.length) sorted_sizes.splice(to_delete.pop(), 1);
  sorted_sizes.unshift([1, min_width_for_more_than_one_column]);
  return sorted_sizes.map(_ref4 => {
    let [cols, max_width] = _ref4;
    return max_width == Infinity ? [cols] : [cols, max_width];
  });
}
function $eb064bc3350276c1$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $eb064bc3350276c1$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $eb064bc3350276c1$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $eb064bc3350276c1$var$_classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
  $eb064bc3350276c1$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
  $eb064bc3350276c1$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "get");
  return $eb064bc3350276c1$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $eb064bc3350276c1$var$_classCheckPrivateStaticFieldDescriptor(descriptor, action) {
  if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}
function $eb064bc3350276c1$var$_classCheckPrivateStaticAccess(receiver, classConstructor) {
  if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}
function $eb064bc3350276c1$var$_classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) return descriptor.get.call(receiver);
  return descriptor.value;
}
const $eb064bc3350276c1$export$dde08b2dca8cc1ce = /*@__PURE__*/new WeakMap();
const $eb064bc3350276c1$var$content_search_default = true;
const $eb064bc3350276c1$var$min_products_to_fetch_ = 20;
const $eb064bc3350276c1$export$bde3eb976dfded9 = depict_search => {
  var _privately_shared_pro;
  return (_privately_shared_pro = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(depict_search)) === null || _privately_shared_pro === void 0 ? void 0 : _privately_shared_pro.search_query_updating_blocked_;
};
var $eb064bc3350276c1$var$_locale_signal = /*#__PURE__*/new WeakMap();
var $eb064bc3350276c1$var$_merchant_signal = /*#__PURE__*/new WeakMap();
var $eb064bc3350276c1$var$_market_signal = /*#__PURE__*/new WeakMap();
var $eb064bc3350276c1$var$_modal_open_signal = /*#__PURE__*/new WeakMap();
var $eb064bc3350276c1$var$_content_search_signal = /*#__PURE__*/new WeakMap();
var $eb064bc3350276c1$var$_router = /*#__PURE__*/new WeakMap();
class $eb064bc3350276c1$export$ac6237957a15b3f0 {
  constructor(_ref) {
    var _this = this;
    let {
      unique_instance_key_for_state = "",
      search_query_url_param_name: search_query_url_param_name_ = "query" + unique_instance_key_for_state,
      url_transformer: url_transformer,
      on_navigation: on_navigation,
      enable_category_suggestions = true,
      display_transformers: display_transformers,
      api: api,
      searchModalComponent: searchModalComponent,
      // Stuff needed for non-standard customer deployments that we shouldn't actually expose
      disable_scrolling_during_modal = true,
      bottom_distance_under_modal: bottom_distance_under_modal,
      override_modal_element: override_modal_element,
      ...props_on_class
    } = _ref;
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_locale_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_merchant_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_market_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_modal_open_signal, {
      writable: true,
      value: $8tj43$createSignal(false)
    });
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_content_search_signal, {
      writable: true,
      value: $8tj43$createSignal()
    });
    $eb064bc3350276c1$var$_classPrivateFieldInitSpec(this, $eb064bc3350276c1$var$_router, {
      writable: true,
      value: new (0, $ac571292d606f30b$export$7e1297a3a19f10d8)("hard_navigation")
    });
    const owner = $8tj43$getOwner() || $8tj43$createRoot(() => $8tj43$getOwner()); // we might have an owner, if so, pass it on. Otherwise, create one so solid doesn't print warnings to the console
    $8tj43$runWithOwner(owner, () => {
      if ($eb064bc3350276c1$var$_classStaticPrivateFieldSpecGet($eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$var$_keys_constructed_with).has(unique_instance_key_for_state) && !(0, $8tj43$isServer))
        // on the server we can't write stuff to history.state anyway so can have multiple
        throw new Error("You can only have one instance of DepictSearch with the same uniqueInstanceKeyForState");
      const modalVersion = searchModalComponent[(0, $b026fa9c9c904a98$export$1ea76ea778b880dd)];
      const BackIcon_ = searchModalComponent[(0, $b026fa9c9c904a98$export$89890212b43f1b60)];
      if (!modalVersion || !BackIcon_) throw new Error("Unrecognized search modal component, make sure symbols are set");
      Object.assign(this, props_on_class);
      if (on_navigation) $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router).on_navigation_ = on_navigation;
      const sorting_query_param_ = "sorting" + unique_instance_key_for_state;
      const filter_query_param_prefix_ = "f" + unique_instance_key_for_state + "_";
      const {
        current_sorting_: current_sorting_,
        selected_filters_: selected_filters_,
        search_query_accessor_: raw_search_query_accessor
      } = $9d3d794b62318ecc$export$477caf01aecaeb2a({
        search_query_url_param_name_: search_query_url_param_name_,
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router),
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_
      });
      const [reset_history_state_, state_] = $bc811d9630f9579b$export$9862539c89138352({
        get_default_values_: () => {
          var _ref2;
          return {
            field_value: (_ref2 = (globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) && new URLSearchParams(location.search).get(search_query_url_param_name_)) !== null && _ref2 !== void 0 ? _ref2 : "",
            filters_open: false,
            sorting_open: false,
            expanded_filters: [],
            // Please make sure that the signal created by below line always updates AFTER selected_filters_ updates on a "popstate" event. If the filter cache is popped before the selected filters are the code in create_modified_filters() is going to re-calculate search_local_filter_cache without knowing the real value of search_selected_filters, and we'll end up with too few filters in search_local_filter_cache in some cases
            local_filter_cache: [],
            expanded_hierarchical_filters: [],
            showing_recommendation_rows: (0, $8ef6232475d44150$export$1c8c715550dc689d),
            content_results_rows: (0, $d53ebed6f63304e4$export$70ceae36059a1036),
            scroll_restoration_data: []
          };
        },
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router),
        prefix_: "search" + unique_instance_key_for_state + "_"
      });
      const search_query_updating_blocked_ = $8tj43$createSignal(false);
      const [get_search_query_updating_blocked] = search_query_updating_blocked_;
      const get_search_query_ = $8tj43$createMemo(previous_value => {
        if (get_search_query_updating_blocked()) return previous_value;else return raw_search_query_accessor();
      });
      // @ts-ignore
      const depict_api_ = api !== null && api !== void 0 ? api : new (0, $284849364a6ef73a$export$e015ed2f2950f2e3)({
        display_transformers: display_transformers
      });
      const previous_searches = $07d90b8270ece8de$export$84bba84a7b837187(get_search_query_);
      const [, set_search_showing_recommendation_rows] = state_.showing_recommendation_rows;
      const [, set_search_content_results_rows] = state_.content_results_rows;
      const after_submit_ = () => {
        set_search_showing_recommendation_rows((0, $8ef6232475d44150$export$1c8c715550dc689d));
        set_search_content_results_rows((0, $d53ebed6f63304e4$export$70ceae36059a1036));
      }; // do this every time after we have submitted a new query - otherwise there might already be a saved number of rows in the state
      const on_submit_with_unchanged_value_ = () => this.modal_open = false;
      const [get_search_field_value_, set_search_field_value_] = state_.field_value;
      const configured_submit_query_ = new_query => $86b0ff0c85e5fc6c$export$e16630ecb9644a1c({
        on_submit_with_unchanged_value_: on_submit_with_unchanged_value_,
        set_search_field_value_: set_search_field_value_,
        get_search_query_: get_search_query_,
        search_param_name_: search_query_url_param_name_,
        after_submit_: after_submit_,
        get_new_query: () => new_query || $8tj43$untrack(get_search_field_value_),
        url_transformer_: url_transformer,
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router)
      });
      const i18n_ = $e18ab2868df26f40$export$f091cbac892643a4($8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_locale_signal)[0]);
      const clear_filters_on_next_submit_ = $d8a66ba54a42eb3e$export$e026af0c7b64ea5f({
        selected_filters_: selected_filters_,
        get_search_query_: get_search_query_,
        current_sorting_: current_sorting_,
        expanded_hierarchical_filters_: state_.expanded_hierarchical_filters,
        i18n_: i18n_,
        local_filter_cache_: state_.local_filter_cache,
        expanded_filters_: state_.expanded_filters,
        filters_open_: state_.filters_open
      });
      $eb064bc3350276c1$export$dde08b2dca8cc1ce.set(this, {
        search_query_url_param_name_: search_query_url_param_name_,
        reset_history_state_: reset_history_state_,
        state_: state_,
        router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router),
        url_transformer_: url_transformer,
        depict_api_: depict_api_,
        enable_category_suggestions_: enable_category_suggestions,
        clear_filters_on_next_submit_: clear_filters_on_next_submit_,
        configured_submit_query_: configured_submit_query_,
        get_search_query_: get_search_query_,
        i18n_: i18n_,
        search_query_updating_blocked_: search_query_updating_blocked_,
        current_sorting_: current_sorting_,
        selected_filters_: selected_filters_,
        modalVersionUsed_: modalVersion,
        BackIcon_: BackIcon_
      });
      $68e6625c8d51f847$export$5162a71f252e6122();
      $8tj43$catchify1(async () => {
        const {
          open_modal_: open_modal_,
          close_modal_: close_modal_
        } = await $d5f1e6a0f9117286$export$79b1565500412d9b(function () {
          $8tj43$onCleanup(() => _this.modal_open = false);
          return searchModalComponent(...arguments);
        }, {
          search_field_value_: state_.field_value,
          get_search_query_: get_search_query_,
          search_query_url_param_name_: search_query_url_param_name_,
          previous_searches_: previous_searches,
          depict_api_: depict_api_,
          merchant_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_merchant_signal)[0],
          clear_filters_: clear_filters_on_next_submit_,
          market_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_market_signal)[0],
          submit_query_: configured_submit_query_,
          url_transformer_: url_transformer,
          router_: $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router),
          sorting_query_param_: sorting_query_param_,
          filter_query_param_prefix_: filter_query_param_prefix_,
          content_search_enabled_: () => {
            var _classPrivateFieldGet2;
            return (_classPrivateFieldGet2 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_content_search_signal)[0]()) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : $eb064bc3350276c1$var$content_search_default;
          },
          instant_results_options_: {
            min_products_to_fetch_: $eb064bc3350276c1$var$min_products_to_fetch_,
            has_sort_or_filters_: $8tj43$createMemo(() => {
              var _Object$keys;
              return !!((_Object$keys = Object.keys(selected_filters_[0]())) !== null && _Object$keys !== void 0 && _Object$keys.length || current_sorting_[0]());
            })
          },
          i18n_: i18n_,
          enable_category_suggestions_: enable_category_suggestions,
          disable_scrolling_: disable_scrolling_during_modal,
          bottom_distance_under_modal_: bottom_distance_under_modal
        }, override_modal_element);
        // This will add some default behaviour to open_modal_ if no style_props_ are supplied
        // The default behaviour is to align the modal with the input field if possible
        const modal_opening_effect = () => {
          var _open_signal_value$, _;
          const open_signal_value = this.modal_open;
          const signal_value_is_options = Array.isArray(open_signal_value);
          // Close modal if signal is false
          if (!open_signal_value) {
            close_modal_();
            return;
          }
          const {
            search_page_aligned_modal_alignment_signals_: search_page_aligned_modal_alignment_signals_
          } = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(this);
          if (signal_value_is_options && (_open_signal_value$ = open_signal_value[0]) !== null && _open_signal_value$ !== void 0 && _open_signal_value$.alignmentSignals_) {
            // They know what they're doing, just call the modal with the provided options
            open_modal_(...open_signal_value);
            return;
          }
          if (!((_ = open_signal_value[0]) !== null && _ !== void 0 && _.alignmentSignals_) && search_page_aligned_modal_alignment_signals_) {
            // Open modal aligned with search page if no alignment specified and possible to align with search page
            const [options_arg, ...rest] = open_signal_value === true ? [{}] : open_signal_value;
            const closingAnimation = $d7833ca17fc05c5e$export$dab9321f3c157061(search_page_aligned_modal_alignment_signals_, modalVersion);
            open_modal_({
              closing_animation_: closingAnimation,
              ...options_arg,
              alignmentSignals_: search_page_aligned_modal_alignment_signals_
            }, ...rest);
            return;
          }
          // Open centered modal
          const centeredModalAlignmentSignals = $8e8ce3f7a5eb11a6$export$41b4894022a3580f();
          const closingAnimation = $d7833ca17fc05c5e$export$dab9321f3c157061(centeredModalAlignmentSignals, modalVersion);
          if (signal_value_is_options) {
            const [options_arg, ...rest] = open_signal_value;
            open_modal_({
              closing_animation_: closingAnimation,
              ...options_arg,
              alignmentSignals_: search_page_aligned_modal_alignment_signals_ || centeredModalAlignmentSignals
            }, ...rest);
            return;
          }
          open_modal_({
            alignmentSignals_: centeredModalAlignmentSignals,
            closing_animation_: closingAnimation
          });
        };
        $8tj43$runWithOwner(owner, () => $8tj43$createEffect(modal_opening_effect));
      })();
      $eb064bc3350276c1$var$_classStaticPrivateFieldSpecGet($eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$var$_keys_constructed_with).add(unique_instance_key_for_state);
      $8tj43$onCleanup(() => $eb064bc3350276c1$var$_classStaticPrivateFieldSpecGet($eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$export$ac6237957a15b3f0, $eb064bc3350276c1$var$_keys_constructed_with).delete(unique_instance_key_for_state));
    });
  }
  get enable_content_search() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_content_search_signal)[0]();
  }
  set enable_content_search(new_state) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_content_search_signal)[1](new_state);
  }
  get on_navigation() {
    // The only non-reactive public property on the class (I don't see it making sense to have it reactive)
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router).on_navigation_;
  }
  set on_navigation(new_function) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_router).on_navigation_ = new_function;
  }
  get localization() {
    // allow reactive access
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_locale_signal)[0]();
  }
  set localization(locale_obj) {
    if (typeof locale_obj === "string")
      // Prevent people not using typescript from accidentally passing a string instead of an object, see https://depictaiworkspace.slack.com/archives/C04RF3KTK0A/p1707211551951239
      throw new Error("locale must be an object, see the TypeScript definitions");
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_locale_signal)[1](locale_obj);
  }
  get modal_open() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_modal_open_signal)[0]();
  }
  set modal_open(new_state) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_modal_open_signal)[1](new_state);
  }
  get merchant() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_merchant_signal)[0]();
  }
  set merchant(tenant) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_merchant_signal)[1](tenant);
  }
  get market() {
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_market_signal)[0]();
  }
  set market(market) {
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $eb064bc3350276c1$var$_market_signal)[1](market);
  }
  async fetchSearchResults(query, filters) {
    let maxResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 48;
    const {
      depict_api_: depict_api_
    } = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(this);
    const result = await depict_api_.query({
      merchant: this.merchant,
      market: this.market,
      query: query,
      filters: filters,
      limit: maxResults,
      locale: this.localization.backend_locale_
    });
    if (result.failed) throw new Error("Failed to fetch search results");
    return result.displays;
  }
}
/**
 * Gets private properties that are shared between the different exported search SDK wrapper functions. SDK users are not allowed to change/access these, they're an internal implementation detail.
 * Only access this in exported SDK functions.
 * @param depict_search The DepictSearch instance to get the shared properties for
 */
var $eb064bc3350276c1$var$_keys_constructed_with = {
  writable: true,
  value: /*@__PURE__*/new Set()
};
function $eb064bc3350276c1$export$12fa711345994013(depict_search) {
  const shared_properties = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(depict_search);
  if (!shared_properties) throw new Error("Can't connect to provided DepictSearch instance");
  return shared_properties;
}
function $eb064bc3350276c1$export$f2dc7e4e4aa11abb(props) {
  const {
    depict_search: depict_search,
    product_card_template: product_card_template
  } = props;
  const shared_properties = $eb064bc3350276c1$export$12fa711345994013(depict_search);
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    const {
      state_: state_
    } = shared_properties;
    const grid_spacing_override = $8tj43$createMemo(() => {
      const {
        grid_spacing: grid_spacing
      } = props; // can be reactive
      return typeof grid_spacing === "string" ? {
        grid_spacing: grid_spacing
      } : {
        override_vertical_spacing: grid_spacing.vertical,
        grid_spacing: grid_spacing.horizontal
      };
    });
    $8tj43$createEffect(prev => {
      // this is here (and not on DepictSearch) so that people also know when PageReplacer removes the page, it's intended to help people replace their own content when a depict page is navigated, see https://depictaiworkspace.slack.com/archives/C04M8MGCF3K/p1691670636155369
      const search_query = shared_properties.get_search_query_();
      $01c33966d9ddb108$export$f50b88e2a00918b5(props.on_query_change)(search_query, prev);
      return search_query;
    });
    $8tj43$onCleanup(() => $01c33966d9ddb108$export$f50b88e2a00918b5(props.on_query_change)());
    $8tj43$onCleanup(shared_properties.reset_history_state_);
    return $da279c5a540c6846$export$a54ec244c8863715({
      input_modal_open_: () => !!depict_search.modal_open,
      tenant_: () => depict_search.merchant,
      market_: () => depict_search.market,
      depict_api_: shared_properties.depict_api_,
      BackIcon_: shared_properties.BackIcon_,
      min_products_to_fetch_: $eb064bc3350276c1$var$min_products_to_fetch_,
      local_filter_cache_: state_.local_filter_cache,
      content_search_enabled_: () => {
        var _depict_search$enable;
        return (_depict_search$enable = depict_search.enable_content_search) !== null && _depict_search$enable !== void 0 ? _depict_search$enable : $eb064bc3350276c1$var$content_search_default;
      },
      search_field_value_: state_.field_value,
      get_search_query_: shared_properties.get_search_query_,
      clear_filters_on_next_submit_: shared_properties.clear_filters_on_next_submit_,
      open_modal_: function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
        return depict_search.modal_open = args;
      },
      submit_query_: shared_properties.configured_submit_query_,
      modalVersionUsed_: shared_properties.modalVersionUsed_,
      showSliderArrow_: () => props.showSliderArrow_,
      i18n_: shared_properties.i18n_,
      modalAlignmentSignalsRef_: style => {
        const shared_info_right_now = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(depict_search);
        if (!shared_info_right_now) return;
        $eb064bc3350276c1$export$dde08b2dca8cc1ce.set(depict_search, {
          ...shared_info_right_now,
          search_page_aligned_modal_alignment_signals_: style
        });
        $8tj43$onCleanup(() => {
          const shared_info_right_now = $eb064bc3350276c1$export$dde08b2dca8cc1ce.get(depict_search);
          if (!shared_info_right_now || shared_info_right_now.search_page_aligned_modal_alignment_signals_ !== style) return;
          $eb064bc3350276c1$export$dde08b2dca8cc1ce.set(depict_search, {
            ...shared_info_right_now,
            search_page_aligned_modal_alignment_signals_: undefined
          });
        });
      },
      current_sorting_: shared_properties.current_sorting_,
      search_filters_open_: state_.filters_open,
      search_sorting_open_: state_.sorting_open,
      expanded_filters_: state_.expanded_filters,
      content_results_rows_: state_.content_results_rows,
      content_blocks_by_row_: () => props.content_blocks_by_row,
      router_: shared_properties.router_,
      make_category_suggestion_card_: shared_properties.enable_category_suggestions_ ? category_suggestion_ => {
        return $dea31647b99a443b$export$d757d54550ebfb3d({
          category_suggestion_: category_suggestion_,
          router_: shared_properties.router_
        });
      } : false,
      expanded_hierarchical_filters_: state_.expanded_hierarchical_filters,
      selected_filters_: shared_properties.selected_filters_,
      showing_recommendation_rows_: state_.showing_recommendation_rows,
      scroll_restoration_data_: state_.scroll_restoration_data,
      include_input_field_: () => props.include_input_field,
      layout_options_: $8tj43$createMemo(() => ({
        cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77(props.cols_at_size),
        ...grid_spacing_override()
      })),
      content_layout_options_: $8tj43$createMemo(() => ({
        cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77($3f7203368ad0d3ca$export$ff7109b9b2b206ba(props.cols_at_size)),
        ...grid_spacing_override()
      })),
      filterModalParent_: $8tj43$untrack(() => props.filterModalParent_),
      product_card_template_: product_card_template,
      class_: () => props.class,
      hideCount0FilterOptions_: () => {
        var _props$hideCount0Filt;
        return (_props$hideCount0Filt = props.hideCount0FilterOptions_) !== null && _props$hideCount0Filt !== void 0 ? _props$hideCount0Filt : false;
      }
    });
  }, "Entire SearchPage failed");
}
function $37e8c97bb6876197$export$828dcdd425fd3231(aligner) {
  const style_element = document.createElement("style");
  document.head.append(style_element);
  const resize_observer = new ResizeObserver($8tj43$catchify1(() => {
    const styles = $cc64aabf2c7a1f1a$export$1233ca167bf71f9a({
      ".depict.plp .depict-search-modal .search-field": {
        "height": "".concat(aligner === null || aligner === void 0 ? void 0 : aligner.clientHeight, "px")
      }
    });
    style_element.replaceChildren(styles);
  }));
  resize_observer.observe(aligner);
  const cleanup = () => {
    resize_observer.disconnect();
    style_element.remove();
  };
  return {
    cleanup: cleanup
  };
}
const $169c13c0531d91d2$export$d86a33413558014e = openModalParams => {
  var _openModalParams$elem;
  const {
    search: search,
    makesNewSearch = true
  } = openModalParams;
  let cleanup;
  openModalParams.location || (openModalParams.location = "centered");
  if (openModalParams.location === "aligned" && !openModalParams.element) throw new Error("No active search header aligner on the page!");
  if (openModalParams.location !== "aligned") {
    // Open centered modal
    search.modal_open = [{
      dont_sync_search_field_value_except_on_submit_: makesNewSearch
    }];
    return;
  }
  const alignment_height = (_openModalParams$elem = openModalParams.element) === null || _openModalParams$elem === void 0 ? void 0 : _openModalParams$elem.clientHeight;
  if (isNaN(alignment_height)) {
    // Open centered modal
    search.modal_open = [{
      dont_sync_search_field_value_except_on_submit_: makesNewSearch
    }];
    return;
  }
  if (!openModalParams.ignoreFieldSize_) ({
    cleanup: cleanup
  } = $37e8c97bb6876197$export$828dcdd425fd3231(openModalParams.element));
  let dispose_aligner;
  /**
  * Setting position to fixed is important to make the modal work with align_field.
  */
  const alignmentSignals_ = {
    body_: $8tj43$createSignal({
      position: "fixed"
    }),
    field_: $8tj43$createSignal({}),
    backdrop_: $8tj43$createSignal({})
  };
  const closingAnimation = $d7833ca17fc05c5e$export$dab9321f3c157061(alignmentSignals_, openModalParams.runAnimations_ ? 2 : 1);
  $8tj43$createRoot(dispose => {
    dispose_aligner = () => {
      var _cleanup;
      (_cleanup = cleanup) === null || _cleanup === void 0 || _cleanup();
      dispose();
    };
    $1308a7816c3d4f2d$export$b3ad617e9036868(alignmentSignals_, openModalParams.element, (0, $1308a7816c3d4f2d$export$3f238c96c45e6cc6));
  });
  search.modal_open = [{
    alignmentSignals_: alignmentSignals_,
    dont_sync_search_field_value_except_on_submit_: makesNewSearch,
    closing_animation_: closingAnimation
  }, dispose_aligner];
};
function $573c007c697a1831$export$d0596b5cae35ad4(open_search) {
  const handler = $8tj43$catchify1(e => {
    const {
      key: key,
      target: target
    } = e;
    const {
      body: body
    } = document;
    if (key === "/" && (target === body || !body.contains(target))) {
      open_search();
      e.preventDefault();
    }
  });
  window.addEventListener("keydown", handler);
  return () => window.removeEventListener("keydown", handler);
}
function $e60a76195ac6d408$export$689e204eadb33baf(pr) {
  let old_url;
  let disconnect_link_observer;
  const link_handler = $8tj43$catchify1(e => {
    const link = e.currentTarget || e.target;
    if (link.href === old_url) {
      history.pushState(history.state, "", link.href);
      e.preventDefault();
    }
  });
  let remove_added_listeners;
  let resolve_remove_added_listeners;
  pr.addEventListener("open", $8tj43$catchify1(() => {
    remove_added_listeners = new Promise(r => resolve_remove_added_listeners = r);
    disconnect_link_observer = (0, $8tj43$observer).onexists("a", async _ref => {
      let {
        element: element
      } = _ref;
      element.addEventListener("click", link_handler);
      await remove_added_listeners;
      element.removeEventListener("click", link_handler);
    });
  }));
  pr.addEventListener("close", $8tj43$catchify1(() => {
    var _disconnect_link_obse, _resolve_remove_added;
    (_disconnect_link_obse = disconnect_link_observer) === null || _disconnect_link_obse === void 0 || _disconnect_link_obse();
    (_resolve_remove_added = resolve_remove_added_listeners) === null || _resolve_remove_added === void 0 || _resolve_remove_added();
  }));
  $8tj43$catchify1(async () => {
    for await (const href of (0, $8tj43$href_change_ipns)) if (!pr.is_page_(new URL(href))) old_url = href;
  })();
}
function $f9fd3017c20b774a$var$_classPrivateMethodInitSpec(obj, privateSet) {
  $f9fd3017c20b774a$var$_checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}
function $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
  $f9fd3017c20b774a$var$_checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function $f9fd3017c20b774a$var$_checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $f9fd3017c20b774a$var$_classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) {
  $f9fd3017c20b774a$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
  $f9fd3017c20b774a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "set");
  $f9fd3017c20b774a$var$_classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
function $f9fd3017c20b774a$var$_classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) descriptor.set.call(receiver, value);else {
    if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
    descriptor.value = value;
  }
}
function $f9fd3017c20b774a$var$_classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
  return fn;
}
function $f9fd3017c20b774a$var$_classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
  $f9fd3017c20b774a$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
  $f9fd3017c20b774a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "get");
  return $f9fd3017c20b774a$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $f9fd3017c20b774a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, action) {
  if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}
function $f9fd3017c20b774a$var$_classCheckPrivateStaticAccess(receiver, classConstructor) {
  if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}
function $f9fd3017c20b774a$var$_classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) return descriptor.get.call(receiver);
  return descriptor.value;
}
var $f9fd3017c20b774a$var$_stop_listening = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_disconnect_observer = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_revert_fns = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_is_open = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_listen = /*#__PURE__*/new WeakSet();
var $f9fd3017c20b774a$var$_get_rendered_recs = /*#__PURE__*/new WeakSet();
var $f9fd3017c20b774a$var$_unload = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_load = /*#__PURE__*/new WeakMap();
var $f9fd3017c20b774a$var$_empty_page_bugfix = /*#__PURE__*/new WeakSet();
class $f9fd3017c20b774a$export$3ccaa27d81dd8556 extends EventTarget {
  /**
  * Returns if the "replacement page" is currently open
  */
  get open_() {
    // make this "readonly" from the outside, the only way to open is by making the url change so that is_page_ returns true
    return $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_is_open);
  }
  /**
  * Stops listening to URL changes and closes the page (if it is currently open)
  */
  destroy_() {
    var _classPrivateFieldGet2;
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_unload).call(this);
    (_classPrivateFieldGet2 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_stop_listening)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
  }
  constructor(_ref) {
    let {
      is_spa_: is_spa_,
      ...options
    } = _ref;
    super();
    $f9fd3017c20b774a$var$_classPrivateMethodInitSpec(this, $f9fd3017c20b774a$var$_empty_page_bugfix);
    $f9fd3017c20b774a$var$_classPrivateMethodInitSpec(this, $f9fd3017c20b774a$var$_get_rendered_recs);
    $f9fd3017c20b774a$var$_classPrivateMethodInitSpec(this, $f9fd3017c20b774a$var$_listen);
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_stop_listening, {
      writable: true,
      value: void 0
    });
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_disconnect_observer, {
      writable: true,
      value: void 0
    });
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_revert_fns, {
      writable: true,
      value: []
    });
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_is_open, {
      writable: true,
      value: false
    });
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_unload, {
      writable: true,
      value: /*@__PURE__*/$8tj43$catchify1(() => {
        var _classPrivateFieldGet3;
        if (!$8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_is_open)) return;
        (_classPrivateFieldGet3 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_disconnect_observer)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        if ($f9fd3017c20b774a$var$_classStaticPrivateFieldSpecGet($f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$var$_reverting_permitted)) while ($8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).length) {
          var _classPrivateFieldGet4;
          (_classPrivateFieldGet4 = $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).pop()) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4();
        }
        $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $f9fd3017c20b774a$var$_is_open, false);
        this.dispatchEvent(new CustomEvent("close"));
      }, "failed to close page")
    });
    $f9fd3017c20b774a$var$_classPrivateFieldInitSpec(this, $f9fd3017c20b774a$var$_load, {
      writable: true,
      value: /*@__PURE__*/$8tj43$catchify1(async els => {
        $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $f9fd3017c20b774a$var$_is_open, true);
        // So that #load doesn't get called again
        let set_should_stay_inserted;
        const should_stay_inserted = new Promise(r => set_should_stay_inserted = r);
        $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).push(() => {
          var _set_should_stay_inse;
          return (_set_should_stay_inse = set_should_stay_inserted) === null || _set_should_stay_inse === void 0 ? void 0 : _set_should_stay_inse(false);
        });
        $8tj43$insert_surfaces({
          surfaces: [{
            elements: els,
            should_stay_inserted: should_stay_inserted
          }],
          verb: this.append_instead_of_replace_ ? "append" : "after",
          target: this.selector_,
          preserve_elements: true,
          remove_after_navigation: false,
          try_forever: true
        });
        const first_element_found = new Promise(r => {
          $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $f9fd3017c20b774a$var$_disconnect_observer, (0, $8tj43$observer).onexists(this.selector_, _ref2 => {
            let {
              element: element,
              disconnector: disconnector
            } = _ref2;
            r();
            if (this.append_instead_of_replace_) {
              disconnector();
              return;
            }
            const {
              style: style
            } = element;
            const old_display_value = style.display;
            style.setProperty("display", "none", "important");
            $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).push(() => {
              style.display = old_display_value;
            });
          }));
        });
        await first_element_found;
        const {
          title: title
        } = document;
        if (this.title_) {
          document.title = this.title_;
          $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).push(() => document.title = title);
        }
        $f9fd3017c20b774a$var$_classPrivateMethodGet(this, $f9fd3017c20b774a$var$_empty_page_bugfix, $f9fd3017c20b774a$var$_empty_page_bugfix2).call(this);
        this.dispatchEvent(new CustomEvent("open")); // we dispatch this once it's actually open
      }, "failed to open page")
    });
    Object.assign(this, options);
    $f9fd3017c20b774a$var$_classPrivateMethodGet(this, $f9fd3017c20b774a$var$_listen, $f9fd3017c20b774a$var$_listen2).call(this).catch(e => $8tj43$report1([e, "Error listening to URL change"], "error"));
    if (!is_spa_) $e60a76195ac6d408$export$689e204eadb33baf(this); // Make so that clicking on links to the previous page work instantly
  }
}
/**
 * Remove hash from URL
 */
async function $f9fd3017c20b774a$var$_listen2() {
  const [exit_ipns, exitable_ipns] = $8tj43$make_asyncIterable_exiter((0, $8tj43$href_change_ipns));
  $8tj43$babelruntimehelpersclassPrivateFieldSet(this, $f9fd3017c20b774a$var$_stop_listening, exit_ipns);
  const caught_page_check_fn = $8tj43$catchify1(this.is_page_, "page check failed");
  for await (const href of exitable_ipns) {
    const url = new URL(href);
    if (!caught_page_check_fn(url)) {
      $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_unload).call(this);
      continue;
    }
    if ($8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_is_open)) continue;
    const els = $f9fd3017c20b774a$var$_classPrivateMethodGet(this, $f9fd3017c20b774a$var$_get_rendered_recs, $f9fd3017c20b774a$var$_get_rendered_recs2).call(this);
    if (!(els !== null && els !== void 0 && els.length)) continue;
    $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_load).call(this, els);
  }
}
function $f9fd3017c20b774a$var$_get_rendered_recs2() {
  return $8tj43$createRoot(dispose => {
    this.addEventListener("close", dispose, {
      once: true
    });
    return $8tj43$catchify1(this.render_, "rendering failed")() || [];
  });
}
function $f9fd3017c20b774a$var$_empty_page_bugfix2() {
  // Called when a "page" is "opened" using PageReplacer
  const on_maybe_popstate = $8tj43$catchify1(what_happened => {
    if (what_happened !== "popstate") return;
    const cleaned_current_url = $f9fd3017c20b774a$var$clean_url(location.href);
    if (!$f9fd3017c20b774a$var$_classStaticPrivateFieldSpecGet($f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$var$_visited_urls).has(cleaned_current_url)) {
      /*
      What does this check do? Well, there's a bug without it where people end up on a page that they shouldn't see (i.e. a somewhat blank page).
      The culprit of that bug is: the browser remembers where to make "hard"-navigations (i.e. a full document rebuild with a new `document` and `window` object) when going back and forwards in the history and where to just change the url. What it doesn't always correctly remember (observed in at least chrome and firefox), is *what document to hard-navigate to*. Therefore, we have to jump in and take care of that.
      The reproduction is this:
      Spendrups has set up a search page for us under /start/search. We don't want to hard-reload the page though to get there.
      1. Go to a product page like https://ehandel.spendrups.se/Product/1104201
      2. Make a search
      We use PageReplacer to just replace the current page (and the url in the address bar) with the search page. The thing is though, that when going back now the URL just updates but the browser doesn't actually navigate - that's fine, PageReplacer will just restore the old page contents
      3. Try going back just for fun
      Everything works as expected
      4. Go forwards again (just for fun, skip this if you skipped 3)
      Now the trouble comes when we introduce "hard" navigation.
      5. Click on a search result. The browser will now "hard" navigate to a new page.
      6. Click "back"
      What happens now, is that the browser hard-navigates to /start/search.
      7. Click "back" again
      What happens now, is that the browser "soft-navigates" (just changes the URL) to https://ehandel.spendrups.se/Product/1104201
      PageReplacer unload itself and reveals the original document - it is expected to be the one under https://ehandel.spendrups.se/Product/1104201, but actually it is the one under /start/search - a white page.
      The fix: is to remember all pages that we have visited since the creation of `window` (we do that by having a static property on PageReplacer since we assume the PageReplacer source code will only exist once on the page and will be loaded at page load, the latter assumption might be wrong, but I hope not). If we get a "popstate" event (meaning back or forwards button, not new page being pushed) to an unknown page we reload.
      */
      $8tj43$dlog("PageReplacer: ", cleaned_current_url, " hasn't been visited since document was created, reloading since we won't be able to show this page otherwise");
      location.reload();
      $f9fd3017c20b774a$var$_classStaticPrivateFieldSpecSet($f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$var$_reverting_permitted, false); // Disallow any reverting since we can't - it would flash a white page until the reload has finished.
      $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_unload).call(this); // Call unload to "kill" the solid-js stuff quicker so that it stops updating - the user is expecting the next thing that happens to be a navigation to the actual page the URL says they're on.
    }
  });

  (0, $8tj43$instant_exec_on_suspect_history_change).add(on_maybe_popstate);
  $8tj43$babelruntimehelpersclassPrivateFieldGet(this, $f9fd3017c20b774a$var$_revert_fns).push(() => (0, $8tj43$instant_exec_on_suspect_history_change).delete(on_maybe_popstate)); // Don't run the bugfixer if there isn't a PageReplacer page open since I assume the bug only happens when going back from a PageReplace'd page
}

var $f9fd3017c20b774a$var$_reverting_permitted = {
  writable: true,
  value: true
};
var $f9fd3017c20b774a$var$_visited_urls = {
  writable: true,
  value: /*@__PURE__*/(() => {
    // Keep track of all URLs that have been visited since the document that was initially loaded (loaded means the process where the browser creates a new `document` and `window` object).
    $8tj43$catchify1(async () => {
      // Static initialization blocks aren't supported in MobileSafari yet, otherwise this would be one.
      // I don't think we want to ship a library that users are *forced* to transpile, it should run in the newest version of all major browsers. So we'll just use a function wrapper for now (adding "last 1 ios version" to the build target does a bunch of other unneeded transpilations).
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/Static_initialization_blocks
      for await (const href of (0, $8tj43$href_change_ipns)) $f9fd3017c20b774a$var$_classStaticPrivateFieldSpecGet($f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$export$3ccaa27d81dd8556, $f9fd3017c20b774a$var$_visited_urls).add($f9fd3017c20b774a$var$clean_url(href));
    })();
    return new Set();
  })()
};
function $f9fd3017c20b774a$var$clean_url(url) {
  // Would want to have this a static private function on PageReplacer, but that's not supported in MobileSafari yet
  // remove hash, all other params *could* trigger a re-request
  const url_object = new URL(url);
  url_object.hash = "";
  return url_object.href;
}
var $a3026fb727bc7550$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class="depict plp search">`);
function $a3026fb727bc7550$export$316f6f283ae64765(props) {
  const {
    depict_search: depict_search,
    modal_dispose_handler: modal_dispose_handler,
    click_handler: click_handler
  } = props;
  const shared_properties = $eb064bc3350276c1$export$12fa711345994013(depict_search);
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    let input_element;
    let buttonInField;
    const search_field = $8tj43$createComponent((0, $584c06c09cf4609d$export$b94867ecbd698f21), {
      class_: () => props.class,
      get BackIcon_() {
        return shared_properties.BackIcon_;
      },
      get search_field_value_() {
        return shared_properties.state_.field_value;
      },
      get submit_query_() {
        return shared_properties.configured_submit_query_;
      },
      get clear_filters_() {
        return shared_properties.clear_filters_on_next_submit_;
      },
      get i18n_() {
        return shared_properties.i18n_;
      },
      disabled_: true,
      input_field_ref_: el => input_element = el,
      buttonInFieldRef_: el => buttonInField = el,
      field_element_ref_: field => {
        const bodyAlignmentSignal_ = $8tj43$createSignal({
          position: "fixed"
        });
        const backdropAlignmentSignal_ = $8tj43$createSignal({});
        const alignmentSignals_ = {
          body_: bodyAlignmentSignal_,
          field_: $8tj43$createSignal({}),
          backdrop_: backdropAlignmentSignal_
        };
        const defaultHandler = $8tj43$catchify1(e => {
          const {
            modalVersionUsed_: modalVersionUsed_
          } = shared_properties;
          let pollAlignment;
          let setModalSearchFieldOuterWidth_;
          let revert;
          if (modalVersionUsed_ === 2) {
            let setPollAlignment_;
            let modalSearchFieldOuterWidth_;
            [pollAlignment, setPollAlignment_] = $8tj43$createSignal(false);
            [modalSearchFieldOuterWidth_, setModalSearchFieldOuterWidth_] = $8tj43$createSignal(0);
            revert = $937791b86d3d1509$export$44f738469d5570cf({
              actualField_: search_field,
              makeFakeField_: () => $8tj43$createComponent((0, $584c06c09cf4609d$export$b94867ecbd698f21), {
                get BackIcon_() {
                  return shared_properties.BackIcon_;
                },
                get search_field_value_() {
                  return shared_properties.state_.field_value;
                },
                get submit_query_() {
                  return shared_properties.configured_submit_query_;
                },
                get clear_filters_() {
                  return shared_properties.clear_filters_on_next_submit_;
                },
                get i18n_() {
                  return shared_properties.i18n_;
                },
                disabled_: true
              }),
              wrap_: true,
              bodyAlignmentSignal_: bodyAlignmentSignal_,
              backdropStyleSignal_: backdropAlignmentSignal_,
              setPollAlignment_: setPollAlignment_,
              buttonInField_: buttonInField,
              modalSearchFieldOuterWidth_: modalSearchFieldOuterWidth_
            });
          }
          // When selecting text in the SearchField that's in the page we want the same selection to persist. It doesn't by itself, since the SearchModalV2 has an entirely different SearchField. Therefore, we manually copy the selection over.
          const selected_text_range_ = [input_element.selectionStart, input_element.selectionEnd];
          const {
            cleanup: cleanup
          } = $a3026fb727bc7550$var$align_field_modal(alignmentSignals_, search_field, modalVersionUsed_, () => props.aligner_ref, pollAlignment);
          const complete_modal_dispose_handler = () => {
            modal_dispose_handler === null || modal_dispose_handler === void 0 || modal_dispose_handler();
            cleanup();
          };
          depict_search.modal_open = [{
            alignmentSignals_: alignmentSignals_,
            selected_text_range_: selected_text_range_,
            closing_animation_: revert,
            setSearchFieldOuterWidth_: setModalSearchFieldOuterWidth_
          }, complete_modal_dispose_handler];
        });
        const handler = click_handler !== null && click_handler !== void 0 ? click_handler : defaultHandler;
        field.addEventListener("click", handler);
        $8tj43$onCleanup(() => field.removeEventListener("click", handler));
      }
    });
    // We assume this to be an array containing exactly on div in js-ui
    return [(() => {
      var _el$ = $8tj43$getNextElement($a3026fb727bc7550$var$_tmpl$);
      $8tj43$insert(_el$, search_field);
      return _el$;
    })()];
  }, "SearchField failed");
}
function $a3026fb727bc7550$var$align_field_modal(alignmentSignals, input, modalVersion, aligner_ref_accessor, pollAlignment) {
  return $8tj43$createRoot(dispose => {
    $8tj43$createComputed(() => {
      const aligner_ref = aligner_ref_accessor === null || aligner_ref_accessor === void 0 ? void 0 : aligner_ref_accessor();
      if (!aligner_ref) {
        $1308a7816c3d4f2d$export$b3ad617e9036868(alignmentSignals, input, (0, $1308a7816c3d4f2d$export$7895aadd1956b1c7) | (0, $1308a7816c3d4f2d$export$3f238c96c45e6cc6) | (modalVersion === 1 ? (0, $1308a7816c3d4f2d$export$902f8b4a7dae5d78) : (0, $1308a7816c3d4f2d$export$6060bc6bee850eb6) | (0, $1308a7816c3d4f2d$export$5097308c5200105a)), undefined, pollAlignment);
        return;
      }
      const {
        cleanup: cleanup
      } = $37e8c97bb6876197$export$828dcdd425fd3231(aligner_ref);
      $8tj43$onCleanup(cleanup);
      $1308a7816c3d4f2d$export$b3ad617e9036868(alignmentSignals, aligner_ref, (0, $1308a7816c3d4f2d$export$3f238c96c45e6cc6), undefined, pollAlignment);
    });
    return {
      cleanup: dispose
    };
  });
}
var $62a8813a51fbd22f$var$_tmpl$ = /*#__PURE__*/$8tj43$template(`<div class="depict plp category">`);
const $62a8813a51fbd22f$var$InExternalAreaDiv = _ref => {
  let {
    children: children
  } = _ref;
  return (() => {
    var _el$ = $8tj43$getNextElement($62a8813a51fbd22f$var$_tmpl$);
    $8tj43$insert(_el$, children);
    $8tj43$effect(() => $8tj43$setAttribute(_el$, "id", (0, $c3820807ac1e6fd7$export$44dad306455dddf).PLP_CATEGORY));
    return _el$;
  })();
};
function $62a8813a51fbd22f$export$5b7c3ce0ebe51f86(_ref2) {
  let {
    depict_category: depict_category
  } = _ref2;
  const {
    i18n_: i18n_,
    breadcrumb_signal_: [crumb_data_],
    router_: router_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_
  } = $f5f54892fd0c7d9f$export$1bc6f63c09b1a481(depict_category);
  return $8tj43$createComponent($62a8813a51fbd22f$var$InExternalAreaDiv, {
    get children() {
      return $52efc9ae4382e25a$export$5646050d516e06bc({
        i18n_: i18n_,
        crumb_data_: crumb_data_,
        router_: router_,
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_
      });
    }
  });
}
function $62a8813a51fbd22f$export$de035477d6fef996(_ref3) {
  let {
    depict_category: depict_category
  } = _ref3;
  const {
    i18n_: i18n_,
    quicklinks_signal_: [quicklinks_data_],
    breadcrumb_signal_: [breadcrumb_data_],
    router_: router_,
    sorting_query_param_: sorting_query_param_,
    filter_query_param_prefix_: filter_query_param_prefix_
  } = $f5f54892fd0c7d9f$export$1bc6f63c09b1a481(depict_category);
  const id_to_query_for_ = $8tj43$createMemo(() => depict_category.listing_query.id);
  const id_type_ = $8tj43$createMemo(() => depict_category.listing_query.type);
  return $8tj43$createComponent($62a8813a51fbd22f$var$InExternalAreaDiv, {
    get children() {
      return $43fbb365ed0ac99e$export$466cdc317043f6cb({
        i18n_: i18n_,
        quicklinks_data_: quicklinks_data_,
        router_: router_,
        id_type_: id_type_,
        id_to_query_for_: id_to_query_for_,
        breadcrumb_data_: breadcrumb_data_,
        sorting_query_param_: sorting_query_param_,
        filter_query_param_prefix_: filter_query_param_prefix_
      });
    }
  });
}
const $8821a19349c36651$var$min_products_to_fetch_ = 20;
function $8821a19349c36651$export$e2bf8ce7779e827e(props) {
  const {
    depict_category: depict_category,
    product_card_template: product_card_template,
    category_title: category_title
  } = props;
  const shared_properties = $f5f54892fd0c7d9f$export$1bc6f63c09b1a481(depict_category);
  const diffableListingQuery = $8tj43$createMemo(() => Object.values(depict_category.listing_query || {}).join(""));
  return $83e8cf2c0b87a58a$export$23fca46f3143581f(() => {
    $8tj43$createEffect(prev => {
      // this is here (and not on DepictCategory) so that people also know when PageReplacer removes the page, it's intended to help people replace their own content when a depict page is navigated, see https://depictaiworkspace.slack.com/archives/C04M8MGCF3K/p1691670636155369
      diffableListingQuery(); // Only re-run this effect when the listing query *actually* changes (not just the object reference)
      const newId = $8tj43$untrack(() => depict_category.listing_query);
      $01c33966d9ddb108$export$f50b88e2a00918b5(props.on_listing_query_change)(newId, prev);
      return newId;
    });
    $8tj43$onCleanup(() => $01c33966d9ddb108$export$f50b88e2a00918b5(props.on_listing_query_change)());
    const is_grid = $8tj43$createMemo(() => {
      const {
        layout: layout
      } = props;
      return !layout || layout === "grid";
    });
    const grid_spacing_override = $8tj43$createMemo(() => {
      const {
        grid_spacing: grid_spacing
      } = props; // can be reactive, therefore read in the memo
      return typeof grid_spacing === "string" ? {
        grid_spacing: grid_spacing
      } : {
        override_vertical_spacing: grid_spacing.vertical,
        grid_spacing: grid_spacing.horizontal
      };
    });
    const {
      local_filter_cache: local_filter_cache_,
      filters_open: category_filters_open_,
      sorting_open: category_sorting_open_,
      expanded_filters: expanded_filters_,
      expanded_hierarchical_filters: expanded_hierarchical_filters_,
      scroll_restoration_data: scroll_restoration_data_,
      history_content_blocks: history_content_blocks_
    } = depict_category.historyStateSignals_;
    const {
      current_sorting_: current_sorting_,
      selected_filters_: selected_filters_,
      override_listing_id_accessor_: override_listing_id_accessor_,
      reset_history_state_: reset_history_state_,
      depict_api_: depict_api_,
      i18n_: i18n_,
      router_: router_,
      breadcrumb_signal_: breadcrumb_signal_,
      quicklinks_signal_: quicklinks_signal_,
      sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
      sorting_query_param_: sorting_query_param_,
      filter_query_param_prefix_: filter_query_param_prefix_
    } = shared_properties;
    $8tj43$onCleanup(reset_history_state_);
    return $4b4b262708b516ee$export$f7d2f673fc2f091d({
      merchant_: () => depict_category.merchant,
      market_: () => depict_category.market,
      depict_api_: depict_api_,
      min_products_to_fetch_: $8821a19349c36651$var$min_products_to_fetch_,
      local_filter_cache_: local_filter_cache_,
      id_to_query_for_: $8tj43$createMemo(() => !depict_category.disable_override_listing_id && override_listing_id_accessor_() || depict_category.listing_query.id),
      id_type_: $8tj43$createMemo(() => {
        if (!depict_category.disable_override_listing_id && override_listing_id_accessor_()) return $397620a4d7958ed1$export$74ee7529ce0f8a00;
        return depict_category.listing_query.type;
      }),
      i18n_: i18n_,
      // default disable quicklinks and breadcrumbs for sliders
      show_quicklinks_: $8tj43$createMemo(() => {
        var _props$show_quicklink;
        return (_props$show_quicklink = props.show_quicklinks) !== null && _props$show_quicklink !== void 0 ? _props$show_quicklink : is_grid();
      }),
      category_title_: category_title,
      show_breadcrumbs_: $8tj43$createMemo(() => {
        var _props$show_breadcrum;
        return (_props$show_breadcrum = props.show_breadcrumbs) !== null && _props$show_breadcrum !== void 0 ? _props$show_breadcrum : is_grid();
      }),
      current_sorting_: current_sorting_,
      router_: router_,
      get_breadcrumb_accessor_: accessor => $8tj43$createComputed(() => breadcrumb_signal_[1](accessor())),
      get_quicklinks_accessor_: accessor => $8tj43$createComputed(() => quicklinks_signal_[1](accessor())),
      category_filters_open_: category_filters_open_,
      category_sorting_open_: category_sorting_open_,
      expanded_filters_: expanded_filters_,
      expanded_hierarchical_filters_: expanded_hierarchical_filters_,
      filterModalParent_: $8tj43$untrack(() => props.filterModalParent_),
      selected_filters_: selected_filters_,
      sideways_filter_clearing_flag_: sideways_filter_clearing_flag_,
      content_blocks_by_row_: () => props.content_blocks_by_row,
      showSliderArrow_: () => props.showSliderArrow_,
      hideCount0FilterOptions_: () => {
        var _props$hideCount0Filt;
        return (_props$hideCount0Filt = props.hideCount0FilterOptions_) !== null && _props$hideCount0Filt !== void 0 ? _props$hideCount0Filt : false;
      },
      scroll_restoration_data_: scroll_restoration_data_,
      history_content_blocks_: history_content_blocks_,
      layout_options_: $8tj43$createMemo(() => ({
        cols_at_size: $a9c7ba6087881ac2$export$6daf8749b65a1b77(props.cols_at_size),
        ...grid_spacing_override(),
        layout: props.layout
      })),
      product_card_template_: product_card_template,
      sorting_query_param_: sorting_query_param_,
      filter_query_param_prefix_: filter_query_param_prefix_
    });
  }, "Entire CategoryPage failed");
}
$8tj43$add_to_version_info("ui", (0, $8db9a15135765c11$export$83d89fbfd8236492));
export { $4b4b262708b516ee$export$1d575f423147a8c as usePLPLayout, $4be619ec2cd7bba3$export$54c6d6ff54e72743 as makeSizeAccessors, $80c7883e020be192$export$f98b8d5ea7207a1 as setExtraDisplayTransformers, $80c7883e020be192$export$b2d94be4f02525b2 as getExtraDisplayTransformers, $98688279b9059f50$export$140423fa4bfb6d63 as ModernResponsiveImage, $ff7feae4dddd6073$export$92aa5d691d588f3f as remap_blocks_to_index, $715f7f2e53146662$export$d4d96868197be50e as useMobileHover, $a35e6f680c5bbc60$export$54299a3c81f5425 as useVisibilityState, $002f09d00aac50b2$export$eaa625fb39439e37 as useSlidableInformation, $618bd53ea0a41cd4$export$80bb7300ce6a8be3 as useProductCardIsVisible, $618bd53ea0a41cd4$export$f223d69ed12f5fb7 as CurrentlyIntersectingContext, $8e8b179489080711$export$5bad61ecde080b1f as useExpandingContainerReactive, $bb34cd283e904784$export$2c9f9bf2092486aa as LooksSliderOrGrid, $22dd375b476673e2$export$44809a8a3e867e30 as LookCard, $ac571292d606f30b$export$7e1297a3a19f10d8 as PseudoRouter, $6d75ec14f537c37f$export$83bb9af5671e1dbe as promiseSafeStructuredClone, $68e6625c8d51f847$export$5162a71f252e6122 as preserve_items_in_history_dot_state, $68e6625c8d51f847$export$3064e1e8c6513da3 as prefixes_to_preserve_in_history_dot_state, $9b35d1384e31813a$export$29d28dadc2d6b631 as allowNativeNavigation, $b026fa9c9c904a98$export$1ea76ea778b880dd as modalVersionSymbol, $a604a8ffa4e4c03f$export$e417c49320921907 as createDeparallelizedNoDropResource, $01c33966d9ddb108$export$f50b88e2a00918b5 as throw_globally, $40411f2ec772c376$export$9265e66f26f8e383 as ClassicSearchModal, $06fcd2a345efd24d$export$b0c55aa2e87c4be7 as SearchModalV2, $98688279b9059f50$export$9d4a4b669b1929ab as ModernResponsiveContainedImage, $6a439680ae7e9ba3$export$3e41faf802a29e71 as Tab, $6a439680ae7e9ba3$export$b2539bed5023c21c as Tabs, $6b0fd8fd20df8ccf$export$d4973c31938cbfd1 as ShopTheLookButton, $972f6bce0f9d61be$export$e183a13865960371 as history_dot_state_to_state, $2855bffe06ef7a03$export$916e6850778505f6 as strip_encoded_filter_and_sort, $2855bffe06ef7a03$export$58aa3f171519b6d7 as encode_filters, $2855bffe06ef7a03$export$f934fa24c3a86811 as decode_filters, $2855bffe06ef7a03$export$62acb285a7579555 as encode_sorting, $2855bffe06ef7a03$export$766e9676e74997d3 as decode_sorting, $4df489344a0f97c7$export$d7b7ab832c20e2f4 as shopifyContainedImageContextSymbol, $5441862cd2f5e111$export$e68cff63f76bd15b as ListingProvider, $5441862cd2f5e111$export$8d0c4fdbb05a2f2e as useListing, $1e69163caedaab4e$export$11354f017ddc9790 as ProductCardIndexProvider, $1e69163caedaab4e$export$e3faf4d95300054f as useProductCardIndex, $4df489344a0f97c7$export$e4b984597b71e989 as ShopifyContainedImage, $002f09d00aac50b2$export$6649caad96ef8870 as SlidableItems, $fc830a7ee59416ef$export$ebdc3711f7e02ccd as make_accurate_width_accessor, $d5d7e58c5c9d8db0$export$9574e176201e5e8d as RecommendationSlider, $b432b11321ad4c97$export$9756467d34d91cdb as RecommendationGrid, $56047603f9d212b6$export$6e5611bc7e57e477 as ShopifyResponsiveImg, $801e8845d3fa3653$export$94026ee33dbabc26 as ImageContainer, $74777e8fe65b3dcb$export$b69d0d92862de18b as SentryErrorBoundary, $74777e8fe65b3dcb$export$240ecf5363d76c0f as ExtraSentryContextProvider, $ad371564683947ab$export$6c6d7a51fa9aa15d as ExpandingDetails, $e18ab2868df26f40$export$f091cbac892643a4 as accessor_of_object_to_object_with_accessor_values, $4711a82d08d2021b$export$fecbb157621501bd as SelectedFilters, $f6b0500577e1b210$export$3f1a388cc0d8fed7 as FilterBody, $44aa24b1bb793549$export$b288c38ae3fddb56 as create_modified_filters, $63f1f8dbcd07d3b0$export$d21e32dfedac04be as SolidLayout, $63f1f8dbcd07d3b0$export$445d8d3f5f706a40 as SolidLayoutWithProvidedElement, $d5f1e6a0f9117286$export$79b1565500412d9b as general_modal_abstraction, $9783d437ad61594c$export$3b621d86b1566b2 as CrossIcon, $ca6ab5f08bd28bca$export$8be2714ec7f169ee as GenericSliderArrowButton, $50aebf5b445518eb$export$58e808b1db15d3bc as fetchDepictRecommendations, $fa332ea03168857c$export$b91cec6bdc6b32a1 as CategoryTitle, $702d7656a373973e$export$824dde41348efed1 as embedded_num_products, $160ea2b55d8772d2$export$c1a6b039e689a58e as get_listings, $f5f54892fd0c7d9f$export$f34314aa9505732e as DepictCategory, $eb064bc3350276c1$export$ac6237957a15b3f0 as DepictSearch, $eb064bc3350276c1$export$bde3eb976dfded9 as get_search_query_updating_blocked_signal, $eb064bc3350276c1$export$f2dc7e4e4aa11abb as SearchPage, $f3b7124b76123e44$export$aa14a9f43128f61f as ProductCardError, $169c13c0531d91d2$export$d86a33413558014e as open_modal_with_alignment, $5eaa00b951637e96$export$ee1733d9a8495996 as DefaultInstantCardPlaceholder, $1308a7816c3d4f2d$export$b3ad617e9036868 as align_field, $1308a7816c3d4f2d$export$3f238c96c45e6cc6 as ALIGN_TOP, $1308a7816c3d4f2d$export$902f8b4a7dae5d78 as ALIGN_WIDTH_ON_MODAL, $1308a7816c3d4f2d$export$7895aadd1956b1c7 as ALIGN_LEFT, $1308a7816c3d4f2d$export$6060bc6bee850eb6 as SET_CENTERED_LEFT, $a9c7ba6087881ac2$export$6daf8749b65a1b77 as convert_sdk_cols_at_size_to_layout, $cc64aabf2c7a1f1a$export$1233ca167bf71f9a as styles_to_valid_css_string, $e56d241d0f33d459$export$fe334901e8bebd57 as disable_scrolling, $573c007c697a1831$export$d0596b5cae35ad4 as open_search_with_shift_slash, $284849364a6ef73a$export$e015ed2f2950f2e3 as DepictAPI, $00a5b94f0c11efbb$export$d9f36cf74e24d595 as media_query_to_accessor, $e60a76195ac6d408$export$689e204eadb33baf as setup_fast_leave, $a61a2051e15c8d7a$export$5196e4c01fa56fcb as show_toast, $60ec7a29849d81db$export$a71e92cfbb498adc as SolidFormatPrice, $37e8c97bb6876197$export$828dcdd425fd3231 as connect_search_field_height_to_aligner_height, $bc2337c9a05ecd18$export$acb3eaade4b23afd as BasePlaceholder, $ceafb6fb91c6f394$export$89c6019e4baa40b1 as TextPlaceholder, $3ab4aa97880fb88d$export$3f37af283f8fb843 as ImagePlaceholder, $f9fd3017c20b774a$export$3ccaa27d81dd8556 as PageReplacer, $d399250dfa491636$export$864d304a0bc46829 as defaultGridSpacing, $d399250dfa491636$export$c3834fa86c616831 as defaultColsAtSize, $d399250dfa491636$export$7bf543b9d9be2c22 as defaultCategoryTitlePlugin, $8db9a15135765c11$export$83d89fbfd8236492 as version, $a3026fb727bc7550$export$316f6f283ae64765 as SearchField, $62a8813a51fbd22f$export$5b7c3ce0ebe51f86 as BreadCrumbs, $62a8813a51fbd22f$export$de035477d6fef996 as QuickLinks, $8821a19349c36651$export$e2bf8ce7779e827e as CategoryPage };